/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: function() { return /* binding */ loadStripe; }
/* harmony export */ });
var V3_URL = 'https://js.stripe.com/v3';
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var findScript = function findScript() {
  var scripts = document.querySelectorAll("script[src^=\"".concat(V3_URL, "\"]"));

  for (var i = 0; i < scripts.length; i++) {
    var script = scripts[i];

    if (!V3_URL_REGEX.test(script.src)) {
      continue;
    }

    return script;
  }

  return null;
};

var injectScript = function injectScript(params) {
  var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
  var script = document.createElement('script');
  script.src = "".concat(V3_URL).concat(queryString);
  var headOrBody = document.head || document.body;

  if (!headOrBody) {
    throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
  }

  headOrBody.appendChild(script);
  return script;
};

var registerWrapper = function registerWrapper(stripe, startTime) {
  if (!stripe || !stripe._registerWrapper) {
    return;
  }

  stripe._registerWrapper({
    name: 'stripe-js',
    version: "1.54.2",
    startTime: startTime
  });
};

var stripePromise = null;
var loadScript = function loadScript(params) {
  // Ensure that we only attempt to load Stripe.js at most once
  if (stripePromise !== null) {
    return stripePromise;
  }

  stripePromise = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      // Resolve to null when imported server side. This makes the module
      // safe to import in an isomorphic code base.
      resolve(null);
      return;
    }

    if (window.Stripe && params) {
      console.warn(EXISTING_SCRIPT_MESSAGE);
    }

    if (window.Stripe) {
      resolve(window.Stripe);
      return;
    }

    try {
      var script = findScript();

      if (script && params) {
        console.warn(EXISTING_SCRIPT_MESSAGE);
      } else if (!script) {
        script = injectScript(params);
      }

      script.addEventListener('load', function () {
        if (window.Stripe) {
          resolve(window.Stripe);
        } else {
          reject(new Error('Stripe.js not available'));
        }
      });
      script.addEventListener('error', function () {
        reject(new Error('Failed to load Stripe.js'));
      });
    } catch (error) {
      reject(error);
      return;
    }
  });
  return stripePromise;
};
var initStripe = function initStripe(maybeStripe, args, startTime) {
  if (maybeStripe === null) {
    return null;
  }

  var stripe = maybeStripe.apply(undefined, args);
  registerWrapper(stripe, startTime);
  return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

// own script injection.

var stripePromise$1 = Promise.resolve().then(function () {
  return loadScript(null);
});
var loadCalled = false;
stripePromise$1["catch"](function (err) {
  if (!loadCalled) {
    console.warn(err);
  }
});
var loadStripe = function loadStripe() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  loadCalled = true;
  var startTime = Date.now();
  return stripePromise$1.then(function (maybeStripe) {
    return initStripe(maybeStripe, args, startTime);
  });
};




/***/ }),

/***/ 903:
/***/ (function(module) {

var naiveFallback = function () {
	if (typeof self === "object" && self) return self;
	if (typeof window === "object" && window) return window;
	throw new Error("Unable to resolve global `this`");
};

module.exports = (function () {
	if (this) return this;

	// Unexpected strict mode (may happen if e.g. bundled into ESM module)

	// Fallback to standard globalThis if available
	if (typeof globalThis === "object" && globalThis) return globalThis;

	// Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
	// In all ES5+ engines global object inherits from Object.prototype
	// (if you approached one that doesn't please report)
	try {
		Object.defineProperty(Object.prototype, "__global__", {
			get: function () { return this; },
			configurable: true
		});
	} catch (error) {
		// Unfortunate case of updates to Object.prototype being restricted
		// via preventExtensions, seal or freeze
		return naiveFallback();
	}
	try {
		// Safari case (window.__global__ works, but __global__ does not)
		if (!__global__) return naiveFallback();
		return __global__;
	} finally {
		delete Object.prototype.__global__;
	}
})();


/***/ }),

/***/ 965:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_187__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_187__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_187__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_187__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__nested_webpack_require_187__.d = function(exports, name, getter) {
/******/ 		if(!__nested_webpack_require_187__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__nested_webpack_require_187__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__nested_webpack_require_187__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __nested_webpack_require_187__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__nested_webpack_require_187__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __nested_webpack_require_187__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__nested_webpack_require_187__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__nested_webpack_require_187__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__nested_webpack_require_187__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_187__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_187__(__nested_webpack_require_187__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "1168":
/***/ (function(module, exports, __nested_webpack_require_3663__) {

module.exports = __nested_webpack_require_3663__("ba0c").version;


/***/ }),

/***/ "1c35":
/***/ (function(module, exports, __nested_webpack_require_3801__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __nested_webpack_require_3801__("1fb5")
var ieee754 = __nested_webpack_require_3801__("9152")
var isArray = __nested_webpack_require_3801__("e3db")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_3801__("c8ba")))

/***/ }),

/***/ "1fb5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "2b07":
/***/ (function(module, __nested_webpack_exports__, __nested_webpack_require_56648__) {

"use strict";
/* harmony export (binding) */ __nested_webpack_require_56648__.d(__nested_webpack_exports__, "a", function() { return Comment; });
/* harmony import */ var _CommentPlatform_js__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_56648__("64c9");
/* harmony import */ var _CommentPlatform_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_56648__.n(_CommentPlatform_js__WEBPACK_IMPORTED_MODULE_0__);


class Comment
{
    constructor({
      clientGeneratedId,
      id,
      message,
      image = null,
      platforms = [],
      isLoading = false,
      isDeleted = false,
      createdAt = new Date(),
    }) {
      this.clientGeneratedId = clientGeneratedId;
      this.id = id;
      this.message = message;
      this.image = image;
      this.platforms = platforms;
      this.isLoading = isLoading;
      this.isDeleted = isDeleted;
      this.createdAt = createdAt;

      platforms.forEach((rawData, key) => {
        this.platforms[key] = new _CommentPlatform_js__WEBPACK_IMPORTED_MODULE_0___default.a(rawData);
      })
    }

    get isSmucMessage() {
      return this.platforms.length === 1 && this.platforms[0].type === 'smuc';
    }

    get smucPlatform() {
      return this.platforms.filter(p => p.type === 'smuc')[0];
    }

    get facebookPlatform() {
      return this.platforms.filter(p => p.type.indexOf('facebook_') === 0)[0];
    }

    get isFacebookMessage() {
      return this.platforms.filter(p => p.type.indexOf('facebook_') === 0).length !== 0;
    }

    get name() {
      return this.platforms.length === 0 ? '' : this.platforms[0].name;
    }

    updateWith(comment) {
      Object.keys(comment).forEach(key => {
        this[key] = comment[key];
      });
    }
};


/***/ }),

/***/ "37e1":
/***/ (function(module) {

module.exports = JSON.parse("{\"You\":\"Te\",\"Ban\":\"Tiltás\",\"Unban\":\"Tiltás feloldása\",\"Delete\":\"Törlés\",\"Recover\":\"Viszzaállítás\",\"Deleted\":\"Törölve\",\"Banned user\":\"Tiltott felhasználó\",\"Pinned comment\":\"Kiemelt hozzászólás\"}");

/***/ }),

/***/ "3b89":
/***/ (function(module, __nested_webpack_exports__, __nested_webpack_require_58766__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony export (binding) */ __nested_webpack_require_58766__.d(__nested_webpack_exports__, "a", function() { return WsClientEvents; });
/* unused harmony export WsClient */
/* unused harmony export HasNoFreeViewerCapacityError */
/* harmony import */ var _Comment_js__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_58766__("2b07");
/* harmony import */ var websocket__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_58766__("7e3c");
/* harmony import */ var websocket__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__nested_webpack_require_58766__.n(websocket__WEBPACK_IMPORTED_MODULE_1__);



const WsClientEvents = {
  ERROR: 'error',
  WS_CONNECT: 'wsConnect',
  WS_CLOSE: 'wsClose',
  WS_MESSAGE: 'wsMessage',
  JOINED: 'joined',
  INFO: 'info',
  STREAM_STATUS_CHANGED: 'streamStatusChanged',
  CHAT_BANNED: 'chatBanned',
  CHAT_UNBANNED: 'chatUnbanned',
  CHAT_MESSAGE: 'chatMessage',
  CHAT_MESSAGES: 'chatMessages',
  CHAT_MESSAGE_DELETED: 'chatMessageDeleted',
  CHAT_MESSAGE_DELETE_FEEDBACK: 'chatMessageDeleteFeedback',
  CHAT_FEEDBACK: 'chatFeedback',
  CHAT_MESSAGE_RECOVERED: 'chatMessageRecovered',
  CHAT_MESSAGE_RECOVER_FEEDBACK: 'chatMessageRecoverFeedback',
  CHAT_MESSAGE_PINNED: 'chatMessagePinned',
  CHAT_MESSAGE_PIN_FEEDBACK: 'chatMessagePinFeedback',
  CHAT_MESSAGE_UNPINNED: 'chatMessageUnpinned',
  CHAT_MESSAGE_UNPIN_FEEDBACK: 'chatMessageUnpinFeedback',
  HEART: 'heart',
  FEED_INFO: 'feedInfo',
}

class WsClient {

  constructor({ wsUrl, apiKey, isAdmin = false, clientPrivateKey = null, serverPublicKey = null }) {
    if (clientPrivateKey && serverPublicKey) {
      this._loadKeys(clientPrivateKey, serverPublicKey);
    }

    this._clientId = this._generateClientId();

    this._wsUrl = wsUrl;
    this._apiKey = apiKey;
    this._isAdmin = isAdmin;

    this._closedManually = false;
    this._isConnected = false
    this._isJoined = false;
    this._isPlaying = false;
    this._isBanned = false;
    this._userId = 0;
    this._chatMessagesBuffer = [];
    this._eventListeners = {};

    this._sendPlayTimer = null;

    this._chatName = '';

    this._connect();
  }

  async _loadKeys(decryptKey, encryptKey) {
    let promises = [];
    promises.push(
      crypto.subtle.importKey(
        'pkcs8',
        Buffer.from(decryptKey, 'base64'),
        { name: 'RSA-OAEP', hash: { name: 'SHA-256' } },
        true,
        ['decrypt']
      )
    );
    promises.push(
      crypto.subtle.importKey(
        'spki',
        Buffer.from(encryptKey, 'base64'),
        { name: 'RSA-OAEP', hash: { name: 'SHA-256' } },
        true,
        ['encrypt']
      )
    );

    Promise.all(promises)
      .then(keys => {
        this._decryptKey = keys[0];
        this._encryptKey = keys[1];
      })
      .catch(err => {
        this._decryptKey = null;
        this._encryptKey = null;
        this._log('Encrypt or decrypt key import error');
        console.error(err);
      });
  }

  async _encryptMessage(message) {
    try {
      const iv = crypto.getRandomValues(new Uint8Array(16));
      const encrypted = await crypto.subtle.encrypt(
        { name: 'RSA-OAEP', iv },
        this._encryptKey,
        Buffer.from(message),
      );

      return Buffer.from(encrypted).toString('base64') + '.' + Buffer.from(iv).toString('base64');
    }
    catch (err) {
      this._log('Message encryption error.');
      console.error(err);
    }

    return message;
  }

  async _decryptMessage(message) {
    if (typeof message !== 'string' || message.length === 0 || message[0] === '{') {
      return message;
    }

    let result = '';

    try {
      const chunks = message.split('-');
      for (let chunk of chunks) {
        const parts = chunk.split('.', 2);
        const encryptedMessage = Buffer.from(parts[0], 'base64');
        const iv = Buffer.from(parts[1], 'base64');

        const content = await crypto.subtle.decrypt(
          { name: 'RSA-OAEP', iv },
          this._decryptKey,
          encryptedMessage
        );
        result += (new TextDecoder()).decode(content);
      }
    }
    catch (err) {
      this._log('Message decryption error.');
      console.error(err);
      result = '{}';
    }

    return result;
  }

  _connect() {
    let url = this._wsUrl;
    if (this._apiKey) {
      url += '/' + this._apiKey + '?client_id=' + this._clientId;
    }

    this._client = new websocket__WEBPACK_IMPORTED_MODULE_1__["w3cwebsocket"](url);
    this._client.onerror = (err) => this._onError(err);
    this._client.onopen = () => this._onConnect();
    this._client.onclose = (event) => this._onClose(event);
    this._client.onmessage = (message) => this._onMessage(message);
  }

  addEventListener(event, callback, listenerId) {
    if (!this._eventListeners[event]) {
      this._eventListeners[event] = [];
    }

    this._eventListeners[event].push({ callback, listenerId });

    if (event === WsClientEvents.CHAT_MESSAGES && this._chatMessagesBuffer.length !== 0) {
      this._chatMessagesBuffer.forEach(item => {
        this._fireEvent(event, item);
      });
      this._chatMessagesBuffer = [];
    }
  }

  removeEventListener(event, callback) {
    if (!this._eventListeners[event]) {
      return;
    }

    this._eventListeners[event] = this._eventListeners[event].filter(item => item.callback != callback);
  }

  get isConnected() {
    return this._isConnected;
  }

  get isJoined() {
    return this._isJoined;
  }

  get isBanned() {
    return this._isBanned;
  }

  get userId() {
    return this._userId;
  }

  set chatName(val) {
    this._chatName = val.toString().trim();
  }

  _onConnect(connection) {
    this._isConnected = true;
    this._log('Conncetion is live');
    this._fireEvent(WsClientEvents.WS_CONNECT, connection);

    if (this._isPlaying) {
      this.play();
    }

    setTimeout(() => {
      if (!this._isJoined) {
        this.disconnect();
        this._connect();
      }
    }, 2000);
  }

  _onError(error) {
    this._log('WS connection error');
    console.error(error);
    this._fireEvent(WsClientEvents.ERROR, error);
  }

  _onClose(event) {
    console.log('WS Close code: ' + event.code);

    this._isConnected = false;
    this._isJoined = false;
    this._log('Connection Closed');
    this._fireEvent(WsClientEvents.WS_CLOSE);

    if (!this._closedManually) {
      setTimeout(() => this._connect(), 500);
    }
  }

  async _onMessage(message) {
    try {
      let messageContent = message.data;
      if (this._encryptKey && this._decryptKey) {
        messageContent = await this._decryptMessage(message.data);
      }

      this._fireEvent(WsClientEvents.WS_MESSAGE, messageContent);

      const parsedMessage = JSON.parse(messageContent);
      this._processMessage(parsedMessage);
    }
    catch (err) {
      console.error(err);
    }
  }

  getInfo() {
    const msg = {
      command: 'getinfo',
    };

    this._submit(msg);
  }

  play() {
    this._isPlaying = true;

    if (this._sendPlayTimer !== null) {
      clearTimeout(this._sendPlayTimer);
      this._sendPlayTimer = null;
    }

    this._sendPlayTimer = setTimeout(() => {
      this._sendPlayTimer = null;
      this._submit({ command: 'play' })
    }, 250);
  }

  pause() {
    this._isPlaying = false;

    if (this._sendPlayTimer !== null) {
      clearTimeout(this._sendPlayTimer);
      this._sendPlayTimer = null;
    }
    else {
      this._submit({ command: 'pause' });
    }
  }

  chatMessage(message, sendTo) {
    if (this._isBanned) {
      throw new Error('You are currently banned, so you cannot post messages.');
    }

    const clientGeneratedId = Array(32).fill().map(() => 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'.charAt(Math.random()*62)).join('');

    const msg = {
      command: 'chat',
      name: this._chatName,
      message,
      clientGeneratedId,
      sendTo,
    };

    this._submit(msg);

    const comment = new _Comment_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]({
      clientGeneratedId,
      message,
      isLoading: true,
    });

    return comment;
  }

  chatGetMessages({ before = new Date(), limit = 20 }) {
    const msg = {
      command: 'getChatMessages',
      before: before.getTime(),
      limit,
      isAdmin: this._isAdmin,
    };

    this._submit(msg);
  }

  chatBan({ userId }) {
    const msg = {
      command: 'ban',
      bannedUserId: userId,
    };

    this._submit(msg);
  }

  chatUnban({ userId }) {
    const msg = {
      command: 'unban',
      bannedUserId: userId,
    };

    this._submit(msg);
  }

  chatMessageDelete(messageId) {
    const msg = {
      command: 'messageDelete',
      messageId,
    };

    this._submit(msg);
  }

  chatMessageRecover(messageId) {
    const msg = {
      command: 'messageRecover',
      messageId,
    };

    this._submit(msg);
  }

  chatMessagePin(messageId) {
    const msg = {
      command: 'messagePin',
      messageId,
    };

    this._submit(msg);
  }

  chatMessageUnpin() {
    const msg = {
      command: 'messageUnpin',
    };

    this._submit(msg);
  }

  feedInfo(content) {
    const msg = {
      command: 'feedinfo',
      feedInfo: content,
    };

    this._submit(msg);
  }

  heart() {
    const msg = {
      command: 'heart',
    };

    this._submit(msg);
  }

  async _submit(message) {
    message['apiKey'] = this._apiKey;
    message['userId'] = this._userId;
    message['ts'] = Date.now();

    if (this._client.readyState === this._client.OPEN) {
      message = JSON.stringify(message);
      if (this._encryptKey && this._decryptKey) {
        message = await this._encryptMessage(message);
      }

      this._client.send(message);
    }
  }

  _processMessage(message) {
    switch (message.error) {
      case 'hasNoFreeViewerCapacity':
        return this._processErrorHasNoFreeViewerCapacity(message);
    }

    switch (message.command) {
      case 'joined':
        return this._processMessageJoined(message);

      case 'info':
        return this._processMessageInfo(message);

      case 'chat':
        return this._processMessageChat(message);

      case 'chatMessages':
        return this._processMessageChatMessages(message);

      case 'banned':
        return this._processMessageBanned(message);

      case 'unbanned':
        return this._processMessageUnbanned(message);

      case 'messageDeleted':
        return this._processMessageDeleted(message);

      case 'messageRecovered':
        return this._processMessageRecovered(message);

      case 'messagePinned':
        return this._processMessagePinned(message);

      case 'messageUnpinned':
        return this._processMessageUnpinned(message);

      case 'heart':
        return this._processMessageHeart(message);

      case 'feedinfo':
        return this._processMessageFeedInfo(message);

      case 'streamStatusChange':
        return this._processMessageStreamStatusChange(message);

      case 'chatFeedback':
        return this._processMessageChatFeedback(message);

      case 'chatMessageDeleteFeedback':
        return this._processMessageChatMessageDeleteFeedback(message);

      case 'chatMessageRecoverFeedback':
        return this._processMessageChatMessageRecoverFeedback(message);

      case 'chatMessagePinFeedback':
        return this._processMessageChatMessagePinFeedback(message);

      case 'chatMessageUnpinFeedback':
        return this._processMessageChatMessageUnpinFeedback(message);

      default:
        this._log('An unreadable message was received from the server.', 'warn');
        console.warn(message);
    }
  }

  _processMessageJoined(message) {
    this._log('Joined to chat room (' + this._apiKey + ')');

    this._userId = message.userId;
    this._isJoined = true;
    this._fireEvent(WsClientEvents.JOINED, message);

    if (
      'feedInfo' in message
      && Array.isArray(message.feedInfo)
      && message.feedInfo.length !== 0
    ) {
      this._processMessageFeedInfo(message);
    }
  }

  _processMessageInfo(message) {
    this._fireEvent(WsClientEvents.INFO, message);
  }

  _processMessageChat(message) {
    const comment = new _Comment_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]({
      id: message.data.id,
      message: message.data.message,
      image: message.data.image,
      isDeleted: message.data.isDeleted,
      platforms: message.data.platforms,
      createdAt: new Date(message.data.createdAt),
    });

    this._fireEvent(WsClientEvents.CHAT_MESSAGE, comment);
  }

  _processMessageChatMessages(message) {
    let comments = [];
    message.data.forEach(item => {
      const comment = new _Comment_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]({
        id: item.id,
        message: item.message,
        image: item.image,
        isDeleted: item.isDeleted,
        platforms: item.platforms,
        createdAt: new Date(item.createdAt),
      });
      comments.push(comment);
    });

    if (!this._hasListener(WsClientEvents.CHAT_MESSAGES)) {
      this._chatMessagesBuffer.push({ comments, pinned: message.pinned });
      return;
    }

    this._fireEvent(WsClientEvents.CHAT_MESSAGES, { comments, pinned: message.pinned });
  }

  _processMessageBanned(message) {
    this._isBanned = true;
    this._fireEvent(WsClientEvents.CHAT_BANNED, message);
  }

  _processMessageUnbanned(message) {
    this._isBanned = false;
    this._fireEvent(WsClientEvents.CHAT_UNBANNED, message);
  }

  _processMessageDeleted(message) {
    this._fireEvent(WsClientEvents.CHAT_MESSAGE_DELETED, message);
  }

  _processMessageRecovered(message) {
    this._fireEvent(WsClientEvents.CHAT_MESSAGE_RECOVERED, message);
  }

  _processMessagePinned(message) {
    const comment = new _Comment_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](message.data);
    this._fireEvent(WsClientEvents.CHAT_MESSAGE_PINNED, comment);
  }

  _processMessageUnpinned(message) {
    this._fireEvent(WsClientEvents.CHAT_MESSAGE_UNPINNED, message);
  }

  _processMessageHeart(message) {
    this._fireEvent(WsClientEvents.HEART, message);
  }

  _processMessageFeedInfo(message) {
    this._fireEvent(WsClientEvents.FEED_INFO, message.feedInfo);
  }

  _processMessageStreamStatusChange(message) {
    this._fireEvent(WsClientEvents.STREAM_STATUS_CHANGED, message.status);
  }

  _processMessageChatFeedback(message) {
    const success = message.success;
    let comment = null;

    if (success) {
      comment = new _Comment_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](message.data);
      if (comment.smucPlatform) {
        comment.smucPlatform.name = 'You';
      }
    }

    this._fireEvent(WsClientEvents.CHAT_FEEDBACK, { success, comment });
  }

  _processMessageChatMessageDeleteFeedback(message) {
    this._fireEvent(WsClientEvents.CHAT_MESSAGE_DELETE_FEEDBACK, message);
  }

  _processMessageChatMessageRecoverFeedback(message) {
    this._fireEvent(WsClientEvents.CHAT_MESSAGE_RECOVER_FEEDBACK, message);
  }

  _processMessageChatMessagePinFeedback(message) {
    this._fireEvent(WsClientEvents.CHAT_MESSAGE_PIN_FEEDBACK, message);
  }

  _processMessageChatMessageUnpinFeedback(message) {
    this._fireEvent(WsClientEvents.CHAT_MESSAGE_UNPIN_FEEDBACK, message);
  }

  _processErrorHasNoFreeViewerCapacity(message) {
    const error = new HasNoFreeViewerCapacityError();
    this._fireEvent(WsClientEvents.ERROR, error);
    this.disconnect();
  }

  disconnect() {
    this._closedManually = true;
    this._client.close();
  }

  _fireEvent(event, payload) {
    if (!this._hasListener(event)) {
      return;
    }

    this._eventListeners[event].forEach(item => item.callback(payload, item.listenerId));
  }

  _hasListener(event) {
    return event in this._eventListeners;
  }

  _log(content, type) {
    if (!type) {
      type = 'info';
    }

    console[type]('[WS Client] ' + content);
  }

  _generateClientId() {
    if (window && window.crypto && window.crypto.randomUUID) {
      return window.crypto.randomUUID();
    }

    return (Math.random() + 1).toString(36).substring(2, 8) +
      '-' + (Math.random() + 1).toString(36).substring(2, 4) +
      '-' + (Math.random() + 1).toString(36).substring(2, 4) +
      '-' + (Math.random() + 1).toString(36).substring(2, 4) +
      '-' + (Math.random() + 1).toString(36).substring(2, 6) + (Math.random() + 1).toString(36).substring(2, 6);
  }

}

class HasNoFreeViewerCapacityError extends Error {
  constructor() {
    super();
    this.message = 'You cannot join at this time because the broadcast has reached the maximum number of viewers.';
  }
}

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_58766__("1c35").Buffer))

/***/ }),

/***/ "64c9":
/***/ (function(module, exports) {

module.exports = class CommentPlatform
{
  constructor({
    type,
    id,
    userId,
    name,
    commentId,
  }) {
    this.type = type;
    this.id = id;
    this.userId = userId;
    this.name = name;
    this.commentId = commentId;
  }

  get platformServiceId() {
    return this.type + '_' + this.id;
  }
};


/***/ }),

/***/ "6787":
/***/ (function(module, exports) {

var naiveFallback = function () {
	if (typeof self === "object" && self) return self;
	if (typeof window === "object" && window) return window;
	throw new Error("Unable to resolve global `this`");
};

module.exports = (function () {
	if (this) return this;

	// Unexpected strict mode (may happen if e.g. bundled into ESM module)

	// Fallback to standard globalThis if available
	if (typeof globalThis === "object" && globalThis) return globalThis;

	// Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
	// In all ES5+ engines global object inherits from Object.prototype
	// (if you approached one that doesn't please report)
	try {
		Object.defineProperty(Object.prototype, "__global__", {
			get: function () { return this; },
			configurable: true
		});
	} catch (error) {
		// Unfortunate case of updates to Object.prototype being restricted
		// via preventExtensions, seal or freeze
		return naiveFallback();
	}
	try {
		// Safari case (window.__global__ works, but __global__ does not)
		if (!__global__) return naiveFallback();
		return __global__;
	} finally {
		delete Object.prototype.__global__;
	}
})();


/***/ }),

/***/ "7e3c":
/***/ (function(module, exports, __nested_webpack_require_77070__) {

var _globalThis;
if (typeof globalThis === 'object') {
	_globalThis = globalThis;
} else {
	try {
		_globalThis = __nested_webpack_require_77070__("6787");
	} catch (error) {
	} finally {
		if (!_globalThis && typeof window !== 'undefined') { _globalThis = window; }
		if (!_globalThis) { throw new Error('Could not determine global this'); }
	}
}

var NativeWebSocket = _globalThis.WebSocket || _globalThis.MozWebSocket;
var websocket_version = __nested_webpack_require_77070__("1168");


/**
 * Expose a W3C WebSocket class with just one or two arguments.
 */
function W3CWebSocket(uri, protocols) {
	var native_instance;

	if (protocols) {
		native_instance = new NativeWebSocket(uri, protocols);
	}
	else {
		native_instance = new NativeWebSocket(uri);
	}

	/**
	 * 'native_instance' is an instance of nativeWebSocket (the browser's WebSocket
	 * class). Since it is an Object it will be returned as it is when creating an
	 * instance of W3CWebSocket via 'new W3CWebSocket()'.
	 *
	 * ECMAScript 5: http://bclary.com/2004/11/07/#a-13.2.2
	 */
	return native_instance;
}
if (NativeWebSocket) {
	['CONNECTING', 'OPEN', 'CLOSING', 'CLOSED'].forEach(function(prop) {
		Object.defineProperty(W3CWebSocket, prop, {
			get: function() { return NativeWebSocket[prop]; }
		});
	});
}

/**
 * Module exports.
 */
module.exports = {
    'w3cwebsocket' : NativeWebSocket ? W3CWebSocket : null,
    'version'      : websocket_version
};


/***/ }),

/***/ "85fe":
/***/ (function(module, __nested_webpack_exports__, __nested_webpack_require_78569__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __nested_webpack_require_78569__.d(__nested_webpack_exports__, "a", function() { return ObserveVisibility; });
/* unused harmony export install */
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function processOptions(value) {
  var options;

  if (typeof value === 'function') {
    // Simple options (callback-only)
    options = {
      callback: value
    };
  } else {
    // Options object
    options = value;
  }

  return options;
}
function throttle(callback, delay) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var timeout;
  var lastState;
  var currentArgs;

  var throttled = function throttled(state) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    currentArgs = args;
    if (timeout && state === lastState) return;
    var leading = options.leading;

    if (typeof leading === 'function') {
      leading = leading(state, lastState);
    }

    if ((!timeout || state !== lastState) && leading) {
      callback.apply(void 0, [state].concat(_toConsumableArray(currentArgs)));
    }

    lastState = state;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      callback.apply(void 0, [state].concat(_toConsumableArray(currentArgs)));
      timeout = 0;
    }, delay);
  };

  throttled._clear = function () {
    clearTimeout(timeout);
    timeout = null;
  };

  return throttled;
}
function deepEqual(val1, val2) {
  if (val1 === val2) return true;

  if (_typeof(val1) === 'object') {
    for (var key in val1) {
      if (!deepEqual(val1[key], val2[key])) {
        return false;
      }
    }

    return true;
  }

  return false;
}

var VisibilityState =
/*#__PURE__*/
function () {
  function VisibilityState(el, options, vnode) {
    _classCallCheck(this, VisibilityState);

    this.el = el;
    this.observer = null;
    this.frozen = false;
    this.createObserver(options, vnode);
  }

  _createClass(VisibilityState, [{
    key: "createObserver",
    value: function createObserver(options, vnode) {
      var _this = this;

      if (this.observer) {
        this.destroyObserver();
      }

      if (this.frozen) return;
      this.options = processOptions(options);

      this.callback = function (result, entry) {
        _this.options.callback(result, entry);

        if (result && _this.options.once) {
          _this.frozen = true;

          _this.destroyObserver();
        }
      }; // Throttle


      if (this.callback && this.options.throttle) {
        var _ref = this.options.throttleOptions || {},
            _leading = _ref.leading;

        this.callback = throttle(this.callback, this.options.throttle, {
          leading: function leading(state) {
            return _leading === 'both' || _leading === 'visible' && state || _leading === 'hidden' && !state;
          }
        });
      }

      this.oldResult = undefined;
      this.observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];

        if (entries.length > 1) {
          var intersectingEntry = entries.find(function (e) {
            return e.isIntersecting;
          });

          if (intersectingEntry) {
            entry = intersectingEntry;
          }
        }

        if (_this.callback) {
          // Use isIntersecting if possible because browsers can report isIntersecting as true, but intersectionRatio as 0, when something very slowly enters the viewport.
          var result = entry.isIntersecting && entry.intersectionRatio >= _this.threshold;
          if (result === _this.oldResult) return;
          _this.oldResult = result;

          _this.callback(result, entry);
        }
      }, this.options.intersection); // Wait for the element to be in document

      vnode.context.$nextTick(function () {
        if (_this.observer) {
          _this.observer.observe(_this.el);
        }
      });
    }
  }, {
    key: "destroyObserver",
    value: function destroyObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      } // Cancel throttled call


      if (this.callback && this.callback._clear) {
        this.callback._clear();

        this.callback = null;
      }
    }
  }, {
    key: "threshold",
    get: function get() {
      return this.options.intersection && typeof this.options.intersection.threshold === 'number' ? this.options.intersection.threshold : 0;
    }
  }]);

  return VisibilityState;
}();

function bind(el, _ref2, vnode) {
  var value = _ref2.value;
  if (!value) return;

  if (typeof IntersectionObserver === 'undefined') {
    console.warn('[vue-observe-visibility] IntersectionObserver API is not available in your browser. Please install this polyfill: https://github.com/w3c/IntersectionObserver/tree/master/polyfill');
  } else {
    var state = new VisibilityState(el, value, vnode);
    el._vue_visibilityState = state;
  }
}

function update(el, _ref3, vnode) {
  var value = _ref3.value,
      oldValue = _ref3.oldValue;
  if (deepEqual(value, oldValue)) return;
  var state = el._vue_visibilityState;

  if (!value) {
    unbind(el);
    return;
  }

  if (state) {
    state.createObserver(value, vnode);
  } else {
    bind(el, {
      value: value
    }, vnode);
  }
}

function unbind(el) {
  var state = el._vue_visibilityState;

  if (state) {
    state.destroyObserver();
    delete el._vue_visibilityState;
  }
}

var ObserveVisibility = {
  bind: bind,
  update: update,
  unbind: unbind
};

function install(Vue) {
  Vue.directive('observe-visibility', ObserveVisibility);
  /* -- Add more components here -- */
}
/* -- Plugin definition & Auto-install -- */

/* You shouldn't have to modify the code below */
// Plugin

var plugin = {
  // eslint-disable-next-line no-undef
  version: "1.0.0",
  install: install
};

var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

/* unused harmony default export */ var _unused_webpack_default_export = (plugin);


/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_78569__("c8ba")))

/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __webpack_require__(100);

/***/ }),

/***/ "907d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9152":
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "ba0c":
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"websocket\",\"description\":\"Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.\",\"keywords\":[\"websocket\",\"websockets\",\"socket\",\"networking\",\"comet\",\"push\",\"RFC-6455\",\"realtime\",\"server\",\"client\"],\"author\":\"Brian McKelvey <theturtle32@gmail.com> (https://github.com/theturtle32)\",\"contributors\":[\"Iñaki Baz Castillo <ibc@aliax.net> (http://dev.sipdoc.net)\"],\"version\":\"1.0.34\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/theturtle32/WebSocket-Node.git\"},\"homepage\":\"https://github.com/theturtle32/WebSocket-Node\",\"engines\":{\"node\":\">=4.0.0\"},\"dependencies\":{\"bufferutil\":\"^4.0.1\",\"debug\":\"^2.2.0\",\"es5-ext\":\"^0.10.50\",\"typedarray-to-buffer\":\"^3.1.5\",\"utf-8-validate\":\"^5.0.2\",\"yaeti\":\"^0.0.6\"},\"devDependencies\":{\"buffer-equal\":\"^1.0.0\",\"gulp\":\"^4.0.2\",\"gulp-jshint\":\"^2.0.4\",\"jshint-stylish\":\"^2.2.1\",\"jshint\":\"^2.0.0\",\"tape\":\"^4.9.1\"},\"config\":{\"verbose\":false},\"scripts\":{\"test\":\"tape test/unit/*.js\",\"gulp\":\"gulp\"},\"main\":\"index\",\"directories\":{\"lib\":\"./lib\"},\"browser\":\"lib/browser.js\",\"license\":\"Apache-2.0\"}");

/***/ }),

/***/ "c5c8":
/***/ (function(module) {

module.exports = JSON.parse("{\"You\":\"Du\",\"Banned user\":\"Benutzer gebannt\",\"Pinned comment\":\"Gepinnter Kommentar\"}");

/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "e3db":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "fb15":
/***/ (function(module, __nested_webpack_exports__, __nested_webpack_require_91269__) {

"use strict";
// ESM COMPAT FLAG
__nested_webpack_require_91269__.r(__nested_webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __nested_webpack_require_91269__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/assets/scss/styles.scss
var styles = __nested_webpack_require_91269__("907d");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"21afa060-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ChatView.vue?vue&type=template&id=7876e3cc&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollWrapper",class:_vm.wrapperClasses,on:{"scroll":_vm.onScrollY}},[(_vm.showFloatingPinnedMessage && _vm.sharedData.pinnedMessage)?_c('floating-pinned-message',{attrs:{"language":_vm.language,"ws-client":_vm.wsClient,"background-color":_vm.buttonColor,"text-color":_vm.textColor,"name":_vm.getName(_vm.sharedData.pinnedMessage),"message":_vm.sharedData.pinnedMessage.message,"is-admin":_vm.isAdmin,"hide":_vm.pinnedMessageHide},on:{"close":_vm.closeFloatingPinnedMessage}}):_vm._e(),_c('div',{staticClass:"s8f33"},[(_vm.isJoined)?_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.infiniteHandler),expression:"infiniteHandler"}]}):_vm._e(),(_vm.showLoader && (_vm.sharedData.isLoading || !_vm.sharedData.firstMessagesReceived))?_c('div',{class:'new-messages-on-the-way ' + (_vm.isEmpty ? 'has-no-message-yes' : '')},[_c('i',{staticClass:"s521b s4a52",style:('background-color: ' + _vm.buttonColor)})]):(!_vm.sharedData.isLoading && _vm.isEmpty)?_c('div',{staticClass:"sdf6d"},[_c('colorizable-no-messages-yet',{attrs:{"color":_vm.buttonColor,"opacity":0.6}}),(_vm.noMessagesText.length > 0)?_c('span',[_vm._v(_vm._s(_vm.noMessagesText))]):_vm._e()],1):_vm._e(),_vm._l((_vm.filteredMessages),function(item,key){return [_c('div',{key:'chat-message--' + key,class:_vm.messageClasses(item)},[(item.isLoading)?_c('i',{staticClass:"sbaec s4a52"}):_vm._l((item.platforms),function(platform,platformKey){return _c('i',{key:'platform--' + item.id + '--' + platformKey,class:_vm.platformIconClasses(platform)})}),_c('a',{staticClass:"sb068",attrs:{"href":_vm.messageSenderLink(item),"target":"_blank"}},[_vm._v(_vm._s(_vm.getName(item)))]),_vm._v(" "+_vm._s(item.message)+" "),(item.image)?_c('div',{staticClass:"s7880"},[_c('img',{attrs:{"src":item.image}})]):_vm._e()],2),(_vm.isAdmin)?_c('div',{key:'chat-message--' + key + '--actions',staticClass:"actions"},[_c('button',{class:'admin-button ' + (!_vm.messageIsPinned(item) ? 'pin' : 'unpin'),on:{"click":() => _vm.pinOrUnpin(item)}},[(_vm.messageBeingPinnedOrUnpinned === item.id)?_c('i',{staticClass:"sbaec s4a52 sd508"}):(!_vm.messageIsPinned(item))?_c('i',{staticClass:"sbaec s8a6f sd508"}):_c('i',{staticClass:"sbaec s280f sd508"}),_vm._v(" "+_vm._s(!_vm.messageIsPinned(item) ? _vm.tr('Pin') : _vm.tr('Unpin'))+" ")]),(!item.isDeleted)?_c('button',{staticClass:"admin-button delete",attrs:{"disabled":_vm.messageBeingDeleted !== null},on:{"click":() => _vm.deleteMessage(item)}},[(_vm.messageBeingDeleted === item.id)?[_c('i',{staticClass:"sbaec s4a52 sd508"})]:[_c('i',{staticClass:"sbaec trash sd508"})],_vm._v(" "+_vm._s(_vm.tr('Delete'))+" ")],2):(_vm.messageIsRecoverable(item))?_c('button',{staticClass:"admin-button recover",attrs:{"disabled":_vm.messageBeingRecovered !== null},on:{"click":() => _vm.recoverMessage(item)}},[(_vm.messageBeingRecovered === item.id)?[_c('i',{staticClass:"sbaec s4a52 sd508"})]:[_c('i',{staticClass:"sbaec recover sd508"})],_vm._v(" "+_vm._s(_vm.tr('Recover'))+" ")],2):_c('button',{staticClass:"admin-button recover",attrs:{"disabled":""}},[_vm._v(" "+_vm._s(_vm.tr('Deleted'))+" ")]),(_vm.banButtonIsVisible(item))?_c('button',{staticClass:"admin-button ban",on:{"click":() => _vm.toggleBan(item.smucPlatform.userId)}},[(!_vm.userIsBanner(item.smucPlatform.userId))?[_c('i',{staticClass:"sbaec ban sd508"}),_vm._v(" "+_vm._s(_vm.tr('Ban'))+" ")]:[_c('i',{staticClass:"sbaec unban sd508"}),_vm._v(" "+_vm._s(_vm.tr('Unban'))+" ")]],2):_vm._e()]):_vm._e()]})],2)],1)
}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ChatView.vue?vue&type=template&id=7876e3cc&

// CONCATENATED MODULE: ./src/mixins/Translator.js
const translations = {
  'hu': __nested_webpack_require_91269__("37e1"),
  'de': __nested_webpack_require_91269__("c5c8"),
};

function replaceParameters(str, params) {
  if (params) {
    Object.keys(params).forEach(param => {
      str = str.replaceAll(param, params[param]);
    });
  }

  return str;
}

/* harmony default export */ var Translator = ({
  props: {
    language: {
      type: String,
      required: false,
      default() {
        return 'en';
      },
    },
  },
  methods: {
    tr(str, params) {
      if (this.language === 'en') {
        return replaceParameters(str, params);
      }

      if (translations[this.language] && translations[this.language][str]) {
        return replaceParameters(translations[this.language][str], params);
      }

      if (false) {}

      return replaceParameters(str, params);
    }
  },
});

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"21afa060-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ColorizableNoMessagesYet.vue?vue&type=template&id=15ac3416&
var ColorizableNoMessagesYetvue_type_template_id_15ac3416_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 250 113","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"10","y":"10","width":"178","height":"50","rx":"10","fill":"white","filter":`url(#shadowtopbox${_vm.rnd})`}}),_c('rect',{attrs:{"x":"49","y":"22","width":"115","height":"10","rx":"5","fill":_vm.color,"fill-opacity":_vm.opacity}}),_c('rect',{attrs:{"x":"49","y":"38","width":"71.9847","height":"10","rx":"5","fill":_vm.color,"fill-opacity":_vm.opacity}}),_c('circle',{attrs:{"cx":"32.5","cy":"35.5","r":"9.5","fill":_vm.color,"fill-opacity":_vm.opacity}}),_c('rect',{attrs:{"x":"62","y":"53","width":"178","height":"50","rx":"10","fill":"white","filter":`url(#shadowbottombox${_vm.rnd})`}}),_c('rect',{attrs:{"x":"101","y":"65","width":"115","height":"10","rx":"5","fill":_vm.color,"fill-opacity":_vm.opacity}}),_c('rect',{attrs:{"x":"101","y":"81","width":"71.9847","height":"10","rx":"5","fill":_vm.color,"fill-opacity":_vm.opacity}}),_c('circle',{attrs:{"cx":"84.5","cy":"78.5","r":"9.5","fill":_vm.color,"fill-opacity":_vm.opacity}}),_c('defs',[_c('filter',{attrs:{"id":`shadowtopbox${_vm.rnd}`,"color-interpolation-filters":"sRGB"}},[_c('feDropShadow',{attrs:{"dx":"0","dy":"0","stdDeviation":"3","flood-opacity":"0.1"}})],1),_c('filter',{attrs:{"id":`shadowbottombox${_vm.rnd}`,"color-interpolation-filters":"sRGB"}},[_c('feDropShadow',{attrs:{"dx":"0","dy":"0","stdDeviation":"3","flood-opacity":"0.1"}})],1)])])
}
var ColorizableNoMessagesYetvue_type_template_id_15ac3416_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ColorizableNoMessagesYet.vue?vue&type=template&id=15ac3416&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ColorizableNoMessagesYet.vue?vue&type=script&lang=js&

/* harmony default export */ var ColorizableNoMessagesYetvue_type_script_lang_js_ = ({
  name: 'ColorizableNoMessagesYet',
  props: {
    color: {
      type: String,
      required: true,
      validator: v => /(#[a-fA-F0-9]{6}|(rgb(a)?\(([0-1][0-9][0-9]|2[0-4][0-9]|25[0-5]|[0-9][0-9]|[0-9])(,([0-1][0-9][0-9]|2[0-4][0-9]|25[0-5]|[0-9][0-9]|[0-9])){2}(,(1|(0(\.\d*)?)))?\)))/.exec(v.replace(/\s+/, '')) !== null,
    },
    opacity: {
      type: [String, Number],
      required: false,
      validator: v => {
        let _v = v
        if (typeof v === 'string') {
          _v = parseInt(v, 10)
        }

        return _v >= 0 && _v <= 1
      }
    }
  },
  data() {
    return {
      rnd: '',
    }
  },
  created() {
    this.rnd = (Math.random() + 1).toString(36).substring(6)
  },
});

// CONCATENATED MODULE: ./src/components/ColorizableNoMessagesYet.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ColorizableNoMessagesYetvue_type_script_lang_js_ = (ColorizableNoMessagesYetvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/ColorizableNoMessagesYet.vue





/* normalize component */

var component = normalizeComponent(
  components_ColorizableNoMessagesYetvue_type_script_lang_js_,
  ColorizableNoMessagesYetvue_type_template_id_15ac3416_render,
  ColorizableNoMessagesYetvue_type_template_id_15ac3416_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ColorizableNoMessagesYet = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"21afa060-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/FloatingPinnedMessage.vue?vue&type=template&id=0e68bc42&
var FloatingPinnedMessagevue_type_template_id_0e68bc42_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"floatingPinnedMessage",class:_vm.wrapperClasses,style:(_vm.wrapperStyle)},[(!_vm.isAdmin)?_c('div',{staticClass:"s7b69",on:{"click":() => _vm.$emit('close')}},[_c('i',{staticClass:"s521b s716f",style:(_vm.iconStyle)})]):_vm._e(),_c('label',[_vm._v(" "+_vm._s(_vm.tr('Pinned comment'))+" "),_c('i',{class:_vm.pinIconClasses,style:(_vm.iconStyle),on:{"click":_vm.unpin}})]),_c('div',[_c('div',{staticClass:"sb068"},[_vm._v(_vm._s(_vm.name)+": ")]),_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var FloatingPinnedMessagevue_type_template_id_0e68bc42_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FloatingPinnedMessage.vue?vue&type=template&id=0e68bc42&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/FloatingPinnedMessage.vue?vue&type=script&lang=js&



/* harmony default export */ var FloatingPinnedMessagevue_type_script_lang_js_ = ({
  name: 'FloatingPinnedMessage',
  mixins: [ Translator ],
  props: {
    wsClient: {
      required: false,
      validator: (value) => {
        if (value === null) {
          return true;
        }

        if (
          typeof value === 'object'
          && value.constructor
          && value.constructor.name
          && value.constructor.name === 'WsClient'
        ) {
          return true
        }

        return false
      },
      default() {
        return null;
      },
    },
    isAdmin: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    name: {
      required: true,
      type: String,
    },
    message: {
      required: true,
      type: String,
    },
    backgroundColor: {
      required: true,
      type: String,
    },
    textColor: {
      required: true,
      type: String,
    },
    hide: {
      required: false,
      type: Boolean,
      default: () => false,
    }
  },
  computed: {
    wrapperClasses() {
      return {
        's69df': true,
        's65f2': this.hide,
      };
    },
    wrapperStyle() {
      return {
        'background-color': this.backgroundColor,
        'color': this.textColor,
      };
    },
    contentStyle() {
      return {
        'border-color': this.textColor,
      };
    },
    iconIsWhite() {
      return this.textColor.indexOf('fff') !== -1 || this.textColor.toLowerCase() === 'white';
    },
    pinIconClasses() {
      return {
        's521b': true,
        's8a6f': !this.isAdmin,
        's280f': this.isAdmin,
      };
    },
    closeIconClasses() {
      return {
        'chat-icon': true,
        'close': true,
      };
    },
    iconStyle() {
      return {
        'background-color': this.textColor,
      };
    },
  },
  methods: {
    unpin() {
      if (!this.isAdmin) {
        return;
      }
      this.wsClient.chatMessageUnpin();
    },
  },
});

// CONCATENATED MODULE: ./src/components/FloatingPinnedMessage.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_FloatingPinnedMessagevue_type_script_lang_js_ = (FloatingPinnedMessagevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/FloatingPinnedMessage.vue





/* normalize component */

var FloatingPinnedMessage_component = normalizeComponent(
  components_FloatingPinnedMessagevue_type_script_lang_js_,
  FloatingPinnedMessagevue_type_template_id_0e68bc42_render,
  FloatingPinnedMessagevue_type_template_id_0e68bc42_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FloatingPinnedMessage = (FloatingPinnedMessage_component.exports);
// EXTERNAL MODULE: ./node_modules/vue-observe-visibility/dist/vue-observe-visibility.esm.js
var vue_observe_visibility_esm = __nested_webpack_require_91269__("85fe");

// EXTERNAL MODULE: ./node_modules/smucio-ws-client/classes/WsClient.js
var WsClient = __nested_webpack_require_91269__("3b89");

// EXTERNAL MODULE: ./node_modules/smucio-ws-client/classes/Comment.js
var Comment = __nested_webpack_require_91269__("2b07");

// EXTERNAL MODULE: ./node_modules/smucio-ws-client/classes/CommentPlatform.js
var CommentPlatform = __nested_webpack_require_91269__("64c9");
var CommentPlatform_default = /*#__PURE__*/__nested_webpack_require_91269__.n(CommentPlatform);

// CONCATENATED MODULE: ./node_modules/smucio-ws-client/main.js






// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __nested_webpack_require_91269__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__nested_webpack_require_91269__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ChatView.vue?vue&type=script&lang=js&









external_commonjs_vue_commonjs2_vue_root_Vue_default.a.directive('observe-visibility', vue_observe_visibility_esm["a" /* ObserveVisibility */])

/* harmony default export */ var ChatViewvue_type_script_lang_js_ = ({
  name: 'ChatView',
  components: { ColorizableNoMessagesYet: ColorizableNoMessagesYet, FloatingPinnedMessage: FloatingPinnedMessage },
  mixins: [ Translator ],
  props: {
    wsClient: {
      required: false,
      validator: (value) => {
        if (value === null) {
          return true;
        }

        if (
          typeof value === 'object'
          && value.constructor
          && value.constructor.name
          && value.constructor.name === 'WsClient'
        ) {
          return true
        }

        return false
      },
      default() {
        return null;
      },
    },
    isAdmin: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    showLoader: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    showFloatingPinnedMessage: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    name: {
      type: String,
      required: false,
      default() {
        return '';
      },
    },
    messages: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    noMessagesText: {
      type: String,
      required: false,
      default: '',
    },
    textColor: {
      type: String,
      required: false,
      default: () => '#ffffff',
    },
    buttonColor: {
      type: String,
      required: false,
      default: () => '#38138e',
    },
    reversedModeration: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      sharedData: 'chat' in this.$root ? this.$root.chat : {
        currentUserId: null,
        messages: [],
        animatedMessages: [],
        pinnedMessage: null,
        hasMore: true,
        isLoading: false,
        inited: false,
        firstMessagesReceived: false,
        bannedUsers: [],
      },
      pinnedMessageHide: false,
      messageBeingDeleted: null,
      messageBeingRecovered: null,
      messageBeingPinnedOrUnpinned: null,
      isAutoscroll: true,
      messagesPerPage: 20,
      observer: null,
      isVisible: null,
    };
  },
  computed: {
    wrapperClasses() {
      return {
        's2dab': true,
        's6ee7': this.isEmpty,
        'chat-view--admin': this.isAdmin,
        'se308': this.reversedModeration,
      };
    },
    isJoined() {
      return this.sharedData.currentUserId !== null;
    },
    isBanned() {
      return this.sharedData.bannedUsers.includes(this.sharedData.currentUserId);
    },
    filteredMessages() {
      let result = [];
      if (this.isAdmin) {
        result = this.sharedData.messages;
      }
      else {
        result = this.sharedData.messages.filter(item => {
          if (
            this.reversedModeration
            && item.smucPlatform
            && item.smucPlatform.userId
            && item.smucPlatform.userId === this.sharedData.currentUserId
          ) {
            return true;
          }

          return !item.isDeleted;
        });
      }

      return result;
    },
    isEmpty() {
      return this.filteredMessages.length === 0
    },
  },
  watch: {
    wsClient: {
      immediate: true,
      handler(val) {
        if (val === null) {
          return;
        }

        this.$nextTick(() => this.initWsClientEvents());
      },
    },
    name(val) {
      if (this.wsClient !== null) {
        this.wsClient.chatName = val;
      }
    },
    isBanned(val) {
      if (val) {
        this.$emit('banned');
      }
      else {
        this.$emit('unbanned');
      }
    },
    'sharedData.messages'() {
      if (!this.isAutoscroll || !this.isVisible) {
        return
      }

      this.scrollToBottom();
    },
    isVisible: {
      immediate: true,
      handler(val, oldVal) {
        if ((val && val !== oldVal) || oldVal === null) {
          this.isAutoscroll = true;
          this.scrollToBottom();
        }
      },
    },
  },
  created() {
    this.sharedData.messages.push(...this.messages);
  },
  mounted() {
    this.observer = new ResizeObserver(entries => {
      this.isVisible = entries[0].contentRect.width !== 0;
    });
    this.observer.observe(this.$el);
  },
  beforeDestroy() {
    if (this.wsClient) {
      this.destroyWsClientEvents();
    }

    if (this.observer !== null && this.$el) {
      this.observer.unobserve(this.$el)
      this.observer.disconnect()
    }
  },
  methods: {
    initWsClientEvents() {
      if (this.sharedData.inited) {
        return;
      }

      this.sharedData.inited = true;
      this.addChatMessagesListener();

      this.wsClient.addEventListener(WsClient["a" /* WsClientEvents */].JOINED, this.onJoined);
      this.wsClient.addEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE, this.onMessage);
      this.wsClient.addEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE_DELETED, this.onMessageDeleted);
      this.wsClient.addEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE_RECOVERED, this.onMessageRecovered);
      this.wsClient.addEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE_PINNED, this.onMessagePinned);
      this.wsClient.addEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE_UNPINNED, this.onMessageUnpinned);
      this.wsClient.addEventListener(WsClient["a" /* WsClientEvents */].CHAT_FEEDBACK, this.onFeedback);
      this.wsClient.addEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE_DELETE_FEEDBACK, this.onMessageDeleteFeedback);
      this.wsClient.addEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE_RECOVER_FEEDBACK, this.onMessageRecoverFeedback);
      this.wsClient.addEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE_PIN_FEEDBACK, this.onMessagePinFeedback);
      this.wsClient.addEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE_UNPIN_FEEDBACK, this.onMessageUnpinFeedback);
      this.wsClient.addEventListener(WsClient["a" /* WsClientEvents */].CHAT_BANNED, this.onUserBanned);
      this.wsClient.addEventListener(WsClient["a" /* WsClientEvents */].CHAT_UNBANNED, this.onUserUnbanned);

      if (this.$root.$bus) {
        this.$root.$bus.$on('chatview.send.message', (comment) => this.onMessage(comment));
      }
    },
    destroyWsClientEvents() {
      this.sharedData.inited = false;

      this.wsClient.removeEventListener(WsClient["a" /* WsClientEvents */].JOINED, this.onJoined);
      this.wsClient.removeEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE, this.onMessage);
      this.wsClient.removeEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE_DELETED, this.onMessageDeleted);
      this.wsClient.removeEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE_RECOVERED, this.onMessageRecovered);
      this.wsClient.removeEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE_PINNED, this.onMessagePinned);
      this.wsClient.removeEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE_UNPINNED, this.onMessageUnpinned);
      this.wsClient.removeEventListener(WsClient["a" /* WsClientEvents */].CHAT_FEEDBACK, this.onFeedback);
      this.wsClient.removeEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE_DELETE_FEEDBACK, this.onMessageDeleteFeedback);
      this.wsClient.removeEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE_RECOVER_FEEDBACK, this.onMessageRecoverFeedback);
      this.wsClient.removeEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE_PIN_FEEDBACK, this.onMessagePinFeedback);
      this.wsClient.removeEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGE_UNPIN_FEEDBACK, this.onMessageUnpinFeedback);
      this.wsClient.removeEventListener(WsClient["a" /* WsClientEvents */].CHAT_BANNED, this.onUserBanned);
      this.wsClient.removeEventListener(WsClient["a" /* WsClientEvents */].CHAT_UNBANNED, this.onUserUnbanned);
    },
    platformIconClasses(platform) {
      let classes = { 's34a6': true };
      classes['platform--' + platform.type] = true;

      return classes;
    },
    scrollToBottom() {
      if (this.sharedData.messages.length === 0) {
        return;
      }

      this.$nextTick(() => {
        let counter = 0;

        const action = () => {
          let top = this.$el.offsetHeight + 100;
          if (top < 2000) {
            top = 2000;
          }
          this.$el.scrollTo({ top });

          ++counter;
          if (counter < 100) {
            setTimeout(() => action(), 1);
          }
        }
        action();
      });
    },
    messageSenderLink(comment) {
      if (comment.isFacebookMessage) {
        return 'https://www.facebook.com/' + comment.facebookPlatform.userId;
      }

      return '';
    },
    banButtonIsVisible(comment) {
      return comment.isSmucMessage && comment.smucPlatform.userId !== this.sharedData.currentUserId;
    },
    messageIsRecoverable(comment) {
      return comment.isSmucMessage;
    },
    sendMessage(message, sendTo) {
      if (this.isBanned) {
        return;
      }

      message = message.trim();
      if (!message) {
        return;
      }

      if (this.wsClient === null) {
        const dummyComment = new Comment["a" /* default */]({
          message,
          isDeleted: this.reversedModeration,
          platforms: [
            new CommentPlatform_default.a({
              type: 'smuc',
              name: 'You',
            }),
          ],
        });
        this.sharedData.messages.push(dummyComment);
        return;
      }

      if (this.wsClient.isConnected) {
        const comment = this.wsClient.chatMessage(message, sendTo);
        comment.isDeleted = this.reversedModeration;

        if (this.$root.$bus) {
          this.$root.$bus.$emit('chatview.send.message', comment);
        }
        else {
          this.onMessage(comment);
        }
      }
    },
    userIsBanner(userId) {
      return this.sharedData.bannedUsers.includes(userId);
    },
    toggleBan(userId) {
      if (this.userIsBanner(userId)) {
        this.unban(userId);
      }
      else {
        this.ban(userId);
      }
    },
    ban(userId) {
      this.onUserBanned(userId);
      this.wsClient.chatBan({ userId });
    },
    unban(userId) {
      this.onUserUnbanned(userId);
      this.wsClient.chatUnban({ userId });
    },
    deleteMessage(message) {
      if (this.messageBeingDeleted !== null) {
        return;
      }
      this.messageBeingDeleted = message.id;
      this.wsClient.chatMessageDelete(message.id);
    },
    recoverMessage(message) {
      if (this.messageBeingRecovered !== null) {
        return;
      }
      this.messageBeingRecovered = message.id;
      this.wsClient.chatMessageRecover(message.id);
    },
    pinOrUnpin(message) {
      if (this.messageBeingPinnedOrUnpinned !== null) {
        return;
      }
      this.messageBeingPinnedOrUnpinned = message.id;
      if (!this.messageIsPinned(message)) {
        this.wsClient.chatMessagePin(message.id);
      }
      else {
        this.wsClient.chatMessageUnpin();
      }
    },
    messageIsPinned(message) {
      return this.sharedData.pinnedMessage && message && message.id === this.sharedData.pinnedMessage.id;
    },
    onJoined(message) {
      this.sharedData.currentUserId = message.userId;
      this.$emit('joined');
    },
    onMessage(comment) {
      const commentId = comment.id ? comment.id : comment.clientGeneratedId;
      this.sharedData.animatedMessages.push(commentId);

      this.sharedData.messages.push(comment);

      setTimeout(() => this.sharedData.animatedMessages = this.sharedData.animatedMessages.filter(i => i !== commentId), 250);
    },
    onMessageDeleted(message) {
      const messageId = message.messageId;
      if (this.messageBeingDeleted === messageId) {
        this.messageBeingDeleted = null;
      }

      const comment = this.sharedData.messages.filter(c => c.id === messageId);
      if (comment.length !== 0) {
        comment[0].isDeleted = true;
      }
    },
    onMessageRecovered(message) {
      const messageId = message.messageId;
      if (this.messageBeingRecovered === messageId) {
        this.messageBeingRecovered = null;
      }

      const comment = this.sharedData.messages.filter(c => c.id === messageId);
      if (comment.length !== 0) {
        comment[0].isDeleted = false;
      }
    },
    onMessagePinned(message) {
      this.$emit('changeFloatingInfoVisibility', false);
      const hasPinnedMessage = this.sharedData.pinnedMessage !== null;
      this.pinnedMessageHide = hasPinnedMessage;

      setTimeout(() => {
        this.sharedData.pinnedMessage = message;
        this.$nextTick(() => {
          this.pinnedMessageHide = false;
          this.$emit('changeFloatingInfoVisibility', true);
        });
      }, hasPinnedMessage ? 175 : 0);
    },
    onMessageUnpinned() {
      this.pinnedMessageHide = true;
      this.$emit('changeFloatingInfoVisibility', false);
      setTimeout(() => this.sharedData.pinnedMessage = null, 175);
    },
    onFeedback(resp) {
      const existsingComment = this.sharedData.messages.filter(c => c.clientGeneratedId === resp.comment.clientGeneratedId);
      if (existsingComment.length !== 0) {
        existsingComment[0].updateWith(resp.comment);
        // existsingComment[0].clientGeneratedId = null;
      }

      if (!resp.success) {
        // TODO: error message.
      }
    },
    onMessageDeleteFeedback(resp) {
      this.messageBeingDeleted = null;
      if (!resp.success) {
        // TODO: error message.
      }
    },
    onMessageRecoverFeedback(resp) {
      this.messageBeingRecovered = null;
      if (!resp.success) {
        // TODO: error message.
      }
    },
    onMessagePinFeedback(resp) {
      this.messageBeingPinnedOrUnpinned = null;
      if (!resp.success) {
        // TODO: error message.
      }
    },
    onMessageUnpinFeedback(resp) {
      this.messageBeingPinnedOrUnpinned = null;
      if (!resp.success) {
        // TODO: error message.
      }
    },
    onUserBanned(message) {
      const userId = message.userId;
      this.sharedData.bannedUsers.push(userId);
    },
    onUserUnbanned(message) {
      const userId = message.userId;
      this.sharedData.bannedUsers = this.sharedData.bannedUsers.filter(item => item !== userId);
    },
    onScrollY() {
      this.$emit('chatviewScrollY', this.$refs.scrollWrapper)

      const posYBottom = this.$refs.scrollWrapper.scrollHeight - (this.$refs.scrollWrapper.scrollTop + this.$refs.scrollWrapper.offsetHeight)
      this.isAutoscroll = posYBottom <= 30;
    },
    infiniteHandler(isVisible, _, reset) {
      if (reset) {
        this.sharedData.hasMore = true;
      }

      if (
        !isVisible
        || !this.sharedData.firstMessagesReceived
        || this.sharedData.isLoading
        || !this.sharedData.hasMore
      ) {
        return;
      }

      this.sharedData.isLoading = true;

      let before = new Date();
      if (!reset && this.sharedData.messages.length !== 0) {
        before = this.sharedData.messages[0].createdAt;
      }

      this.addChatMessagesListener();
      this.wsClient.chatGetMessages({ limit: this.messagesPerPage, before });
    },
    messageClasses(comment) {
      return {
        's78e7': true,
        's8a4f': this.messageIsPinned(comment),
        'deleted': comment.isDeleted,
        'is-loading': comment.isLoading,
        's01fe': this.sharedData.animatedMessages.includes(comment.id) || this.sharedData.animatedMessages.includes(comment.clientGeneratedId),
      };
    },
    getName(comment) {
      if (comment.smucPlatform && this.userIsBanner(comment.smucPlatform.userId)) {
        return this.tr('Banned user');
      }

      if (comment.name === 'You' || !comment.name) {
        return this.tr('You');
      }

      return comment.name;
    },
    closeFloatingPinnedMessage() {
      this.onMessageUnpinned();
    },
    addChatMessagesListener(reset) {
      const listenerId = (Math.random() + 1).toString(36).substring(7);

      const onMessagesReceivedCallback = ({ comments, pinned }, lid) => {
        if (listenerId !== lid) {
          return;
        }

        this.wsClient.removeEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGES, onMessagesReceivedCallback);

        this.sharedData.hasMore = comments.length === this.messagesPerPage;

        let originalHeight = this.$refs.scrollWrapper.scrollHeight;
        let scrollPosition = this.$refs.scrollWrapper.scrollTop;

        if (reset) {
          this.sharedData.messages = comments;
        }
        else {
          this.sharedData.messages.unshift(...comments);
        }

        if (pinned) {
          this.onMessagePinned(pinned);
        }

        this.$nextTick(() => {
          const newHeight = this.$refs.scrollWrapper.scrollHeight;
          const newScrollPosition = newHeight - originalHeight + scrollPosition;

          this.$el.scrollTo({ top: newScrollPosition });

          this.sharedData.isLoading = false;
          this.sharedData.firstMessagesReceived = true;
        });
      };

      this.wsClient.addEventListener(WsClient["a" /* WsClientEvents */].CHAT_MESSAGES, onMessagesReceivedCallback, listenerId);
    },
  },
});

// CONCATENATED MODULE: ./src/components/ChatView.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ChatViewvue_type_script_lang_js_ = (ChatViewvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/ChatView.vue





/* normalize component */

var ChatView_component = normalizeComponent(
  components_ChatViewvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ChatView = (ChatView_component.exports);
// CONCATENATED MODULE: ./src/install.js




const SmucChatView = {
  install(Vue) {
    Vue.component('chat-view', ChatView);
  }
};

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(SmucChatView);
}

/* harmony default export */ var install = (SmucChatView);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __nested_webpack_exports__["default"] = (install);



/***/ })

/******/ });
//# sourceMappingURL=smucio-chatview.common.js.map

/***/ }),

/***/ 455:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ConnectedPlatform = void 0;
class ConnectedPlatform {
    constructor({ id, type, name, image, connected_at, inactive } = {
        id: null,
        type: null,
        name: null,
        image: null,
        connected_at: {},
        inactive: {},
    }) {
        this.id = id;
        this.type = type;
        this.name = name;
        this.image = image;
        this.connected_at = connected_at;
        this.inactive = inactive;
    }
    get serviceId() {
        return this.type + '_' + this.id;
    }
}
exports.ConnectedPlatform = ConnectedPlatform;
//# sourceMappingURL=connectedplatform.js.map

/***/ }),

/***/ 547:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Feed_instances, _Feed_strTimeInSec;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Feed = void 0;
const media_1 = __webpack_require__(987);
class Feed {
    constructor(rawData = {
        id: 0,
        stream_id: 0,
        show_in_feed: false,
        payable: false,
        pinned: false,
        pinned_from: null,
        pinned_to: null,
        first_from: null,
        first_to: null,
        link: null,
        link_open_in: '_blank',
        image: null,
        image_link: null,
        title: '',
        description: null,
        alternate_text: null,
        price: null,
        sales_price: null,
        sku: null,
        ordno: null,
        quantity: null,
        variations: null,
        cta: null,
        card_click_tracking: null,
        link_click_tracking: null,
        created: null,
        updated: null,
        uniqueKey: null,
        owner_id: 0,
        migrated: false,
        created_at: null,
        updated_at: null,
    }) {
        _Feed_instances.add(this);
        this.id = rawData.id;
        this.stream_id = rawData.stream_id;
        this.show_in_feed = rawData.show_in_feed;
        this.payable = rawData.payable;
        this.pinned = rawData.pinned;
        this.pinned_from = rawData.pinned_from;
        this.pinned_to = rawData.pinned_to;
        this.first_from = rawData.first_from;
        this.first_to = rawData.first_to;
        this.link = rawData.link;
        this.link_open_in = rawData.link_open_in;
        this.image_link = rawData.image_link;
        if (rawData.image !== null && Object.prototype.toString.call(rawData.image) === '[object Object]') {
            this.image = new media_1.Media(rawData.image.id, rawData.image.url, rawData.image.thumbnail_url);
        }
        else {
            this.image = null;
        }
        this.title = rawData.title;
        this.description = rawData.description;
        this.alternate_text = rawData.alternate_text;
        this.price = rawData.price;
        this.sales_price = rawData.sales_price;
        this.sku = rawData.sku;
        this.ordno = rawData.ordno;
        this.quantity = rawData.quantity;
        this.variations = rawData.variations;
        this.cta = rawData.cta;
        this.card_click_tracking = rawData.card_click_tracking;
        this.link_click_tracking = rawData.link_click_tracking;
        this.owner_id = rawData.owner_id;
        this.migrated = rawData.migrated;
        this.created_at = rawData.created_at;
        this.updated_at = rawData.updated_at;
        this.created = rawData.created || new Date();
        this.updated = rawData.updated || new Date();
        if (typeof rawData.uniqueKey === 'string' && rawData.uniqueKey.length > 0) {
            this.uniqueKey = rawData.uniqueKey;
        }
        else if (typeof rawData.uniqueKey === 'undefined' || rawData.uniqueKey === null || rawData.uniqueKey === '') {
            this.uniqueKey = Math.random().toString(36).slice(2);
        }
        else {
            this.uniqueKey = rawData.uniqueKey || null;
        }
    }
    get pinned_from_in_sec() {
        return __classPrivateFieldGet(this, _Feed_instances, "m", _Feed_strTimeInSec).call(this, this.pinned_from);
    }
    get pinned_to_in_sec() {
        return __classPrivateFieldGet(this, _Feed_instances, "m", _Feed_strTimeInSec).call(this, this.pinned_to);
    }
    get first_from_in_sec() {
        return __classPrivateFieldGet(this, _Feed_instances, "m", _Feed_strTimeInSec).call(this, this.first_from);
    }
    get first_to_in_sec() {
        return __classPrivateFieldGet(this, _Feed_instances, "m", _Feed_strTimeInSec).call(this, this.first_to);
    }
}
exports.Feed = Feed;
_Feed_instances = new WeakSet(), _Feed_strTimeInSec = function _Feed_strTimeInSec(time) {
    if (typeof time !== 'string' || time.indexOf(':') === -1) {
        return null;
    }
    const parts = time.split(':');
    if (parts.length !== 3) {
        return null;
    }
    let result = 0;
    result += parseInt(parts[0]) * 3600;
    result += parseInt(parts[1]) * 60;
    result += parseInt(parts[2]);
    return result;
};
//# sourceMappingURL=feed.js.map

/***/ }),

/***/ 234:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FeedVariation = void 0;
class FeedVariation {
    constructor({ id, label, price, sales_price, quantity } = {
        id: '',
        label: '',
        price: 0,
        sales_price: 0,
        quantity: null
    }) {
        this.id = id;
        this.label = label;
        this.price = price;
        this.sales_price = sales_price;
        this.quantity = quantity;
    }
}
exports.FeedVariation = FeedVariation;
//# sourceMappingURL=feedvariation.js.map

/***/ }),

/***/ 310:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Font = void 0;
class Font {
    constructor({ id, font_family, mime_type, path_to_regular, path_to_bold, legal, owner_id, created_at, updated_at } = {
        id: '',
        font_family: '',
        mime_type: '',
        path_to_regular: null,
        path_to_bold: null,
        legal: false,
        owner_id: 0,
        created_at: null,
        updated_at: null,
    }) {
        this.id = id;
        this.font_family = font_family;
        this.mime_type = mime_type;
        this.path_to_regular = path_to_regular;
        this.path_to_bold = path_to_bold;
        this.legal = legal;
        this.owner_id = owner_id;
        this.created_at = created_at;
        this.updated_at = updated_at;
    }
}
exports.Font = Font;
//# sourceMappingURL=font.js.map

/***/ }),

/***/ 801:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SubscriberForm = void 0;
class SubscriberForm {
    constructor({ id, name, title, description, name_enabled, name_placeholder, email_placeholder, phone_enabled, phone_placeholder, privacy_url, cta_label, click_tracking, submit_click_tracking, owner_id, created_at, updated_at, no_of_subscriptions, } = {
        id: 0,
        name: '',
        title: '',
        description: null,
        name_enabled: false,
        name_placeholder: null,
        email_placeholder: '',
        phone_enabled: false,
        phone_placeholder: null,
        privacy_url: '',
        cta_label: null,
        click_tracking: null,
        submit_click_tracking: null,
        owner_id: 0,
        created_at: null,
        updated_at: null,
        no_of_subscriptions: 0,
    }) {
        this.id = id;
        this.title = title;
        this.name = name;
        this.description = description;
        this.name_enabled = name_enabled;
        this.name_placeholder = name_placeholder;
        this.email_placeholder = email_placeholder;
        this.phone_enabled = phone_enabled;
        this.phone_placeholder = phone_placeholder;
        this.privacy_url = privacy_url;
        this.cta_label = cta_label;
        this.click_tracking = click_tracking;
        this.submit_click_tracking = submit_click_tracking;
        this.owner_id = owner_id;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.no_of_subscriptions = no_of_subscriptions;
    }
}
exports.SubscriberForm = SubscriberForm;
//# sourceMappingURL=form.js.map

/***/ }),

/***/ 387:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ConnectedPlatform = exports.SubscriberForm = exports.Font = exports.PollAnswer = exports.Poll = exports.Payment = exports.Media = exports.FeedVariation = exports.Feed = void 0;
var feed_1 = __webpack_require__(547);
Object.defineProperty(exports, "Feed", ({ enumerable: true, get: function () { return feed_1.Feed; } }));
var feedvariation_1 = __webpack_require__(234);
Object.defineProperty(exports, "FeedVariation", ({ enumerable: true, get: function () { return feedvariation_1.FeedVariation; } }));
var media_1 = __webpack_require__(987);
Object.defineProperty(exports, "Media", ({ enumerable: true, get: function () { return media_1.Media; } }));
var payment_1 = __webpack_require__(505);
Object.defineProperty(exports, "Payment", ({ enumerable: true, get: function () { return payment_1.Payment; } }));
var poll_1 = __webpack_require__(118);
Object.defineProperty(exports, "Poll", ({ enumerable: true, get: function () { return poll_1.Poll; } }));
var pollanswer_1 = __webpack_require__(108);
Object.defineProperty(exports, "PollAnswer", ({ enumerable: true, get: function () { return pollanswer_1.PollAnswer; } }));
var font_1 = __webpack_require__(310);
Object.defineProperty(exports, "Font", ({ enumerable: true, get: function () { return font_1.Font; } }));
var form_1 = __webpack_require__(801);
Object.defineProperty(exports, "SubscriberForm", ({ enumerable: true, get: function () { return form_1.SubscriberForm; } }));
__exportStar(__webpack_require__(703), exports);
var connectedplatform_1 = __webpack_require__(455);
Object.defineProperty(exports, "ConnectedPlatform", ({ enumerable: true, get: function () { return connectedplatform_1.ConnectedPlatform; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 987:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Media = void 0;
class Media {
    constructor(id, url, thumbnail_url) {
        this.id = id;
        this.url = url;
        this.thumbnail_url = thumbnail_url;
    }
}
exports.Media = Media;
//# sourceMappingURL=media.js.map

/***/ }),

/***/ 505:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Payment = void 0;
class Payment {
    constructor({ id, owner_id, title, type, data } = {
        id: 0,
        owner_id: 0,
        title: '',
        type: '',
        data: {},
    }) {
        this.id = id;
        this.owner_id = owner_id;
        this.title = title;
        this.type = type;
        this.data = data;
    }
}
exports.Payment = Payment;
//# sourceMappingURL=payment.js.map

/***/ }),

/***/ 118:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Poll = void 0;
const classes_1 = __webpack_require__(387);
class Poll {
    constructor({ id, name, question, answers, closed, owner_id, created_at, updated_at, user_answer, position } = {
        id: '',
        name: '',
        question: '',
        answers: [],
        closed: false,
        owner_id: 0,
        created_at: null,
        updated_at: null,
        user_answer: null,
        position: 0,
    }) {
        this.id = id;
        this.name = name;
        this.question = question;
        this.answers = answers.map((answer) => new classes_1.PollAnswer(answer));
        this.closed = closed;
        this.owner_id = owner_id;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.user_answer = user_answer;
        this.position = position;
    }
    toObject() {
        return {
            id: this.id,
            name: this.name,
            question: this.question,
            answers: this.answers.map((answer) => answer.toObject()),
            closed: this.closed,
        };
    }
    updateWith({ name, question, answers, closed, position, }) {
        if (typeof name !== 'undefined') {
            this.name = name;
        }
        if (typeof question !== 'undefined') {
            this.question = question;
        }
        if (typeof closed !== 'undefined') {
            this.closed = closed;
        }
        if (typeof position !== 'undefined') {
            this.position = position;
        }
        if (typeof answers !== 'undefined') {
            for (const answer of answers) {
                const currentAnswer = this.answers.filter((a) => a.id === answer.id);
                if (currentAnswer && currentAnswer[0]) {
                    answer.votes = currentAnswer[0].votes;
                }
            }
            this.answers = answers;
        }
    }
    get isAnswered() {
        return !!this.user_answer;
    }
}
exports.Poll = Poll;
//# sourceMappingURL=poll.js.map

/***/ }),

/***/ 108:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PollAnswer = void 0;
class PollAnswer {
    constructor({ id, text, votes } = {
        id: '',
        text: '',
        votes: 0,
    }) {
        this.id = id;
        this.text = text;
        this.votes = votes;
    }
    toObject() {
        return {
            id: this.id,
            text: this.text,
        };
    }
    updateWith({ text }) {
        this.text = text;
    }
}
exports.PollAnswer = PollAnswer;
//# sourceMappingURL=pollanswer.js.map

/***/ }),

/***/ 703:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StreamData = exports.colorRegexp = exports.datetimeRegexp = exports.defaultTimeOffset = exports.defaultMaxDimensions = void 0;
const istreamdata_1 = __webpack_require__(946);
const feed_1 = __webpack_require__(547);
const payment_1 = __webpack_require__(505);
const poll_1 = __webpack_require__(118);
const media_1 = __webpack_require__(987);
const connectedplatform_1 = __webpack_require__(455);
const errors_1 = __webpack_require__(770);
const consts_1 = __webpack_require__(734);
exports.defaultMaxDimensions = {
    max_width: 960,
    max_height: 540,
};
exports.defaultTimeOffset = 5 * 60 * 1000;
exports.datetimeRegexp = /[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}(?:(\.[0-9]{3}Z)|(\+[0-9]{2}:[0-9]{2}))/;
exports.colorRegexp = /(?:^\#([a-f0-9]{3}|[a-f0-9]{6})$)|(?:rgb\(([0-1]?[0-9]?[0-9]?|2[0-4][0-9]|25[0-5])([ ]+)?,([ ]+)?([0-1]?[0-9]?[0-9]?|2[0-4][0-9]|25[0-5])([ ]+)?,([ ]+)?([0-1]?[0-9]?[0-9]?|2[0-4][0-9]|25[0-5])\))/i;
class StreamData {
    constructor(rawData = {
        id: 0,
        type: 0,
        apikey: null,
        streamkey: null,
        webcam_streamkey: null,
        customer: '',
        campaign: '',
        title: 'New stream',
        title_color: '#000000',
        title_hidden: false,
        orientation: 1,
        width: null,
        height: null,
        max_width: exports.defaultMaxDimensions.max_width,
        max_height: exports.defaultMaxDimensions.max_height,
        video_layout: istreamdata_1.StreamVideoLayout.Fill,
        button_color: '#000000',
        text_color: '#ffffff',
        logo: null,
        cover: null,
        cover_portrait: null,
        vods: null,
        vod_data_id: '0',
        restreams: [],
        restream_title: null,
        restream_desc: null,
        restream_scheduling: null,
        restream_privacy_status: 'public',
        privacy_policy_url: null,
        start_date: null,
        end_date: null,
        timezone: null,
        timezone_offset: 0,
        feed: [],
        streamview_language: 'en',
        currency: 'huf',
        show_share_button: true,
        show_viewers: true,
        show_close_button: true,
        show_countdown_box: false,
        show_chat: true,
        show_product_list: true,
        show_polls: true,
        show_smuc_logo: true,
        show_title: true,
        show_like: true,
        show_like_demo: false,
        show_match_info: false,
        show_cheering: false,
        team_home_logo: null,
        team_away_logo: null,
        team_home_color: null,
        team_away_color: null,
        team_home_name: null,
        team_away_name: null,
        team_home_points: null,
        team_away_points: null,
        reversed_chat_moderation: false,
        auto_chat_moderation: false,
        is_sponsored_content: true,
        viewer_count: 0,
        ga_code: null,
        allow_extra_viewers: null,
        stream_status: istreamdata_1.StreamStatus.Waiting,
        payment: null,
        start_minimized: false,
        rounded_corners: true,
        optimize_for_ad: false,
        ad_bg: null,
        ad_size: null,
        ad_url: null,
        ad_button_label: null,
        ad_use_featured_image: null,
        ad_featured_image: null,
        ad_featured_image_link: null,
        rtmp_data: null,
        stream_urls: null,
        playlist: {},
        frequency: 'always',
        owner_id: null,
        impressions: 0,
        visible_impressions: 0,
        three_sec_views: 0,
        vcr: 0,
        video_clicks: 0,
        stored_minutes: 0,
        total_viewers: 0,
        total_minutes: 0,
        avg_viewed_minutes: 0,
        product_clicks: 0,
        product_link_clicks: 0,
        product_impressions: 0,
        product_ctr: 0,
        product_link_ctr: 0,
        product_purchases: 0,
        hearts: 0,
        comments: 0,
        shares: 0,
        total_interactions: 0,
        engagement_rate: 0,
        engagement_rate_based_on_visible_impression: 0,
        notification_email_subject: null,
        notification_email_text: null,
        subscribers: 0,
        embed_social_video: null,
        embed_social_video_processing: false,
        tab_products_label_singular: null,
        tab_products_label_plural: null,
        tab_subscription_form_label: null,
        purchase_gtc_url: null,
        embed_codes: null,
        player_url: null,
        player_autoplay: false,
        player_muted: false,
        player_loop: false,
        player_subdomain: null,
        font_id: null,
        font_meta: null,
        subscriber_form_id: null,
        subscriber_form: null,
        polls: [],
        agency_logo: null,
        photoad_photo: null,
        photoad_photos: [],
        photoad_autoswipe_duration: null,
        auto_card_timing: true,
        sidebar_transparency: true,
        delay_sidebar_appearance: null,
    }) {
        this.id = rawData.id || 0;
        this.type = rawData.type;
        this.apikey = rawData.apikey || null;
        this.streamkey = rawData.streamkey || null;
        this.webcam_streamkey = rawData.webcam_streamkey || null;
        this.customer = rawData.customer || '';
        this.campaign = rawData.campaign || '';
        this.title = rawData.title;
        this.title_color = rawData.title_color;
        this.title_hidden = rawData.title_hidden;
        this.orientation = rawData.orientation;
        this.width = rawData.width;
        this.height = rawData.height;
        this.max_width = rawData.max_width;
        this.max_height = rawData.max_height;
        this.video_layout = rawData.video_layout;
        this.button_color = rawData.button_color;
        this.text_color = rawData.text_color;
        this.logo =
            Object.prototype.toString.call(rawData.logo) === '[object Object]' && rawData.logo !== null
                ? new media_1.Media(rawData.logo.id, rawData.logo.url, rawData.logo.thumbnail_url)
                : null;
        this.cover =
            Object.prototype.toString.call(rawData.cover) === '[object Object]' && rawData.cover !== null
                ? new media_1.Media(rawData.cover.id, rawData.cover.url, rawData.cover.thumbnail_url)
                : null;
        this.cover_portrait =
            Object.prototype.toString.call(rawData.cover_portrait) === '[object Object]' && rawData.cover_portrait !== null
                ? new media_1.Media(rawData.cover_portrait.id, rawData.cover_portrait.url, rawData.cover_portrait.thumbnail_url)
                : null;
        this.vods = rawData.vods || null;
        this.vod_data_id = rawData.vod_data_id || '0';
        this.restreams = rawData.restreams;
        this.restream_title = rawData.restream_title;
        this.restream_desc = rawData.restream_desc;
        this.restream_scheduling = rawData.restream_scheduling;
        this.restream_privacy_status = rawData.restream_privacy_status;
        this.privacy_policy_url = rawData.privacy_policy_url;
        this.timezone = rawData.timezone;
        this.timezone_offset = rawData.timezone_offset;
        this.streamview_language = rawData.streamview_language;
        this.currency = rawData.currency || 'huf';
        this.show_share_button = this.parseBool(rawData.show_share_button);
        this.show_viewers = this.parseBool(rawData.show_viewers);
        this.show_close_button = this.parseBool(rawData.show_close_button);
        this.show_countdown_box = this.parseBool(rawData.show_countdown_box);
        this.show_chat = this.parseBool(rawData.show_chat);
        this.show_product_list = this.parseBool(rawData.show_product_list);
        this.show_polls = this.parseBool(rawData.show_polls);
        this.show_smuc_logo = this.parseBool(rawData.show_smuc_logo);
        this.show_title = this.parseBool(rawData.show_title);
        this.show_like = this.parseBool(rawData.show_like);
        this.show_like_demo = this.parseBool(rawData.show_like_demo);
        this.show_match_info = this.parseBool(rawData.show_match_info);
        this.show_cheering = this.parseBool(rawData.show_cheering);
        this.team_home_color = rawData.team_home_color;
        this.team_away_color = rawData.team_away_color;
        this.team_home_name = rawData.team_home_name;
        this.team_away_name = rawData.team_away_name;
        this.team_home_points = rawData.team_home_points || rawData.team_home_points == 0 ? rawData.team_home_points : null;
        this.team_away_points = rawData.team_away_points || rawData.team_away_points == 0 ? rawData.team_away_points : null;
        this.reversed_chat_moderation = this.parseBool(rawData.reversed_chat_moderation);
        this.auto_chat_moderation = this.parseBool(rawData.auto_chat_moderation);
        this.is_sponsored_content = this.parseBool(rawData.is_sponsored_content);
        this.viewer_count = rawData.viewer_count || 0;
        this.ga_code = rawData.ga_code;
        this.allow_extra_viewers = this.parseBool(rawData.allow_extra_viewers);
        this.stream_status = rawData.stream_status;
        this.payment =
            Object.prototype.toString.call(rawData.payment) == '[object Object]' && rawData.payment != null
                ? new payment_1.Payment(rawData.payment)
                : null;
        this.start_minimized = this.parseBool(rawData.start_minimized);
        this.rounded_corners = this.parseBool(rawData.rounded_corners);
        this.optimize_for_ad = this.parseBool(rawData.optimize_for_ad);
        this.ad_bg = rawData.ad_bg || null;
        this.ad_size = rawData.ad_size || null;
        this.ad_url = rawData.ad_url || null;
        this.ad_button_label = rawData.ad_button_label || null;
        this.ad_use_featured_image = rawData.ad_use_featured_image || null;
        this.ad_featured_image = rawData.ad_featured_image || null;
        this.ad_featured_image_link = rawData.ad_featured_image_link || null;
        this.rtmp_data = rawData.rtmp_data || null;
        this.stream_urls = rawData.stream_urls;
        this.playlist = rawData.playlist || {};
        this.frequency = rawData.frequency;
        this.owner_id = rawData.owner_id != null ? parseInt(rawData.owner_id.toString(), 10) : null;
        this.impressions = rawData.impressions || 0;
        this.visible_impressions = rawData.visible_impressions || 0;
        this.three_sec_views = rawData.three_sec_views || 0;
        this.vcr = rawData.vcr || 0;
        this.video_clicks = rawData.video_clicks || 0;
        this.stored_minutes = rawData.stored_minutes || 0;
        this.total_viewers = rawData.total_viewers || 0;
        this.total_minutes = rawData.total_minutes || 0;
        this.avg_viewed_minutes = rawData.avg_viewed_minutes || 0;
        this.product_clicks = rawData.product_clicks || 0;
        this.product_link_clicks = rawData.product_link_clicks || 0;
        this.product_impressions = rawData.product_impressions || 0;
        this.product_ctr = rawData.product_ctr || 0;
        this.product_link_ctr = rawData.product_link_ctr || 0;
        this.product_purchases = rawData.product_purchases || 0;
        this.hearts = rawData.hearts || 0;
        this.comments = rawData.comments || 0;
        this.shares = rawData.shares || 0;
        this.total_interactions = rawData.total_interactions || 0;
        this.engagement_rate = rawData.engagement_rate || 0;
        this.engagement_rate_based_on_visible_impression = rawData.engagement_rate_based_on_visible_impression || 0;
        this.notification_email_subject = rawData.notification_email_subject || '';
        this.notification_email_text = rawData.notification_email_text || '';
        this.subscribers = rawData.subscribers || 0;
        this.embed_social_video = rawData.embed_social_video;
        this.embed_social_video_processing = rawData.embed_social_video_processing || false;
        this.tab_products_label_singular = rawData.tab_products_label_singular || null;
        this.tab_products_label_plural = rawData.tab_products_label_plural || null;
        this.tab_subscription_form_label = rawData.tab_subscription_form_label || null;
        this.purchase_gtc_url = rawData.purchase_gtc_url || null;
        this.player_url = rawData.player_url || null;
        this.embed_codes = rawData.embed_codes || null;
        this.player_autoplay = rawData.player_autoplay || false;
        this.player_muted = rawData.player_muted || false;
        this.player_loop = rawData.player_loop || false;
        this.player_subdomain = rawData.player_subdomain || null;
        this.font_id = rawData.font_id || null;
        this.font_meta = rawData.font_meta || null;
        this.subscriber_form_id = rawData.subscriber_form_id || null;
        this.subscriber_form = rawData.subscriber_form || null;
        this.polls = (rawData.polls || [])
            .map((item) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return new poll_1.Poll(item);
        })
            .reverse();
        this.logo = null;
        if ('logo_url' in rawData) {
            this.logo = rawData.logo_url !== null ? new media_1.Media('0', '' + rawData.logo_url, '') : null;
        }
        this.agency_logo = null;
        this.cover = null;
        this.cover_portrait = null;
        this.photoad_photo = null;
        this.ad_featured_image = null;
        this.team_home_logo = null;
        this.team_away_logo = null;
        const imageFields = [
            'logo',
            'cover',
            'cover_portrait',
            'agency_logo',
            'photoad_photo',
            'ad_featured_image',
            'team_home_logo',
            'team_away_logo',
        ];
        imageFields.forEach((imageField) => {
            const key = imageField;
            if (!(imageField in rawData) || rawData[key] === null) {
                return;
            }
            const that = this;
            if (typeof rawData[key] === 'string') {
                that[key] = new media_1.Media('0', '' + rawData[key], '');
            }
            else {
                const item = rawData[key];
                that[key] = new media_1.Media(item.id + '', item.url, item.thumbnail_url);
            }
        });
        this.photoad_photos = Array.isArray(rawData.photoad_photos)
            ? rawData.photoad_photos.map((item) => {
                if (typeof item === 'string') {
                    return new media_1.Media('0', item, '');
                }
                return item !== null ? new media_1.Media(item.id, item.url, item.thumbnail_url) : null;
            })
            : [];
        if (this.photoad_photo !== null) {
            this.photoad_photos.push(this.photoad_photo);
        }
        if (this.photoad_photos.length === 0) {
            this.photoad_photos.push(null);
        }
        this.photoad_autoswipe_duration = rawData.photoad_autoswipe_duration || null;
        this.auto_card_timing = this.parseBool(rawData.auto_card_timing);
        this.sidebar_transparency = this.parseBool(rawData.sidebar_transparency);
        this.delay_sidebar_appearance = rawData.delay_sidebar_appearance || null;
        let userTimeZone = 'Europe/Budapest';
        try {
            userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        }
        catch (_a) { }
        let start_date_is_default = false;
        if (rawData.start_date instanceof Date) {
            this.start_date = rawData.start_date;
        }
        else if (typeof rawData.start_date === 'string') {
            this.start_date = !isNaN(Date.parse(rawData.start_date)) ? new Date(Date.parse(rawData.start_date)) : new Date();
        }
        else if (typeof rawData.start_date === 'number' && /^\d{10,13}$/.test(rawData.start_date)) {
            let theDate = parseInt(rawData.start_date, 10);
            if (theDate.toString().length === 10) {
                theDate = theDate * 1000;
            }
            this.start_date = new Date(theDate);
        }
        else {
            start_date_is_default = true;
            this.start_date = new Date();
            if (this.id == 0) {
                this.start_date.setSeconds(0);
                this.start_date.setMilliseconds(0);
                this.start_date.setTime(this.start_date.getTime() + exports.defaultTimeOffset);
            }
        }
        this.end_date = null;
        if (rawData.end_date instanceof Date) {
            this.end_date = rawData.end_date;
        }
        else if (rawData.end_date !== null && typeof rawData.end_date === 'string') {
            this.end_date = !isNaN(Date.parse(rawData.end_date)) ? new Date(Date.parse(rawData.end_date)) : null;
        }
        else if (rawData.end_date !== null && /^\d{10,13}$/.test(rawData.end_date)) {
            let theDate = parseInt(rawData.end_date, 10);
            if (theDate.toString().length === 10) {
                theDate = theDate * 1000;
            }
            this.end_date = new Date(theDate);
        }
        // @TODO - Should we manipulate data here?! Data manipulation should not be here..
        if (rawData.timezone != userTimeZone) {
            if (!start_date_is_default) {
                this.start_date = new Date(this.start_date.toLocaleString('en-US', { timeZone: rawData.timezone || undefined }));
            }
            if (this.end_date !== null) {
                this.end_date = new Date(this.end_date.toLocaleString('en-US', { timeZone: rawData.timezone || undefined }));
            }
        }
        this.feed = [];
        if (typeof rawData.feed !== 'undefined' && rawData.feed !== null) {
            const _feed = Array.isArray(rawData.feed) ? rawData.feed : Object.values(rawData.feed);
            for (const item of _feed) {
                const _item = item;
                _item.show_in_feed = typeof _item.show_in_feed === 'undefined' || _item.show_in_feed;
                this.feed.push(new feed_1.Feed(_item));
            }
        }
        if (rawData.payment !== null) {
            this.payment = new payment_1.Payment(rawData.payment);
        }
        if (this.width && this.height) {
            // Portrait fix
            if (this.orientation === 0) {
                if (this.width > this.height) {
                    const tmp = this.width;
                    this.width = this.height;
                    this.height = tmp;
                }
            }
        }
    }
    parseBool(v) {
        switch (v) {
            case true:
            case 'true':
            case 1:
            case '1':
            case 'on':
            case 'yes':
                return true;
            default:
                return false;
        }
    }
    // @TODO - Not yet finished!
    updateValues(rawData) {
        if (Object.prototype.toString.call(rawData) !== '[object Object]') {
            return;
        }
        for (const [key, value] of Object.entries(rawData)) {
            if (!this.hasOwnProperty(key)) {
                continue;
            }
            if (key === 'feed') {
                let _feeds = Array.isArray(value) ? value : Object.values(value);
                let feeds = [];
                for (const item of _feeds) {
                    feeds.push(new feed_1.Feed(item));
                }
                this[key] = feeds;
                continue;
            }
            if (key === 'polls') {
                let polls = [];
                for (const item of value) {
                    polls.push(new poll_1.Poll(item));
                }
                this[key] = polls;
                continue;
            }
            if (key === 'payment' && value) {
                this[key] = new payment_1.Payment(value);
                continue;
            }
            if (key === 'restreams' && value) {
                let platforms = [];
                for (const index in value) {
                    platforms.push(new connectedplatform_1.ConnectedPlatform(value[index]));
                }
                this[key] = platforms;
                continue;
            }
            if ((key === 'logo' || key === 'cover' || key === 'cover_portrait') &&
                Object.prototype.toString.call(value) === '[object Object]' &&
                Object.keys(value).length > 0) {
                this[key] = new media_1.Media(value.id, value.url, value.thumbnail_url);
                continue;
            }
            if (key === 'start_date' || key === 'end_date') {
                if (value) {
                    if (value instanceof Date) {
                        this[key] = new Date(value.getTime());
                    }
                    else {
                        this[key] = new Date(parseInt(value, 10) * 1000);
                    }
                    // @deprecated
                    // NOTE: This is done in _prepareEntityToSubmit() method in admin's services/Stream.js
                    //
                    // if (this[key] != null && rawData.timezone) {
                    //   const theDate = this[key] as Date;
                    //   const timezoneCorrected = moment(theDate.getTime()).tz(rawData.timezone)
                    //   this[key] = new Date(timezoneCorrected.format('MM/DD/YYYY HH:mm'))
                    // }
                }
                continue;
            }
            if (key === 'max_width' || key === 'max_height') {
                this[key] = /^\d+$/.exec(value) && parseInt(value, 10) > 0 ? parseInt(value, 10) : 0;
                if (this[key] === 0) {
                    this[key] = exports.defaultMaxDimensions[key];
                }
                continue;
            }
            this[key] = value;
        }
        this.validate();
    }
    validate() {
        if (this.type < 0) {
            throw new errors_1.StreamDataValidationError('Invalid stream type value was given. Value must be 0 or positive integer value.', 'currency');
        }
        const colors = {
            title_color: this.title_color,
            button_color: this.button_color,
            text_color: this.text_color,
        };
        for (const [fieldName, fieldValue] of Object.entries(colors)) {
            if (fieldValue != null && exports.colorRegexp.exec(fieldValue) == null) {
                throw new errors_1.StreamDataValidationError('Invalid color value was given. Supported color formats are: hex values (#000 or #000000) OR rgb() parttern.', fieldName);
            }
        }
        const currencyCodes = consts_1.streamAvailableCurrencies.map((c) => c.code);
        if (this.currency != null && !currencyCodes.includes(this.currency)) {
            throw new errors_1.StreamDataValidationError('Invalid currency was given. Available values are ' + currencyCodes.join(', ') + '.', 'currency');
        }
    }
    get products() {
        return this.feed.filter((f) => !!f.show_in_feed === true);
    }
    get streamkeyForWebcamLive() {
        return this.webcam_streamkey ? this.webcam_streamkey : this.streamkey;
    }
    get unansweredOpenPollsNumber() {
        return this.polls.filter((poll) => !poll.closed && !poll.isAnswered).length;
    }
}
exports.StreamData = StreamData;
//# sourceMappingURL=streamdata.js.map

/***/ }),

/***/ 734:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.streamAvailableCurrencies = void 0;
exports.streamAvailableCurrencies = [
    {
        code: 'usd',
        label: 'U.S. Dollar',
        stripeMinAmount: 0.5,
    },
    {
        code: 'eur',
        label: 'Euro',
        stripeMinAmount: 0.5,
    },
    {
        code: 'chf',
        label: 'Swiss franc',
        stripeMinAmount: 0.5,
    },
    {
        code: 'huf',
        label: 'Hungarian Forint',
        stripeMinAmount: 175,
    },
    {
        code: 'czk',
        label: 'Czech koruna',
        stripeMinAmount: 15,
    },
    {
        code: 'pln',
        label: 'Polish zloty',
        stripeMinAmount: 2,
    },
];
//# sourceMappingURL=consts.js.map

/***/ }),

/***/ 770:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StreamDataValidationError = void 0;
var validation_1 = __webpack_require__(187);
Object.defineProperty(exports, "StreamDataValidationError", ({ enumerable: true, get: function () { return validation_1.StreamDataValidationError; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 187:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StreamDataValidationError = void 0;
class StreamDataValidationError extends Error {
    constructor(msg, field) {
        super(msg);
        this._field = field;
        this._errorMessage = msg;
        Object.setPrototypeOf(this, StreamDataValidationError.prototype);
    }
    get field() {
        return this._field;
    }
    get errorMessage() {
        return this._errorMessage;
    }
}
exports.StreamDataValidationError = StreamDataValidationError;
//# sourceMappingURL=validation.js.map

/***/ }),

/***/ 248:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(337), exports);
__exportStar(__webpack_require__(387), exports);
__exportStar(__webpack_require__(770), exports);
__exportStar(__webpack_require__(734), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 337:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(946), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 946:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StreamStatus = exports.StreamVideoLayout = void 0;
var StreamVideoLayout;
(function (StreamVideoLayout) {
    StreamVideoLayout["Fit"] = "fit";
    StreamVideoLayout["Fill"] = "fill";
})(StreamVideoLayout || (exports.StreamVideoLayout = StreamVideoLayout = {}));
var StreamStatus;
(function (StreamStatus) {
    StreamStatus[StreamStatus["Waiting"] = 0] = "Waiting";
    StreamStatus[StreamStatus["Live"] = 1] = "Live";
    StreamStatus[StreamStatus["Paused"] = 2] = "Paused";
    StreamStatus[StreamStatus["Closed"] = 3] = "Closed";
})(StreamStatus || (exports.StreamStatus = StreamStatus = {}));
//# sourceMappingURL=istreamdata.js.map

/***/ }),

/***/ 191:
/***/ (function(module) {

module.exports = class CommentPlatform
{
  constructor({
    type,
    id,
    userId,
    name,
    commentId,
  }) {
    this.type = type;
    this.id = id;
    this.userId = userId;
    this.name = name;
    this.commentId = commentId;
  }

  get platformServiceId() {
    return this.type + '_' + this.id;
  }
};


/***/ }),

/***/ 429:
/***/ (function(module) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_187__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_187__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_187__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_187__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__nested_webpack_require_187__.d = function(exports, name, getter) {
/******/ 		if(!__nested_webpack_require_187__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__nested_webpack_require_187__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__nested_webpack_require_187__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __nested_webpack_require_187__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__nested_webpack_require_187__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __nested_webpack_require_187__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__nested_webpack_require_187__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__nested_webpack_require_187__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__nested_webpack_require_187__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_187__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_187__(__nested_webpack_require_187__.s = "fae3");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __nested_webpack_require_3663__) {

var wellKnownSymbol = __nested_webpack_require_3663__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __nested_webpack_require_3943__) {

var aFunction = __nested_webpack_require_3943__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "04d1":
/***/ (function(module, exports, __nested_webpack_require_4619__) {

var userAgent = __nested_webpack_require_4619__("342f");

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __nested_webpack_require_4843__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var toIndexedObject = __nested_webpack_require_4843__("fc6a");
var $getOwnPropertyNames = __nested_webpack_require_4843__("241c").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __nested_webpack_require_5671__) {

var DESCRIPTORS = __nested_webpack_require_5671__("83ab");
var propertyIsEnumerableModule = __nested_webpack_require_5671__("d1e7");
var createPropertyDescriptor = __nested_webpack_require_5671__("5c6c");
var toIndexedObject = __nested_webpack_require_5671__("fc6a");
var toPrimitive = __nested_webpack_require_5671__("c04e");
var has = __nested_webpack_require_5671__("5135");
var IE8_DOM_DEFINE = __nested_webpack_require_5671__("0cfb");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "07ac":
/***/ (function(module, exports, __nested_webpack_require_6717__) {

var $ = __nested_webpack_require_6717__("23e7");
var $values = __nested_webpack_require_6717__("6f53").values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ "0b32":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0cb2":
/***/ (function(module, exports, __nested_webpack_require_7184__) {

var toObject = __nested_webpack_require_7184__("7b0b");

var floor = Math.floor;
var replace = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __nested_webpack_require_8654__) {

var DESCRIPTORS = __nested_webpack_require_8654__("83ab");
var fails = __nested_webpack_require_8654__("d039");
var createElement = __nested_webpack_require_8654__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "107c":
/***/ (function(module, exports, __nested_webpack_require_9167__) {

var fails = __nested_webpack_require_9167__("d039");

module.exports = fails(function () {
  // babel-minify transpiles RegExp('.', 'g') -> /./g and it causes SyntaxError
  var re = RegExp('(?<a>b)', (typeof '').charAt(5));
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __nested_webpack_require_9548__) {

var classof = __nested_webpack_require_9548__("c6b6");
var regexpExec = __nested_webpack_require_9548__("9263");

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "159b":
/***/ (function(module, exports, __nested_webpack_require_10229__) {

var global = __nested_webpack_require_10229__("da84");
var DOMIterables = __nested_webpack_require_10229__("fdbc");
var forEach = __nested_webpack_require_10229__("17c2");
var createNonEnumerableProperty = __nested_webpack_require_10229__("9112");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __nested_webpack_require_10953__) {

"use strict";

var $forEach = __nested_webpack_require_10953__("b727").forEach;
var arrayMethodIsStrict = __nested_webpack_require_10953__("a640");

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ "19aa":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __nested_webpack_require_11817__) {

var getBuiltIn = __nested_webpack_require_11817__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __nested_webpack_require_12211__) {

var wellKnownSymbol = __nested_webpack_require_12211__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1c94":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_13271__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vueperslide_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_13271__("4192");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vueperslide_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_13271__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vueperslide_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1cdc":
/***/ (function(module, exports, __nested_webpack_require_14930__) {

var userAgent = __nested_webpack_require_14930__("342f");

module.exports = /(?:iphone|ipod|ipad).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __nested_webpack_require_15415__) {

var fails = __nested_webpack_require_15415__("d039");
var wellKnownSymbol = __nested_webpack_require_15415__("b622");
var V8_VERSION = __nested_webpack_require_15415__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "2266":
/***/ (function(module, exports, __nested_webpack_require_16142__) {

var anObject = __nested_webpack_require_16142__("825a");
var isArrayIteratorMethod = __nested_webpack_require_16142__("e95a");
var toLength = __nested_webpack_require_16142__("50c4");
var bind = __nested_webpack_require_16142__("0366");
var getIteratorMethod = __nested_webpack_require_16142__("35a1");
var iteratorClose = __nested_webpack_require_16142__("2a62");

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator);
      throw error;
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __nested_webpack_require_18205__) {

var toInteger = __nested_webpack_require_18205__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __nested_webpack_require_18721__) {

var global = __nested_webpack_require_18721__("da84");
var getOwnPropertyDescriptor = __nested_webpack_require_18721__("06cf").f;
var createNonEnumerableProperty = __nested_webpack_require_18721__("9112");
var redefine = __nested_webpack_require_18721__("6eeb");
var setGlobal = __nested_webpack_require_18721__("ce4e");
var copyConstructorProperties = __nested_webpack_require_18721__("e893");
var isForced = __nested_webpack_require_18721__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __nested_webpack_require_21221__) {

var internalObjectKeys = __nested_webpack_require_21221__("ca84");
var enumBugKeys = __nested_webpack_require_21221__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "2532":
/***/ (function(module, exports, __nested_webpack_require_21758__) {

"use strict";

var $ = __nested_webpack_require_21758__("23e7");
var notARegExp = __nested_webpack_require_21758__("5a34");
var requireObjectCoercible = __nested_webpack_require_21758__("1d80");
var correctIsRegExpLogic = __nested_webpack_require_21758__("ab13");

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __nested_webpack_require_22450__) {

"use strict";

var getBuiltIn = __nested_webpack_require_22450__("d066");
var definePropertyModule = __nested_webpack_require_22450__("9bf2");
var wellKnownSymbol = __nested_webpack_require_22450__("b622");
var DESCRIPTORS = __nested_webpack_require_22450__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "2a62":
/***/ (function(module, exports, __nested_webpack_require_23123__) {

var anObject = __nested_webpack_require_23123__("825a");

module.exports = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject(returnMethod.call(iterator)).value;
  }
};


/***/ }),

/***/ "2cf4":
/***/ (function(module, exports, __nested_webpack_require_23431__) {

var global = __nested_webpack_require_23431__("da84");
var fails = __nested_webpack_require_23431__("d039");
var bind = __nested_webpack_require_23431__("0366");
var html = __nested_webpack_require_23431__("1be4");
var createElement = __nested_webpack_require_23431__("cc12");
var IS_IOS = __nested_webpack_require_23431__("1cdc");
var IS_NODE = __nested_webpack_require_23431__("605d");

var location = global.location;
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins -- safe
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    typeof postMessage == 'function' &&
    !global.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __nested_webpack_require_26446__) {

var global = __nested_webpack_require_26446__("da84");
var userAgent = __nested_webpack_require_26446__("342f");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "342f":
/***/ (function(module, exports, __nested_webpack_require_27060__) {

var getBuiltIn = __nested_webpack_require_27060__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __nested_webpack_require_27252__) {

var classof = __nested_webpack_require_27252__("f5df");
var Iterators = __nested_webpack_require_27252__("3f8c");
var wellKnownSymbol = __nested_webpack_require_27252__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __nested_webpack_require_27655__) {

var DESCRIPTORS = __nested_webpack_require_27655__("83ab");
var definePropertyModule = __nested_webpack_require_27655__("9bf2");
var anObject = __nested_webpack_require_27655__("825a");
var objectKeys = __nested_webpack_require_27655__("df75");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __nested_webpack_require_28404__) {

var isObject = __nested_webpack_require_28404__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __nested_webpack_require_28690__) {

"use strict";

var charAt = __nested_webpack_require_28690__("6547").charAt;
var InternalStateModule = __nested_webpack_require_28690__("69f3");
var defineIterator = __nested_webpack_require_28690__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "4192":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "428f":
/***/ (function(module, exports, __nested_webpack_require_29984__) {

var global = __nested_webpack_require_29984__("da84");

module.exports = global;


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __nested_webpack_require_30136__) {

var fails = __nested_webpack_require_30136__("d039");
var classof = __nested_webpack_require_30136__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __nested_webpack_require_30721__) {

var wellKnownSymbol = __nested_webpack_require_30721__("b622");
var create = __nested_webpack_require_30721__("7c73");
var definePropertyModule = __nested_webpack_require_30721__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44de":
/***/ (function(module, exports, __nested_webpack_require_31428__) {

var global = __nested_webpack_require_31428__("da84");

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __nested_webpack_require_31732__) {

var isObject = __nested_webpack_require_31732__("861d");
var classof = __nested_webpack_require_31732__("c6b6");
var wellKnownSymbol = __nested_webpack_require_31732__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "4840":
/***/ (function(module, exports, __nested_webpack_require_32224__) {

var anObject = __nested_webpack_require_32224__("825a");
var aFunction = __nested_webpack_require_32224__("1c0b");
var wellKnownSymbol = __nested_webpack_require_32224__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __nested_webpack_require_32790__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __nested_webpack_require_32790__("2d00");
var fails = __nested_webpack_require_32790__("d039");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __nested_webpack_require_33567__) {

var toIndexedObject = __nested_webpack_require_33567__("fc6a");
var toLength = __nested_webpack_require_33567__("50c4");
var toAbsoluteIndex = __nested_webpack_require_33567__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __nested_webpack_require_34912__) {

"use strict";

var $ = __nested_webpack_require_34912__("23e7");
var $filter = __nested_webpack_require_34912__("b727").filter;
var arrayMethodHasSpeciesSupport = __nested_webpack_require_34912__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __nested_webpack_require_35575__) {

"use strict";

var bind = __nested_webpack_require_35575__("0366");
var toObject = __nested_webpack_require_35575__("7b0b");
var callWithSafeIterationClosing = __nested_webpack_require_35575__("9bdd");
var isArrayIteratorMethod = __nested_webpack_require_35575__("e95a");
var toLength = __nested_webpack_require_35575__("50c4");
var createProperty = __nested_webpack_require_35575__("8418");
var getIteratorMethod = __nested_webpack_require_35575__("35a1");

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "4e82":
/***/ (function(module, exports, __nested_webpack_require_37388__) {

"use strict";

var $ = __nested_webpack_require_37388__("23e7");
var aFunction = __nested_webpack_require_37388__("1c0b");
var toObject = __nested_webpack_require_37388__("7b0b");
var toLength = __nested_webpack_require_37388__("50c4");
var fails = __nested_webpack_require_37388__("d039");
var internalSort = __nested_webpack_require_37388__("addb");
var arrayMethodIsStrict = __nested_webpack_require_37388__("a640");
var FF = __nested_webpack_require_37388__("04d1");
var IE_OR_EDGE = __nested_webpack_require_37388__("d998");
var V8 = __nested_webpack_require_37388__("2d00");
var WEBKIT = __nested_webpack_require_37388__("512c");

var test = [];
var nativeSort = test.sort;

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return String(x) > String(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aFunction(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort.call(array) : nativeSort.call(array, comparefn);

    var items = [];
    var arrayLength = toLength(array.length);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) items.push(array[index]);
    }

    items = internalSort(items, getSortCompare(comparefn));
    itemsLength = items.length;
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) delete array[index++];

    return array;
  }
});


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __nested_webpack_require_40357__) {

var toInteger = __nested_webpack_require_40357__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "512c":
/***/ (function(module, exports, __nested_webpack_require_40731__) {

var userAgent = __nested_webpack_require_40731__("342f");

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),

/***/ "5135":
/***/ (function(module, exports, __nested_webpack_require_40957__) {

var toObject = __nested_webpack_require_40957__("7b0b");

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};


/***/ }),

/***/ "5319":
/***/ (function(module, exports, __nested_webpack_require_41240__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __nested_webpack_require_41240__("d784");
var fails = __nested_webpack_require_41240__("d039");
var anObject = __nested_webpack_require_41240__("825a");
var toLength = __nested_webpack_require_41240__("50c4");
var toInteger = __nested_webpack_require_41240__("a691");
var requireObjectCoercible = __nested_webpack_require_41240__("1d80");
var advanceStringIndex = __nested_webpack_require_41240__("8aa5");
var getSubstitution = __nested_webpack_require_41240__("0cb2");
var regExpExec = __nested_webpack_require_41240__("14c3");
var wellKnownSymbol = __nested_webpack_require_41240__("b622");

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      if (
        typeof replaceValue === 'string' &&
        replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1 &&
        replaceValue.indexOf('$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, this, string, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(this);
      var S = String(string);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __nested_webpack_require_46103__) {

var IS_PURE = __nested_webpack_require_46103__("c430");
var store = __nested_webpack_require_46103__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.15.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __nested_webpack_require_46526__) {

var getBuiltIn = __nested_webpack_require_46526__("d066");
var getOwnPropertyNamesModule = __nested_webpack_require_46526__("241c");
var getOwnPropertySymbolsModule = __nested_webpack_require_46526__("7418");
var anObject = __nested_webpack_require_46526__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __nested_webpack_require_47443__) {

var requireObjectCoercible = __nested_webpack_require_47443__("1d80");
var whitespaces = __nested_webpack_require_47443__("5899");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "5a34":
/***/ (function(module, exports, __nested_webpack_require_48556__) {

var isRegExp = __nested_webpack_require_48556__("44e7");

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "605d":
/***/ (function(module, exports, __nested_webpack_require_49064__) {

var classof = __nested_webpack_require_49064__("c6b6");
var global = __nested_webpack_require_49064__("da84");

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ "6069":
/***/ (function(module, exports) {

module.exports = typeof window == 'object';


/***/ }),

/***/ "60da":
/***/ (function(module, exports, __nested_webpack_require_49396__) {

"use strict";

var DESCRIPTORS = __nested_webpack_require_49396__("83ab");
var fails = __nested_webpack_require_49396__("d039");
var objectKeys = __nested_webpack_require_49396__("df75");
var getOwnPropertySymbolsModule = __nested_webpack_require_49396__("7418");
var propertyIsEnumerableModule = __nested_webpack_require_49396__("d1e7");
var toObject = __nested_webpack_require_49396__("7b0b");
var IndexedObject = __nested_webpack_require_49396__("44ad");

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __nested_webpack_require_51598__) {

var toInteger = __nested_webpack_require_51598__("a691");
var requireObjectCoercible = __nested_webpack_require_51598__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __nested_webpack_require_52797__) {

var isObject = __nested_webpack_require_52797__("861d");
var isArray = __nested_webpack_require_52797__("e8b5");
var wellKnownSymbol = __nested_webpack_require_52797__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "682b":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_53582__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vueperslides_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_53582__("fe3f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vueperslides_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_53582__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vueperslides_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __nested_webpack_require_55244__) {

var NATIVE_WEAK_MAP = __nested_webpack_require_55244__("7f9a");
var global = __nested_webpack_require_55244__("da84");
var isObject = __nested_webpack_require_55244__("861d");
var createNonEnumerableProperty = __nested_webpack_require_55244__("9112");
var objectHas = __nested_webpack_require_55244__("5135");
var shared = __nested_webpack_require_55244__("c6cd");
var sharedKey = __nested_webpack_require_55244__("f772");
var hiddenKeys = __nested_webpack_require_55244__("d012");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __nested_webpack_require_57176__) {

var global = __nested_webpack_require_57176__("da84");
var createNonEnumerableProperty = __nested_webpack_require_57176__("9112");
var has = __nested_webpack_require_57176__("5135");
var setGlobal = __nested_webpack_require_57176__("ce4e");
var inspectSource = __nested_webpack_require_57176__("8925");
var InternalStateModule = __nested_webpack_require_57176__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "6f53":
/***/ (function(module, exports, __nested_webpack_require_58790__) {

var DESCRIPTORS = __nested_webpack_require_58790__("83ab");
var objectKeys = __nested_webpack_require_58790__("df75");
var toIndexedObject = __nested_webpack_require_58790__("fc6a");
var propertyIsEnumerable = __nested_webpack_require_58790__("d1e7").f;

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __nested_webpack_require_59790__) {

var isObject = __nested_webpack_require_59790__("861d");
var setPrototypeOf = __nested_webpack_require_59790__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __nested_webpack_require_60717__) {

var path = __nested_webpack_require_60717__("428f");
var has = __nested_webpack_require_60717__("5135");
var wrappedWellKnownSymbolModule = __nested_webpack_require_60717__("e538");
var defineProperty = __nested_webpack_require_60717__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __nested_webpack_require_61437__) {

var requireObjectCoercible = __nested_webpack_require_61437__("1d80");

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __nested_webpack_require_61747__) {

var anObject = __nested_webpack_require_61747__("825a");
var defineProperties = __nested_webpack_require_61747__("37e8");
var enumBugKeys = __nested_webpack_require_61747__("7839");
var hiddenKeys = __nested_webpack_require_61747__("d012");
var html = __nested_webpack_require_61747__("1be4");
var documentCreateElement = __nested_webpack_require_61747__("cc12");
var sharedKey = __nested_webpack_require_61747__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7db0":
/***/ (function(module, exports, __nested_webpack_require_64643__) {

"use strict";

var $ = __nested_webpack_require_64643__("23e7");
var $find = __nested_webpack_require_64643__("b727").find;
var addToUnscopables = __nested_webpack_require_64643__("44d2");

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __nested_webpack_require_65403__) {

"use strict";

var $ = __nested_webpack_require_65403__("23e7");
var createIteratorConstructor = __nested_webpack_require_65403__("9ed3");
var getPrototypeOf = __nested_webpack_require_65403__("e163");
var setPrototypeOf = __nested_webpack_require_65403__("d2bb");
var setToStringTag = __nested_webpack_require_65403__("d44e");
var createNonEnumerableProperty = __nested_webpack_require_65403__("9112");
var redefine = __nested_webpack_require_65403__("6eeb");
var wellKnownSymbol = __nested_webpack_require_65403__("b622");
var IS_PURE = __nested_webpack_require_65403__("c430");
var Iterators = __nested_webpack_require_65403__("3f8c");
var IteratorsCore = __nested_webpack_require_65403__("ae93");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __nested_webpack_require_69394__) {

var global = __nested_webpack_require_69394__("da84");
var inspectSource = __nested_webpack_require_69394__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "81d5":
/***/ (function(module, exports, __nested_webpack_require_69695__) {

"use strict";

var toObject = __nested_webpack_require_69695__("7b0b");
var toAbsoluteIndex = __nested_webpack_require_69695__("23cb");
var toLength = __nested_webpack_require_69695__("50c4");

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __nested_webpack_require_70492__) {

var isObject = __nested_webpack_require_70492__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __nested_webpack_require_70750__) {

var fails = __nested_webpack_require_70750__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __nested_webpack_require_71140__) {

"use strict";

var toPrimitive = __nested_webpack_require_71140__("c04e");
var definePropertyModule = __nested_webpack_require_71140__("9bf2");
var createPropertyDescriptor = __nested_webpack_require_71140__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "857a":
/***/ (function(module, exports, __nested_webpack_require_71639__) {

var requireObjectCoercible = __nested_webpack_require_71639__("1d80");

var quot = /"/g;

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = String(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __nested_webpack_require_75578__) {

var store = __nested_webpack_require_75578__("c6cd");

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __nested_webpack_require_75999__) {

"use strict";

var charAt = __nested_webpack_require_75999__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __nested_webpack_require_76591__) {

var DESCRIPTORS = __nested_webpack_require_76591__("83ab");
var definePropertyModule = __nested_webpack_require_76591__("9bf2");
var createPropertyDescriptor = __nested_webpack_require_76591__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __nested_webpack_require_77063__) {

"use strict";

/* eslint-disable regexp/no-assertion-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var regexpFlags = __nested_webpack_require_77063__("ad6d");
var stickyHelpers = __nested_webpack_require_77063__("9f7f");
var shared = __nested_webpack_require_77063__("5692");
var create = __nested_webpack_require_77063__("7c73");
var getInternalState = __nested_webpack_require_77063__("69f3").get;
var UNSUPPORTED_DOT_ALL = __nested_webpack_require_77063__("fce3");
var UNSUPPORTED_NCG = __nested_webpack_require_77063__("107c");

var nativeExec = RegExp.prototype.exec;
var nativeReplace = shared('native-string-replace', String.prototype.replace);

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  // eslint-disable-next-line max-statements -- TODO
  patchedExec = function exec(str) {
    var re = this;
    var state = getInternalState(re);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = patchedExec.call(raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __nested_webpack_require_80793__) {

var fails = __nested_webpack_require_80793__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "9911":
/***/ (function(module, exports, __nested_webpack_require_81448__) {

"use strict";

var $ = __nested_webpack_require_81448__("23e7");
var createHTML = __nested_webpack_require_81448__("857a");
var forcedStringHTMLMethod = __nested_webpack_require_81448__("af03");

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __nested_webpack_require_81940__) {

"use strict";

var $ = __nested_webpack_require_81940__("23e7");
var fails = __nested_webpack_require_81940__("d039");
var isArray = __nested_webpack_require_81940__("e8b5");
var isObject = __nested_webpack_require_81940__("861d");
var toObject = __nested_webpack_require_81940__("7b0b");
var toLength = __nested_webpack_require_81940__("50c4");
var createProperty = __nested_webpack_require_81940__("8418");
var arraySpeciesCreate = __nested_webpack_require_81940__("65f0");
var arrayMethodHasSpeciesSupport = __nested_webpack_require_81940__("1dde");
var wellKnownSymbol = __nested_webpack_require_81940__("b622");
var V8_VERSION = __nested_webpack_require_81940__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __nested_webpack_require_84338__) {

var anObject = __nested_webpack_require_84338__("825a");
var iteratorClose = __nested_webpack_require_84338__("2a62");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator);
    throw error;
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __nested_webpack_require_84785__) {

var DESCRIPTORS = __nested_webpack_require_84785__("83ab");
var IE8_DOM_DEFINE = __nested_webpack_require_84785__("0cfb");
var anObject = __nested_webpack_require_84785__("825a");
var toPrimitive = __nested_webpack_require_84785__("c04e");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __nested_webpack_require_85682__) {

"use strict";

var IteratorPrototype = __nested_webpack_require_85682__("ae93").IteratorPrototype;
var create = __nested_webpack_require_85682__("7c73");
var createPropertyDescriptor = __nested_webpack_require_85682__("5c6c");
var setToStringTag = __nested_webpack_require_85682__("d44e");
var Iterators = __nested_webpack_require_85682__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __nested_webpack_require_86449__) {

var fails = __nested_webpack_require_86449__("d039");

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
var RE = function (s, f) {
  return RegExp(s, f);
};

exports.UNSUPPORTED_Y = fails(function () {
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ "a434":
/***/ (function(module, exports, __nested_webpack_require_87020__) {

"use strict";

var $ = __nested_webpack_require_87020__("23e7");
var toAbsoluteIndex = __nested_webpack_require_87020__("23cb");
var toInteger = __nested_webpack_require_87020__("a691");
var toLength = __nested_webpack_require_87020__("50c4");
var toObject = __nested_webpack_require_87020__("7b0b");
var arraySpeciesCreate = __nested_webpack_require_87020__("65f0");
var createProperty = __nested_webpack_require_87020__("8418");
var arrayMethodHasSpeciesSupport = __nested_webpack_require_87020__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),

/***/ "a4b4":
/***/ (function(module, exports, __nested_webpack_require_89650__) {

var userAgent = __nested_webpack_require_89650__("342f");

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __nested_webpack_require_89835__) {

"use strict";

var $ = __nested_webpack_require_89835__("23e7");
var global = __nested_webpack_require_89835__("da84");
var getBuiltIn = __nested_webpack_require_89835__("d066");
var IS_PURE = __nested_webpack_require_89835__("c430");
var DESCRIPTORS = __nested_webpack_require_89835__("83ab");
var NATIVE_SYMBOL = __nested_webpack_require_89835__("4930");
var USE_SYMBOL_AS_UID = __nested_webpack_require_89835__("fdbf");
var fails = __nested_webpack_require_89835__("d039");
var has = __nested_webpack_require_89835__("5135");
var isArray = __nested_webpack_require_89835__("e8b5");
var isObject = __nested_webpack_require_89835__("861d");
var anObject = __nested_webpack_require_89835__("825a");
var toObject = __nested_webpack_require_89835__("7b0b");
var toIndexedObject = __nested_webpack_require_89835__("fc6a");
var toPrimitive = __nested_webpack_require_89835__("c04e");
var createPropertyDescriptor = __nested_webpack_require_89835__("5c6c");
var nativeObjectCreate = __nested_webpack_require_89835__("7c73");
var objectKeys = __nested_webpack_require_89835__("df75");
var getOwnPropertyNamesModule = __nested_webpack_require_89835__("241c");
var getOwnPropertyNamesExternal = __nested_webpack_require_89835__("057f");
var getOwnPropertySymbolsModule = __nested_webpack_require_89835__("7418");
var getOwnPropertyDescriptorModule = __nested_webpack_require_89835__("06cf");
var definePropertyModule = __nested_webpack_require_89835__("9bf2");
var propertyIsEnumerableModule = __nested_webpack_require_89835__("d1e7");
var createNonEnumerableProperty = __nested_webpack_require_89835__("9112");
var redefine = __nested_webpack_require_89835__("6eeb");
var shared = __nested_webpack_require_89835__("5692");
var sharedKey = __nested_webpack_require_89835__("f772");
var hiddenKeys = __nested_webpack_require_89835__("d012");
var uid = __nested_webpack_require_89835__("90e3");
var wellKnownSymbol = __nested_webpack_require_89835__("b622");
var wrappedWellKnownSymbolModule = __nested_webpack_require_89835__("e538");
var defineWellKnownSymbol = __nested_webpack_require_89835__("746f");
var setToStringTag = __nested_webpack_require_89835__("d44e");
var InternalStateModule = __nested_webpack_require_89835__("69f3");
var $forEach = __nested_webpack_require_89835__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a630":
/***/ (function(module, exports, __nested_webpack_require_102529__) {

var $ = __nested_webpack_require_102529__("23e7");
var from = __nested_webpack_require_102529__("4df4");
var checkCorrectnessOfIteration = __nested_webpack_require_102529__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __nested_webpack_require_103080__) {

"use strict";

var fails = __nested_webpack_require_103080__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __nested_webpack_require_103820__) {

"use strict";

var DESCRIPTORS = __nested_webpack_require_103820__("83ab");
var global = __nested_webpack_require_103820__("da84");
var isForced = __nested_webpack_require_103820__("94ca");
var redefine = __nested_webpack_require_103820__("6eeb");
var has = __nested_webpack_require_103820__("5135");
var classof = __nested_webpack_require_103820__("c6b6");
var inheritIfRequired = __nested_webpack_require_103820__("7156");
var toPrimitive = __nested_webpack_require_103820__("c04e");
var fails = __nested_webpack_require_103820__("d039");
var create = __nested_webpack_require_103820__("7c73");
var getOwnPropertyNames = __nested_webpack_require_103820__("241c").f;
var getOwnPropertyDescriptor = __nested_webpack_require_103820__("06cf").f;
var defineProperty = __nested_webpack_require_103820__("9bf2").f;
var trim = __nested_webpack_require_103820__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "ab13":
/***/ (function(module, exports, __nested_webpack_require_107312__) {

var wellKnownSymbol = __nested_webpack_require_107312__("b622");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __nested_webpack_require_107748__) {

"use strict";

var $ = __nested_webpack_require_107748__("23e7");
var exec = __nested_webpack_require_107748__("9263");

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __nested_webpack_require_108096__) {

"use strict";

var anObject = __nested_webpack_require_108096__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "addb":
/***/ (function(module, exports) {

// TODO: use something more complex like timsort?
var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    mergeSort(array.slice(0, middle), comparefn),
    mergeSort(array.slice(middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;
  var result = [];

  while (lindex < llength || rindex < rlength) {
    if (lindex < llength && rindex < rlength) {
      result.push(comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]);
    } else {
      result.push(lindex < llength ? left[lindex++] : right[rindex++]);
    }
  } return result;
};

module.exports = mergeSort;


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __nested_webpack_require_109912__) {

"use strict";

var fails = __nested_webpack_require_109912__("d039");
var getPrototypeOf = __nested_webpack_require_109912__("e163");
var createNonEnumerableProperty = __nested_webpack_require_109912__("9112");
var has = __nested_webpack_require_109912__("5135");
var wellKnownSymbol = __nested_webpack_require_109912__("b622");
var IS_PURE = __nested_webpack_require_109912__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if ((!IS_PURE || NEW_ITERATOR_PROTOTYPE) && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "af03":
/***/ (function(module, exports, __nested_webpack_require_111650__) {

var fails = __nested_webpack_require_111650__("d039");

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ "b041":
/***/ (function(module, exports, __nested_webpack_require_112054__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __nested_webpack_require_112054__("00ee");
var classof = __nested_webpack_require_112054__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __nested_webpack_require_112488__) {

var DESCRIPTORS = __nested_webpack_require_112488__("83ab");
var defineProperty = __nested_webpack_require_112488__("9bf2").f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b575":
/***/ (function(module, exports, __nested_webpack_require_113218__) {

var global = __nested_webpack_require_113218__("da84");
var getOwnPropertyDescriptor = __nested_webpack_require_113218__("06cf").f;
var macrotask = __nested_webpack_require_113218__("2cf4").set;
var IS_IOS = __nested_webpack_require_113218__("1cdc");
var IS_WEBOS_WEBKIT = __nested_webpack_require_113218__("a4b4");
var IS_NODE = __nested_webpack_require_113218__("605d");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __nested_webpack_require_115983__) {

var global = __nested_webpack_require_115983__("da84");
var shared = __nested_webpack_require_115983__("5692");
var has = __nested_webpack_require_115983__("5135");
var uid = __nested_webpack_require_115983__("90e3");
var NATIVE_SYMBOL = __nested_webpack_require_115983__("4930");
var USE_SYMBOL_AS_UID = __nested_webpack_require_115983__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __nested_webpack_require_116883__) {

var $ = __nested_webpack_require_116883__("23e7");
var toObject = __nested_webpack_require_116883__("7b0b");
var nativeKeys = __nested_webpack_require_116883__("df75");
var fails = __nested_webpack_require_116883__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __nested_webpack_require_117410__) {

var bind = __nested_webpack_require_117410__("0366");
var IndexedObject = __nested_webpack_require_117410__("44ad");
var toObject = __nested_webpack_require_117410__("7b0b");
var toLength = __nested_webpack_require_117410__("50c4");
var arraySpeciesCreate = __nested_webpack_require_117410__("65f0");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod(7)
};


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __nested_webpack_require_120230__) {

var isObject = __nested_webpack_require_120230__("861d");

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __nested_webpack_require_121336__) {

var global = __nested_webpack_require_121336__("da84");
var setGlobal = __nested_webpack_require_121336__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c740":
/***/ (function(module, exports, __nested_webpack_require_121621__) {

"use strict";

var $ = __nested_webpack_require_121621__("23e7");
var $findIndex = __nested_webpack_require_121621__("b727").findIndex;
var addToUnscopables = __nested_webpack_require_121621__("44d2");

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __nested_webpack_require_122980__) {

var has = __nested_webpack_require_122980__("5135");
var toIndexedObject = __nested_webpack_require_122980__("fc6a");
var indexOf = __nested_webpack_require_122980__("4d64").indexOf;
var hiddenKeys = __nested_webpack_require_122980__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "caad":
/***/ (function(module, exports, __nested_webpack_require_123613__) {

"use strict";

var $ = __nested_webpack_require_123613__("23e7");
var $includes = __nested_webpack_require_123613__("4d64").includes;
var addToUnscopables = __nested_webpack_require_123613__("44d2");

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "cb29":
/***/ (function(module, exports, __nested_webpack_require_124228__) {

var $ = __nested_webpack_require_124228__("23e7");
var fill = __nested_webpack_require_124228__("81d5");
var addToUnscopables = __nested_webpack_require_124228__("44d2");

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __nested_webpack_require_124672__) {

var global = __nested_webpack_require_124672__("da84");
var isObject = __nested_webpack_require_124672__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cca6":
/***/ (function(module, exports, __nested_webpack_require_125087__) {

var $ = __nested_webpack_require_125087__("23e7");
var assign = __nested_webpack_require_125087__("60da");

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "cdf9":
/***/ (function(module, exports, __nested_webpack_require_125488__) {

var anObject = __nested_webpack_require_125488__("825a");
var isObject = __nested_webpack_require_125488__("861d");
var newPromiseCapability = __nested_webpack_require_125488__("f069");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __nested_webpack_require_125968__) {

var global = __nested_webpack_require_125968__("da84");
var createNonEnumerableProperty = __nested_webpack_require_125968__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __nested_webpack_require_126581__) {

var path = __nested_webpack_require_126581__("428f");
var global = __nested_webpack_require_126581__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __nested_webpack_require_127822__) {

var defineWellKnownSymbol = __nested_webpack_require_127822__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __nested_webpack_require_128086__) {

/* eslint-disable no-proto -- safe */
var anObject = __nested_webpack_require_128086__("825a");
var aPossiblePrototype = __nested_webpack_require_128086__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __nested_webpack_require_129149__) {

var TO_STRING_TAG_SUPPORT = __nested_webpack_require_129149__("00ee");
var redefine = __nested_webpack_require_129149__("6eeb");
var toString = __nested_webpack_require_129149__("b041");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __nested_webpack_require_129577__) {

var defineProperty = __nested_webpack_require_129577__("9bf2").f;
var has = __nested_webpack_require_129577__("5135");
var wellKnownSymbol = __nested_webpack_require_129577__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __nested_webpack_require_130053__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__nested_webpack_require_130053__("ac1f");
var redefine = __nested_webpack_require_130053__("6eeb");
var regexpExec = __nested_webpack_require_130053__("9263");
var fails = __nested_webpack_require_130053__("d039");
var wellKnownSymbol = __nested_webpack_require_130053__("b622");
var createNonEnumerableProperty = __nested_webpack_require_130053__("9112");

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine(String.prototype, KEY, methods[0]);
    redefine(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __nested_webpack_require_132670__) {

"use strict";

var $ = __nested_webpack_require_132670__("23e7");
var $map = __nested_webpack_require_132670__("b727").map;
var arrayMethodHasSpeciesSupport = __nested_webpack_require_132670__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "d998":
/***/ (function(module, exports, __nested_webpack_require_133309__) {

var UA = __nested_webpack_require_133309__("342f");

module.exports = /MSIE|Trident/.test(UA);


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __nested_webpack_require_133474__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_133474__("c8ba")))

/***/ }),

/***/ "dbb4":
/***/ (function(module, exports, __nested_webpack_require_134264__) {

var $ = __nested_webpack_require_134264__("23e7");
var DESCRIPTORS = __nested_webpack_require_134264__("83ab");
var ownKeys = __nested_webpack_require_134264__("56ef");
var toIndexedObject = __nested_webpack_require_134264__("fc6a");
var getOwnPropertyDescriptorModule = __nested_webpack_require_134264__("06cf");
var createProperty = __nested_webpack_require_134264__("8418");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __nested_webpack_require_135296__) {

var global = __nested_webpack_require_135296__("da84");
var DOMIterables = __nested_webpack_require_135296__("fdbc");
var ArrayIteratorMethods = __nested_webpack_require_135296__("e260");
var createNonEnumerableProperty = __nested_webpack_require_135296__("9112");
var wellKnownSymbol = __nested_webpack_require_135296__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "df75":
/***/ (function(module, exports, __nested_webpack_require_136879__) {

var internalObjectKeys = __nested_webpack_require_136879__("ca84");
var enumBugKeys = __nested_webpack_require_136879__("7839");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __nested_webpack_require_137286__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __nested_webpack_require_137286__("23e7");
var DESCRIPTORS = __nested_webpack_require_137286__("83ab");
var global = __nested_webpack_require_137286__("da84");
var has = __nested_webpack_require_137286__("5135");
var isObject = __nested_webpack_require_137286__("861d");
var defineProperty = __nested_webpack_require_137286__("9bf2").f;
var copyConstructorProperties = __nested_webpack_require_137286__("e893");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __nested_webpack_require_139430__) {

var has = __nested_webpack_require_139430__("5135");
var toObject = __nested_webpack_require_139430__("7b0b");
var sharedKey = __nested_webpack_require_139430__("f772");
var CORRECT_PROTOTYPE_GETTER = __nested_webpack_require_139430__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __nested_webpack_require_140250__) {

var fails = __nested_webpack_require_140250__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __nested_webpack_require_140622__) {

"use strict";

var toIndexedObject = __nested_webpack_require_140622__("fc6a");
var addToUnscopables = __nested_webpack_require_140622__("44d2");
var Iterators = __nested_webpack_require_140622__("3f8c");
var InternalStateModule = __nested_webpack_require_140622__("69f3");
var defineIterator = __nested_webpack_require_140622__("7dd0");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "e2cc":
/***/ (function(module, exports, __nested_webpack_require_142802__) {

var redefine = __nested_webpack_require_142802__("6eeb");

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "e439":
/***/ (function(module, exports, __nested_webpack_require_143067__) {

var $ = __nested_webpack_require_143067__("23e7");
var fails = __nested_webpack_require_143067__("d039");
var toIndexedObject = __nested_webpack_require_143067__("fc6a");
var nativeGetOwnPropertyDescriptor = __nested_webpack_require_143067__("06cf").f;
var DESCRIPTORS = __nested_webpack_require_143067__("83ab");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __nested_webpack_require_143864__) {

var wellKnownSymbol = __nested_webpack_require_143864__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e667":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "e6cf":
/***/ (function(module, exports, __nested_webpack_require_144248__) {

"use strict";

var $ = __nested_webpack_require_144248__("23e7");
var IS_PURE = __nested_webpack_require_144248__("c430");
var global = __nested_webpack_require_144248__("da84");
var getBuiltIn = __nested_webpack_require_144248__("d066");
var NativePromise = __nested_webpack_require_144248__("fea9");
var redefine = __nested_webpack_require_144248__("6eeb");
var redefineAll = __nested_webpack_require_144248__("e2cc");
var setPrototypeOf = __nested_webpack_require_144248__("d2bb");
var setToStringTag = __nested_webpack_require_144248__("d44e");
var setSpecies = __nested_webpack_require_144248__("2626");
var isObject = __nested_webpack_require_144248__("861d");
var aFunction = __nested_webpack_require_144248__("1c0b");
var anInstance = __nested_webpack_require_144248__("19aa");
var inspectSource = __nested_webpack_require_144248__("8925");
var iterate = __nested_webpack_require_144248__("2266");
var checkCorrectnessOfIteration = __nested_webpack_require_144248__("1c7e");
var speciesConstructor = __nested_webpack_require_144248__("4840");
var task = __nested_webpack_require_144248__("2cf4").set;
var microtask = __nested_webpack_require_144248__("b575");
var promiseResolve = __nested_webpack_require_144248__("cdf9");
var hostReportErrors = __nested_webpack_require_144248__("44de");
var newPromiseCapabilityModule = __nested_webpack_require_144248__("f069");
var perform = __nested_webpack_require_144248__("e667");
var InternalStateModule = __nested_webpack_require_144248__("69f3");
var isForced = __nested_webpack_require_144248__("94ca");
var wellKnownSymbol = __nested_webpack_require_144248__("b622");
var IS_BROWSER = __nested_webpack_require_144248__("6069");
var IS_NODE = __nested_webpack_require_144248__("605d");
var V8_VERSION = __nested_webpack_require_144248__("2d00");

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromiseConstructorPrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var NATIVE_REJECTION_EVENT = typeof PromiseRejectionEvent == 'function';
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromiseConstructorPrototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  task.call(global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  task.call(global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromiseConstructorPrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructorPrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && typeof NativePromise == 'function' && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          nativeThen.call(that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine(NativePromisePrototype, 'catch', PromiseConstructorPrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromiseConstructorPrototype);
    }
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __nested_webpack_require_158281__) {

var has = __nested_webpack_require_158281__("5135");
var ownKeys = __nested_webpack_require_158281__("56ef");
var getOwnPropertyDescriptorModule = __nested_webpack_require_158281__("06cf");
var definePropertyModule = __nested_webpack_require_158281__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __nested_webpack_require_158926__) {

var classof = __nested_webpack_require_158926__("c6b6");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __nested_webpack_require_159277__) {

var wellKnownSymbol = __nested_webpack_require_159277__("b622");
var Iterators = __nested_webpack_require_159277__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "f069":
/***/ (function(module, exports, __nested_webpack_require_159702__) {

"use strict";

var aFunction = __nested_webpack_require_159702__("1c0b");

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __nested_webpack_require_160364__) {

var TO_STRING_TAG_SUPPORT = __nested_webpack_require_160364__("00ee");
var classofRaw = __nested_webpack_require_160364__("c6b6");
var wellKnownSymbol = __nested_webpack_require_160364__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __nested_webpack_require_161417__) {

var shared = __nested_webpack_require_161417__("5692");
var uid = __nested_webpack_require_161417__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "fae3":
/***/ (function(module, __nested_webpack_exports__, __nested_webpack_require_161706__) {

"use strict";
// ESM COMPAT FLAG
__nested_webpack_require_161706__.r(__nested_webpack_exports__);

// EXPORTS
__nested_webpack_require_161706__.d(__nested_webpack_exports__, "VueperSlides", function() { return /* reexport */ vueperslides; });
__nested_webpack_require_161706__.d(__nested_webpack_exports__, "VueperSlide", function() { return /* reexport */ vueperslide; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __nested_webpack_require_161706__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __nested_webpack_require_161706__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"28eb6110-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/vueperslides/vueperslides.vue?vue&type=template&id=6306b6e6&lang=pug&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"vueperslides",staticClass:"s4a54",class:_vm.vueperslidesClasses,style:(_vm.vueperslidesStyles),attrs:{"aria-label":"Slideshow"}},[(_vm.slidesCount && _vm.conf.slideContentOutside === 'top')?_c('div',{staticClass:"sdc1b vueperslide__content-wrapper--outside-top",class:_vm.conf.slideContentOutsideClass},[(_vm.currentSlide.contentSlot)?_c('vnodes',{attrs:{"vnodes":_vm.currentSlide.contentSlot}}):[(_vm.currentSlide.title)?_c('div',{staticClass:"vueperslide__title",domProps:{"innerHTML":_vm._s(_vm.currentSlide.title)}}):_vm._e(),(_vm.currentSlide.content)?_c('div',{staticClass:"vueperslide__content",domProps:{"innerHTML":_vm._s(_vm.currentSlide.content)}}):_vm._e()]],2):_vm._e(),_c('div',{staticClass:"s901b"},[_c('div',{staticClass:"sa6e5",style:(("padding-bottom: " + (_vm.conf.slideRatio * 100) + "%")),attrs:{"aria-live":"polite"}},[_c('div',{ref:"track",staticClass:"sbd52",class:{ 'vueperslides__track--dragging': _vm.touch.dragging, 'vueperslides__track--mousedown': _vm.mouseDown },style:(_vm.trackStyles)},[_c('div',{staticClass:"s8908",style:(_vm.trackInnerStyles)},[_vm._t("default"),(_vm.isReady && _vm.conf.infinite && _vm.canSlide && _vm.lastSlide)?_c('vueper-slide',{staticClass:"vueperslide--clone sd449",style:(_vm.lastSlide.style),attrs:{"clone":"","title":_vm.lastSlide.title,"content":_vm.lastSlide.content,"image":_vm.lastSlide.image,"link":_vm.lastSlide.link,"lazyloaded":_vm.lastSlide.loaded,"aria-hidden":"true"}},[(_vm.lastSlide.contentSlot)?_c('template',{slot:"content"},[_c('vnodes',{attrs:{"vnodes":_vm.lastSlide.contentSlot}})],1):_vm._e(),(_vm.conf.lazy && !_vm.lastSlide.loaded)?_c('template',{slot:"loader"},[_c('vnodes',{attrs:{"vnodes":_vm.lastSlide.loaderSlot}})],1):_vm._e()],2):_vm._e(),(_vm.isReady && _vm.conf.infinite && _vm.canSlide && _vm.firstSlide)?_c('vueper-slide',{staticClass:"vueperslide--clone vueperslide--clone-2",style:(_vm.firstSlide.style),attrs:{"clone":"","title":_vm.firstSlide.title,"content":_vm.firstSlide.content,"image":_vm.firstSlide.image,"link":_vm.firstSlide.link,"lazyloaded":_vm.firstSlide.loaded,"aria-hidden":"true"}},[(_vm.firstSlide.contentSlot)?_c('template',{slot:"content"},[_c('vnodes',{attrs:{"vnodes":_vm.firstSlide.contentSlot}})],1):_vm._e(),(_vm.conf.lazy && !_vm.firstSlide.loaded)?_c('template',{slot:"loader"},[_c('vnodes',{attrs:{"vnodes":_vm.firstSlide.loaderSlot}})],1):_vm._e()],2):_vm._e()],2)])]),((_vm.conf.pauseOnHover || _vm.conf.pauseOnTouch) && _vm.$slots.pause)?_c('div',{staticClass:"s313f"},[_vm._t("pause")],2):_vm._e(),(_vm.conf.progress)?_c('div',{staticClass:"s0d8d"},[_vm._t("progress",function(){return [_c('div',{style:(("width: " + ((_vm.slides.current + 1) * 100 / _vm.slidesCount) + "%"))})]},{"current":_vm.slides.current + 1,"total":_vm.slidesCount})],2):_vm._e(),(_vm.conf.fractions)?_c('div',{staticClass:"sdbbf"},[_vm._t("fraction",function(){return [_vm._v(_vm._s(((_vm.slides.current + 1) + " / " + _vm.slidesCount)))]},{"current":_vm.slides.current + 1,"total":_vm.slidesCount})],2):_vm._e(),(_vm.conf.arrows && _vm.canSlide && !_vm.disable)?_c('div',{staticClass:"s90f5",class:{ 'vueperslides__arrows--outside': _vm.conf.arrowsOutside }},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.arrowPrevDisabled),expression:"!arrowPrevDisabled"}],staticClass:"s51c7 s748c",attrs:{"type":"button","aria-label":"Previous"},on:{"click":function($event){return _vm.previous()},"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }_vm.conf.rtl ? _vm.next() : _vm.previous()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }_vm.conf.rtl ? _vm.previous() : _vm.next()}]}},[_vm._t(("arrow-" + (_vm.conf.rtl ? 'right' : 'left')),function(){return [_c('svg',{attrs:{"viewBox":"0 0 9 18"}},[_c('path',{attrs:{"stroke-linecap":"round","d":_vm.conf.rtl ? 'm1 1 l7 8 -7 8' : 'm8 1 l-7 8 7 8'}})])]})],2),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.arrowNextDisabled),expression:"!arrowNextDisabled"}],staticClass:"s51c7 s1cbe",attrs:{"type":"button","aria-label":"Next"},on:{"click":function($event){return _vm.next()},"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }_vm.conf.rtl ? _vm.next() : _vm.previous()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }_vm.conf.rtl ? _vm.previous() : _vm.next()}]}},[_vm._t(("arrow-" + (_vm.conf.rtl ? 'left' : 'right')),function(){return [_c('svg',{attrs:{"viewBox":"0 0 9 18"}},[_c('path',{attrs:{"stroke-linecap":"round","d":_vm.conf.rtl ? 'm8 1 l-7 8 7 8' : 'm1 1 l7 8 -7 8'}})])]})],2)]):_vm._e(),(_vm.conf.bullets && _vm.canSlide && !_vm.disable && !_vm.conf.bulletsOutside)?_c('div',{ref:"bullets",staticClass:"sc954",attrs:{"role":"tablist","aria-label":"Slideshow navigation"}},[_vm._t("bullets",function(){return _vm._l((_vm.bulletIndexes),function(slideIndex,i){return _c('button',{key:i,staticClass:"s1a3f",class:{ 'vueperslides__bullet--active': _vm.slides.current === slideIndex },attrs:{"type":"button","role":"tab","aria-label":("Slide " + (i + 1))},on:{"click":function($event){return _vm.goToSlide(slideIndex)},"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }_vm.conf.rtl ? _vm.next() : _vm.previous()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }_vm.conf.rtl ? _vm.previous() : _vm.next()}]}},[_vm._t("bullet",function(){return [_c('div',{staticClass:"sc21f"},[_c('span',[_vm._v(_vm._s(i + 1))])])]},{"active":_vm.slides.current === slideIndex,"slideIndex":slideIndex,"index":i + 1})],2)})},{"currentSlide":_vm.slides.current,"bulletIndexes":_vm.bulletIndexes,"goToSlide":_vm.goToSlide,"previous":_vm.previous,"next":_vm.next})],2):_vm._e()]),(_vm.conf.bullets && _vm.canSlide && !_vm.disable && _vm.conf.bulletsOutside)?_c('div',{ref:"bullets",staticClass:"sc954 s069b",attrs:{"role":"tablist","aria-label":"Slideshow navigation"}},[_vm._t("bullets",function(){return _vm._l((_vm.bulletIndexes),function(slideIndex,i){return _c('button',{key:i,staticClass:"s1a3f",class:{ 'vueperslides__bullet--active': _vm.slides.current === slideIndex },attrs:{"type":"button","role":"tab","aria-label":("Slide " + (i + 1))},on:{"click":function($event){return _vm.goToSlide(slideIndex)},"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }_vm.conf.rtl ? _vm.next() : _vm.previous()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }_vm.conf.rtl ? _vm.previous() : _vm.next()}]}},[_vm._t("bullet",function(){return [_c('div',{staticClass:"sc21f"},[_c('span',[_vm._v(_vm._s(i + 1))])])]},{"active":_vm.slides.current === slideIndex,"slideIndex":slideIndex,"index":i + 1})],2)})},{"currentSlide":_vm.slides.current,"bulletIndexes":_vm.bulletIndexes,"goToSlide":_vm.goToSlide,"previous":_vm.previous,"next":_vm.next})],2):_vm._e(),(_vm.slidesCount && _vm.conf.slideContentOutside === 'bottom')?_c('div',{staticClass:"sdc1b vueperslide__content-wrapper--outside-bottom",class:_vm.conf.slideContentOutsideClass},[(_vm.currentSlide.contentSlot)?_c('vnodes',{attrs:{"vnodes":_vm.currentSlide.contentSlot}}):[(_vm.currentSlide.title)?_c('div',{staticClass:"vueperslide__title",domProps:{"innerHTML":_vm._s(_vm.currentSlide.title)}}):_vm._e(),(_vm.currentSlide.content)?_c('div',{staticClass:"vueperslide__content",domProps:{"innerHTML":_vm._s(_vm.currentSlide.content)}}):_vm._e()]],2):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/vueperslides/vueperslides.vue?vue&type=template&id=6306b6e6&lang=pug&

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __nested_webpack_require_161706__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __nested_webpack_require_161706__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __nested_webpack_require_161706__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __nested_webpack_require_161706__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __nested_webpack_require_161706__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __nested_webpack_require_161706__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __nested_webpack_require_161706__("ddb0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __nested_webpack_require_161706__("a630");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js








function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __nested_webpack_require_161706__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __nested_webpack_require_161706__("b0c0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js






function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __nested_webpack_require_161706__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __nested_webpack_require_161706__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __nested_webpack_require_161706__("e439");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __nested_webpack_require_161706__("159b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __nested_webpack_require_161706__("dbb4");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js








function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __nested_webpack_require_161706__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __nested_webpack_require_161706__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __nested_webpack_require_161706__("5319");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __nested_webpack_require_161706__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __nested_webpack_require_161706__("cb29");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.link.js
var es_string_link = __nested_webpack_require_161706__("9911");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __nested_webpack_require_161706__("4e82");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __nested_webpack_require_161706__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __nested_webpack_require_161706__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __nested_webpack_require_161706__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __nested_webpack_require_161706__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __nested_webpack_require_161706__("cca6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __nested_webpack_require_161706__("c740");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __nested_webpack_require_161706__("a434");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"28eb6110-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/vueperslides/vueperslide.vue?vue&type=template&id=048e73ef&lang=pug&
var vueperslidevue_type_template_id_048e73ef_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.link ? 'a' : 'div',{tag:"component",staticClass:"s3579",class:_vm.slideClasses,style:(_vm.slideStyles),attrs:{"href":_vm.link && !_vm.justDragged ? _vm.link : false,"target":_vm.link && _vm.openInNew ? (typeof _vm.openInNew === 'boolean' ? '_blank' : _vm.openInNew) : '_self',"face":_vm.slideFace3d,"aria-hidden":_vm.slides.activeId === _vm._uid || _vm.isSlideVisible ? 'false' : 'true'},on:{"mouseenter":function($event){return _vm.$emit('mouse-enter', { slideIndex: _vm.slideIndex, title: _vm.title, content: _vm.content, image: _vm.image, link: _vm.link }, _vm.$el)},"mouseleave":function($event){return _vm.$emit('mouse-leave')}}},[(_vm.videoObj)?[(_vm.videoObj.webm || _vm.videoObj.mp4)?_c('video',_vm._b({staticClass:"sb280",attrs:{"width":"100%","height":"100%"}},'video',_vm.videoObj.props || {},false),[(_vm.videoObj.webm)?_c('source',{attrs:{"src":_vm.videoObj.webm,"type":"video/webm"}}):_vm._e(),(_vm.videoObj.mp4)?_c('source',{attrs:{"src":_vm.videoObj.mp4,"type":"video/mp4"}}):_vm._e(),(_vm.videoObj.ogv)?_c('source',{attrs:{"src":_vm.videoObj.ogv,"type":"video/ogg"}}):_vm._e(),(_vm.videoObj.avi)?_c('source',{attrs:{"src":_vm.videoObj.avi,"type":"video/avi"}}):_vm._e(),_vm._v(_vm._s(_vm.videoObj.alt || "Sorry, your browser doesn't support embedded videos."))]):(_vm.videoObj.url)?_c('iframe',_vm._b({staticClass:"sb280",attrs:{"src":_vm.videoObj.url,"type":"text/html","frameborder":"0","width":"100%","height":"100%"}},'iframe',_vm.videoObj.props || {},false)):_vm._e()]:_vm._e(),(_vm.imageSrc && _vm.conf.slideImageInside)?_c('div',{staticClass:"s8b48",style:(_vm.imageStyles)}):_vm._e(),(_vm.conf.slideContentOutside)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._t("content",function(){return [_c('div',{staticClass:"sdc1b"},[(_vm.title)?_c('div',{staticClass:"vueperslide__title",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),(_vm.content)?_c('div',{staticClass:"vueperslide__content",domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e()])]})],2):_vm._t("content",function(){return [_c('div',{staticClass:"sdc1b"},[(_vm.title)?_c('div',{staticClass:"vueperslide__title",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),(_vm.content)?_c('div',{staticClass:"vueperslide__content",domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e()])]}),(_vm.conf.lazy && !_vm.loaded)?_c('div',{staticClass:"s7798"},[_vm._t("loader")],2):_vm._e()],2)}
var vueperslidevue_type_template_id_048e73ef_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/vueperslides/vueperslide.vue?vue&type=template&id=048e73ef&lang=pug&

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __nested_webpack_require_161706__("e6cf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __nested_webpack_require_161706__("07ac");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/vueperslides/vueperslide.vue?vue&type=script&lang=js&










//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var vueperslidevue_type_script_lang_js_ = ({
  inject: ['slides', 'touch', 'updateSlide', 'addClone', 'addSlide', 'removeSlide'],
  props: {
    clone: {
      type: Boolean
    },
    image: {
      type: String,
      default: ''
    },
    video: {
      type: [String, Object],
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: 0
    },
    lazyloaded: {
      type: Boolean
    },
    openInNew: {
      type: [Boolean, String]
    }
  },
  emits: ['mouse-enter', 'mouse-leave'],
  data: function data() {
    return {
      // For lazy loading.
      imageSrc: '',
      loading: false,
      loaded: false
    };
  },
  computed: {
    conf: function conf() {
      return this.$parent.conf;
    },
    slideClasses: function slideClasses() {
      return {
        'vueperslide--active': this.slides.activeId === this._uid,
        'vueperslide--previous-slide': this.isPreviousSlide,
        'vueperslide--next-slide': this.isNextSlide,
        'vueperslide--visible': this.isSlideVisible,
        'vueperslide--loading': this.conf.lazy && !this.loaded,
        'vueperslide--has-video': this.videoObj,
        'vueperslide--has-image-inside': this.conf.slideImageInside,
        'vueperslide--no-pointer-events': this.videoObj && this.videoObj.pointerEvents === false
      };
    },
    slideStyles: function slideStyles() {
      var _this$conf = this.conf,
          visibleSlides = _this$conf.visibleSlides,
          fade = _this$conf.fade,
          slideImageInside = _this$conf.slideImageInside,
          gap = _this$conf.gap,
          gapPx = _this$conf.gapPx;
      return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, !slideImageInside && this.imageSrc && {
        backgroundImage: "url(\"".concat(this.imageSrc, "\")")
      }), visibleSlides > 1 && {
        width: (100 - (gap ? gap * (visibleSlides - 1) : 0)) / visibleSlides + '%'
      }), visibleSlides > 1 && fade && _defineProperty({}, this.conf.rtl ? 'right' : 'left', this.slideIndex % visibleSlides / visibleSlides * 100 + '%')), gap && _defineProperty({}, this.conf.rtl ? 'marginLeft' : 'marginRight', gap + (gapPx ? 'px' : '%')));
    },
    videoObj: function videoObj() {
      if (!this.video) return null;
      var video = {
        url: '',
        alt: '',
        props: {
          controls: true
        }
      };
      if (_typeof(this.video) === 'object') video = Object.assign(video, this.video);else if (typeof this.video === 'string') video.url = this.video;
      return video;
    },
    youtubeVideo: function youtubeVideo() {
      return /youtube\.|youtu\.be/.test(this.videoObj.url);
    },
    imageStyles: function imageStyles() {
      return _objectSpread2({}, this.conf.slideImageInside && this.imageSrc && {
        backgroundImage: "url(\"".concat(this.imageSrc, "\")")
      });
    },
    slideFace3d: function slideFace3d() {
      if (!this.conf['3d']) return false;
      var faces = ['front', 'right', 'back', 'left'];
      var prevSlideIndex = (this.slides.current - 1 + this.slidesCount) % this.slidesCount;
      var nextSlideIndex = (this.slides.current + 1) % this.slidesCount;
      var face = 'front';
      if (this.slideIndex === prevSlideIndex) face = faces[(4 + this.slides.current - 1) % 4];else if (this.slideIndex === nextSlideIndex) face = faces[(this.slides.current + 1) % 4];
      face = faces[this.slideIndex % 4];
      if (this.conf.rtl && face === 'left') face = 'right';else if (this.conf.rtl && face === 'right') face = 'left';
      return face;
    },
    isPreviousSlide: function isPreviousSlide() {
      if (!this.conf['3d']) return false;
      var prevSlideIndex = (this.slides.current - 1 + this.slidesCount) % this.slidesCount;
      return this._uid === this.slides.list[prevSlideIndex].id;
    },
    isNextSlide: function isNextSlide() {
      if (!this.conf['3d']) return false;
      var nextSlideIndex = (this.slides.current + 1) % this.slidesCount;
      return this._uid === this.slides.list[nextSlideIndex].id;
    },
    isSlideVisible: function isSlideVisible() {
      return this.slideIndex >= this.slides.firstVisible && this.slideIndex < this.slides.firstVisible + this.conf.visibleSlides;
    },
    slidesList: function slidesList() {
      return this.slides.list.map(function (slide) {
        return slide.id;
      });
    },
    slidesCount: function slidesCount() {
      return this.slidesList.length;
    },
    slideIndex: function slideIndex() {
      return this.slidesList.indexOf(this._uid);
    },
    justDragged: function justDragged() {
      return this.touch.justDragged;
    },
    shouldSkipUpdate: function shouldSkipUpdate() {
      return this.clone || !this.conf.infinite || !this.conf.slideContentOutside && !this.conf.alwaysRefreshClones;
    }
  },
  methods: {
    updateThisSlide: function updateThisSlide(props) {
      // Injected method.
      this.updateSlide(this._uid, props);
    },
    // Only for lazy loading, this method is called from the Vueperslides component.
    loadImage: function loadImage() {
      var _this = this;

      // Don't try to reload image if already loaded.
      if (this.loading || this.loaded) return;
      this.loading = true;
      return new Promise(function (resolve, reject) {
        var img = document.createElement('img');

        img.onload = function () {
          _this.imageSrc = _this.image;
          _this.loading = false;
          _this.loaded = true;

          _this.$nextTick(function () {
            resolve({
              image: _this.imageSrc,
              style: ((_this.$el.attributes || {}).style || {}).value
            });
          });
        };

        img.onerror = (_this.loading = false) || reject; // Always call reject.

        img.src = _this.image;
      });
    },
    playVideo: function playVideo() {
      if (!this.videoObj) return;

      if (this.videoObj.url) {
        this.$el.querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      } else this.$el.querySelector('video').play();
    },
    pauseVideo: function pauseVideo() {
      if (!this.videoObj) return;

      if (this.videoObj.url) {
        this.$el.querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      } else this.$el.querySelector('video').pause();
    }
  },
  created: function created() {
    this.imageSrc = this.conf.lazy ? '' : this.image;
    if (this.clone) return this.addClone();
    this.addSlide({
      id: this._uid,
      image: this.imageSrc,
      video: this.videoObj && _objectSpread2(_objectSpread2({}, this.videoObj), {}, {
        play: this.playVideo,
        pause: this.pauseVideo
      }),
      title: this.title,
      content: this.content,
      contentSlot: this.$slots.content,
      loaderSlot: this.$slots.loader,
      // For lazy loading.
      link: this.link,
      style: '',
      // For lazy loading: pass the function to Vueperslides, it will call it before slide
      // and on slide drag for each visible slide.
      loadImage: this.loadImage,
      duration: this.duration // Allow overriding the global autoplay slide duration.

    });
  },
  mounted: function mounted() {
    if (this.clone) return;
    this.updateThisSlide({
      contentSlot: this.$slots.content,
      loaderSlot: this.$slots.loader,
      // For lazy loading.
      style: ((this.$el.attributes || {}).style || {}).value
    });
  },
  beforeUpdate: function beforeUpdate() {
    if (this.shouldSkipUpdate || !Object.values(this.$slots).length) return;
    this.updateThisSlide({
      contentSlot: this.$slots.content,
      loaderSlot: this.$slots.loader,
      // For lazy loading.
      style: ((this.$el.attributes || {}).style || {}).value
    });
  },
  destroyed: function destroyed() {
    // When removing a slide programmatically, remove it from the list of slides.
    if (!this.clone) this.removeSlide(this._uid);
  },
  watch: {
    image: function image() {
      // If the image of the slide is changed on the fly, notify VueperSlides to update the clones.
      // If lazy loading, unset the image until this slide is requested.
      this.imageSrc = this.conf.lazy && !this.isSlideVisible ? '' : this.image;

      if (!this.clone) {
        this.updateThisSlide(_objectSpread2({
          image: this.imageSrc
        }, !this.conf.slideImageInside && {
          style: this.slideStyles
        }));
      }
    },
    title: function title() {
      if (!this.clone) this.updateThisSlide({
        title: this.title
      });
    },
    content: function content() {
      if (!this.clone) this.updateThisSlide({
        content: this.content
      });
    },
    link: function link() {
      if (!this.clone) this.updateThisSlide({
        link: this.link
      });
    },
    lazyloaded: function lazyloaded() {
      if (this.clone) this.loaded = this.lazyloaded;
    }
  }
});
// CONCATENATED MODULE: ./src/components/vueperslides/vueperslide.vue?vue&type=script&lang=js&
 /* harmony default export */ var vueperslides_vueperslidevue_type_script_lang_js_ = (vueperslidevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/vueperslides/vueperslide.vue?vue&type=style&index=0&lang=scss&
var vueperslidevue_type_style_index_0_lang_scss_ = __nested_webpack_require_161706__("1c94");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/vueperslides/vueperslide.vue






/* normalize component */

var component = normalizeComponent(
  vueperslides_vueperslidevue_type_script_lang_js_,
  vueperslidevue_type_template_id_048e73ef_lang_pug_render,
  vueperslidevue_type_template_id_048e73ef_lang_pug_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vueperslide = (component.exports);
// EXTERNAL MODULE: ./src/components/vueperslides/styles.scss
var styles = __nested_webpack_require_161706__("0b32");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/vueperslides/vueperslides.vue?vue&type=script&lang=js&

















//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var vueperslidesvue_type_script_lang_js_ = ({
  name: 'vueper-slides',
  components: {
    VueperSlide: vueperslide,
    vnodes: {
      functional: true,
      render: function render(h, ctx) {
        return ctx.props.vnodes;
      }
    }
  },
  provide: function provide() {
    return {
      // By design in Vue, provided variables are not reactive unless they are in an object.
      // Objects.
      conf: this.conf,
      slides: this.slides,
      touch: this.touch,
      // Methods.
      updateSlide: this.updateSlide,
      addClone: this.addClone,
      addSlide: this.addSlide,
      removeSlide: this.removeSlide
    };
  },
  props: {
    alwaysRefreshClones: {
      type: Boolean,
      default: false
    },
    arrows: {
      type: Boolean,
      default: true
    },
    arrowsOutside: {
      type: Boolean,
      default: null
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    breakpoints: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    bullets: {
      type: Boolean,
      default: true
    },
    bulletsOutside: {
      type: Boolean,
      default: null
    },
    disable: {
      type: Boolean,
      default: false
    },
    // Ability to disable arrows on slideshow edges. Only if not infinite mode.
    disableArrowsOnEdges: {
      type: [Boolean, String],
      default: false
    },
    // By default when touch is enabled you have to drag from a slide side and pass 50% of
    // slideshow width to change slide. This setting changes this behavior to a horizontal
    // pixel amount from anywhere on slideshow.
    draggingDistance: {
      type: Number,
      default: null
    },
    duration: {
      type: [Number, String],
      default: 4000
    },
    // Autoplay slide duration.
    infinite: {
      type: Boolean,
      default: true
    },
    fade: {
      type: Boolean,
      default: false
    },
    fixedHeight: {
      type: [Boolean, String],
      default: false
    },
    fractions: {
      type: Boolean,
      default: false
    },
    gap: {
      type: Number,
      default: 0
    },
    initSlide: {
      type: Number,
      default: 1
    },
    lazy: {
      type: Boolean,
      default: false
    },
    lazyLoadOnDrag: {
      type: Boolean,
      default: false
    },
    pauseOnHover: {
      type: Boolean,
      default: true
    },
    pauseOnTouch: {
      type: Boolean,
      default: true
    },
    parallax: {
      type: [Boolean, Number],
      default: false
    },
    pageScrollingElement: {
      type: String,
      default: ''
    },
    parallaxFixedContent: {
      type: Boolean,
      default: false
    },
    // This one is not modifiable through breakpoints: event handlers are added/removed.
    preventYScroll: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Boolean,
      default: false
    },
    rtl: {
      type: Boolean,
      default: false
    },
    slideContentOutside: {
      type: [Boolean, String],
      default: false
    },
    slideContentOutsideClass: {
      type: String,
      default: ''
    },
    slideImageInside: {
      type: Boolean,
      default: false
    },
    slideMultiple: {
      type: [Boolean, Number],
      default: false
    },
    slideRatio: {
      type: Number,
      default: 1 / 3
    },
    touchable: {
      type: Boolean,
      default: true
    },
    transitionSpeed: {
      type: [Number, String],
      default: 600
    },
    visibleSlides: {
      type: Number,
      default: 1
    },
    '3d': {
      type: Boolean,
      default: false
    }
  },
  emits: ['ready', 'next', 'previous', 'autoplay-pause', 'autoplay-resume', 'before-slide', 'slide', 'image-loaded', 'image-failed'],
  data: function data() {
    return {
      isReady: false,
      isPaused: false,
      // When autoplay is true, whether the slideshow in a playing or paused state.
      container: null,
      slides: {
        list: [],
        activeId: null,
        current: 0,
        // Index of current slide.
        // Don't loose the focused slide when changing breakpoint & slideMultiple > 1.
        focus: 0,
        firstVisible: 0 // The first visible slide on the left. Useful when visibleSlides > 1.

      },
      mouseDown: false,
      mouseOver: false,
      touch: {
        enabled: true,
        dragging: false,
        // When lazy & lazyLoadOnDrag are true, try to lazy load the next visible slides
        // and set a flag that it already triggered to not keep trying in the same drag.
        lazyloadTriggered: false,
        justDragged: false,
        dragStartX: 0,
        dragNowX: 0,
        dragAmount: 0
      },
      transition: {
        currentTranslation: 0,
        speed: 0,
        animated: false
      },
      autoplayTimer: null,
      nextSlideIsClone: false,
      breakpointsData: {
        list: [],
        current: null
      },
      parallaxData: {
        translation: 0,
        slideshowOffsetTop: null,
        isVisible: false
      }
    };
  },
  computed: {
    // this.conf needs to be reactive so user can change a Vueper Slides option and everything gets updated.
    conf: function conf() {
      // Read config from the props then check if breakpoints are defined.
      // If so override the config with the breakpoint ones.
      var conf = _objectSpread2(_objectSpread2({}, this.$props), this.$props.breakpoints && this.$props.breakpoints[this.breakpointsData.current] || {}); // Overrides: once config from breakpoints is imported, we can use the `conf` object
      // and be sure all the options are up to date.
      // ------------------------------- //


      conf.slideMultiple = conf.slideMultiple ? conf.visibleSlides : 1;
      conf.gap = this.gap && parseInt(this.gap) || 0; // conf.gapPx = this.gap && this.gap.toString().includes('px')

      if (conf.visibleSlides > 1) conf['3d'] = false;

      if (conf.fade || conf.disableArrowsOnEdges || conf.visibleSlides > 1 || conf['3d']) {
        conf.infinite = false;
      } // Place arrows & bullets outside by default if visibleSlides > 1.


      if (conf.visibleSlides > 1 && conf.arrowsOutside === null) conf.arrowsOutside = true;
      if (conf.visibleSlides > 1 && conf.bulletsOutside === null) conf.bulletsOutside = true;
      if (this.touch.enabled !== conf.touchable) this.toggleTouchableOption(conf.touchable);

      if (conf.parallax && conf.parallaxFixedContent) {
        conf.slideContentOutside = 'top';
        conf.slideContentOutsideClass = 'parallax-fixed-content';
      } // ------------------------------- //


      return conf;
    },
    slidesCount: function slidesCount() {
      return this.slides.list.length;
    },
    // The total number of gaps to subtract for current track translation.
    // i.e. all the gaps on the left of the current slide.
    gapsCount: function gapsCount() {
      var _this$conf = this.conf,
          fade = _this$conf.fade,
          threeD = _this$conf['3d'],
          slideMultiple = _this$conf.slideMultiple,
          gap = _this$conf.gap;
      if (!gap || fade || threeD) return 0;
      if (this.multipleSlides1by1 && this.slides.current < this.preferredPosition) return 0; // nextSlideIsClone can only be 0 or 1 with infinite option.

      if (!this.slides.current && this.nextSlideIsClone) return this.slidesCount;
      if (this.nextSlideIsClone === 0) return -1;
      var gapsCount = this.slides.current / slideMultiple - this.preferredPosition;

      if (this.multipleSlides1by1 && this.slidePosAfterPreferred > 0) {
        gapsCount -= this.slidePosAfterPreferred;
      }

      return gapsCount;
    },
    // The number of slides remaining on the right of the current slide.
    slidesAfterCurrent: function slidesAfterCurrent() {
      return this.slidesCount - (this.slides.current + 1);
    },
    // When visibleSlides > 1, the preferred position is the most center slide amongst the visible ones.
    // If visibleSlides is an odd number the preferred position can never be at the center,
    // so take the closest on the left side.
    preferredPosition: function preferredPosition() {
      return this.multipleSlides1by1 ? Math.ceil(this.conf.visibleSlides / 2) - 1 : 0;
    },
    slidePosAfterPreferred: function slidePosAfterPreferred() {
      return this.conf.visibleSlides - this.preferredPosition - this.slidesAfterCurrent - 1;
    },
    multipleSlides1by1: function multipleSlides1by1() {
      return this.conf.visibleSlides > 1 && this.conf.slideMultiple === 1;
    },
    touchEnabled: {
      get: function get() {
        return this.slidesCount > 1 && this.touch.enabled;
      },
      set: function set(value) {
        this.touch.enabled = value;
      }
    },
    canSlide: function canSlide() {
      return this.slidesCount / this.conf.visibleSlides > 1;
    },
    firstSlide: function firstSlide() {
      var slide = this.slidesCount ? this.slides.list[0] : {};

      if (slide.style && typeof slide.style === 'string') {
        slide.style = slide.style.replace(/width: ?\d+.*?;?/, '');
      }

      return slide;
    },
    lastSlide: function lastSlide() {
      var slide = this.slidesCount ? this.slides.list[this.slidesCount - 1] : {};

      if (slide.style && typeof slide.style === 'string') {
        slide.style = slide.style.replace(/width: ?\d+.*?;?/, '');
      }

      return slide;
    },
    currentSlide: function currentSlide() {
      var currentSlide = this.slidesCount && this.slides.list[this.slides.current] || {};

      if (this.slides.current < this.slidesCount && currentSlide.id !== this.slides.activeId) {
        this.goToSlide(this.slides.current, {
          animation: false,
          autoPlaying: true
        });
      }

      return currentSlide;
    },
    vueperslidesClasses: function vueperslidesClasses() {
      return {
        'vueperslides--ready': this.isReady,
        'vueperslides--rtl': this.conf.rtl,
        'vueperslides--fade': this.conf.fade,
        'vueperslides--parallax': this.conf.parallax,
        'vueperslides--slide-image-inside': this.conf.slideImageInside,
        'vueperslides--touchable': this.touchEnabled && !this.disable,
        'vueperslides--fixed-height': this.conf.fixedHeight,
        'vueperslides--3d': this.conf['3d'],
        'vueperslides--slide-multiple': this.conf.slideMultiple > 1,
        'vueperslides--bullets-outside': this.conf.bulletsOutside,
        'vueperslides--animated': this.transition.animated,
        // While transitioning.
        'vueperslides--no-animation': !this.isReady
      };
    },
    vueperslidesStyles: function vueperslidesStyles() {
      return /^-?\d/.test(this.conf.fixedHeight) ? "height: ".concat(this.conf.fixedHeight) : null;
    },
    trackStyles: function trackStyles() {
      var styles = {};

      if (this.conf.parallax) {
        styles.transform = "translate3d(0, ".concat(this.parallaxData.translation, "%, 0)"); // Increase browser optimizations by allocating more machine resource.
        // ! \\ To be used wisely so deactivate when not needed.

        styles.willChange = this.parallaxData.isVisible ? 'transform' : 'auto';
      }

      return styles;
    },
    trackInnerStyles: function trackInnerStyles() {
      var styles = {};
      var _this$conf2 = this.conf,
          fade = _this$conf2.fade,
          threeD = _this$conf2['3d']; // Always override default transition (in CSS) if any transition.speed. But when
      // this.transition.animated is false, the class `no-animation` is added forcing
      // transition-duration 0ms in CSS.

      styles.transitionDuration = "".concat(this.transition.speed, "ms");

      if (threeD) {
        var rotation = this.transition.currentTranslation * 90 / 100; // Following calculation is equivalent to:
        // 'translateZ(slideshowWidth / 2) rotateY(' + rotation + 'deg)'
        // but does not require a fixed width.

        styles.transform = "rotateY(-90deg) translateX(-50%) rotateY(90deg) rotateY(".concat(rotation, "deg)");
      } else if (!fade) {
        styles.transform = "translate3d(".concat(this.transition.currentTranslation, "%, 0, 0)"); // Increase browser optimizations by allocating more machine resource.
        // ! \\ To be used wisely so deactivate when not needed.

        styles.willChange = this.touch.dragging || this.transition.animated ? 'transform' : 'auto';
      }

      return styles;
    },
    bulletIndexes: function bulletIndexes() {
      var _this = this;

      return Array(Math.ceil(this.slidesCount / this.conf.slideMultiple)).fill().map(function (v, i) {
        return i * _this.conf.slideMultiple;
      });
    },
    arrowPrevDisabled: function arrowPrevDisabled() {
      return !this.slides.current && this.conf.disableArrowsOnEdges;
    },
    arrowNextDisabled: function arrowNextDisabled() {
      var _this$conf3 = this.conf,
          disableArrowsOnEdges = _this$conf3.disableArrowsOnEdges,
          visibleSlides = _this$conf3.visibleSlides,
          slideMultiple = _this$conf3.slideMultiple;
      var lastSlide = this.slides.current + (slideMultiple > 1 && visibleSlides > 1 ? visibleSlides - 1 : 0);
      return lastSlide === this.slidesCount - 1 && disableArrowsOnEdges;
    }
  },
  methods: {
    init: function init() {
      var _this2 = this;

      this.container = this.$refs.vueperslides;
      this.touchEnabled = this.conf.touchable; // Store speed in extra variable because transition.speed can be set to 0,
      // then after slide change we need to reapply original speed.

      this.transition.speed = this.conf.transitionSpeed;

      if (Object.keys(this.breakpoints).length) {
        this.setBreakpointsList();
        this.setBreakpointConfig(this.getCurrentBreakpoint());
      }

      var options = {
        animation: false,
        autoPlaying: this.conf.autoplay
      };
      this.goToSlide(this.conf.initSlide - 1, options);
      this.bindEvents(); // Give it a tick to be mounted in the DOM.

      this.$nextTick(function () {
        _this2.isReady = true;

        _this2.emit('ready');
      });
    },
    // Emit a named event outside the component with 2 possible parameters:
    // current slide info & next slide info.
    emit: function emit(name) {
      var includeCurrentSlide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var includeNextSlide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var args = null;

      if (includeCurrentSlide || typeof includeNextSlide === 'number') {
        args = {};

        if (includeCurrentSlide && this.slides.activeId && this.slidesCount) {
          args.currentSlide = this.getSlideData(this.slides.current);
        }

        if (typeof includeNextSlide === 'number' && this.slidesCount) {
          var _this$getSlideInRange = this.getSlideInRange(includeNextSlide),
              nextSlideIndex = _this$getSlideInRange.nextSlide;

          args.nextSlide = this.getSlideData(nextSlideIndex);
        }
      }

      this.$emit.apply(this, _toConsumableArray(args ? [name, args] : [name]));
    },
    getSlideData: function getSlideData(index) {
      var slide = this.slides.list[index];
      var data = {};

      if (slide) {
        data = {
          index: index,
          title: slide.title,
          content: slide.content,
          contentSlot: slide.contentSlot,
          image: slide.image,
          link: slide.link
        };
      }

      return data;
    },
    setBreakpointsList: function setBreakpointsList() {
      this.breakpointsData.list = [99999].concat(_toConsumableArray(Object.keys(this.breakpoints))).map(function (bp) {
        return parseInt(bp);
      }).sort(function (a, b) {
        return parseInt(b) - parseInt(a);
      });
    },
    getCurrentBreakpoint: function getCurrentBreakpoint() {
      var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      var breakpoints = [windowWidth].concat(_toConsumableArray(this.breakpointsData.list)).sort(function (a, b) {
        return parseInt(b) - parseInt(a);
      });
      return this.breakpointsData.list[breakpoints.indexOf(windowWidth) - 1];
    },
    hasBreakpointChanged: function hasBreakpointChanged(breakpoint) {
      return this.breakpointsData.current !== parseInt(breakpoint);
    },
    setBreakpointConfig: function setBreakpointConfig(breakpoint) {
      var bp = this.breakpoints && this.breakpoints[breakpoint] || {};
      var slideMultipleChanged = bp.slideMultiple && bp.slideMultiple !== this.conf.slideMultiple;
      var visibleSlidesChanged = bp.visibleSlides && bp.visibleSlides !== this.conf.visibleSlides; // this.conf gets updated by itself when this.breakpointsData.current changes.

      this.breakpointsData.current = breakpoint;
      this.slides.current = this.getFirstVisibleSlide(this.slides.focus);

      if (slideMultipleChanged || visibleSlidesChanged) {
        this.goToSlide(this.slides.current, {
          breakpointChange: true
        });
      } else this.updateTrackTranslation();
    },
    bindEvents: function bindEvents() {
      var _this3 = this;

      var hasTouch = ('ontouchstart' in window); // Allow mouse or touch dragging slides.

      if (this.touchEnabled) this.toggleTouchableOption(true); // Pause autoplay on mouseover or touch.

      if (this.conf.autoplay) {
        if (this.conf.pauseOnHover && !hasTouch) {
          this.container.addEventListener('mouseenter', this.onMouseEnter);
          this.container.addEventListener('mouseleave', this.onMouseLeave);
        } else if (this.conf.pauseOnTouch && hasTouch) {
          document.addEventListener('touchstart', function (e) {
            _this3[_this3.$el.contains(e.target) ? 'onSlideshowTouch' : 'onOustideTouch']();
          });
        }
      } // Breakpoints or parallax need a resize event.


      if (this.breakpointsData.list.length || this.conf.parallax) {
        window.addEventListener('resize', this.onResize);
      } // Parallax slideshow.


      if (this.conf.parallax) this.enableParallax();
    },
    // Recursively sum all the offsetTop values from current element up the tree until body.
    // By doing so a padding or margin on a parent won't cause a wrong calculation.
    getSlideshowOffsetTop: function getSlideshowOffsetTop() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.parallaxData.slideshowOffsetTop === null || force) {
        var el = this.container;
        var top = el.offsetTop;

        while (el = el.offsetParent) {
          top += el.offsetTop;
        }

        this.parallaxData.slideshowOffsetTop = top;
      }

      return this.parallaxData.slideshowOffsetTop;
    },
    enableParallax: function enableParallax() {
      // First render the onload translation.
      this.refreshParallax(); // Then add event listener.
      // The scrolling DOM element may be a different element than the HTML document.

      if (this.pageScrollingElement) {
        // Store the found DOM element in variable for fast access in onScroll().
        this.parallaxData.scrollingEl = document.querySelector(this.pageScrollingElement);
        this.parallaxData.scrollingEl.addEventListener('scroll', this.onScroll);
      } else document.addEventListener('scroll', this.onScroll);
    },
    disableParallax: function disableParallax() {
      var scrollingElement = this.pageScrollingElement ? document.querySelector(this.pageScrollingElement) : document;
      scrollingElement.removeEventListener('scroll', this.onScroll);
      this.parallaxData.scrollingEl = null;
      this.parallaxData.isVisible = false;
      this.parallaxData.translation = 0;
      this.parallaxData.slideshowOffsetTop = null;
    },
    onScroll: function onScroll() {
      var scrollingEl = this.parallaxData.scrollingEl;
      var doc = document.documentElement;
      var scrollTop = 0;
      if (scrollingEl) scrollTop = scrollingEl.scrollTop;else scrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
      var windowHeight = window.innerHeight || doc.clientHeight || document.body.clientHeight;
      var slideshowHeight = this.container.clientHeight;
      var slideshowTopOffset = this.getSlideshowOffsetTop(); // The distance between the bottom line of the current vueperslides slideshow and top of window.
      // Negative value means the slideshow is totally above the current window box.

      var vsBottom2WinTop = slideshowTopOffset + slideshowHeight - scrollTop; // The distance between the top line of the current vueperslides slideshow and bottom of window.
      // Negative value means the slideshow is totally bellow the current window box.

      var vsTop2winBottom = windowHeight + scrollTop - slideshowTopOffset;
      this.parallaxData.isVisible = vsBottom2WinTop > 0 && vsTop2winBottom > 0; // Only apply translation when slideshow is visible.

      if (this.parallaxData.isVisible) {
        var heightToCoverWithTranslation = windowHeight + slideshowHeight;
        var percentage = vsBottom2WinTop * 100 / heightToCoverWithTranslation;
        var translatePercentage = this.conf.parallax === -1 ? 100 - percentage : percentage;
        this.parallaxData.translation = -translatePercentage / 2;
      }
    },
    onResize: function onResize() {
      if (this.breakpointsData.list.length) {
        var breakpoint = this.getCurrentBreakpoint();
        if (this.hasBreakpointChanged(breakpoint)) this.setBreakpointConfig(breakpoint);
      } // Only refresh parallaxData.slideshowOffsetTop value on resize for better performance.


      if (this.conf.parallax) this.getSlideshowOffsetTop(true);
    },
    // Not on touch device.
    onMouseEnter: function onMouseEnter() {
      this.mouseOver = true;
      if (this.conf.pauseOnHover && this.conf.autoplay) this.isPaused = true;
    },
    // Not on touch device.
    onMouseLeave: function onMouseLeave() {
      this.mouseOver = false;
      if (this.conf.pauseOnHover && this.conf.autoplay) this.isPaused = false;
    },
    // Both on desktop and touch device.
    onMouseDown: function onMouseDown(e) {
      if (!this.touchEnabled || this.disable) return;
      if (!e.touches && this.preventYScroll) e.preventDefault();
      this.mouseDown = true; // Store drag start in var for distance calculation in onMouseUp().

      this.touch.dragStartX = this.getCurrentMouseX(e);
      if (!this.conf.draggingDistance) this.updateTrackTranslation(this.touch.dragStartX);
    },
    // Both on desktop and touch device.
    onMouseMove: function onMouseMove(e) {
      if (this.mouseDown || this.touch.dragging) {
        if (this.conf.autoplay) this.isPaused = true; // Pause any autoplay while dragging.

        if (this.preventYScroll) e.preventDefault();
        this.mouseDown = false;
        this.touch.dragging = true; // Store current drag position in var for distance calculation in onMouseUp().

        this.touch.dragNowX = this.getCurrentMouseX(e);

        if (this.conf.draggingDistance) {
          this.touch.dragAmount = this.touch.dragNowX - this.touch.dragStartX;
          var dragAmountPercentage = this.touch.dragAmount / this.container.clientWidth;
          this.updateTrackTranslation();
          this.transition.currentTranslation += 100 * dragAmountPercentage;
        } else this.updateTrackTranslation(this.touch.dragNowX);
      }
    },
    // Both on desktop and touch device.
    // Note: on touch device, the e.target is the same target as the one you start dragging.
    onMouseUp: function onMouseUp(e) {
      var _this4 = this;

      this.mouseDown = false; // If no mouse move there is nothing to do so don't go further.

      if (!this.touch.dragging) return this.cancelSlideChange();else if (this.conf.autoplay) {
        // Since the autoplay is always paused while dragging, resume autoplay if:
        // - not touch device and not hover slideshow
        // - touch device and pauseOnTouch is set to false.
        var hasTouch = ('ontouchstart' in window);
        if (!hasTouch && !this.mouseOver) this.isPaused = false; // On touch device if pauseOnTouch is false, resume the autoplay on release of a slide dragging.
        else if (!this.conf.pauseOnTouch) this.isPaused = false;
      }
      this.touch.dragging = false;
      var dragAmount = this.conf.draggingDistance ? -this.touch.dragAmount : 0;
      var dragPercentageStart = (this.touch.dragStartX - this.container.offsetLeft) / this.container.clientWidth;
      var dragPercentageNow = (this.touch.dragNowX - this.container.offsetLeft) / this.container.clientWidth;
      var dragPercentage = ((dragPercentageStart < 0.5 ? 0 : 1) - dragPercentageNow) * 100;
      var forwards = (dragAmount || dragPercentage) > 0;
      if (this.conf.rtl) forwards = !forwards;
      var reasonsToCancelSliding = [// Dragging distance conf is set & drag amount is lesser than dragging distance conf.
      Math.abs(dragAmount) < this.conf.draggingDistance, // Dragging distance conf is not set & dragging is lesser than 50%.
      !this.conf.draggingDistance && Math.abs(dragPercentage) < 50, // arrowNext is disabled and dragging beyond last slide.
      this.arrowPrevDisabled && !this.slides.current && !forwards, // arrowPrev is disabled and dragging beyond first slide.
      this.arrowNextDisabled && this.slides.current === this.slidesCount - 1 && forwards];
      if (reasonsToCancelSliding.includes(true)) this.cancelSlideChange();else {
        var targetSlide = this.slides.current + this.conf.slideMultiple * (forwards ? 1 : -1);
        this.emit(forwards ? 'next' : 'previous');
        this.goToSlide(targetSlide);
      }
      this.touch.dragStartX = null;
      this.touch.dragNowX = null;
      this.touch.dragAmount = null; // Can be called from a click event.
      // As click event triggers after mouseup, we need a persistent variable until
      // click event triggers.

      this.touch.justDragged = true;
      setTimeout(function () {
        return _this4.touch.justDragged = false;
      }, 50);
      this.touch.lazyloadTriggered = false; // Reinit for the next drag.
    },
    onSlideshowTouch: function onSlideshowTouch() {
      this.isPaused = true;
    },
    onOustideTouch: function onOustideTouch() {
      this.isPaused = false;
    },
    // Check if dragging just happened - also for external use.
    justDragged: function justDragged() {
      return this.touch.justDragged;
    },
    // Dragging did not pass conditions to change slide, snap back to current slide.
    cancelSlideChange: function cancelSlideChange() {
      if (!this.conf.fade) this.updateTrackTranslation();
    },
    getCurrentMouseX: function getCurrentMouseX(e) {
      return 'ontouchstart' in window ? e.touches[0].clientX : e.clientX;
    },

    /**
     * The slides track translation of most cases, in other cases this can still be used as a base calc.
     */
    getBasicTranslation: function getBasicTranslation() {
      return this.slides.current / this.conf.visibleSlides;
    },

    /**
     * Update the current translation of the slides track - for sliding slideshows.
     * The resulting translation will be set in percentage and negative value.
     *
     * @param {null | float} currentMouseX whether the slide track is being dragged and if so
     *                                     the value of the current drag.
     */
    updateTrackTranslation: function updateTrackTranslation() {
      var currentMouseX = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var translation = this.getBasicTranslation();
      var _this$conf4 = this.conf,
          infinite = _this$conf4.infinite,
          visibleSlides = _this$conf4.visibleSlides,
          slideMultiple = _this$conf4.slideMultiple,
          gap = _this$conf4.gap,
          threeD = _this$conf4['3d'],
          lazy = _this$conf4.lazy,
          lazyLoadOnDrag = _this$conf4.lazyLoadOnDrag; // nextSlideIsClone can be 0 or 1 or false.

      if (infinite && this.nextSlideIsClone !== false) {
        translation = (this.nextSlideIsClone ? this.slidesCount : -1) / visibleSlides;
      } // Add all the gaps to the translation except if current slide is first.


      if (gap) {
        translation += this.gapsCount / (visibleSlides / slideMultiple) * gap / 100;
      } // If dragging.


      if (infinite && this.nextSlideIsClone !== false) {} else if (this.touch.dragStartX && currentMouseX) {
        var dragPercentage = 0;
        var dragPercentageStart = (this.touch.dragStartX - this.container.offsetLeft) / this.container.clientWidth;
        var dragPercentageNow = (currentMouseX - this.container.offsetLeft) / this.container.clientWidth;

        if (threeD) {
          // Prevent dragging more than 1 face away from front face,
          // So that we don't need to update faces on drag.
          var range = Math.round(dragPercentageStart) ? [0, 2] : [-1, 1];
          dragPercentageNow = Math.min(Math.max(dragPercentageNow, range[0]), range[1]);
        }

        dragPercentage = (dragPercentageStart < 0.5 ? 0 : 1) - dragPercentageNow;
        translation += dragPercentage * (this.conf.rtl ? -1 : 1);

        if (lazy && lazyLoadOnDrag && !this.touch.lazyloadTriggered) {
          this.touch.lazyloadTriggered = true;
          var nextSlideGuess = this.slides.current + (dragPercentage > 0 ? 1 : -1) * visibleSlides; // If out of range and infinite, load the correct clone original, that will update the clone.

          if (infinite && nextSlideGuess === -1) nextSlideGuess = this.slidesCount - 1;else if (infinite && nextSlideGuess === this.slidesCount) nextSlideGuess = 0; // Load the next visible slides images.

          for (var i = 0; i < visibleSlides; i++) {
            var slide = this.slides.list[nextSlideGuess + i];
            if (slide && !slide.loaded) this.loadSlide(slide, nextSlideGuess + i);
          }
        }
      } // Special behavior if multiple visible slides and sliding 1 by 1:
      // The translation is modified as user slides just to look nicer.


      if (this.multipleSlides1by1 && !infinite) {
        // The preferred position is the most center slide amongst the visible ones,
        // if `visibleSlides` is an odd number the preferred position can never be at the center,
        // so take the closest on the left side.
        var preferredPositionIsPassed = this.slidePosAfterPreferred > 0; // Subtract the first slides without translation, until we reach the preferred position.

        var subtractFromTranslation = Math.min(this.preferredPosition, this.slides.current); // From next position after the preferred position.

        if (preferredPositionIsPassed) subtractFromTranslation += this.slidePosAfterPreferred;
        translation -= subtractFromTranslation / visibleSlides;
      }

      this.transition.currentTranslation = -translation * 100 * (this.conf.rtl ? -1 : 1);
    },
    pauseAutoplay: function pauseAutoplay() {
      this.isPaused = true;
      clearTimeout(this.autoplayTimer);
      this.autoplayTimer = 0;
      this.emit('autoplay-pause');
    },
    resumeAutoplay: function resumeAutoplay() {
      this.isPaused = false;
      this.doAutoplay();
      this.emit('autoplay-resume');
    },
    doAutoplay: function doAutoplay() {
      var _this5 = this;

      clearTimeout(this.autoplayTimer);
      this.autoplayTimer = setTimeout(function () {
        _this5.goToSlide(_this5.slides.current + _this5.conf.slideMultiple, {
          autoPlaying: true
        });
      }, this.currentSlide.duration || this.conf.duration);
    },
    previous: function previous() {
      var emit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (emit) this.emit('previous');
      this.goToSlide(this.slides.current - this.conf.slideMultiple);
    },
    next: function next() {
      var emit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (emit) this.emit('next');
      this.goToSlide(this.slides.current + this.conf.slideMultiple);
    },
    refreshParallax: function refreshParallax() {
      var _this6 = this;

      setTimeout(function () {
        _this6.onResize();

        _this6.onScroll();
      }, 100);
    },

    /**
     * When visibleSlides > 1, get the first visible slide from given index.
     * The first visible slide may be before the given index (on the left).
     *
     * @param {number} index the slide index where to get the next visible one from.
     * @return {number} the first visible slide index.
     */
    getFirstVisibleSlide: function getFirstVisibleSlide(index) {
      var _this$conf5 = this.conf,
          slideMultiple = _this$conf5.slideMultiple,
          visibleSlides = _this$conf5.visibleSlides;
      var firstVisible = this.slides.current;

      if (visibleSlides > 1 && slideMultiple === visibleSlides) {
        firstVisible = Math.floor(index / visibleSlides) * visibleSlides;
      } else if (this.multipleSlides1by1) {
        firstVisible = index - Math.min(index, this.preferredPosition) - Math.max(this.slidePosAfterPreferred, 0);
      }

      return firstVisible;
    },
    getSlideInRange: function getSlideInRange(index, autoPlaying) {
      var clone = false; // If infinite enabled, going out of range takes the first slide from the other end.

      if (this.conf.infinite && index === -1) clone = 0;else if (this.conf.infinite && index === this.slidesCount) clone = 1; // Generic case:
      // If going beyond slides count, take the modulo as next slide index.
      // E.g. If we want to access slide 9 and there are only 6 slides, go to slide 3.
      // (index + this.slidesCount) to also handle negative index.

      var newIndex = (index + this.slidesCount) % this.slidesCount;

      if (this.conf.slideMultiple > 1) {
        var lastSlideItems = this.slidesCount % this.conf.slideMultiple || this.conf.slideMultiple;
        var missingItems = this.conf.slideMultiple - lastSlideItems;
        newIndex += index < 0 ? missingItems : 0;
        newIndex = this.getFirstVisibleSlide(newIndex);
      } // Disable sliding if already on edge with disableArrowsOnEdges.


      if (this.conf.disableArrowsOnEdges && (index < 0 || index > this.slidesCount - 1) && !autoPlaying) {
        newIndex = this.slides.current;
      }

      return {
        nextSlide: newIndex,
        clone: clone
      };
    },
    // animation = slide transition will be animated.
    // autoPlaying = going to the next slide from autoplay - no user intervention.
    // jumping = after reaching a clone, the callback jumps back to original slide with no animation.
    goToSlide: function goToSlide(index) {
      var _this7 = this;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$animation = _ref.animation,
          animation = _ref$animation === void 0 ? true : _ref$animation,
          _ref$autoPlaying = _ref.autoPlaying,
          autoPlaying = _ref$autoPlaying === void 0 ? false : _ref$autoPlaying,
          _ref$jumping = _ref.jumping,
          jumping = _ref$jumping === void 0 ? false : _ref$jumping,
          _ref$breakpointChange = _ref.breakpointChange,
          breakpointChange = _ref$breakpointChange === void 0 ? false : _ref$breakpointChange,
          _ref$emit = _ref.emit,
          emit = _ref$emit === void 0 ? true : _ref$emit;

      if (!this.slidesCount || this.disable) return; // When autoplay is on and user slides via kbd arrows but not mouse hovering, reset the timer.

      if (this.conf.autoplay && !autoPlaying && !this.isPaused) {
        this.isPaused = true;
        this.$nextTick(function () {
          return _this7.isPaused = false;
        });
      }

      this.transition.animated = animation;
      setTimeout(function () {
        return _this7.transition.animated = false;
      }, this.transitionSpeed); // Get the next slide index and whether it's a clone.

      var _this$getSlideInRange2 = this.getSlideInRange(index, autoPlaying),
          nextSlide = _this$getSlideInRange2.nextSlide,
          nextSlideIsClone = _this$getSlideInRange2.clone;

      this.nextSlideIsClone = nextSlideIsClone; // If the slide is not found don't go further.

      if (!this.slides.list[nextSlide]) return;

      if (this.conf.lazy) {
        // Load each of the next visible slide images.
        for (var i = 0; i < this.conf.visibleSlides; i++) {
          var slide = this.slides.list[nextSlide + i];
          if (slide && !slide.loaded) this.loadSlide(slide, nextSlide + i);
        }
      } // Emit event. First use of `goToSlide` is while init, so should not propagate an event.


      if (this.isReady && !jumping && emit) this.emit('before-slide', true, nextSlide); // First pause all the videos.
      // this.slides.list.forEach(slide => slide.video && slide.video.pause())

      var nextSlideObj = this.slides.list[nextSlide];

      if (this.isReady && nextSlideObj.video) {
        var currSlideObj = this.slides.list[this.slides.current];
        if (currSlideObj.video) currSlideObj.video.pause();
        nextSlideObj.video.play();
      } // Infinite sliding with cloned slides:
      // When reaching last slide and going next the cloned slide of the first slide
      // shows up, when the animation ends the real change to the first slide is done
      // immediately with no animation.
      // Same principle when going beyond first slide.


      if (nextSlideIsClone !== false) {
        // Gives clone id (0 or 1) or false.
        setTimeout(function () {
          // inside the callback, also check if it is not too late to apply next slide
          // (user may have slid fast multiple times) if so cancel callback.
          var passedCloneBackward = index === -1 && _this7.slides.current !== _this7.slidesCount - 1;
          var passedCloneForward = index === _this7.slidesCount && _this7.slides.current !== 0;
          var tooLateToSetTimeout = passedCloneBackward || passedCloneForward;

          if (!tooLateToSetTimeout) {
            _this7.transition.speed = 0;

            _this7.goToSlide(nextSlideIsClone ? 0 : _this7.slidesCount - 1, {
              animation: false,
              jumping: true
            });

            setTimeout(function () {
              return _this7.transition.speed = _this7.conf.transitionSpeed;
            }, 50);
          }
        }, this.transition.speed - 50);
      }

      this.slides.current = nextSlide;
      this.slides.firstVisible = this.getFirstVisibleSlide(nextSlide); // Don't change the focus slide if calling goToSlide from breakpoint change.
      // The focused slide is to keep track which slide to snap to when switching
      // between 2 breakpoints that have multiple visible slides.

      if (!breakpointChange) this.slides.focus = nextSlide; // Only apply sliding transition when the slideshow animation type is `slide`.

      if (!this.conf.fade) this.updateTrackTranslation();
      this.slides.activeId = this.slides.list[this.slides.current].id;
      if (this.conf.autoplay && autoPlaying && !this.isPaused) this.doAutoplay();

      if (this.slidesCount) {
        // First use of goToSlide is while init, so should not propagate an event.
        if (this.$slots.default[this.slides.current] && this.isReady && !jumping && emit) {
          this.emit('slide');
        } // Focus the current bullet for accessibility.
        // First get the ref on bullets list then try to find buttons.
        // As this is customizable through a slot there might not be any.


        if (this.isReady && this.conf.bullets && !autoPlaying && !jumping && this.$refs.bullets) {
          var bulletButtons = this.$refs.bullets.children;
          var activeBulletButton = bulletButtons && bulletButtons[this.slides.current / this.conf.slideMultiple];

          if (activeBulletButton && activeBulletButton.nodeName.toLowerCase() === 'button') {
            // Prevent auto-scrolling to a slideshow that is not in viewport on bullet focus.
            var scrollingDomEl = document.documentElement;
            if (this.pageScrollingElement) scrollingDomEl = document.querySelector(this.pageScrollingElement);
            var scrollTop = scrollingDomEl.scrollTop;
            activeBulletButton.focus({
              preventScroll: true
            }); // Safari can't `preventScroll`, hence the scrollTop.

            scrollingDomEl.scrollTop = scrollTop;
          }
        }
      }
    },
    addSlide: function addSlide(newSlide) {
      this.slides.list.push(newSlide); // If the slideshow was initialized with no slides and with autoplay, resume the autoplay
      // when the first slide is added.

      if (this.isReady && this.slidesCount === 1 && this.conf.autoplay && this.isPaused) {
        this.isPaused = false;
      }

      return this.slidesCount;
    },
    addClone: function addClone() {
      // On adding clone, recalculate the current track translation.
      // (case when starting in infinite mode with no slide until later loaded).
      this.updateTrackTranslation();
      return this.slidesCount;
    },
    updateSlide: function updateSlide(slideId, newProps) {
      var slide = this.slides.list.find(function (slide) {
        return slide.id === slideId;
      });
      if (slide) slide = Object.assign(slide, newProps);
    },
    removeSlide: function removeSlide(slideId) {
      var index = this.slides.list.findIndex(function (slide) {
        return slide.id === slideId;
      });

      if (index > -1) {
        this.slides.list.splice(index, 1); // Remove the slide.
        // If the slide to remove is the current slide, slide to the previous slide,
        // unless it was the only one.

        if (this.slidesCount && slideId === this.slides.activeId) {
          this.goToSlide(index - 1, {
            autoPlaying: true
          });
        }
      } // This can only happen if removing and adding slides very fast - like hot reloading.


      if (this.slides.current >= this.slidesCount) this.goToSlide(0, {
        autoPlaying: true
      });
    },
    // Lazy loading a slide image.
    loadSlide: function loadSlide(slide, index) {
      var _this8 = this;

      slide.loadImage().then(function (response) {
        var image = response.image,
            style = response.style;
        slide.loaded = true;
        slide.image = image;
        slide.style = style;

        _this8.$emit('image-loaded', _this8.getSlideData(index));
      }, function () {
        slide.loaded = false;

        _this8.$emit('image-failed', _this8.getSlideData(index));
      });
    },
    toggleTouchableOption: function toggleTouchableOption(isTouchable) {
      var track = this.$refs.track;
      if (!track) return;
      this.touchEnabled = isTouchable;
      var hasTouch = ('ontouchstart' in window); // Touch enabled slideshow.

      if (isTouchable) {
        this.$refs.track.addEventListener(hasTouch ? 'touchstart' : 'mousedown', this.onMouseDown, {
          passive: !this.preventYScroll
        });
        document.addEventListener(hasTouch ? 'touchmove' : 'mousemove', this.onMouseMove, {
          passive: !this.preventYScroll
        });
        document.addEventListener(hasTouch ? 'touchend' : 'mouseup', this.onMouseUp, {
          passive: true
        });
      } else this.removeEventListeners();
    },
    removeEventListeners: function removeEventListeners() {
      var hasTouch = ('ontouchstart' in window);
      this.$refs.track.removeEventListener(hasTouch ? 'touchstart' : 'mousedown', this.onMouseDown, {
        passive: !this.preventYScroll
      });
      document.removeEventListener(hasTouch ? 'touchmove' : 'mousemove', this.onMouseMove, {
        passive: !this.preventYScroll
      });
      document.removeEventListener(hasTouch ? 'touchend' : 'mouseup', this.onMouseUp, {
        passive: true
      });
    }
  },
  watch: {
    isPaused: function isPaused(bool) {
      this[bool ? 'pauseAutoplay' : 'resumeAutoplay']();
    },
    parallax: function parallax(bool) {
      this[bool ? 'enableParallax' : 'disableParallax']();
    }
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    var _this9 = this;

    this.removeEventListeners();
    if (this.conf.parallax) this.disableParallax();
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('touchstart', function (e) {
      _this9[_this9.$el.contains(e.target) ? 'onSlideshowTouch' : 'onOustideTouch']();
    });
    this.container.removeEventListener('mouseenter', this.onMouseEnter);
    this.container.removeEventListener('mouseleave', this.onMouseLeave);
  }
});
// CONCATENATED MODULE: ./src/components/vueperslides/vueperslides.vue?vue&type=script&lang=js&
 /* harmony default export */ var vueperslides_vueperslidesvue_type_script_lang_js_ = (vueperslidesvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/vueperslides/vueperslides.vue?vue&type=style&index=0&lang=scss&
var vueperslidesvue_type_style_index_0_lang_scss_ = __nested_webpack_require_161706__("682b");

// CONCATENATED MODULE: ./src/components/vueperslides/vueperslides.vue






/* normalize component */

var vueperslides_component = normalizeComponent(
  vueperslides_vueperslidesvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vueperslides = (vueperslides_component.exports);
// CONCATENATED MODULE: ./src/components/vueperslides/index.js



// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js




/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __nested_webpack_require_243345__) {

"use strict";

var $ = __nested_webpack_require_243345__("23e7");
var isObject = __nested_webpack_require_243345__("861d");
var isArray = __nested_webpack_require_243345__("e8b5");
var toAbsoluteIndex = __nested_webpack_require_243345__("23cb");
var toLength = __nested_webpack_require_243345__("50c4");
var toIndexedObject = __nested_webpack_require_243345__("fc6a");
var createProperty = __nested_webpack_require_243345__("8418");
var wellKnownSymbol = __nested_webpack_require_243345__("b622");
var arrayMethodHasSpeciesSupport = __nested_webpack_require_243345__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __nested_webpack_require_245314__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __nested_webpack_require_245314__("44ad");
var requireObjectCoercible = __nested_webpack_require_245314__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fce3":
/***/ (function(module, exports, __nested_webpack_require_245651__) {

var fails = __nested_webpack_require_245651__("d039");

module.exports = fails(function () {
  // babel-minify transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
  var re = RegExp('.', (typeof '').charAt(0));
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __nested_webpack_require_246821__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __nested_webpack_require_246821__("4930");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "fe3f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fea9":
/***/ (function(module, exports, __nested_webpack_require_247226__) {

var global = __nested_webpack_require_247226__("da84");

module.exports = global.Promise;


/***/ })

/******/ });
//# sourceMappingURL=vueperslides.common.js.map

/***/ }),

/***/ 952:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _globalThis;
if (typeof globalThis === 'object') {
	_globalThis = globalThis;
} else {
	try {
		_globalThis = __webpack_require__(903);
	} catch (error) {
	} finally {
		if (!_globalThis && typeof window !== 'undefined') { _globalThis = window; }
		if (!_globalThis) { throw new Error('Could not determine global this'); }
	}
}

var NativeWebSocket = _globalThis.WebSocket || _globalThis.MozWebSocket;
var websocket_version = __webpack_require__(840);


/**
 * Expose a W3C WebSocket class with just one or two arguments.
 */
function W3CWebSocket(uri, protocols) {
	var native_instance;

	if (protocols) {
		native_instance = new NativeWebSocket(uri, protocols);
	}
	else {
		native_instance = new NativeWebSocket(uri);
	}

	/**
	 * 'native_instance' is an instance of nativeWebSocket (the browser's WebSocket
	 * class). Since it is an Object it will be returned as it is when creating an
	 * instance of W3CWebSocket via 'new W3CWebSocket()'.
	 *
	 * ECMAScript 5: http://bclary.com/2004/11/07/#a-13.2.2
	 */
	return native_instance;
}
if (NativeWebSocket) {
	['CONNECTING', 'OPEN', 'CLOSING', 'CLOSED'].forEach(function(prop) {
		Object.defineProperty(W3CWebSocket, prop, {
			get: function() { return NativeWebSocket[prop]; }
		});
	});
}

/**
 * Module exports.
 */
module.exports = {
    'w3cwebsocket' : NativeWebSocket ? W3CWebSocket : null,
    'version'      : websocket_version
};


/***/ }),

/***/ 840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3).version;


/***/ }),

/***/ 718:
/***/ (function() {

if (!("path" in Event.prototype)) {
  Object.defineProperty(Event.prototype, "path", {
    get: function () {
      var path = [];
      var currentElem = this.target;
      while (currentElem) {
        path.push(currentElem);
        currentElem = currentElem.parentElement;
      }
      if (path.indexOf(window) === -1 && path.indexOf(document) === -1) {
        path.push(document);
      }
      if (path.indexOf(window) === -1) {
        path.push(window);
      }
      return path;
    }
  });
}


/***/ }),

/***/ 100:
/***/ (function(module) {

"use strict";
module.exports = require("vue");

/***/ }),

/***/ 3:
/***/ (function(module) {

"use strict";
module.exports = {"version":"1.0.35"};

/***/ }),

/***/ 333:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"Stream starting soon..":"..البث سيبدأ قريبًا","Live is coming soon":"البث المباشر سيبدأ قريبًا","Stream continues soon..":"..البث سيكمل قريبًا","Stream is over..":"..البث انتهى","Stream is interrupted":"البث متوقف","Live":"مباشر","Write a comment":"اكتب تعليقًا","Enter your name!":"!أدخل اسمك","You must enter a name to be able to comment on the video!":"!يجب إدخال اسم لتتمكن من التعليق على الفيديو","Your name…":"… اسمك","Save your name and write a comment":"احفظ اسمك واكتب تعليقًا","Write your comment here...":"...اكتب تعليقك هنا","You are banned from chat.":".تم حظرك من الدردشة","{number} viewer":"مشاهد {number}","{number} viewers":"مشاهدين {number}","Sponsored content":"محتوى مدعوم","Copy link to clipboard":"نسخ الرابط إلى الحافظة","Copied to clipboard":"تم النسخ إلى الحافظة","Copy":"نسخ","share the ad":"شارك الإعلان","share the player":"شارك المشغل","Share with others":"شارك مع الآخرين","Learn more":"اقرأ المزيد","Purchase":"شراء","Share":"شارك","day":"يوم","days":"أيام","hour":"ساعة","hours":"ساعات","minute":"دقيقة","minutes":"دقائق","More":"المزيد","Subscribe and get notified":"اشترك لتصلك الإشعارات","Please, enter your e-mail and we will notify before the live will getting started.":".يرجى ادخال بريدك الإلكتروني وسنقوم بإبلاغك قبل بدء البث المباشر","Your e-mail...":"...بريدك الإلكتروني","By subscribing, you confirm that you have read and accept our <a target=_blank href={url}>Privacy Policy</a>. We use your email address only for sending notifications about the broadcast.":"بالاشتراك، تؤكد أنك قد قرأت ووافقت على <a target=_blank href={url}>سياسة الخصوصية</a>. .نحن نستخدم عنوان بريدك الإلكتروني فقط لإرسال الإشعارات حول البث","Subscribe to live":"اشترك في البث المباشر","Products":"منتجات","Comments":"تعليقات","@count items":"عناصر @count","Details":"تفاصيل","Back":"عودة","Description":"وصف","Add your name here to join the chat":"أضف اسمك هنا للانضمام إلى الدردشة","Please, enter your name to join chat and start sending comments!":"!أدخل اسمك من فضلك للانضمام إلى الدردشة وبدء إرسال التعليقات","No comments yet.":".لا توجد تعليقات حتى الآن","Billing name":"الاسم على الفاتورة","Billing address":"عنوان وصول الفواتير","Email address":"عنوان البريد الإلكتروني","Phone number":"رقم الهاتف","Fill out form to pay":"املأ الاستمارة للدفع","Pay":"ادفع","Pay now":"ادفع الآن","I accept the <a target=\\"_blank\\" href=\\"{url}\\">Privacy Policy</a>":"أوافق على <a target=\\"_blank\\" href=\\"{url}\\">سياسة الخصوصية</a>","The email address you provided is incorrect":"عنوان البريد الإلكتروني الذي ادخلته غير صحيح","Payment informations":"معلومات الدفع","successful payment":"تم الدفع بنجاح","unsuccessful payment":"تعذر إتمام الدفع","Use the close button to return to the live broadcast.":".اضغط زر الإغلاق للعودة إلى البث المباشر","or":"أو","Subscribe":"اشترك","Subscription":"الاشتراك","I accept the <a target=\\"_blank\\" href=\\"{url}\\">Privacy Policy</a>.":"أوافق على <a target=\\"_blank\\" href=\\"{url}\\">سياسة الخصوصية</a>.","Name field is required.":"الرجاء إدخال اسمك.","Email address field is required.":"الرجاء ادخال بريدك الالكتروني.","Please confirm that you have read and understood the Privacy Policy.":".يرجى تأكيد قراءة وفهم سياسة الخصوصية","You have been successfully subscribed!":"تم الاشتراك بنجاح","You are already subscribed!":"لديك اشتراك سابق","Something went wrong.":".حدث خطأ ما","Please try again later.":"يرجى المحاولة مرة أخرى لاحقًا.","Full name":"الاسم الكامل"}');

/***/ }),

/***/ 369:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"Stream starting soon..":"Der Stream startet demnächst","Live is coming soon":"Live kommt bald","Stream continues soon..":"Der Stream wird bald fortgesetzt","Stream is over..":"Der Stream beendet","Stream is interrupted":"Der Stream wurde unterbrochen","Live":"Live","Write a comment":"Kommentar schreiben","Enter your name!":"Dein Name","You must enter a name to be able to comment on the video!":"Bitte gib einen Namen an, um das Video zu kommentieren","Your name…":"Dein Name","Save your name and write a comment":"Speichern Sie Ihren Namen und schreiben Sie einen Kommentar","Write your comment here...":"Schreiben Sie hier Ihren Kommentar...","You are banned from chat.":"Du wurdest aus dem Chat gebannt.","{number} viewer":"{number} Zuschauer","{number} viewers":"{number} Zuschauer","Sponsored content":"Gesponserte Inhalte","Copy link to clipboard":"Link zu diesem Stream kopieren","Copied to clipboard":"In Zwischenablage kopiert","Copy":"Copy","share the ad":"teile die Anzeige","share the player":"teilen sie den videoplayer","Share with others":"Mit anderen teilen","Learn more":"Mehr erfahren","Purchase":"Kaufen","Share":"Teilen","day":"Tag","days":"Tage","hour":"Stunde","hours":"Stunden","minute":"Minute","minutes":"Minuten","More":"Mehr","Subscribe and get notified":"Abonnieren und benachrichtigt werden","Please, enter your e-mail and we will notify before the live will getting started.":"Bitte geben Sie Ihre E-Mail-Adresse ein und wir werden Sie benachrichtigen, bevor die Live-Übertragung beginnt.","Your e-mail...":"Deine E-Mail...","By subscribing, you confirm that you have read and accept our <a target=_blank href={url}>Privacy Policy</a>. We use your email address only for sending notifications about the broadcast.":"Indem Sie sich anmelden, bestätigen Sie, dass Sie unsere <a target=_blank href={url}>Datenschutzrichtlinie</a> gelesen und akzeptiert haben. Wir verwenden Ihre E-Mail-Adresse nur zum Versenden von Benachrichtigungen über die Sendung.","Subscribe to live":"Live abonnieren","Products":"Produkte","Comments":"Kommentare","@count items":"@count produkte","Details":"Einzelheiten","Back":"Zurück","Description":"Beschreibung","Add your name here to join the chat":"Fügen Sie hier Ihren Namen hinzu, um dem Chat beizutreten","Please, enter your name to join chat and start sending comments!":"Bitte geben Sie Ihren Namen ein, um dem Chat beizutreten und mit dem Senden von Kommentaren zu beginnen!","No comments yet.":"Noch keine Kommentare.","Billing name":"Abrechnungsname","Billing address":"Rechnungsadresse","Email address":"E-Mail-Addresse","Phone number":"Telefonnummer","Fill out form to pay":"Formular ausfüllen","Pay":"Zahlen","Pay now":"Zahlen jetzt","I accept the <a target=\\"_blank\\" href=\\"{url}\\">Privacy Policy</a>":"Ich akzeptiere die <a target=\\"_blank\\" href={url}>Datenschutzerklärung</a>","The email address you provided is incorrect":"Die von Ihnen angegebene E-Mail-Adresse ist falsch","Payment informations":"Zahlungsinformationen","successful payment":"erfolgreiche Zahlung","unsuccessful payment":"erfolglose Zahlung","Use the close button to return to the live broadcast.":"Verwenden Sie die Schließen-Schaltfläche, um zur Live-Übertragung zurückzukehren.","or":"oder","Subscribe":"Abonnieren","Subscription":"Abonnement","I accept the <a target=\\"_blank\\" href=\\"{url}\\">Privacy Policy</a>.":"Ich akzeptiere das <a target=\\"_blank\\" href=\\"{url}\\">Geschäftsbedingungen</a>.","The name field is required.":"A név mező kitöltése kötelező.","Name field is required.":"Namensfeld ist erforderlich.","Email address field is required.":"Das Feld für die E-Mail-Adresse ist erforderlich.","Phone number field is required.":"Das Feld für die Telefonnummer ist erforderlich.","Please confirm that you have read and understood the Privacy Policy.":"Bitte bestätigen Sie, dass Sie die Datenschutzerklärung gelesen und verstanden haben.","You have been successfully subscribed!":"Sie wurden erfolgreich abonniert!","You are already subscribed!":"Sie sind bereits abonniert!","Something went wrong.":"Etwas ist schief gelaufen.","Please try again later.":"Bitte versuchen Sie es später erneut.","Full name":"Vollständiger Name"}');

/***/ }),

/***/ 909:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"Stream starting soon..":"Hamarosan kezdődik","Live is coming soon":"Hamarosan kezdődik","Stream continues soon..":"Hamarosan folytatódik","Stream is over..":"Adás vége","Stream is interrupted":"Az adás megszakadt","Live":"Élő","Write a comment":"Hozzászólás írása","Enter your name!":"Add meg a neved!","You must enter a name to be able to comment on the video!":"Meg kell adnod egy nevet, hogy hozzászólhass a videóhoz!","Your name…":"Ide írd a neved…","Save your name and write a comment":"Név mentése és hozzászólás","Write your comment here...":"Ide írd a hozzászólásod...","You are banned from chat.":"Ki vagy tiltva a chatről.","{number} viewer":"{number} néző","{number} viewers":"{number} néző","Sponsored content":"Szponzorált tartalom","Copy link to clipboard":"Link másolása a vágólapra","Copied to clipboard":"Vágólapra helyezve","Copy":"Másolás","share the ad":"hirdetés megosztása","share the player":"lejátszó megosztása","Share with others":"Megosztás másokkal","Learn more":"További információk","Purchase":"Megvásárlom","Share":"Megosztás","day":"nap","days":"nap","hour":"óra","hours":"óra","minute":"perc","minutes":"perc","More":"Tovább","Subscribe and get notified":"Iratkozz fel és értesülj az adás kezdésről","Please, enter your e-mail and we will notify before the live will getting started.":"Add meg e-mail címed, és értesítünk egy órával az adás megkezdése előtt.","Your e-mail...":"E-mail címed","By subscribing, you confirm that you have read and accept our <a target=_blank href={url}>Privacy Policy</a>. We use your email address only for sending notifications about the broadcast.":"A feliratkozással elfogadod az <a target=_blank href={url}>adatvédelmi nyilatkozatot</a>. Az e-mail címedet kizárólag az adás értesítés kiküldésére használjuk.","Subscribe to live":"Értesíts az élő adásról!","Products":"Termékek","Comments":"Hozzászólások","@count items":"@count termék","Details":"Részletek","Back":"Vissza","Description":"Leírás","Add your name here to join the chat":"Add meg a neved, és csatlakozz a csevegéshez","Please, enter your name to join chat and start sending comments!":"Kérjük, add meg a neved, hogy csatlakozhass a chathez, és a hozzászólások írásához!","No comments yet.":"Még nincsenek hozzászólások.","Billing name":"Számlázási név","Billing address":"Számlázási cím","Email address":"Email cím","Phone number":"Telefonszám","Fill out form to pay":"Töltse ki az űrlapot","Pay":"Fizetek","Pay now":"Fizetek","I accept the <a target=\\"_blank\\" href=\\"{url}\\">Privacy Policy</a>":"Elfogadom az <a target=\\"_blank\\" href=\\"{url}\\">Adatkezelési tájékoztatót</a>","The email address you provided is incorrect":"Az általad megadott e-mail cím nem megfelelő","Payment informations":"Fizetési információk","successful payment":"sikeres fizetés","unsuccessful payment":"sikertelen fizetés","Use the close button to return to the live broadcast.":"Az élő adáshoz való visszatéréshez, használd a bezárás gombot.","or":"vagy","Subscribe":"Feliratkozom","Subscription":"Feliratkozás","I accept the <a target=\\"_blank\\" href=\\"{url}\\">Privacy Policy</a>.":"Elfogadom az <a target=\\"_blank\\" href=\\"{url}\\">Adatvédelmi Irányelveket</a>.","Name field is required.":"A név mező kitöltése kötelező.","Email address field is required.":"A email cím mező kitöltése kötelező.","Please confirm that you have read and understood the Privacy Policy.":"Kérjük, erősítse meg, hogy elolvasta és megértette az Adatvédelmi Irányelveket.","You have been successfully subscribed!":"Sikeresen feliratkozott!","You are already subscribed!":"Már korábban feliratkozott!","Something went wrong.":"Váratlan hiba történt.","Please try again later.":"Kérem, próbálja újra később.","Full name":"Teljes név"}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ entry_lib; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/js/eventPathPolyfill.js
var eventPathPolyfill = __webpack_require__(718);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StreamView.vue?vue&type=template&id=3c9d6cfc
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cssClasses,style:(_vm.customStyles),attrs:{"data-smuc-cfid":_vm.stream.font_id}},[(_vm.coverUrl)?_c('div',{ref:"blurredBg",staticClass:"s00db"}):_vm._e(),_c('overlay-top',{attrs:{"stream":_vm.stream,"has-sidebar":!_vm.noSidebar,"has-error":_vm.hasError,"has-share-link":_vm.stream.show_share_button && _vm.shareThisLink.length > 0,"is-vod":_vm.isVod,"is-simple-vod":_vm.isSimpleVod,"is-photo-ad":_vm.isPhotoAd,"is-minimized":_vm.isMinimized,"is-muted":_vm.isMuted,"kind-text":_vm.kindText,"language":_vm.theLanguage,"mode":_vm.mode,"the-kind":_vm.theKind,"viewers-count":_vm.viewersCount,"sidebar-collapsed":_vm.sidebarCollapsed,"is-portrait":_vm.isFullPortrait || _vm.isOrientationPortraitForced || _vm.previewViewMode === 'mobile',"player-domain":_vm.playerDomain},on:{"onClose":() => _vm.$root.$bus.$emit('streamview.close'),"onShare":() => _vm.eventOnShare(),"onToggleSidebar":() => _vm.onToggleSidebar()}}),_c('div',{ref:"videoContainer",class:{'sb03f': true, 's1b93': _vm.fullPortraitSidebarIsVisible, 'fluid': _vm.fullPortraitSidebarIsVisible},on:{"mousemove":_vm.onVideoContainerMouseMove,"mouseenter":(e) => _vm.onVideoContainerMouseOverChange(true, e),"mouseleave":(e) => _vm.onVideoContainerMouseOverChange(false, e)}},[(_vm.isEmbedSocialVideo && _vm.videoSource != null)?_c('stream-view-embed-social',{style:(_vm.simpleVodCustomStyles),attrs:{"video-source":_vm.videoSource,"stream-type":_vm.streamType,"autoplay":_vm.stream.player_autoplay,"muted":_vm.stream.player_muted,"loop":_vm.stream.player_loop},on:{"load":() => _vm.onIframeLoaded(),"onPlay":() => _vm.onPlay(),"onPause":() => _vm.onPause(),"videoLoaded":_vm.videoLoadedDefault,"videoLoadedMetadata":_vm.videoLoadedMetadata,"playerReady":(p) => _vm.player = p}}):(_vm.videoSource != null)?_c('stream-view-cloudflare',{ref:"cloudflarePlayer",attrs:{"ws-client":_vm.wsClient,"player-domain":_vm.playerDomain,"video-source":_vm.videoSource,"view-mode":_vm.mode,"optimize-for-ad":_vm.optimizeForAd,"stream-type":_vm.streamType,"is-vod":_vm.isVod || _vm.isSimpleVod,"is-preview":_vm.isPreview,"has-next-vod-chapter":_vm.hasNextVodChapter,"button-color":_vm.stream.button_color,"poster":_vm.coverUrl,"autoplay":_vm.stream.player_autoplay,"muted":_vm.stream.player_muted,"loop":_vm.stream.player_loop,"has-ad-url":_vm.hasAdUrl},on:{"load":() => _vm.onIframeLoaded(),"onPlay":() => _vm.onPlay(),"onPause":() => _vm.onPause(),"videoLoaded":_vm.videoLoadedDefault,"videoLoadedMetadata":_vm.videoLoadedMetadata,"playerReady":(p) => _vm.player = p,"streamEnded":() => _vm.playerEventEnded(),"minimize":() => _vm.eventOnMinimize(),"volumeChange":(value) => _vm.eventOnVolumeChange(value),"playerVideoClicked":() => _vm.eventPlayerVideoClicked()}},[(!_vm.hasError && !_vm.isStatusMessageVisible)?_c('heart-gun',{attrs:{"ws-client":_vm.wsClient,"run-demo":_vm.stream.show_like_demo}}):_vm._e()],1):(_vm.stream && _vm.isPhotoAd)?_c('stream-view-photoad',{attrs:{"stream":_vm.stream,"optimize-for-ad":_vm.optimizeForAd,"stream-type":_vm.streamType,"view-mode":_vm.mode,"is-preview":_vm.isPreview,"ad-url":_vm.adUrl}},[(!_vm.hasError && !_vm.isStatusMessageVisible)?_c('heart-gun',{attrs:{"ws-client":_vm.wsClient,"run-demo":_vm.stream.show_like_demo}}):_vm._e()],1):(_vm.isPreview && _vm.videoSource == null)?_c('video',{staticClass:"s35d4",style:({opacity: _vm.stream.embed_social_video_processing ? 0 : 1}),attrs:{"autoplay":true,"loop":true,"controls":false,"src":_vm.videoSourceForPreview},domProps:{"muted":true}}):_c('iframe',{staticClass:"s1488 the-empty-player",staticStyle:{"border":"none"},attrs:{"frameborder":"0","allow":"autoplay; encrypted-media;","allowfullscreen":""}}),(!_vm.isPhotoAd && _vm.optimizeForAd && _vm.stream.ad_button_label && _vm.stream.ad_url)?_c('div',{class:_vm.popupAdButtonClasses,style:('color: ' + _vm.stream.button_color),on:{"click":() => _vm.eventPlayerVideoClicked()}},[_vm._v(" "+_vm._s(_vm.stream.ad_button_label)+" ")]):_vm._e(),((_vm.videoSource && !_vm.iframeLoaded) || _vm.stream.embed_social_video_processing)?_c('div',{attrs:{"id":"video-source-loader"}},[_c('div',{staticClass:"spinner"})]):_vm._e(),(!_vm.unmutedFirst && !_vm.isVod && !_vm.isPreview && _vm.videoSourceIsLoaded && _vm.liveStatus === 'live' && !_vm.isSimpleVod)?_c('div',{staticClass:"s11f4",on:{"click":_vm.eventOnUnmute}},[_vm._m(0)]):_vm._e(),(_vm.hasError)?_c('div',{staticClass:"sa60d"},[_c('div',{staticClass:"s1cb2"},[_vm._v(_vm._s(_vm.errorMessage))])]):_vm._e(),(_vm.liveStreamDisconnected && !_vm.isPreview)?_c('div',{staticClass:"s3a56"},[_c('div',{staticClass:"s1cb2 blinking"},[_vm._v(_vm._s(_vm.tr(_vm.disconnectedText)))])]):_vm._e(),(_vm.isStatusMessageVisible && !_vm.isSimpleVod && !_vm.isPhotoAd)?_c('div',{staticClass:"s2322"},[(_vm.coverUrl)?_c('div',{staticClass:"s6fd2",style:('background-image: url(' + _vm.coverUrl + ')')}):_vm._e(),(_vm.liveStatus === 'waiting')?_c('span',{staticClass:"s2026"},[_vm._v(_vm._s(_vm.tr('Stream starting soon..')))]):_vm._e(),(_vm.liveStatus === 'paused')?_c('span',{staticClass:"s2026"},[_vm._v(_vm._s(_vm.tr('Stream continues soon..')))]):_vm._e(),(_vm.liveStatus === 'closed')?_c('span',{staticClass:"s2026"},[_vm._v(_vm._s(_vm.tr('Stream is over..')))]):_vm._e()]):_vm._e(),(_vm.delayedPinnedProduct && _vm.stream.show_product_list)?_c('product-feed',{class:_vm.pinnedProductClasses,attrs:{"product":_vm.delayedPinnedProduct,"currency":_vm.stream.currency,"is-pinned":true,"language":_vm.theLanguage,"button-color":_vm.stream.button_color}}):_vm._e(),_c('overlay-tools',{directives:[{name:"show",rawName:"v-show",value:(_vm.videoSourceIsLoaded && _vm.iframeLoaded && !_vm.isVideoAd640x360),expression:"videoSourceIsLoaded && iframeLoaded && !isVideoAd640x360"}],attrs:{"stream":_vm.stream,"full-portrait-sidebar-is-visible":_vm.fullPortraitSidebarIsVisible,"is-chat-window-visible":_vm.isChatWindowVisible,"is-full-portrait":_vm.isFullPortrait,"is-minimized":_vm.isMinimized,"is-mobile":_vm.isMobileBreakpoint,"language":_vm.theLanguage,"show-chat-tab":_vm.showChatTab,"show-products-tab":_vm.showProductsTab,"show-subscription-tab":_vm.showSubscriptionTab,"sidebar-active-tab":_vm.sidebarActiveTab,"ws-client":_vm.wsClient}}),(_vm.isVideoAd640x360)?_c('div',{ref:"sidebarToggle640x360",staticClass:"s85c5 sa31d s854d",on:{"click":_vm.openSidebarVideoAd640x360}},[(_vm.showProductsTab)?_c('span',[_c('i',{staticClass:"sbaec sdd35"}),(_vm.hasCustomProductsTabLabel)?[_vm._v(" "+_vm._s(_vm.stream.tab_products_label_plural)+" ")]:(_vm.hasCustomProductsTabLabelSingular)?[_vm._v(" "+_vm._s(_vm.stream.tab_products_label_singular)+" ")]:[_vm._v(" "+_vm._s(_vm.tr('Products'))+" ")]],2):(_vm.showChatTab)?_c('span',[_c('i',{staticClass:"sbaec s19d8"}),_vm._v(" "+_vm._s(_vm.tr('Chat'))+" ")]):(_vm.showSubscriptionTab)?_c('span',[_vm._v(" "+_vm._s(_vm.stream.tab_subscription_form_label ?? _vm.tr('Subscription'))+" ")]):_vm._e(),_c('i',{staticClass:"sbaec s1a72"})]):_vm._e()],1),(_vm.isCompactAdvertisementSize || _vm.stream.ad_use_featured_image)?_c('compact-ad-control-bar',{attrs:{"has-subscription-form":_vm.showSubscriptionTab,"has-products":_vm.stream.products.length > 0,"has-custom-products-tab-label":_vm.hasCustomProductsTabLabel,"products-label-plural":_vm.stream.tab_products_label_plural,"hide-products-button":!_vm.stream.show_product_list,"pinned-product":_vm.delayedPinnedProduct,"language":_vm.theLanguage,"button-color":_vm.stream.button_color,"text-color":_vm.stream.text_color},on:{"activeTab":(v) => _vm.makeCompactAdvertisementSidebarVisible(v)}}):_vm._e(),(!_vm.noSidebar || _vm.stream.ad_use_featured_image)?_c('sidebar',{ref:"sidebar",attrs:{"stream":_vm.stream,"language":_vm.theLanguage,"is-full-portrait":_vm.isFullPortrait,"streamview-el":_vm.thisEl,"videocontainer-el":_vm.$refs.videoContainer,"has-error":_vm.hasError,"has-custom-products-tab-label":_vm.hasCustomProductsTabLabel,"is-compact-advertisement":_vm.isCompactAdvertisementSize,"is-vod":_vm.isVod,"is-minimized":_vm.isMinimized,"is-chat-window-visible":_vm.isChatWindowVisible,"show-chat-tab":_vm.showChatTab,"show-products-tab":_vm.showProductsTab,"show-subscription-tab":_vm.showSubscriptionTab,"ws-client":_vm.wsClient,"is-preview":_vm.isPreview},on:{"activeTab":(v) => _vm.sidebarActiveTab = v,"fullPortraitSidebarIsVisible":(v) => _vm.fullPortraitSidebarIsVisible = v,"dragbarClosed":() => _vm.dragbarClosed()}}):(!_vm.stream.ad_use_featured_image)?_c('aside',{staticClass:"s44a6"},[_c('stream-info-bar',{staticClass:"overlay--bar--bottom--infos",attrs:{"name":_vm.stream.title,"is-sponsored-content":_vm.stream.is_sponsored_content,"language":_vm.theLanguage}})],1):_vm._e(),(_vm.stream.ad_use_featured_image)?_c('ad-featured-image',{attrs:{"stream":_vm.stream}}):_vm._e(),(_vm.previewProductDetails)?_c('product-details',{attrs:{"product":_vm.previewProductDetails,"payment":_vm.stream.payment,"currency":_vm.stream.currency,"is-mobile":_vm.isMobileBreakpoint,"language":_vm.theLanguage,"button-color":_vm.stream.button_color,"text-color":_vm.stream.text_color}}):_vm._e(),(_vm.payableProduct && _vm.stream.payment)?_c('payment-details',{attrs:{"product":_vm.payableProduct,"currency":_vm.stream.currency,"payment":_vm.stream.payment,"privacy-policy-url":_vm.stream.privacy_policy_url,"language":_vm.theLanguage,"button-color":_vm.stream.button_color,"text-color":_vm.stream.text_color}}):_vm._e(),(_vm.shareModalOpened && _vm.shareThisLink.length)?_c('share-this-stream-modal',{attrs:{"title":_vm.stream.title,"url":_vm.shareThisLink,"button-color":_vm.stream.button_color,"text-color":_vm.stream.text_color,"language":_vm.theLanguage,"is-ad":_vm.stream.optimize_for_ad},on:{"closed":function($event){_vm.shareModalOpened = false}}}):_vm._e(),(_vm.isSubscriptionModalVisible && _vm.stream.subscriber_form !== null)?_c('subscription-panel',{attrs:{"form":_vm.stream.subscriber_form,"label":_vm.stream.tab_subscription_form_label,"button-color":_vm.stream.button_color,"preview-mode":_vm.isPreview,"language":_vm.theLanguage,"customer":_vm.stream.customer,"campaign":_vm.stream.campaign}}):_vm._e(),(_vm.indamediaMobilePixelVisible)?_c('img',{attrs:{"src":"https://indexadhu.hit.gemius.pl/redot.gif?id=ciU66M8hk0.eMomEzObhSMQ6zZX_nQNk5SBynogoSQX.Q7/stparam=mogfhlnjss/fastid=gftaavychuzxqgmpqhzwvjnarpni/nc=0","border":"0","height":"0","width":"0"}}):_vm._e(),(_vm.indamediaDesktopPixelVisible)?_c('img',{attrs:{"src":"https://indexadhu.hit.gemius.pl/redot.gif?id=ciU66M8hk0.eMomEzObhSMQ6zZX_nQNk5SBynogoSQX.Q7/stparam=tamibtkhrh/fastid=lzycckblcaqtnyniphqtjccgonky/nc=0","border":"0","height":"0","width":"0"}}):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"sbaec sccf8"})])
}]


;// CONCATENATED MODULE: ./src/components/StreamView.vue?vue&type=template&id=3c9d6cfc

// EXTERNAL MODULE: ./node_modules/smucio-stream-entities/lib/index.js
var lib = __webpack_require__(248);
;// CONCATENATED MODULE: ./src/mixins/Translator.js
const translations = {
  'hu': __webpack_require__(909),
  'de': __webpack_require__(369),
  'ar': __webpack_require__(333),
};

function replaceParameters(str, params) {
  if (params) {
    Object.keys(params).forEach(param => {
      str = str.replaceAll(param, params[param]);
    });
  }

  return str;
}

/* harmony default export */ var Translator = ({
  props: {
    language: {
      type: String,
      required: false,
      default() {
        return 'en';
      },
    },
  },
  methods: {
    tr(str, params) {
      if (this.language === 'en') {
        return replaceParameters(str, params);
      }

      if (translations[this.language] && translations[this.language][str]) {
        return replaceParameters(translations[this.language][str], params);
      }

      if (false) {}

      return replaceParameters(str, params);
    }
  },
});

;// CONCATENATED MODULE: ./src/mixins/SoftKeyboardDetection.js
/* harmony default export */ var SoftKeyboardDetection = ({
  data() {
    return {
      softKeyboardVisible: false,
      softKeyboardInputFocused: false,
      softKeyboardInputBlurred: false,
      innerWidthPreviousValue: 0,
      innerHeightPreviousValue: 0,
    }
  },
  computed: {
    isIos() {
      return !!navigator.userAgent.match(/iPad/i) || !!navigator.userAgent.match(/iPhone/i);
    },
    isWebKit() {
      return !!navigator.userAgent.match(/WebKit/i);
    },
    isIosSafari() {
      return this.isIos && this.isWebKit && !navigator.userAgent.match(/CriOS/i);
    },
  },
  created() {
    if (!this.isIosSafari || Object.prototype.toString.call(window.visualViewport) !== '[object VisualViewport]') {
      return;
    }
    console.info('[SoftKeyboardDetection] Initialized.');

    // 'focus' event can be attached to a specific DOM element and cannot be used here, in Event Delegation, also, focus event is not bubbling!
    document.body.addEventListener('focusin', this.onFocused);
    // 'focus' event can be attached to a specific DOM element and cannot be used here, in Event Delegation, also, blur event is not bubbling!
    document.addEventListener('focusout', this.onBlurred);

    window.visualViewport.addEventListener('resize', this.orientationChangeWatcherForSoftKeyboard, { passive: true });

    this.innerWidthPreviousValue = window.visualViewport.width;
    this.innerHeightPreviousValue = window.visualViewport.height;
  },
  beforeDestroy() {
    window.visualViewport.removeEventListener('resize', this.orientationChangeWatcherForSoftKeyboard, { passive: true });
    document.removeEventListener('focusin', this.onFocused);
    document.removeEventListener('focusout', this.onBlurred);
  },
  methods: {
    orientationChangeWatcherForSoftKeyboard: function() {
      const orientation = this.getOrientation();
      if (
        (this.softKeyboardInputFocused || this.softKeyboardInputBlurred)
        && this.deviceOrientation === orientation
        && window.visualViewport.width === this.innerWidthPreviousValue
      ) {
        this.softKeyboardVisible = window.visualViewport.height < this.innerHeightPreviousValue;
        if (this.softKeyboardInputFocused) {
          this.softKeyboardInputBlurred = false;
        } else if (this.softKeyboardInputBlurred) {
          this.softKeyboardInputFocused = false;
        }
      }

      this.innerWidthPreviousValue = window.visualViewport.width;
      this.innerHeightPreviousValue = window.visualViewport.height;
    },
    onFocused(e) {
      if (e && ['textarea', 'input'].includes(e.target.nodeName.toLowerCase())) {
        this.softKeyboardInputFocused = true;
        this.softKeyboardInputBlurred = false;
      }
    },
    onBlurred(e) {
      if (e && ['textarea', 'input'].includes(e.target.nodeName.toLowerCase())) {
        this.softKeyboardInputBlurred = true;
        this.softKeyboardInputFocused = false;
      }
    },
    getOrientation() {
      return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
    },
  }
});

;// CONCATENATED MODULE: ./src/mixins/Safari14Mixin.js
const IS_SAFARI_14 = /version\/14(?:\.\d+)?(?:\.\d+)?\s+safari/i.test(navigator.userAgent.toLowerCase())

/* harmony default export */ var Safari14Mixin = ({
  created() {
    if (!IS_SAFARI_14) {
      return
    }

    window.addEventListener('resize', this.safari14Resizer)
  },
  beforeDestroy() {
    if (!IS_SAFARI_14) {
      return
    }

    window.removeEventListener('resize', this.safari14Resizer)
  },
  mounted() {
    if (!IS_SAFARI_14) {
      return
    }

    this.safari14Resizer()
    if (this.$refs.videoContainer) {
      new ResizeObserver(this.safari14Resizer).observe(this.$refs.videoContainer);
    }
  },
  methods: {
    safari14Resizer(forcedLandscape = false) {
      // Constants
      const MAX_WIDTH = this.isMobileBreakpoint ? 330 : 980
      const MAX_HEIGHT = this.isMobileBreakpoint ? 632 : 600
      // const SIDEBAR_WIDTH = 360
      const TOOLBAR_TOP_HEIGHT = 45
      const FORCED_PADDING_SIDES = 30

      let VIDEO_RATIO = 16/9
      if (this.stream.width !== null && this.stream.height !== null) {
        const ratio = this.stream.width / this.stream.height
        if (ratio <= 10 / 16) {
          VIDEO_RATIO = 9/16
        }
      } else {
        if (this.isOrientationPortraitForced) {
          VIDEO_RATIO = 9/16
        }
        else {
          if (this.videoOrientation === 'portrait') {
            VIDEO_RATIO = 9/16
          }
        }
      }

      // Variables..
      const RATIO = MAX_WIDTH / MAX_HEIGHT
      let width = window.innerWidth > MAX_WIDTH ? MAX_WIDTH : window.innerWidth
      if (this.mode == 'viewer') {
        width -= FORCED_PADDING_SIDES
      }

      this.$el.style.width = `${width}px`
      const height = (window.innerHeight > MAX_HEIGHT && this.$el.offsetWidth >= MAX_WIDTH) ? MAX_HEIGHT : Math.ceil(this.$el.offsetWidth / RATIO)
      this.$el.style.height = `${height}px`

      if (this.$refs.videoContainer) {
        const $iframe = this.$refs.videoContainer.querySelector('iframe')
        if ($iframe) {
          const iframeParentWidth = this.$refs.videoContainer.offsetWidth
          let iframeNewHeight = Math.ceil(iframeParentWidth / VIDEO_RATIO)
          if (iframeNewHeight > (this.$el.offsetHeight - TOOLBAR_TOP_HEIGHT)) {
            iframeNewHeight = this.$el.offsetHeight - TOOLBAR_TOP_HEIGHT
          }

          if (forcedLandscape) {
            iframeNewHeight = Math.ceil(iframeParentWidth / (16/9))
          }

          $iframe.style.width = `${iframeParentWidth}px`
          $iframe.style.minHeight = `${iframeNewHeight}px`
        }
      }
    },
  },
  watch: {
    cssClasses() {
      if (IS_SAFARI_14) {
        this.$nextTick(() => this.safari14Resizer())
      }
    },
    isOrientationPortraitForced() {
      if (IS_SAFARI_14) {
        this.$nextTick(() => this.safari14Resizer())
      }
    },
    fullPortraitSidebarIsVisible(newVal) {
      if (IS_SAFARI_14) {
        this.$nextTick(() => this.safari14Resizer(newVal))
      }
    },
  },
});

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HeartGun.vue?vue&type=template&id=8c775db0
var HeartGunvue_type_template_id_8c775db0_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s4e09"},[_vm._l((_vm.items),function(item){return _c('div',{key:'item--' + item.id,class:item.classes},[_c('div',{staticClass:"sbaec"})])}),_c('div',{staticClass:"s7c27"},[_c('div',{staticClass:"s886b"},[_vm._v(" "+_vm._s(_vm.counterLabel)+" ")]),_c('div',{staticClass:"s6ce5 sa31d sce9d sd320",on:{"click":_vm.onClick}},[_c('i',{staticClass:"sbaec sbda9 s3189"})])])],2)
}
var HeartGunvue_type_template_id_8c775db0_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/smucio-ws-client/classes/CommentPlatform.js
var classes_CommentPlatform = __webpack_require__(191);
;// CONCATENATED MODULE: ./node_modules/smucio-ws-client/classes/Comment.js


class Comment_Comment
{
    constructor({
      clientGeneratedId,
      id,
      message,
      image = null,
      platforms = [],
      isLoading = false,
      isDeleted = false,
      createdAt = new Date(),
    }) {
      this.clientGeneratedId = clientGeneratedId;
      this.id = id;
      this.message = message;
      this.image = image;
      this.platforms = platforms;
      this.isLoading = isLoading;
      this.isDeleted = isDeleted;
      this.createdAt = createdAt;

      platforms.forEach((rawData, key) => {
        this.platforms[key] = new CommentPlatform(rawData);
      })
    }

    get isSmucMessage() {
      return this.platforms.length === 1 && this.platforms[0].type === 'smuc';
    }

    get smucPlatform() {
      return this.platforms.filter(p => p.type === 'smuc')[0];
    }

    get facebookPlatform() {
      return this.platforms.filter(p => p.type.indexOf('facebook_') === 0)[0];
    }

    get isFacebookMessage() {
      return this.platforms.filter(p => p.type.indexOf('facebook_') === 0).length !== 0;
    }

    get name() {
      return this.platforms.length === 0 ? '' : this.platforms[0].name;
    }

    updateWith(comment) {
      Object.keys(comment).forEach(key => {
        this[key] = comment[key];
      });
    }
};

// EXTERNAL MODULE: ./node_modules/websocket/lib/browser.js
var browser = __webpack_require__(952);
;// CONCATENATED MODULE: ./node_modules/smucio-ws-client/classes/WsClient.js




const WsClientEvents = {
  ERROR: 'error',
  WS_CONNECT: 'wsConnect',
  WS_CLOSE: 'wsClose',
  WS_MESSAGE: 'wsMessage',
  JOINED: 'joined',
  INFO: 'info',
  STREAM_STATUS_CHANGED: 'streamStatusChanged',
  CHAT_BANNED: 'chatBanned',
  CHAT_UNBANNED: 'chatUnbanned',
  CHAT_MESSAGE: 'chatMessage',
  CHAT_MESSAGES: 'chatMessages',
  CHAT_MESSAGE_DELETED: 'chatMessageDeleted',
  CHAT_MESSAGE_DELETE_FEEDBACK: 'chatMessageDeleteFeedback',
  CHAT_FEEDBACK: 'chatFeedback',
  CHAT_MESSAGE_RECOVERED: 'chatMessageRecovered',
  CHAT_MESSAGE_RECOVER_FEEDBACK: 'chatMessageRecoverFeedback',
  CHAT_MESSAGE_PINNED: 'chatMessagePinned',
  CHAT_MESSAGE_PIN_FEEDBACK: 'chatMessagePinFeedback',
  CHAT_MESSAGE_UNPINNED: 'chatMessageUnpinned',
  CHAT_MESSAGE_UNPIN_FEEDBACK: 'chatMessageUnpinFeedback',
  POLL: 'poll',
  POLL_REMOVE: 'pollRemove',
  POLL_VOTE: 'pollVote',
  POLL_VOTE_FEEDBACK: 'pollVoteFeedback',
  POLL_RESULTS: 'pollResults',
  HEART: 'heart',
  FEED_INFO: 'feedInfo',
}

class WsClient {

  constructor({ wsUrl, apiKey, isAdmin = false, clientPrivateKey = null, serverPublicKey = null }) {
    if (clientPrivateKey && serverPublicKey) {
      this._loadKeys(clientPrivateKey, serverPublicKey);
    }

    this._clientId = this._generateClientId();

    this._wsUrl = wsUrl;
    this._apiKey = apiKey;
    this._isAdmin = isAdmin;

    this._closedManually = false;
    this._isConnected = false
    this._isJoined = false;
    this._isPlaying = false;
    this._isBanned = false;
    this._userId = 0;
    this._chatMessagesBuffer = [];
    this._eventListeners = {};

    this._sendPlayTimer = null;

    this._chatName = '';

    this._connect();
  }

  async _loadKeys(decryptKey, encryptKey) {
    let promises = [];
    promises.push(
      crypto.subtle.importKey(
        'pkcs8',
        Buffer.from(decryptKey, 'base64'),
        { name: 'RSA-OAEP', hash: { name: 'SHA-256' } },
        true,
        ['decrypt']
      )
    );
    promises.push(
      crypto.subtle.importKey(
        'spki',
        Buffer.from(encryptKey, 'base64'),
        { name: 'RSA-OAEP', hash: { name: 'SHA-256' } },
        true,
        ['encrypt']
      )
    );

    Promise.all(promises)
      .then(keys => {
        this._decryptKey = keys[0];
        this._encryptKey = keys[1];
      })
      .catch(err => {
        this._decryptKey = null;
        this._encryptKey = null;
        this._log('Encrypt or decrypt key import error');
        console.error(err);
      });
  }

  async _encryptMessage(message) {
    try {
      const iv = crypto.getRandomValues(new Uint8Array(16));
      const encrypted = await crypto.subtle.encrypt(
        { name: 'RSA-OAEP', iv },
        this._encryptKey,
        Buffer.from(message),
      );

      return Buffer.from(encrypted).toString('base64') + '.' + Buffer.from(iv).toString('base64');
    }
    catch (err) {
      this._log('Message encryption error.');
      console.error(err);
    }

    return message;
  }

  async _decryptMessage(message) {
    if (typeof message !== 'string' || message.length === 0 || message[0] === '{') {
      return message;
    }

    let result = '';

    try {
      const chunks = message.split('-');
      for (let chunk of chunks) {
        const parts = chunk.split('.', 2);
        const encryptedMessage = Buffer.from(parts[0], 'base64');
        const iv = Buffer.from(parts[1], 'base64');

        const content = await crypto.subtle.decrypt(
          { name: 'RSA-OAEP', iv },
          this._decryptKey,
          encryptedMessage
        );
        result += (new TextDecoder()).decode(content);
      }
    }
    catch (err) {
      this._log('Message decryption error.');
      console.error(err);
      result = '{}';
    }

    return result;
  }

  _connect() {
    let url = this._wsUrl;
    if (this._apiKey) {
      url += '/' + this._apiKey + '?client_id=' + this._clientId;
      if (this._isAdmin) {
        url += '&admin';
      }
    }

    this._client = new w3cwebsocket(url);
    this._client.onerror = (err) => this._onError(err);
    this._client.onopen = () => this._onConnect();
    this._client.onclose = (event) => this._onClose(event);
    this._client.onmessage = (message) => this._onMessage(message);
  }

  addEventListener(event, callback, listenerId) {
    if (!this._eventListeners[event]) {
      this._eventListeners[event] = [];
    }

    this._eventListeners[event].push({ callback, listenerId });

    if (event === WsClientEvents.CHAT_MESSAGES && this._chatMessagesBuffer.length !== 0) {
      this._chatMessagesBuffer.forEach(item => {
        this._fireEvent(event, item);
      });
      this._chatMessagesBuffer = [];
    }
  }

  removeEventListener(event, callback) {
    if (!this._eventListeners[event]) {
      return;
    }

    this._eventListeners[event] = this._eventListeners[event].filter(item => item.callback != callback);
  }

  get isConnected() {
    return this._isConnected;
  }

  get isJoined() {
    return this._isJoined;
  }

  get isBanned() {
    return this._isBanned;
  }

  get userId() {
    return this._userId;
  }

  set chatName(val) {
    this._chatName = val.toString().trim();
  }

  _onConnect(connection) {
    this._isConnected = true;
    this._log('Conncetion is live');
    this._fireEvent(WsClientEvents.WS_CONNECT, connection);

    if (this._isPlaying) {
      this.play();
    }

    setTimeout(() => {
      if (!this._isJoined) {
        this.disconnect();
        this._connect();
      }
    }, 2000);
  }

  _onError(error) {
    this._log('WS connection error');
    console.error(error);
    this._fireEvent(WsClientEvents.ERROR, error);
  }

  _onClose(event) {
    console.log('WS Close code: ' + event.code);

    this._isConnected = false;
    this._isJoined = false;
    this._log('Connection Closed');
    this._fireEvent(WsClientEvents.WS_CLOSE);

    if (!this._closedManually) {
      setTimeout(() => this._connect(), 500);
    }
  }

  async _onMessage(message) {
    try {
      let messageContent = message.data;
      if (this._encryptKey && this._decryptKey) {
        messageContent = await this._decryptMessage(message.data);
      }

      this._fireEvent(WsClientEvents.WS_MESSAGE, messageContent);

      const parsedMessage = JSON.parse(messageContent);
      this._processMessage(parsedMessage);
    }
    catch (err) {
      console.error(err);
    }
  }

  getInfo() {
    const msg = {
      command: 'getinfo',
    };

    this._submit(msg);
  }

  play() {
    this._isPlaying = true;

    if (this._sendPlayTimer !== null) {
      clearTimeout(this._sendPlayTimer);
      this._sendPlayTimer = null;
    }

    this._sendPlayTimer = setTimeout(() => {
      this._sendPlayTimer = null;
      this._submit({ command: 'play' })
    }, 250);
  }

  pause() {
    this._isPlaying = false;

    if (this._sendPlayTimer !== null) {
      clearTimeout(this._sendPlayTimer);
      this._sendPlayTimer = null;
    }
    else {
      this._submit({ command: 'pause' });
    }
  }

  chatMessage(message, sendTo) {
    if (this._isBanned) {
      throw new Error('You are currently banned, so you cannot post messages.');
    }

    const clientGeneratedId = Array(32).fill().map(() => 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'.charAt(Math.random()*62)).join('');

    const msg = {
      command: 'chat',
      name: this._chatName,
      message,
      clientGeneratedId,
      sendTo,
    };

    this._submit(msg);

    const comment = new Comment({
      clientGeneratedId,
      message,
      isLoading: true,
    });

    return comment;
  }

  chatGetMessages({ before = new Date(), limit = 20 }) {
    const msg = {
      command: 'getChatMessages',
      before: before.getTime(),
      limit,
      isAdmin: this._isAdmin,
    };

    this._submit(msg);
  }

  chatBan({ userId }) {
    const msg = {
      command: 'ban',
      bannedUserId: userId,
    };

    this._submit(msg);
  }

  chatUnban({ userId }) {
    const msg = {
      command: 'unban',
      bannedUserId: userId,
    };

    this._submit(msg);
  }

  chatMessageDelete(messageId) {
    const msg = {
      command: 'messageDelete',
      messageId,
    };

    this._submit(msg);
  }

  chatMessageRecover(messageId) {
    const msg = {
      command: 'messageRecover',
      messageId,
    };

    this._submit(msg);
  }

  chatMessagePin(messageId) {
    const msg = {
      command: 'messagePin',
      messageId,
    };

    this._submit(msg);
  }

  chatMessageUnpin() {
    const msg = {
      command: 'messageUnpin',
    };

    this._submit(msg);
  }

  feedInfo(content) {
    const msg = {
      command: 'feedinfo',
      feedInfo: content,
    };

    this._submit(msg);
  }

  heart() {
    const msg = {
      command: 'heart',
    };

    this._submit(msg);
  }

  pollVote(pollId, answerId) {
    const msg = {
      command: 'pollVote',
      pollId,
      answerId,
    };

    this._submit(msg);
  }

  pollGetResults(pollId) {
    const msg = {
      command: 'pollGetResults',
      pollId,
    };

    this._submit(msg);
  }

  async _submit(message) {
    message['apiKey'] = this._apiKey;
    message['userId'] = this._userId;
    message['ts'] = Date.now();

    if (this._client.readyState === this._client.OPEN) {
      message = JSON.stringify(message);
      if (this._encryptKey && this._decryptKey) {
        message = await this._encryptMessage(message);
      }

      this._client.send(message);
    }
  }

  _processMessage(message) {
    console.log(message);
    switch (message.error) {
      case 'hasNoFreeViewerCapacity':
        return this._processErrorHasNoFreeViewerCapacity(message);
    }

    switch (message.command) {
      case 'joined':
        return this._processMessageJoined(message);

      case 'info':
        return this._processMessageInfo(message);

      case 'chat':
        return this._processMessageChat(message);

      case 'chatMessages':
        return this._processMessageChatMessages(message);

      case 'banned':
        return this._processMessageBanned(message);

      case 'unbanned':
        return this._processMessageUnbanned(message);

      case 'messageDeleted':
        return this._processMessageDeleted(message);

      case 'messageRecovered':
        return this._processMessageRecovered(message);

      case 'messagePinned':
        return this._processMessagePinned(message);

      case 'messageUnpinned':
        return this._processMessageUnpinned(message);

      case 'heart':
        return this._processMessageHeart(message);

      case 'feedinfo':
        return this._processMessageFeedInfo(message);

      case 'streamStatusChange':
        return this._processMessageStreamStatusChange(message);

      case 'chatFeedback':
        return this._processMessageChatFeedback(message);

      case 'chatMessageDeleteFeedback':
        return this._processMessageChatMessageDeleteFeedback(message);

      case 'chatMessageRecoverFeedback':
        return this._processMessageChatMessageRecoverFeedback(message);

      case 'chatMessagePinFeedback':
        return this._processMessageChatMessagePinFeedback(message);

      case 'chatMessageUnpinFeedback':
        return this._processMessageChatMessageUnpinFeedback(message);

      case 'poll':
        return this._processMessagePoll(message);

      case 'pollRemove':
        return this._processMessagePollRemove(message);

      case 'pollVoteFeedback':
        return this._processMessagePollVoteFeedback(message);

      case 'pollVote':
        return this._processMessagePollVote(message);

      case 'pollResults':
        return this._processMessagePollResults(message);

      default:
        this._log('An unreadable message was received from the server.', 'warn');
        console.warn(message);
    }
  }

  _processMessageJoined(message) {
    this._log('Joined to chat room (' + this._apiKey + ')');

    this._userId = message.userId;
    this._isJoined = true;
    this._fireEvent(WsClientEvents.JOINED, message);

    if (
      'feedInfo' in message
      && Array.isArray(message.feedInfo)
      && message.feedInfo.length !== 0
    ) {
      this._processMessageFeedInfo(message);
    }
  }

  _processMessageInfo(message) {
    this._fireEvent(WsClientEvents.INFO, message);
  }

  _processMessageChat(message) {
    const comment = new Comment({
      id: message.data.id,
      message: message.data.message,
      image: message.data.image,
      isDeleted: message.data.isDeleted,
      platforms: message.data.platforms,
      createdAt: new Date(message.data.createdAt),
    });

    this._fireEvent(WsClientEvents.CHAT_MESSAGE, comment);
  }

  _processMessageChatMessages(message) {
    let comments = [];
    message.data.forEach(item => {
      const comment = new Comment({
        id: item.id,
        message: item.message,
        image: item.image,
        isDeleted: item.isDeleted,
        platforms: item.platforms,
        createdAt: new Date(item.createdAt),
      });
      comments.push(comment);
    });

    if (!this._hasListener(WsClientEvents.CHAT_MESSAGES)) {
      this._chatMessagesBuffer.push({ comments, pinned: message.pinned });
      return;
    }

    this._fireEvent(WsClientEvents.CHAT_MESSAGES, { comments, pinned: message.pinned });
  }

  _processMessageBanned(message) {
    this._isBanned = true;
    this._fireEvent(WsClientEvents.CHAT_BANNED, message);
  }

  _processMessageUnbanned(message) {
    this._isBanned = false;
    this._fireEvent(WsClientEvents.CHAT_UNBANNED, message);
  }

  _processMessageDeleted(message) {
    this._fireEvent(WsClientEvents.CHAT_MESSAGE_DELETED, message);
  }

  _processMessageRecovered(message) {
    this._fireEvent(WsClientEvents.CHAT_MESSAGE_RECOVERED, message);
  }

  _processMessagePinned(message) {
    const comment = new Comment(message.data);
    this._fireEvent(WsClientEvents.CHAT_MESSAGE_PINNED, comment);
  }

  _processMessageUnpinned(message) {
    this._fireEvent(WsClientEvents.CHAT_MESSAGE_UNPINNED, message);
  }

  _processMessageHeart(message) {
    this._fireEvent(WsClientEvents.HEART, message);
  }

  _processMessageFeedInfo(message) {
    this._fireEvent(WsClientEvents.FEED_INFO, message.feedInfo);
  }

  _processMessageStreamStatusChange(message) {
    this._fireEvent(WsClientEvents.STREAM_STATUS_CHANGED, message.status);
  }

  _processMessageChatFeedback(message) {
    const success = message.success;
    let comment = null;

    if (success) {
      comment = new Comment(message.data);
      if (comment.smucPlatform) {
        comment.smucPlatform.name = 'You';
      }
    }

    this._fireEvent(WsClientEvents.CHAT_FEEDBACK, { success, comment });
  }

  _processMessageChatMessageDeleteFeedback(message) {
    this._fireEvent(WsClientEvents.CHAT_MESSAGE_DELETE_FEEDBACK, message);
  }

  _processMessageChatMessageRecoverFeedback(message) {
    this._fireEvent(WsClientEvents.CHAT_MESSAGE_RECOVER_FEEDBACK, message);
  }

  _processMessageChatMessagePinFeedback(message) {
    this._fireEvent(WsClientEvents.CHAT_MESSAGE_PIN_FEEDBACK, message);
  }

  _processMessageChatMessageUnpinFeedback(message) {
    this._fireEvent(WsClientEvents.CHAT_MESSAGE_UNPIN_FEEDBACK, message);
  }

  _processMessagePoll(message) {
    this._fireEvent(WsClientEvents.POLL, new Poll(message.data));
  }

  _processMessagePollRemove(message) {
    this._fireEvent(WsClientEvents.POLL_REMOVE, message.data.id);
  }

  _processMessagePollVote(message) {
    this._fireEvent(WsClientEvents.POLL_VOTE, message);
  }

  _processMessagePollVoteFeedback(message) {
    this._fireEvent(WsClientEvents.POLL_VOTE_FEEDBACK, message);
  }

  _processMessagePollResults(message) {
    this._fireEvent(WsClientEvents.POLL_RESULTS, message);
  }

  _processErrorHasNoFreeViewerCapacity(message) {
    const error = new HasNoFreeViewerCapacityError();
    this._fireEvent(WsClientEvents.ERROR, error);
    this.disconnect();
  }

  disconnect() {
    this._closedManually = true;
    this._client.close();
  }

  _fireEvent(event, payload) {
    if (!this._hasListener(event)) {
      return;
    }

    this._eventListeners[event].forEach(item => item.callback(payload, item.listenerId));
  }

  _hasListener(event) {
    return event in this._eventListeners;
  }

  _log(content, type) {
    if (!type) {
      type = 'info';
    }

    console[type]('[WS Client] ' + content);
  }

  _generateClientId() {
    if (window && window.crypto && window.crypto.randomUUID) {
      return window.crypto.randomUUID();
    }

    return (Math.random() + 1).toString(36).substring(2, 8) +
      '-' + (Math.random() + 1).toString(36).substring(2, 4) +
      '-' + (Math.random() + 1).toString(36).substring(2, 4) +
      '-' + (Math.random() + 1).toString(36).substring(2, 4) +
      '-' + (Math.random() + 1).toString(36).substring(2, 6) + (Math.random() + 1).toString(36).substring(2, 6);
  }

}

class HasNoFreeViewerCapacityError extends Error {
  constructor() {
    super();
    this.message = 'You cannot join at this time because the broadcast has reached the maximum number of viewers.';
  }
}

;// CONCATENATED MODULE: ./node_modules/smucio-ws-client/main.js






;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HeartGun.vue?vue&type=script&lang=js



/* harmony default export */ var HeartGunvue_type_script_lang_js = ({
  name: 'HeartGun',
  props: {
    wsClient: {
      required: false,
      validator: (value) => {
        if (value === null) {
          return true;
        }

        if (
          typeof value === 'object'
          && value.constructor
          && value.constructor.name
          && value.constructor.name === 'WsClient'
        ) {
          return true
        }

        return false
      },
      default() {
        return null;
      },
    },
    runDemo: {
      required: false,
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    items: [],
    counter: 0,
    demoTimers: [],
  }),
  computed: {
    counterLabel() {
      if (this.counter < 1000) {
        return this.counter;
      }

      let resp = parseFloat((this.counter / 1000).toFixed(1));
      return resp + 'K';
    },
  },
  watch: {
    wsClient: {
      immediate: true,
      handler(val) {
        if (val !== null) {
          val.addEventListener(WsClientEvents.HEART, () => this.trigger());
          val.addEventListener(WsClientEvents.INFO, (info) => this.updateCounter(info.heartCount));
        }
      }
    },
    runDemo: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => this.initDemoAnimation());
        }
        else {
          for (let i in this.demoTimers) {
            if (this.demoTimers[i] !== null) {
              clearTimeout(this.demoTimers[i]);
              this.demoTimers[i] = null;
            }
          }
        }
      },
    },
  },
  methods: {
    initDemoAnimation() {
      const observer = new IntersectionObserver((entries) => {
        const isVisible = entries[0].isIntersecting;
        if (isVisible) {
          observer.disconnect();

          const animationCount = Math.floor(Math.random() * 10) + 10;
          const animationDuration = 5000;

          for (let i = 0; i < animationCount; ++i) {
            let delay = Math.random() * animationDuration;
            this.demoTimers[i] = setTimeout(() => {
              this.demoTimers[i] = null;
              this.trigger(true)
            }, delay);
          }
        }
      });
      observer.observe(this.$el);
    },
    onClick() {
      if (this.wsClient !== null) {
        this.wsClient.heart();
      }
      this.trigger();
    },
    trigger(ignoreCounter) {
      if (!ignoreCounter) {
        ++this.counter;
      }

      const itemId = this.generateItemId();
      const randomX = Math.floor(Math.random() * 3 + 1);
      const randomY = Math.floor(Math.random() * 3 + 1);
      const randomXDelay = Math.floor(Math.random() * 3 + 1);
      const randomYDelay = Math.floor(Math.random() * 3 + 1);

      this.items.push({
        id: itemId,
        classes: [
          'item',
          'shake-y-' + randomY,
          'shake-x-' + randomX,
          'shake-x-delay-' + randomXDelay,
          'shake-y-delay-' + randomYDelay,
        ]
      });
      setTimeout(() => {
        this.items = this.items.filter(e => e.id !== itemId);
      }, 50000);
    },
    generateItemId() {
      return (Math.random() + 1).toString(36).substring(7);
    },
    updateCounter(value) {
      this.counter = value;
    },
  }
});

;// CONCATENATED MODULE: ./src/components/HeartGun.vue?vue&type=script&lang=js
 /* harmony default export */ var components_HeartGunvue_type_script_lang_js = (HeartGunvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/HeartGun.vue





/* normalize component */
;
var component = normalizeComponent(
  components_HeartGunvue_type_script_lang_js,
  HeartGunvue_type_template_id_8c775db0_render,
  HeartGunvue_type_template_id_8c775db0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var HeartGun = (component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProductFeed.vue?vue&type=template&id=6a5c28e1
var ProductFeedvue_type_template_id_6a5c28e1_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.product.quantity === null || _vm.product.quantity === '' || typeof _vm.product.quantity === 'undefined' || _vm.product.quantity > 0),expression:"product.quantity === null || product.quantity === '' || typeof product.quantity === 'undefined' || product.quantity > 0"}],class:{'s3e79': true, 's8a4f': _vm.isPinned},on:{"mousedown":_vm.onMouseDown,"mouseup":_vm.onMouseUp}},[_c('div',{staticClass:"sc8b1"},[_c('div',{class:_vm.photoWrapperClasses},[(_vm.product.image_link)?_c('img',{ref:"image",class:_vm.imageClasses,on:{"load":_vm.onImageLoaded,"error":_vm.onImageError}}):_vm._e(),(_vm.imageIsLoading)?_c('i',{staticClass:"sbaec s4a52 s1ffd"}):_vm._e()]),_c('div',{staticClass:"s8486"},[(!_vm.isPinned)?_c('label',[_vm._v(_vm._s(_vm.product.title))]):_vm._e(),(_vm.hasAlternateText)?_c('div',{staticClass:"sdf28"},[_vm._v(" "+_vm._s(_vm.product.alternate_text)+" ")]):(_vm.formattedPrice !== null)?_c('div',{class:{'s78a5': true, 'sf36e': _vm.product.sales_price}},[(_vm.product.sales_price)?_c('span',{staticClass:"s51d3"},[_vm._v(_vm._s(_vm.formattedSalesPrice))]):_vm._e(),_c('span',{staticClass:"s2200"},[_vm._v(_vm._s(_vm.formattedPrice))])]):_vm._e()])]),(!_vm.isPinned)?_c('div',{staticClass:"s2779",style:(_vm.detailsButtonStyle),on:{"mouseover":() => _vm.detailsButtonHovered = true,"mouseleave":() => _vm.detailsButtonHovered = false}},[(_vm.showCart)?_c('span',{staticClass:"sb934",on:{"click":_vm.addToCart}},[(_vm.isLoading)?_c('i',{staticClass:"sbaec s4a52",style:(_vm.cartIconStyle)}):_c('i',{staticClass:"sbaec s1ffd sfe41",style:(_vm.cartIconStyle)})]):_vm._e(),_c('span',{staticClass:"s1bda"},[_vm._v(_vm._s(_vm.buttonLabel))])]):_c('div',{staticClass:"sd479"},[_c('span',{staticClass:"s1bda"},[_vm._v(_vm._s(_vm.tr('Details')))])]),(_vm.isPinned && _vm.hasPinnedItemTimer)?_c('div',{staticClass:"s986e"},[_c('div',{staticClass:"s67b3",style:(_vm.pinnedItemTimerStyle)})]):_vm._e()])
}
var ProductFeedvue_type_template_id_6a5c28e1_staticRenderFns = []


;// CONCATENATED MODULE: ./src/js/mixin.js
/* harmony default export */ var mixin = ({
  computed: {
    formattedPrice() {
      const isNumeric = typeof this.product.price === 'number'
      || (
        typeof this.product.price === 'string'
        && this.product.price.length > 0
        && /^\d+(?:\.\d+)?$/.exec(this.product.price) != null
      )

      const opts = {
        style: 'currency',
        currency: this.currency.toUpperCase(),
        minimumFractionDigits: this.currency.toUpperCase() === 'HUF' ? 0 : 2,
      }
      return (isNumeric && parseFloat(this.product.price) > 0)
        ? Number(this.product.price).toLocaleString(window.navigator.language, opts)
        : null
    },
    formattedSalesPrice() {
      const isNumeric = typeof this.product.sales_price === 'number'
      || (
        typeof this.product.sales_price === 'string'
        && this.product.sales_price.length > 0
        && /^\d+(?:\.\d+)?$/.exec(this.product.sales_price) != null
      )

      const opts = {
        style: 'currency',
        currency: this.currency.toUpperCase(),
        minimumFractionDigits: this.currency.toUpperCase() === 'HUF' ? 0 : 2,
      }
      return (isNumeric && parseFloat(this.product.sales_price) > 0)
        ? Number(this.product.sales_price).toLocaleString(window.navigator.language, opts)
        : null
    },
  },
});

;// CONCATENATED MODULE: ./src/consts.js
const Events = {
  PLAYER_CONTROL_VISIVILITY_CHANGE: 'player.control_visibility_change',
  PLAYBACK_POSITION: 'playback.position',
  NEW_MESSAGE_COUNTER_VALUE: 'new_message_counter.value'
};

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProductFeed.vue?vue&type=script&lang=js






/* harmony default export */ var ProductFeedvue_type_script_lang_js = ({
  name: 'ProductFeed',
  mixins: [ mixin, Translator ],
  props: {
    product: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: false,
      default: 'huf'
    },
    isPinned: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonColor: {
      type: String,
      required: false,
      default: () => null,
    },
    textColor: {
      type: String,
      required: false,
      default: () => null,
    },
  },
  data: () => ({
    // This `isDisabled` property is a TEMPORARY one!
    // Once decision is made for operations (close/cart) revise this!
    isDisabled: true,
    mouseDownEvent: null,
    isLoading: false,
    imageIsLoading: false,
    playbackPosition: 0,
    imageMime: null,
    detailsButtonHovered: false,
  }),
  computed: {
    photoWrapperClasses() {
      return {
        's5ae0': true,
        'sb717': !this.product.image_link,
      };
    },
    imageClasses() {
      return {
        's4c49': this.imageIsLoading,
        'plain-image': this.imageMime !== null && this.imageMime.includes('image/') && !this.imageMime.includes('svg'),
        's2982': this.imageMime !== null && this.imageMime.includes('svg'),
      };
    },
    detailsButtonStyle() {
      return {
        'border-color': this.buttonColor,
        'background-color': this.detailsButtonHovered ? this.buttonColor : 'transparent',
        'color': this.detailsButtonHovered ? this.textColor : this.buttonColor,
      };
    },
    cartIconStyle() {
      return {
        'background-color': this.detailsButtonHovered ? this.textColor : this.buttonColor,
      };
    },
    showCart() {
      if((window.woocommerce_params || window.Shopify) && this.product.price > 0 && this.product.link && !this.product.payable){
        var url = new URL(this.product.link)
        return window.location.origin == url.origin;
      }
      return false;
    },
    hasPinnedItemTimer() {
      return this.product.pinned_from_in_sec !== null && this.product.pinned_to_in_sec !== null
        && this.product.pinned_from_in_sec <= this.playbackPosition
        && this.product.pinned_to_in_sec >= this.playbackPosition;
    },
    pinnedItemTimerStyle() {
      const width = 100 - (this.playbackPosition - this.product.pinned_from_in_sec) / (this.product.pinned_to_in_sec - this.product.pinned_from_in_sec) * 100;

      return { 'width': width + '%', 'background-color': this.buttonColor };
    },
    hasAlternateText() {
      return typeof this.product.alternate_text == 'string' && this.product.alternate_text.length > 0
    },
    buttonLabel() {
      const ctaLabelOverride = typeof this.product.cta == 'string' && this.product.cta.length > 0
      return ctaLabelOverride ? this.product.cta : this.tr('Details');
    },
  },
  watch: {
    'product.image_link'(val, oldVal) {
      if (val == oldVal) {
        return;
      }

      this.$nextTick(() => this.initImageLazyload());
    },
  },
  created() {
    if (this.isPinned) {
      this.$root.$bus.$on(Events.PLAYBACK_POSITION, this.updatePlaybackPosition);
      this.$root.$bus.$emit('aq', ['visibleItem', this.product.id.toString()]);
    }
  },
  mounted() {
    this.addHandler()
    this.$nextTick(() => this.initImageLazyload());
  },
  beforeDestroy() {
    this.removeHandler()
    if (this.isPinned) {
      this.$root.$bus.$off(Events.PLAYBACK_POSITION, this.updatePlaybackPosition);
    }
  },
  methods: {
    initImageLazyload() {
      if (
        !this.$refs.image
        || this.$refs.image.getAttribute('src') == this.product.image_link
      ) {
        return;
      }

      this.$refs.image.setAttribute('src', '');

      if (!this.product.image_link) {
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        const isVisible = entries[0].isIntersecting;
        if (isVisible) {
          if (!this.$refs.image) {
            return;
          }
          this.imageIsLoading = true;
          this.$refs.image.setAttribute('src', this.product.image_link)
          observer.disconnect();
          this.fetchMimeType(this.product.image_link)
            .then(mimetype => this.imageMime = mimetype)
        }
      });
      observer.observe(this.$refs.image);
    },
    onMouseDown(e) {
      this.mouseDownEvent = e;
    },
    onMouseUp(e) {
      if (
        !this.mouseDownEvent
        || (
          this.mouseDownEvent
          && this.mouseDownEvent.target
          && (
            this.mouseDownEvent.target.classList.contains('cart-plus')
            || this.mouseDownEvent.target.classList.contains('loader')
          )
        )
      ) {
        return;
      }

      const timeDiff = e.timeStamp - this.mouseDownEvent.timeStamp;
      if (timeDiff > 300) {
        return;
      }

      const xDiff = Math.abs(e.pageX - this.mouseDownEvent.pageX);
      const yDiff = Math.abs(e.pageY - this.mouseDownEvent.pageY);

      if (xDiff + yDiff > 2) {
        return;
      }

      this.$root.$bus.$emit('streamview.product.feed.details', this.product);
      this.$root.$bus.$emit('streamview.product.feed.click', this.product);
      this.$root.$bus.$emit('aq', ['event', 'click', { item: this.product.id.toString() }]);

      if (this.product.card_click_tracking) {
        (new Image()).src = this.product.card_click_tracking;
      }
    },
    addToCart() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      if (this.product.link) {
        var productUrl = new URL(this.product.link);
        if (window.location.origin == productUrl.origin) {
          window.postMessage({
            event: 'streamview.product.feed.addtocart.start',
            product: this.product
          });
        }
      }
    },
    // closePinnedItem() {
    //   this.$root.$bus.$emit('streamview.product.feed.pinned.close', this.product)
    // },
    updatePlaybackPosition(val) {
      this.playbackPosition = val;
    },
    addHandler() {
      window.addEventListener('message', this.messageListener);
    },
    removeHandler() {
      window.removeEventListener('message', this.messageListener);
    },
    messageListener(msg){
      if (msg && msg.data.event == 'streamview.product.feed.addtocart.finish') {
        if (msg.data.product.id == this.product.id) {
          this.isLoading = false;
        }
      }
    },
    fetchMimeType(src) {
      return fetch(src, { method: 'HEAD' }).then(response => response.headers.get('Content-type'))
    },
    onImageLoaded() {
      this.imageIsLoading = false;
    },
    onImageError(e) {
      if (!e.target.getAttribute('src')) {
        return;
      }

      this.imageIsLoading = false;
      this.product.image_link = null;
    }
  }
});

;// CONCATENATED MODULE: ./src/components/ProductFeed.vue?vue&type=script&lang=js
 /* harmony default export */ var components_ProductFeedvue_type_script_lang_js = (ProductFeedvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/ProductFeed.vue





/* normalize component */
;
var ProductFeed_component = normalizeComponent(
  components_ProductFeedvue_type_script_lang_js,
  ProductFeedvue_type_template_id_6a5c28e1_render,
  ProductFeedvue_type_template_id_6a5c28e1_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductFeed = (ProductFeed_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StreamInfoBar.vue?vue&type=template&id=2d2546d6
var StreamInfoBarvue_type_template_id_2d2546d6_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s58f5"},[_c('div',{staticClass:"sa1b5"},[(!_vm.hideTitle)?_c('label',{staticClass:"stream-label",style:(_vm.streamTitleCustomStyles),attrs:{"title":_vm.name}},[_vm._v(" "+_vm._s(_vm.name)+" ")]):_vm._e(),(_vm.isSponsoredContent)?_c('span',{staticClass:"s39dd"},[_vm._v(_vm._s(_vm.tr('Sponsored content')))]):_vm._e()]),(!_vm.hideTitle)?_c('div',{staticClass:"s3f76"},[(_vm.agencyLogo !== null)?_c('img',{staticClass:"s79aa",attrs:{"src":_vm.agencyLogo.url}}):_c('a',{staticClass:"s899f",attrs:{"href":"https://bannerse.com","target":"_blank","title":"Bannerse.com"}})]):_vm._e()])
}
var StreamInfoBarvue_type_template_id_2d2546d6_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StreamInfoBar.vue?vue&type=script&lang=js



/* harmony default export */ var StreamInfoBarvue_type_script_lang_js = ({
  name: 'StreamInfoBar',
  mixins: [ Translator ],
  props: {
    name: {
      type: String,
      required: true
    },
    nameColor: {
      type: String,
      required: false,
      default: '',
      validator: v => v == '' || (v.length > 0 && /^#?([0-9a-f]{3}|[0-9a-f]{6})$/.exec(v.toLowerCase()) !== null),
    },
    hideTitle: {
      type: Boolean,
      required: false,
      default: false
    },
    isSponsoredContent: {
      type: Boolean,
      required: false,
      default: false
    },
    agencyLogo: {
      type: Object,
      required: false,
      default: null,
      validator: v => v === null || Object.prototype.toString.call(v) == '[object Object]'
    }
  },
  computed: {
    streamTitleCustomStyles() {
      const s = {}
      if (this.nameColor != '' && this.nameColor != null && this.nameColor != '#000' && this.nameColor != '#000000') {
        s['color'] = '#' + this.nameColor.replace('#', '')
      }
      return s
    }
  }
});

;// CONCATENATED MODULE: ./src/components/StreamInfoBar.vue?vue&type=script&lang=js
 /* harmony default export */ var components_StreamInfoBarvue_type_script_lang_js = (StreamInfoBarvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/StreamInfoBar.vue





/* normalize component */
;
var StreamInfoBar_component = normalizeComponent(
  components_StreamInfoBarvue_type_script_lang_js,
  StreamInfoBarvue_type_template_id_2d2546d6_render,
  StreamInfoBarvue_type_template_id_2d2546d6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StreamInfoBar = (StreamInfoBar_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProductDetails.vue?vue&type=template&id=14c1b624
var ProductDetailsvue_type_template_id_14c1b624_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"frame",class:_vm.frameClasses},[_c('header',{staticClass:"sd808"},[(_vm.streamviewEl != null)?_c('dragbar',{attrs:{"streamview-el":_vm.streamviewEl,"draggable-container":_vm.$el,"tap-to-close":true,"rule-to-update":"top","top-offset":0},on:{"closed":_vm.eventOnDetailsClose}}):_vm._e(),_c('span',{on:{"click":_vm.eventOnBack}},[_c('i',{staticClass:"sbaec s469b s1ffd"}),_vm._v(" "+_vm._s(_vm.tr('Back'))+" ")])],1),_c('section',{staticClass:"sd808 smc-product-details--head"},[_c('label',{staticClass:"s22b6"},[_vm._v(_vm._s(_vm.product.title))]),(_vm.formattedPrice !== null)?_c('div',{class:{'s112b': true, 'sf36e': _vm.product.sales_price}},[(_vm.product.sales_price)?_c('span',{staticClass:"s51d3"},[_vm._v(_vm._s(_vm.formattedSalesPrice))]):_vm._e(),_c('span',{staticClass:"s2200"},[_vm._v(_vm._s(_vm.formattedPrice))])]):_vm._e()]),_c('section',{staticClass:"sd808"},[_c('label',{staticClass:"s322f"},[_vm._v(_vm._s(_vm.tr('Description')))])]),_c('section',{staticClass:"sd808 s593e"},[_c('div',{ref:"productDescription",staticClass:"s1562"},[_c('img',{attrs:{"src":_vm.product.image_link}}),_c('div',{staticClass:"s1f56",domProps:{"innerHTML":_vm._s(_vm.product.description)}})])]),(_vm.productLink)?_c('section',{staticClass:"sd808 s14a4"},[_c('a',{staticClass:"s7274",style:({'background-color': _vm.buttonColor, 'color': _vm.textColor}),attrs:{"href":_vm.productLink,"target":_vm.productLinkTarget},on:{"click":_vm.eventOnPurchaseClick}},[_vm._v(_vm._s(_vm.buttonLabel))])]):_vm._e()])
}
var ProductDetailsvue_type_template_id_14c1b624_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dragbar.vue?vue&type=template&id=05870884
var Dragbarvue_type_template_id_05870884_render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var Dragbarvue_type_template_id_05870884_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sd27a",attrs:{"draggable":"true"}},[_c('span')])
}]


;// CONCATENATED MODULE: ./src/components/Dragbar.vue?vue&type=template&id=05870884

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dragbar.vue?vue&type=script&lang=js

/* harmony default export */ var Dragbarvue_type_script_lang_js = ({
  namespaced: true,
  name: 'Dragbar',
  props: {
    draggableContainer: {
      type: HTMLElement,
      required: true,
    },
    streamviewEl: {
      type: HTMLElement,
      required: true,
    },
    tapToClose: {
      type: Boolean,
      required: false,
      default: false,
    },
    minimumHeight: {
      type: [Function, Number],
      required: false,
      default: 0,
    },
    ruleToUpdate: {
      type: String,
      required: false,
      default: 'height',
      validator: (v) => {
        return ['height', 'top'].includes(v)
      }
    },
    topOffset: {
      type: Number,
      required: false,
      default: 0,
      validator: (v) => v >= 0
    }
  },
  data() {
    return {
      dragbarStartPosY: this.topOffset || 0,
      isDragging: false,
      dragIcon: document.createElement('img'),
    }
  },
  created() {
    this.dragIcon.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
    this.dragIcon.width = 0
    this.dragIcon.height = 0
    this.dragIcon.opacity = 0
  },
  mounted() {
    this.$nextTick(() => {
      if (this.isTouchEventsSupported) {
        this.$el.addEventListener('touchmove', this.dragging, true);
        this.$el.addEventListener('touchstart', this.dragStart, true);
        this.$el.addEventListener('touchend', this.dragEnd, true);
      } else {
        this.$el.addEventListener('drag', this.dragging, true);
        this.$el.addEventListener('dragstart', this.dragStart, true);
        this.$el.addEventListener('dragend', this.dragEnd, true);
        this.$el.addEventListener('dragover', this.dragOver, true);
      }
    })
    this.$el.addEventListener('click', this.closeOnTap)
  },
  beforeDestroy() {
    if (this.isTouchEventsSupported) {
      this.$el.removeEventListener('touchmove', this.dragging, true);
      this.$el.removeEventListener('touchstart', this.dragStart, true);
      this.$el.removeEventListener('touchend', this.dragEnd, true);
    } else {
      this.$el.removeEventListener('drag', this.dragging, true);
      this.$el.removeEventListener('dragstart', this.dragStart, true);
      this.$el.removeEventListener('dragend', this.dragEnd, true);
      this.$el.removeEventListener('dragover', this.dragOver, true);
    }
    this.$el.removeEventListener('click', this.closeOnTap)
  },
  computed: {
    isTouchEventsSupported() {
      return 'ontouchstart' in document.documentElement
    }
  },
  methods: {
    dragging(e) {
      e.preventDefault()

      const movement = this.dragbarMovementResult(e)
      if (movement.Y === null) {
        return false
      }

      if (this.ruleToUpdate === 'height') {
        this.draggableContainer.style.height = movement.Y.toString() + 'px'
        this.draggableContainer.style.flex = '0 0 ' + movement.Y.toString() + 'px'
      } else if (this.ruleToUpdate === 'top') {
        this.draggableContainer.style.top = movement.Y.toString() + 'px'
      }

      this.$emit('dragging', e)
    },
    dragStart(e) {
      this.draggableContainer.classList.add('dragging')
      this.draggableContainer.classList.remove('fluid')
      // Note: e.touches could be enough, but be consequent..
      this.dragbarStartPosY = ((e instanceof TouchEvent) ? e.changedTouches[0].pageY : e.pageY) - this.topOffset

      if (e.dataTransfer) {
        e.dataTransfer.effectAllowed = 'move'

        // Remove ghosting dragged element while dragging..
        e.dataTransfer.setDragImage(this.dragIcon, 0, 0)
      }

      this.$emit('drag-start', e)
    },
    dragEnd(e) {
      this.draggableContainer.classList.remove('dragging')
      this.draggableContainer.classList.add('fluid')
      const movement = this.dragbarMovementResult(e)
      if (movement.isMin || movement.halfwayBefore) {
        if (this.ruleToUpdate === 'height') {
          // @TODO - ...
          const newHeight = (this.streamviewEl.offsetWidth * (9/16)) + 'px'
          this.draggableContainer.style.height = newHeight
          this.draggableContainer.style.flex = '0 0 ' + newHeight
        } else if (this.ruleToUpdate === 'top') {
          this.draggableContainer.style.top = this.topOffset.toString() + 'px'
        }
      } else if (movement.isMax || movement.halfwayAfter) {
        this.closeOnTap()
      }

      this.$emit('drag-end', e)
    },
    dragOver(e) {
      // To fires dragend event immediately!
      e.preventDefault()
    },
    dragbarMovementResult(e) {
      let o = {Y:null,isMin:false,isMax:false,halfwayAfter:false,halfwayBefore:false}
      let minimumHeight = 0
      if (typeof this.minimumHeight === 'number') {
        minimumHeight = this.minimumHeight
      } else if (typeof this.minimumHeight === 'function') {
        minimumHeight = this.minimumHeight()
      }

      // Note: e.touches is NOT enough here because lifted finger will remove TouchEvent
      // from e.touches array and will appear in changedTouches!
      const pageY = (e instanceof TouchEvent) ? e.changedTouches[0].pageY : e.pageY
      const offset = (-1 * this.dragbarStartPosY) + pageY
      if (minimumHeight + offset <= minimumHeight) {
        o.isMin = true
        return o
      } else if ((this.streamviewEl.offsetHeight - 45 - minimumHeight - offset) <= 0) {
        o.isMax = true
        return o
      }

      if (((this.streamviewEl.offsetHeight - 45) / 2) < (minimumHeight + offset)) {
        o.halfwayAfter = true
      } else {
        o.halfwayBefore = true
      }

      o.Y = minimumHeight + offset
      return o
    },
    closeOnTap() {
      this.draggableContainer.classList.add('fluid')
      if (this.ruleToUpdate === 'height') {
        const newHeight = (this.streamviewEl.offsetHeight - 45) + 'px'
        this.draggableContainer.style.height = newHeight
        this.draggableContainer.style.flex = '0 0 ' + newHeight

        setTimeout(() => this.draggableContainer.classList.remove('fluid'), 250)
      } else if (this.ruleToUpdate === 'top') {
        this.draggableContainer.style.top = this.streamviewEl.offsetHeight.toString() + 'px'
      }

      this.$emit('closed')
    }
  }
});

;// CONCATENATED MODULE: ./src/components/Dragbar.vue?vue&type=script&lang=js
 /* harmony default export */ var components_Dragbarvue_type_script_lang_js = (Dragbarvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/Dragbar.vue





/* normalize component */
;
var Dragbar_component = normalizeComponent(
  components_Dragbarvue_type_script_lang_js,
  Dragbarvue_type_template_id_05870884_render,
  Dragbarvue_type_template_id_05870884_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Dragbar = (Dragbar_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProductDetails.vue?vue&type=script&lang=js





/* harmony default export */ var ProductDetailsvue_type_script_lang_js = ({
  name: 'ProductDetails',
  components: { Dragbar: Dragbar },
  mixins: [ mixin, Translator ],
  props: {
    product: {
      type: Object,
      required: true
    },
    payment: {
      type: [Object, null],
      required: false,
      default: null
    },
    currency: {
      type: String,
      required: false,
      default: 'huf'
    },
    isMobile: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonColor: {
      type: String,
      required: false,
      default() {
        return '#000000';
      },
    },
    textColor: {
      type: String,
      required: false,
      default() {
        return '#ffffff';
      },
    },
  },
  data() {
    return {
      slideUpClassOnFrame: true,
      streamviewEl: null,
    }
  },
  computed: {
    frameClasses() {
      return {
        'sab97': true,
        'see95': this.slideUpClassOnFrame,
      };
    },
    isPurchasable() {
      return this.payment && this.product.payable && this.product.price
    },
    buttonLabel() {
      const ctaLabelOverride = typeof this.product.cta == 'string' && this.product.cta.length > 0
      return ctaLabelOverride
        ? this.product.cta
        : (this.isPurchasable ? this.tr('Purchase') : this.tr('Learn more'))
    },
    productLink() {
      let link = this.product.link;
      if (this.$root.clickTracker) {
        link = this.$root.clickTracker + link;
      }

      return link;
    },
    productLinkTarget() {
      return this.product.link_open_in ? this.product.link_open_in : '_blank';
    },
    isSafari() {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    },
  },
  mounted() {
    if (this.$parent && this.$parent && this.$parent.$el) {
      this.streamviewEl = this.$parent.$el
    }

    setTimeout(() => this.slideUpClassOnFrame = false, 300)
  },
  methods: {
    eventOnBack() {
      this.$refs.frame.classList.add('slide-down');
      this.eventOnDetailsClose();
    },
    eventOnDetailsClose() {
      setTimeout(() => {
        this.$root.$bus.$emit('streamview.product.feed.details.close')
      }, 200)
    },
    eventOnPurchaseClick(e) {
      if (this.isPurchasable) {
        this.$root.$bus.$emit('streamview.product.payment.start', this.product)

        this.eventOnBack();

        e.preventDefault()
        return false
      }
      else {
        this.$root.$bus.$emit('aq', ['event', 'link_click', { item: this.product.id.toString() }]);

        if (this.product.link_click_tracking) {
          (new Image()).src = this.product.link_click_tracking;
        }
      }
    }
  },
  watch: {
    product(newVal, oldVal) {
      if (oldVal == null || newVal == null) {
        return
      }

      const opts = {top: 0}
      if (!this.isSafari) {
        opts.behavior = 'smooth'
      }
      this.$refs.productDescription.scrollTo(opts)
    }
  }
});

;// CONCATENATED MODULE: ./src/components/ProductDetails.vue?vue&type=script&lang=js
 /* harmony default export */ var components_ProductDetailsvue_type_script_lang_js = (ProductDetailsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/ProductDetails.vue





/* normalize component */
;
var ProductDetails_component = normalizeComponent(
  components_ProductDetailsvue_type_script_lang_js,
  ProductDetailsvue_type_template_id_14c1b624_render,
  ProductDetailsvue_type_template_id_14c1b624_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductDetails = (ProductDetails_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StreamViewCloudflare.vue?vue&type=template&id=e7e111a4
var StreamViewCloudflarevue_type_template_id_e7e111a4_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc7ff",style:(_vm.wrapperStyle)},[_c('iframe',{ref:"videoPlayer",class:_vm.iframeClasses,staticStyle:{"border":"none"},attrs:{"src":_vm.videoPlayerSrc,"frameborder":"0","allow":"autoplay; encrypted-media;","allowfullscreen":""},on:{"load":_vm.onVideoPlayerLoaded}}),_vm._t("default")],2)
}
var StreamViewCloudflarevue_type_template_id_e7e111a4_staticRenderFns = []


;// CONCATENATED MODULE: ./src/mixins/StreamViewType.js
/* harmony default export */ var StreamViewType = ({
  props: {
    videoSource: {
      required: false,
      default: null,
      validator: (v) => {
        return v === null || /(youtube|vimeo|facebook|cloudflarestream|videodelivery)|(\.(m3u8|mp4))/.exec(v) != null
      }
    },
    poster: {
      type: String,
      required: false,
      default: () => null,
    },
    streamType: {
      type: String,
      required: true,
      validator: (v) => ['live', 'playback', 'embed', 'ad', 'photo_ad'].includes(v)
    },
    isPreview: {
      type: Boolean,
      required: false,
      default: false,
    },
    isVod: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasNextVodChapter: {
      type: Boolean,
      required: false,
      default: false,
    },
    wsClient: {
      required: false,
      validator: (value) => {
        if (value === null) {
          return true;
        }

        if (
          typeof value === 'object'
          && value.constructor
          && value.constructor.name
          && value.constructor.name === 'WsClient'
        ) {
          return true
        }

        return false
      },
      default: null,
    },
    autoplay: {
      type: Boolean,
      required: false,
      default: false,
    },
    muted: {
      type: Boolean,
      required: false,
      default: false,
    },
    loop: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasAdUrl: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    emitVideoDimensions(width, height) {
      this.$emit('videoLoadedMetadata', {width, height})
    },
  }
});

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StreamViewCloudflare.vue?vue&type=script&lang=js




/* harmony default export */ var StreamViewCloudflarevue_type_script_lang_js = ({
  name: 'StreamViewCloudflare',
  namespaced: true,
  mixins: [StreamViewType],
  props: {
    playerDomain: {
      type: String,
      required: false,
      default: () => 'player.bannerse.com',
    },
    isPreview: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonColor: {
      type: String,
      required: false,
      default() {
        return '#3D1094';
      },
    },
    viewMode: {
      type: String,
      required: false,
      default() {
        return 'embedded';
      },
    },
    optimizeForAd: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      playerHeight: '100%',
      autoHeight: true,
      ready: false,
      iframeEmitQueue: [],
      iframeLoaded: false,
      playerId: Math.floor(Math.random() * 99999999),
      visibilityObserver: null,
      visibilityObserverVisible: false,

      duration: null,
      videoPlayStarted: false,
      videoPlayed100: false,
    }
  },
  computed: {
    iframeClasses() {
      return {
        's1488': true,
        's4c49': !this.ready,
      }
    },
    videoId() {
      const videoId = this.testCloudflareVideo
      if (!videoId) {
        return null
      }

      return videoId[1];
    },
    videoPlayerSrc() {
      if (!this.videoId) {
        return null
      }

      let playmode = 'playback';
      if ((this.streamType === 'live' || this.streamType === 'playback') && !this.isVod) {
        playmode = 'live';
      }

      const params = new URLSearchParams({
        'player-id': this.playerId,
        'preload': 'true',
        'controls': 'true',
        'ad-mode': this.optimizeForAd ? 'true' : 'false',
        'has-ad-url': this.hasAdUrl ? 'true' : 'false',
        'color': this.buttonColor.replace('#', ''),
        'playmode': playmode,
        'viewmode': this.viewMode === 'overlay' ? 'overlay' : 'embed',
      })
      if (!this.isVod || this.autoplay) {
        if (this.viewMode != 'embedded') {
          params.append('autoplay', 'true')
        }
        params.append('muted', 'true')
      }
      if (this.isPreview || this.loop) {
        params.append('loop', 'true')
      }
      if (this.isVod && this.hasNextVodChapter) {
        params.append('autoplay', 'true')
      }
      if (this.muted) {
        params.append('muted', 'true')
      }
      if (this.poster) {
        params.append('poster', this.poster);
      }

      return 'https://' + this.playerDomain + '/frame?' + this.videoId + '&' + params.toString();
    },
    testCloudflareVideo() {
      return (this.videoSource || '').match(/(?:videodelivery\.net|cloudflarestream\.com)\/([0-9a-f]{32})/)
    },
    wrapperStyle() {
      return { height: this.autoHeight ? this.playerHeight : '100%' };
    },
  },
  mounted() {
    window.addEventListener('message', this.iframeMessageListener, false);
    this.attachVisibilityObserver();
  },
  beforeDestroy() {
    window.removeEventListener('message', this.iframeMessageListener, false);
    this.detachVisibilityObserver()
  },
  methods: {
    attachVisibilityObserver() {
      if (this.viewMode != 'embedded') {
        return
      }

      const options = { threshold: 0.25 };
      this.visibilityObserver = new IntersectionObserver((entries) => this.visibilityChanged(entries[0]), options);
      this.visibilityObserver.observe(this.$el);
    },
    detachVisibilityObserver() {
      if (this.viewMode != 'embedded') {
        return;
      }

      if (this.visibilityObserver != null) {
        this.visibilityObserver.unobserve(this.$el);
        this.visibilityObserver.disconnect();
        this.visibilityObserver = null;
      }
    },
    visibilityChanged(entry) {
      if (entry && this.autoplay) {
        if (entry.isIntersecting && !this.visibilityObserverVisible) {
          this.visibilityObserverVisible = true;
          this.emitToIframe({ action: 'play' });
        } else {
          this.emitToIframe({ action: 'pause' });
          this.visibilityObserverVisible = false;
        }
      }
    },
    iframeMessageListener(e) {
      if (
        !e.data
        || !e.data.from
        || e.data.from !== 'smuc-player-frame'
        || !e.data.id
        || e.data.id != this.videoId
        || e.data.playerId != this.playerId
      ) {
        return;
      }

      switch (e.data.$emit) {
        case 'playerHeight':
          this.playerHeight = e.data.data.value + 'px';
          break;

        case 'playerReady':
          this.$emit('playerReady', new FakePlayer(this));
          break;

        /* case 'loadstart':
          this.$emit('videoLoaded');
          break; */

        case 'loadeddata':
        case 'loadedmetadata':
          if (!this.ready) {
            this.$emit('videoLoaded');
            this.ready = true;
          }
          this.emitVideoDimensions(e.data.data.width, e.data.data.height)
          this.duration = e.data.data.duration;
          break;

        case 'play':
          this.$emit('onPlay');
          break;

        case 'pause':
          this.$emit('onPause');
          break;

        case 'ended':
          this.$emit('streamEnded');
          break;

        case 'currentTime':
          if (this.duration > 0) {
            if (!this.videoPlayStarted) {
              if (e.data.data >= 1) {
                this.videoPlayStarted = true;
                this.$root.$bus.$emit('aq', ['event', 'play_start']);
              }
            }
            else if (!this.videoPlayed100) {
              if (Math.floor(this.duration) - 1 <= e.data.data) {
                this.videoPlayed100 = true;
                this.$root.$bus.$emit('aq', ['event', '100p_view']);
              }
            }
          }

          this.$root.$bus.$emit(Events.PLAYBACK_POSITION, e.data.data);
          break;

        case 'controlVisibilityChange':
          this.$root.$bus.$emit(Events.PLAYER_CONTROL_VISIVILITY_CHANGE, e.data.data);
          break;

        case 'minimize':
          this.emitToIframe({ action: 'toggleMinimize' });
          this.$emit('minimize');
          break;

        case 'volumeChange':
          this.$emit('volumeChange', e.data.data.value);
          break;

        case 'playerVideoClicked':
          this.$emit('playerVideoClicked');
          break;
      }
    },
    onVideoPlayerLoaded() {
      this.$nextTick(() => {
        this.iframeLoaded = true;

        this.iframeEmitQueue.forEach(item => {
          const data = JSON.parse(item);
          this.emitToIframe(data);
        });

        this.iframeEmitQueue = [];
      });

      this.$emit('load');
    },
    onMouseOver(isOver) {
      this.emitToIframe({ action: 'mouseOverPlayer', value: isOver });
    },
    freezeControls(status) {
      this.emitToIframe({ action: 'freezeControls', value: status });
    },
    setAutosize(isOn) {
      this.autoHeight = !!isOn;
      this.emitToIframe({ action: 'setAutosize', value: this.autoHeight });
    },
    loadPoster(url) {
      this.emitToIframe({ action: 'loadPoster', value: url });
    },
    setCoverContentMode(contentMode) {
      this.emitToIframe({ action: 'setCoverContentMode', value: contentMode });
    },
    setFullPortraitSidebarIsVisible(visible) {
      this.emitToIframe({ action: 'setFullPortraitSidebarIsVisible', value: visible });
    },
    setOptimizeForAd(val) {
      this.emitToIframe({ action: 'setOptimizeForAd', value: val });
    },
    emitToIframe(data) {
      if (
        !this.$refs.videoPlayer
        || !this.$refs.videoPlayer.contentWindow
        || !this.iframeLoaded
      ) {
        const jsonData = JSON.stringify(data);
        if (!this.iframeEmitQueue.includes(jsonData)) {
          this.iframeEmitQueue.push(jsonData);
        }

        return false;
      }

      this.$refs.videoPlayer.contentWindow.postMessage(Object.assign({ from: 'smuc-player', id: this.videoId }, data), '*');
      return true;
    },
  }
});

class FakePlayer {
  constructor(vueComponent) {
    this.vueComponent = vueComponent;
  }

  set muted(value) {
    this.vueComponent.emitToIframe({ action: 'muted', value });
  }

  play() {
    this.vueComponent.emitToIframe({ action: 'play' });
  }

  pause() {
    this.vueComponent.emitToIframe({ action: 'pause' });
  }

  destroy() { }
}

;// CONCATENATED MODULE: ./src/components/StreamViewCloudflare.vue?vue&type=script&lang=js
 /* harmony default export */ var components_StreamViewCloudflarevue_type_script_lang_js = (StreamViewCloudflarevue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/StreamViewCloudflare.vue





/* normalize component */
;
var StreamViewCloudflare_component = normalizeComponent(
  components_StreamViewCloudflarevue_type_script_lang_js,
  StreamViewCloudflarevue_type_template_id_e7e111a4_render,
  StreamViewCloudflarevue_type_template_id_e7e111a4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StreamViewCloudflare = (StreamViewCloudflare_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StreamViewEmbedSocial.vue?vue&type=template&id=37fc394e
var StreamViewEmbedSocialvue_type_template_id_37fc394e_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isYoutubeIframe)?_c('div',{staticClass:"s1939"},[_c('div',{attrs:{"id":"youtube-player"}})]):(_vm.isFacebookIframe)?_c('div',{staticClass:"s1939"},[_c('div',{staticClass:"fb-video",attrs:{"data-href":_vm.iframeSrcEmbedSocialVideo,"data-allowfullscreen":"true"}})]):_c('iframe',{ref:"iframePlayer",staticClass:"s1488 s1939",attrs:{"src":_vm.iframeSrcEmbedSocialVideo,"frameborder":"0","allow":"autoplay; encrypted-media;","allowfullscreen":""},on:{"load":() => _vm.$emit('load')}})
}
var StreamViewEmbedSocialvue_type_template_id_37fc394e_staticRenderFns = []


;// CONCATENATED MODULE: ./src/mixins/StreamViewPlaybackPosition.js


const UPDATE_INTERVAL = 100;

/* harmony default export */ var StreamViewPlaybackPosition = ({
  beforeDestroy() {
    this.destroyPlaybackPositionUpdater();
  },
  data: () => ({
    playbackPositionTimer: null,
    playbackPosition: 0,
  }),
  watch: {
    playbackPosition(val, oldVal) {
      if (val == oldVal) {
        return;
      }

      this.$root.$bus.$emit(Events.PLAYBACK_POSITION, val);
    },
  },
  methods: {
    initPlaybackPositionUpdater(callback) {
      this.playbackPositionTimer = setInterval(async () => {
        this.playbackPosition = await callback();
      }, UPDATE_INTERVAL);
    },
    destroyPlaybackPositionUpdater() {
      if (this.playbackPositionTimer !== null) {
        clearInterval(this.playbackPositionTimer);
        this.playbackPositionTimer = null;
      }
    }
  },
});

;// CONCATENATED MODULE: ./src/js/waitFor.js
/* harmony default export */ var waitFor = ((windowVariableName) => {
  return (new Promise(resolve => {
    const timer = setInterval(() => {
      if (typeof window[windowVariableName] !== 'undefined') {
        clearInterval(timer);
        resolve();
      }
    }, 100)
  }))
});

;// CONCATENATED MODULE: ./src/js/loadJs.js


/* harmony default export */ var loadJs = (async (url, windowVariableName) => {
  const scriptTag = document.createElement('script');
  scriptTag.src = url;
  document.body.appendChild(scriptTag);

  if (windowVariableName) {
    await waitFor(windowVariableName);
  }
});

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StreamViewEmbedSocial.vue?vue&type=script&lang=js





/* harmony default export */ var StreamViewEmbedSocialvue_type_script_lang_js = ({
  name: 'StreamViewSimpleVod',
  namespaced: true,
  mixins: [StreamViewPlaybackPosition, StreamViewType],
  computed: {
    facebookVideoId() {
      if (!this.videoSource) {
        return null;
      }

      const test = this.videoSource.match(/^(?:https?:\/\/)?(?:www\.)?facebook\..*(?:\/videos.*\/|v=)(\d+).*$/)
      return test !== null && test[1] ? test[1] : null
    },
    youtubeVideoId() {
      if (!this.videoSource) {
        return null;
      }

      const test = this.videoSource.match(/(?:(?:https?:\/\/)(?:www)?\.?(?:youtu\.?be)(?:\.com)?\/(?:.*[=/])*)([^= &?/\r\n]{8,11})/)
      return test !== null && test[1] ? test[1] : null
    },
    vimeoVideoId() {
      if (!this.videoSource) {
        return null;
      }

      const test = this.videoSource.match(/vimeo\.com\/(\d+)/)
      return test !== null && test[1] ? test[1] : null
    },
    isYoutubeIframe() {
      return this.streamType === 'embed' && this.youtubeVideoId !== null
    },
    isVimeoIframe() {
      return this.streamType === 'embed' && this.vimeoVideoId !== null
    },
    isFacebookIframe() {
      return this.streamType === 'embed' && this.facebookVideoId !== null
    },
    iframeSrcEmbedSocialVideo() {
      if (this.vimeoVideoId !== null) {
        return `https://player.vimeo.com/video/${this.vimeoVideoId}`
      }
      else if (this.facebookVideoId !== null) {
        // Shit Zuckerberg.. here we have to use the full video url instead of videoid..
        return `https://www.facebook.com/watch/?v=${this.facebookVideoId}`
      }

      return null
    },
  },
  mounted() {
    this.initPlayer()
  },
  methods: {
    initPlayer() {
      if (this.isYoutubeIframe) {
        this.$nextTick(() => this.initYoutubePlayer());
      }
      else if (this.isVimeoIframe) {
        this.$nextTick(() => this.initVimeoPlayer());
      }
      else if (this.isFacebookIframe) {
        this.$nextTick(() => this.initFacebookPlayer());
      }
    },
    async initYoutubePlayer() {
      /* global YT */
      await loadJs('https://www.youtube.com/iframe_api', 'YT');

      let iv = setInterval(() => {
        if (typeof YT !== 'undefined') {
          clearInterval(iv)
          iv = null
          this.initYoutubeIframePlayer()
        }
      }, 200)
    },
    initYoutubeIframePlayer() {
      const player = new YT.Player('youtube-player', {
        videoId: this.youtubeVideoId,
        events: {
          onReady: (event) => {
            let _width = 640
            let _height = 360
            if (
              event.target.j
              && event.target.j.i
              && event.target.j.i.width
              && event.target.j.i.height
            ) {
              _width = event.target.j.i.width
              _height = event.target.j.i.height
            }

            this.emitVideoDimensions(_width, _height)

            this.$emit('videoLoaded')
          },
          onStateChange: (e) => {
            switch (e.data) {
              case YT.PlayerState.PLAYING:
                this.$emit('onPlay')
                break;

              case YT.PlayerState.PAUSED:
              case YT.PlayerState.ENDED:
                this.$emit('onPause')
                break;
            }
          },
        }
      });

      this.initPlaybackPositionUpdater(() => player.getCurrentTime ? player.getCurrentTime() : 0);
    },
    async initVimeoPlayer() {
      /* global Vimeo */
      await loadJs('https://player.vimeo.com/api/player.js', 'Vimeo');

      let iv = setInterval(() => {
        if (typeof Vimeo !== 'undefined') {
          clearInterval(iv)
          iv = null
          this.initVimeoIframePlayer()
        }
      }, 200)
    },
    initVimeoIframePlayer() {
      const player = new Vimeo.Player(this.$refs.iframePlayer);
      player.on('loaded', () => this.$emit('videoLoaded'));
      player.on('play', () => this.$emit('onPlay'));
      player.on('pause', () => this.$emit('onPause'));

      Promise.all([player.getVideoWidth(), player.getVideoHeight()])
        .then((dimensions) => {
          this.emitVideoDimensions(dimensions[0], dimensions[1])
        });

      this.initPlaybackPositionUpdater(() => player.getCurrentTime ? player.getCurrentTime() : 0);
    },
    async initFacebookPlayer() {
      /* global FB */
      await loadJs('https://connect.facebook.net/en_US/sdk.js', 'FB');

      let iv = setInterval(() => {
        if (typeof FB !== 'undefined') {
          clearInterval(iv)
          iv = null
          this.initFacebookIframePlayer()
        }
      }, 200)
    },
    initFacebookIframePlayer() {
      FB.init({
        xfbml: true,
        version: 'v13.0'
      });

      FB.Event.subscribe('xfbml.ready', (msg) => {
        if (msg.type === 'video') {
          this.$emit('videoLoaded');

          const player = msg.instance;

          this.$nextTick(() => {
            const fbVideoElement = this.$el.querySelector('.fb_iframe_widget_fluid_desktop iframe')
            if (fbVideoElement) {
              if (fbVideoElement.style && fbVideoElement.style.height) {
                let w = fbVideoElement.style.width.replace('px', '')
                if (/^\d+$/.test(w)) {
                  w = parseInt(w, 10)
                }

                let h = fbVideoElement.style.height.replace('px', '')
                if (/^\d+$/.test(h)) {
                  h = parseInt(h, 10)
                }

                this.videoWidth = w
                this.videoHeight = h
              } else {
                this.videoWidth = fbVideoElement.offsetWidth
                this.videoHeight = fbVideoElement.offsetHeight
              }
              this.emitVideoDimensions(this.videoWidth, this.videoHeight)
            }
          })

          player.subscribe('startedPlaying', () => this.$emit('onPlay'));
          player.subscribe('paused', () => this.$emit('onPause'));
          player.subscribe('finishedPlaying', () => this.$emit('onPause'));

          this.initPlaybackPositionUpdater(() => player.getCurrentPosition ? player.getCurrentPosition() : 0);
        }
      });
    },
  }
});

;// CONCATENATED MODULE: ./src/components/StreamViewEmbedSocial.vue?vue&type=script&lang=js
 /* harmony default export */ var components_StreamViewEmbedSocialvue_type_script_lang_js = (StreamViewEmbedSocialvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/StreamViewEmbedSocial.vue





/* normalize component */
;
var StreamViewEmbedSocial_component = normalizeComponent(
  components_StreamViewEmbedSocialvue_type_script_lang_js,
  StreamViewEmbedSocialvue_type_template_id_37fc394e_render,
  StreamViewEmbedSocialvue_type_template_id_37fc394e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StreamViewEmbedSocial = (StreamViewEmbedSocial_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Sidebar.vue?vue&type=template&id=68db5785
var Sidebarvue_type_template_id_68db5785_render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{class:{'sdcc6': true, 'sa507': _vm.stream.sidebar_transparency}},[(_vm.isFullPortrait && _vm.streamviewEl !== null && _vm.videocontainerEl !== null)?_c('dragbar',{attrs:{"draggable-container":_vm.videocontainerEl,"streamview-el":_vm.streamviewEl,"tap-to-close":true,"minimum-height":_vm.dragbarMinHeight},on:{"closed":_vm.dragbarClosed}}):_vm._e(),((_vm.isCompactAdvertisement && _vm.streamviewEl !== null && _vm.videocontainerEl !== null))?_c('dragbar',{attrs:{"draggable-container":_vm.$el,"streamview-el":_vm.streamviewEl,"tap-to-close":true,"rule-to-update":"top"},on:{"closed":_vm.dragbarClosed}}):_vm._e(),(_vm.stream.ad_use_featured_image && _vm.streamviewEl !== null && _vm.videocontainerEl !== null)?_c('dragbar',{attrs:{"draggable-container":_vm.$el,"streamview-el":_vm.streamviewEl,"tap-to-close":true,"rule-to-update":"top","top-offset":_vm.dragbarMinHeightFeaturedImage},on:{"closed":_vm.dragbarClosed}}):_vm._e(),(_vm.stream.ad_size === '640x360')?_c('div',{staticClass:"sd9bd",on:{"click":_vm.dragbarClosed}},[_c('i',{staticClass:"sbaec s1a72 toggle-close"})]):_vm._e(),_c('stream-info-bar',{staticClass:"overlay--bar--bottom--infos",attrs:{"name":_vm.stream.title,"name-color":_vm.stream.title_color,"hide-title":_vm.stream.title_hidden,"is-sponsored-content":_vm.stream.is_sponsored_content,"language":_vm.language,"agency-logo":_vm.stream.agency_logo}}),_c('nav',{ref:"tabs",class:_vm.sidebarTabsClasses},[_c('div',{class:_vm.sidebarTabsTabsClasses},[_c('div',{ref:"sidebarTabSelection",staticClass:"sef57"}),(_vm.showProductsTab)?_c('div',{ref:"products-tab",class:{'s9c7e': true, 'sc76a': _vm.activeTab === 'products'},attrs:{"data-smuc-tabid":"products"},on:{"click":function($event){return _vm.switchTo($event, 'products')}}},[(_vm.hasCustomProductsTabLabel)?[_vm._v(" "+_vm._s(_vm.stream.tab_products_label_plural)+" ")]:[_c('i',{staticClass:"sbaec sdd35 s1ffd"}),_vm._v(" "+_vm._s(_vm.tr('Products'))+" ")]],2):_vm._e(),(_vm.showChatTab)?_c('div',{ref:"chat-tab",class:{'s9c7e': true, 'sc76a': _vm.activeTab === 'chat'},attrs:{"data-smuc-tabid":"chat"},on:{"click":function($event){return _vm.switchTo($event, 'chat')}}},[_c('div',{staticClass:"s992c"},[_c('i',{staticClass:"sbaec s19d8 s1ffd"}),(_vm.newMessageCounter)?_c('div',{ref:"newMessagesCounter",staticClass:"sd56d s0f14"},[_vm._v(_vm._s(_vm.newMessageCounter))]):_vm._e()]),_vm._v(" "+_vm._s(_vm.tr('Comments'))+" ")]):_vm._e(),(_vm.showSubscriptionTab)?_c('div',{ref:"subscription-tab",class:{'s9c7e': true, 'sc76a': _vm.activeTab === 'subscription'},attrs:{"data-smuc-tabid":"subscription"},on:{"click":function($event){return _vm.switchTo($event, 'subscription')}}},[_vm._v(" "+_vm._s(_vm.stream.tab_subscription_form_label ?? _vm.tr('Subscription'))+" ")]):_vm._e()])]),_c('div',{staticClass:"s3056"},[(_vm.showProductsTab)?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 'products'),expression:"activeTab === 'products'"}],staticClass:"s35bb"},[_c('products-feed',{ref:"tabComponentProducts",attrs:{"name":_vm.stream.title,"items":_vm.stream.products,"currency":_vm.stream.currency,"payment":_vm.stream.payment,"closable":!_vm.isVod,"language":_vm.language,"button-color":_vm.stream.button_color,"text-color":_vm.stream.text_color,"counter-label-singular":_vm.stream.tab_products_label_singular,"counter-label-plural":_vm.stream.tab_products_label_plural,"fake-scrollbar":true}})],1)]:_vm._e(),(_vm.showChatTab && !_vm.hasError)?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 'chat'),expression:"activeTab === 'chat'"}],staticClass:"s35bb"},[(_vm.isChatWindowVisible)?_c('chat',{ref:"tabComponentChat",attrs:{"ws-client":_vm.wsClient,"is-joined":_vm.isJoined,"messages":_vm.chatMessages,"button-color":_vm.stream.button_color,"text-color":_vm.stream.text_color,"language":_vm.language,"reversed-moderation":_vm.stream.reversed_chat_moderation,"initial-name":_vm.chatInitialName,"show-floating-pinned-message":"","show-loader":!_vm.isPreview},on:{"changeFloatingInfoVisibility":(visible) => _vm.hasFloatingInfoInChat = visible,"updateChatName":(n) => _vm.chatInitialName = n,"joined":(j) => _vm.isJoined = j}}):_vm._e()],1)]:_vm._e(),(_vm.showSubscriptionTab && _vm.stream.subscriber_form !== null)?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 'subscription'),expression:"activeTab === 'subscription'"}],staticClass:"s35bb"},[(!_vm.showProductsTab && !_vm.showChatTab)?_c('subscription-form',{attrs:{"form":_vm.stream.subscriber_form,"label":_vm.stream.tab_subscription_form_label,"button-color":_vm.stream.button_color,"preview-mode":_vm.isPreview,"customer":_vm.stream.customer,"campaign":_vm.stream.campaign,"language":_vm.language,"transparent":"","relative":""}}):_c('div',{staticClass:"s9859"},[(_vm.isSubscriptionReopenVisible)?_c('button',{staticClass:"s016b",on:{"click":function($event){return _vm.reopenSubscriptionPanel()}}},[_vm._v(" Open panel ")]):_vm._e()])],1)]:_vm._e()],2)],1)
}
var Sidebarvue_type_template_id_68db5785_staticRenderFns = []


;// CONCATENATED MODULE: ./src/js/consts.js
const dummyChatMessages = () => {
  const platformsSmuc = [{"type": "smuc", "userId": "3fe7661c-1d34-4bcc-b71a-32c0a8d77ee3","name": "SMUC moderator"}]
  const platformsYt = [{"type": "youtube", "userId": "3fe7661c-1d34-4bcc-b71a-32c0a8d77ee3","name": "YouTube star"}]
  const platformsFb = [{"type": "facebook_page", "userId": "3fe7661c-1d34-4bcc-b71a-32c0a8d77ee3","name": "Facebooker"}]

  return [
    { name: 'Burke', message: 'Lorem ipsum', platforms: platformsSmuc },
    { name: 'Lord Kevin', message: 'dolor sit amet', platforms: platformsSmuc },
    { name: 'Burge', message: 'consectetur adipiscing elit', platforms: platformsSmuc },
    { name: 'Kaira', message: 'Sed turpis nulla, laoreet a cursus in', platforms: platformsFb },
    { name: 'Burke', message: 'hendrerit eget urna', platforms: platformsSmuc },
    { name: 'Williams', message: 'Aliquam ante libero, sagittis ut suscipit in', platforms: platformsFb },
    { name: 'Grayson', message: 'tincidunt et nunc', platforms: platformsYt },
    { name: 'Lord Kevin', message: 'Curabitur id nibh ornare eros efficitur convallis sit amet quis urna', platforms: platformsYt },
    { name: 'Burke', message: 'Duis sit amet aliquet risus', platforms: platformsSmuc },
    { name: 'Alice', message: 'et luctus enim', platforms: platformsFb },
    { name: 'Alice', message: 'Sed id nulla in sem vestibulum', platforms: platformsYt },
    { name: 'Rodger', message: 'convallis a vitae tortor', platforms: platformsSmuc },
  ]
};

;// CONCATENATED MODULE: ./src/js/debounce.js
function _debounce(func, timeout = 300) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => { func.apply(this, args); }, timeout)

    return {
      cancel() {
        clearTimeout(timer)
      }
    }
  };
}

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Chat.vue?vue&type=template&id=5c81a25e
var Chatvue_type_template_id_5c81a25e_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chatcomp",staticClass:"s62d1"},[_c('div',{staticClass:"s448b"},[_c('chat-view',{ref:"chat",class:{'focused': _vm.isFocused},attrs:{"ws-client":_vm.wsClient,"messages":_vm.messages,"no-messages-text":_vm.tr('No comments yet.'),"name":_vm.name,"language":_vm.language,"reversed-moderation":_vm.reversedModeration,"text-color":_vm.textColor,"button-color":_vm.buttonColor,"show-floating-pinned-message":_vm.showFloatingPinnedMessage,"show-loader":_vm.showLoader},on:{"joined":() => _vm.$emit('joined', true),"banned":() => _vm.isBanned = true,"unbanned":() => _vm.isBanned = false,"chatviewScrollY":_vm.onScroll,"changeFloatingInfoVisibility":(visible) => _vm.$emit('changeFloatingInfoVisibility', visible)},nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}}}),(!_vm.isLoading)?[(!_vm.nameEntered)?_c('div',{staticClass:"s71f2 s5f1e"},[_c('button',{staticClass:"s7274",style:('background-color:' + _vm.buttonColor + '; color: ' + _vm.textColor),on:{"click":_vm.openNameModal}},[_vm._v(" "+_vm._s(_vm.tr('Write a comment'))+" ")])]):_c('div',{staticClass:"s71f2 s1bc2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],ref:"messageInput",attrs:{"placeholder":_vm.isBanned ? _vm.tr('You are banned from chat.') : _vm.tr('Write your comment here...'),"disabled":_vm.isBanned},domProps:{"value":(_vm.message)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.sendMessage.apply(null, arguments)},"click":_vm.onInputClick,"input":function($event){if($event.target.composing)return;_vm.message=$event.target.value}}}),_c('button',{class:{'s7274': true, 'disabled': !_vm.message.length},attrs:{"disabled":!_vm.message.length},on:{"click":_vm.sendMessage}},[_c('i',{staticClass:"sbaec s55f5 sbb7a"})])])]:_vm._e()],2),(_vm.nameInputOpened)?_c('div',{ref:"chatNameInputOverlay",staticClass:"s8593"},[_c('div',{staticClass:"sea97"},[_c('header',[(_vm.parentEl && _vm.refChatNameInputOverlay)?_c('dragbar',{attrs:{"streamview-el":_vm.parentEl,"draggableContainer":_vm.refChatNameInputOverlay,"tap-to-close":true,"rule-to-update":"top"},on:{"closed":_vm.eventOnNameInputOverlayClose}}):_vm._e(),_c('span',{staticClass:"scc28",on:{"click":_vm.onNameInputOverlayClick}},[_c('i',{staticClass:"sbaec s469b s1ffd"}),_vm._v(" "+_vm._s(_vm.tr('Back'))+" ")])],1),_c('div',{staticClass:"sd5d3"},[_c('b',[_vm._v(_vm._s(_vm.tr('Add your name here to join the chat')))]),_c('br'),_vm._v(" "+_vm._s(_vm.tr('Please, enter your name to join chat and start sending comments!'))+" ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],ref:"nameInput",attrs:{"placeholder":_vm.tr('Your name…')},domProps:{"value":(_vm.name)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.enterName.apply(null, arguments)},"input":function($event){if($event.target.composing)return;_vm.name=$event.target.value}}}),_c('button',{staticClass:"s7274",style:('background-color:' + _vm.buttonColor + '; color: ' + _vm.textColor),on:{"click":_vm.enterName}},[_vm._v(_vm._s(_vm.tr('Save your name and write a comment')))])])]):_vm._e()])
}
var Chatvue_type_template_id_5c81a25e_staticRenderFns = []


// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(100);
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);
// EXTERNAL MODULE: ./node_modules/smucio-chatview/dist/smucio-chatview.common.js
var smucio_chatview_common = __webpack_require__(965);
var smucio_chatview_common_default = /*#__PURE__*/__webpack_require__.n(smucio_chatview_common);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Chat.vue?vue&type=script&lang=js






external_commonjs_vue_commonjs2_vue_root_Vue_default().use((smucio_chatview_common_default()))

;

const Chatvue_type_script_lang_js_debounce = function _debounce(func, timeout = 300) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => { func.apply(this, args); }, timeout)

    return {
      cancel() {
        clearTimeout(timer)
      }
    }
  };
}

/* harmony default export */ var Chatvue_type_script_lang_js = ({
  name: 'Chat',
  mixins: [ Translator ],
  components: { Dragbar: Dragbar },
  props: {
    wsClient: {
      required: false,
      validator: (value) => {
        if (value === null) {
          return true;
        }

        if (
          typeof value === 'object'
          && value.constructor
          && value.constructor.name
          && value.constructor.name === 'WsClient'
        ) {
          return true
        }

        return false
      },
      default() {
        return null;
      },
    },
    reversedModeration: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    buttonColor: {
      type: String,
      required: false,
      default() {
        return '#000000';
      },
    },
    textColor: {
      type: String,
      required: false,
      default() {
        return '#ffffff';
      },
    },
    messages: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    showFloatingPinnedMessage: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    showLoader: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    isJoined: {
      type: Boolean,
      required: false,
      default: false,
    },
    initialName: {
      type: String,
      required: false,
      default: null,
      validator: v => v === null || typeof v === 'string' && v.length > 0
    },
  },
  data: () => ({
    isBanned: false,
    nameEntered: false,
    name: '',
    message: '',
    isFocused: false,
    isFocusedTimer: null,
    nameInputOpened: false,
    chatScrollviewHeight: 0,
    parentEl: null,
    refChatNameInputOverlay: null,
  }),
  computed: {
    isLoading() {
      return !this.isJoined;
    },
  },
  watch: {
    isLoading(val) {
      if (!val) {
        this.$nextTick(() => this.$refs['chat'].$el.scrollTo({ top: 1000 }));
      }
    },
  },
  mounted() {
    if (this.wsClient === null) {
      this.$emit('joined', true)
    }

    if (typeof this.initialName == 'string' && this.initialName.length > 0) {
      this.name = this.initialName
      this.nameEntered = true
      setTimeout(() => this.$refs['messageInput'].focus(), 100);
    }

    // @TODO - Update to use this.$el.closest...
    this.parentEl = document.querySelector('.smc-sidebar')
  },
  methods: {
    openNameModal() {
      this.nameInputOpened = true
      // this.$modal.show('chat-name');
      setTimeout(() => this.$refs['nameInput'].focus(), 100);

      let iv = setInterval(() => {
        if (this.$refs.chatNameInputOverlay) {
          this.refChatNameInputOverlay = this.$refs.chatNameInputOverlay
          clearInterval(iv)
          iv = null
        }
      }, 50)
    },
    enterName() {
      // this.$modal.hide('chat-name');
      this.name = this.name.trim();
      if (!this.name) {
        return;
      }

      this.nameEntered = true;
      setTimeout(() => this.$refs['messageInput'].focus(), 100);
      this.nameInputOpened = false

      this.$emit('updateChatName', this.name)
    },
    sendMessage() {
      this.message = this.message.trim();
      if (!this.message) {
        return;
      }

      this.$refs['chat'].sendMessage(this.message);
      this.message = '';

      this.revalidateFocusedTimer()
    },
    revalidateFocusedTimer() {
      if (this.isFocusedTimer) {
        this.isFocusedTimer.cancel()
        this.isFocusedTimer = null
      }
      this.isFocusedTimer = Chatvue_type_script_lang_js_debounce(this.resetFocused, 5000)()
    },
    onScroll(el) {
      // Note: This check will help prevent to be the chat fully visible
      // when others post messages.
      if (el.scrollTop > this.chatScrollviewHeight) {
        this.chatScrollviewHeight = el.scrollTop
        return
      }

      this.isFocused = true
      this.revalidateFocusedTimer()
    },
    onClick() {
      this.isFocused = true
      this.revalidateFocusedTimer()
    },
    onInputClick() {
      this.isFocused = true
    },
    resetFocused() {
      this.isFocused = false
    },
    onNameInputOverlayClick() {
      // const inner = this.$refs.chatNameOverlayInner;
      // if (!e.path.includes(inner)) {
        this.nameInputOpened = false
      // }
    },
    eventOnNameInputOverlayClose() {
      this.onNameInputOverlayClick()
    }
  },
});

;// CONCATENATED MODULE: ./src/components/Chat.vue?vue&type=script&lang=js
 /* harmony default export */ var components_Chatvue_type_script_lang_js = (Chatvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/Chat.vue





/* normalize component */
;
var Chat_component = normalizeComponent(
  components_Chatvue_type_script_lang_js,
  Chatvue_type_template_id_5c81a25e_render,
  Chatvue_type_template_id_5c81a25e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Chat = (Chat_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProductsFeed.vue?vue&type=template&id=8cefe366
var ProductsFeedvue_type_template_id_8cefe366_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'s1a3a': true, 'closed': !_vm.isOpened}},[_c('div',{staticClass:"sea97"},[_c('div',{staticClass:"se294"},[(_vm.customCounterLabel)?[_vm._v(" "+_vm._s(_vm.customCounterLabel)+" ")]:(_vm.items.length < 2)?[_vm._v(" "+_vm._s(_vm.tr('@count item', {'@count': _vm.items.length}))+" ")]:[_vm._v(" "+_vm._s(_vm.tr('@count items', {'@count': _vm.items.length}))+" ")]],2),_c('div',{ref:"productsFrame",staticClass:"s691d"},[(_vm.hasFirstItemTimer)?_c('div',{staticClass:"s4bf3",style:(_vm.firstItemTimerStyle)}):_vm._e(),_vm._l((_vm.delayedItems),function(product){return _c('product-feed',{key:'product-' + product.id,ref:"product",refInFor:true,attrs:{"product":product,"currency":_vm.currency,"language":_vm.language,"button-color":_vm.buttonColor,"text-color":_vm.textColor}})})],2),(_vm.fakeScrollbar)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fakeScrollbarCanVisible),expression:"fakeScrollbarCanVisible"}],staticClass:"s07d2"},[_c('div',{ref:"fakebarinner",staticClass:"sffa6"})]):_vm._e()])])
}
var ProductsFeedvue_type_template_id_8cefe366_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/gsap/gsap-core.js
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/

/* eslint-disable */
var _config = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
},
    _defaults = {
  duration: .5,
  overwrite: false,
  delay: 0
},
    _suppressOverwrites,
    _reverting,
    _context,
    _bigNum = 1e8,
    _tinyNum = 1 / _bigNum,
    _2PI = Math.PI * 2,
    _HALF_PI = _2PI / 4,
    _gsID = 0,
    _sqrt = Math.sqrt,
    _cos = Math.cos,
    _sin = Math.sin,
    _isString = function _isString(value) {
  return typeof value === "string";
},
    _isFunction = function _isFunction(value) {
  return typeof value === "function";
},
    _isNumber = function _isNumber(value) {
  return typeof value === "number";
},
    _isUndefined = function _isUndefined(value) {
  return typeof value === "undefined";
},
    _isObject = function _isObject(value) {
  return typeof value === "object";
},
    _isNotFalse = function _isNotFalse(value) {
  return value !== false;
},
    _windowExists = function _windowExists() {
  return typeof window !== "undefined";
},
    _isFuncOrString = function _isFuncOrString(value) {
  return _isFunction(value) || _isString(value);
},
    _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function () {},
    // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray,
    _strictNumExp = /(?:-?\.?\d|\.)+/gi,
    //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
    //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
    _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
    //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/,
    _delimitedValueExp = /[^,'"\[\]\s]+/gi,
    // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
    _globalTimeline,
    _win,
    _coreInitted,
    _doc,
    _globals = {},
    _installScope = {},
    _coreReady,
    _install = function _install(scope) {
  return (_installScope = _merge(scope, _globals)) && gsap;
},
    _missingPlugin = function _missingPlugin(property, value) {
  return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
},
    _warn = function _warn(message, suppress) {
  return !suppress && console.warn(message);
},
    _addGlobal = function _addGlobal(name, obj) {
  return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
},
    _emptyFunc = function _emptyFunc() {
  return 0;
},
    _startAtRevertConfig = {
  suppressEvents: true,
  isStart: true,
  kill: false
},
    _revertConfigNoKill = {
  suppressEvents: true,
  kill: false
},
    _revertConfig = {
  suppressEvents: true
},
    _reservedProps = {},
    _lazyTweens = [],
    _lazyLookup = {},
    _lastRenderedFrame,
    _plugins = {},
    _effects = {},
    _nextGCFrame = 30,
    _harnessPlugins = [],
    _callbackNames = "",
    _harness = function _harness(targets) {
  var target = targets[0],
      harnessPlugin,
      i;
  _isObject(target) || _isFunction(target) || (targets = [targets]);

  if (!(harnessPlugin = (target._gsap || {}).harness)) {
    // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
    i = _harnessPlugins.length;

    while (i-- && !_harnessPlugins[i].targetTest(target)) {}

    harnessPlugin = _harnessPlugins[i];
  }

  i = targets.length;

  while (i--) {
    targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
  }

  return targets;
},
    _getCache = function _getCache(target) {
  return target._gsap || _harness(toArray(target))[0]._gsap;
},
    _getProperty = function _getProperty(target, property, v) {
  return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
},
    _forEachName = function _forEachName(names, func) {
  return (names = names.split(",")).forEach(func) || names;
},
    //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
  return Math.round(value * 100000) / 100000 || 0;
},
    _roundPrecise = function _roundPrecise(value) {
  return Math.round(value * 10000000) / 10000000 || 0;
},
    // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
  var operator = value.charAt(0),
      end = parseFloat(value.substr(2));
  start = parseFloat(start);
  return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
},
    _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
  //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
  var l = toFind.length,
      i = 0;

  for (; toSearch.indexOf(toFind[i]) < 0 && ++i < l;) {}

  return i < l;
},
    _lazyRender = function _lazyRender() {
  var l = _lazyTweens.length,
      a = _lazyTweens.slice(0),
      i,
      tween;

  _lazyLookup = {};
  _lazyTweens.length = 0;

  for (i = 0; i < l; i++) {
    tween = a[i];
    tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
  }
},
    _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
  _lazyTweens.length && !_reverting && _lazyRender();
  animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
  _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
},
    _numericIfPossible = function _numericIfPossible(value) {
  var n = parseFloat(value);
  return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
},
    _passThrough = function _passThrough(p) {
  return p;
},
    _setDefaults = function _setDefaults(obj, defaults) {
  for (var p in defaults) {
    p in obj || (obj[p] = defaults[p]);
  }

  return obj;
},
    _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
  return function (obj, defaults) {
    for (var p in defaults) {
      p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    }
  };
},
    _merge = function _merge(base, toMerge) {
  for (var p in toMerge) {
    base[p] = toMerge[p];
  }

  return base;
},
    _mergeDeep = function _mergeDeep(base, toMerge) {
  for (var p in toMerge) {
    p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
  }

  return base;
},
    _copyExcluding = function _copyExcluding(obj, excluding) {
  var copy = {},
      p;

  for (p in obj) {
    p in excluding || (copy[p] = obj[p]);
  }

  return copy;
},
    _inheritDefaults = function _inheritDefaults(vars) {
  var parent = vars.parent || _globalTimeline,
      func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;

  if (_isNotFalse(vars.inherit)) {
    while (parent) {
      func(vars, parent.vars.defaults);
      parent = parent.parent || parent._dp;
    }
  }

  return vars;
},
    _arraysMatch = function _arraysMatch(a1, a2) {
  var i = a1.length,
      match = i === a2.length;

  while (match && i-- && a1[i] === a2[i]) {}

  return i < 0;
},
    _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }

  if (lastProp === void 0) {
    lastProp = "_last";
  }

  var prev = parent[lastProp],
      t;

  if (sortBy) {
    t = child[sortBy];

    while (prev && prev[sortBy] > t) {
      prev = prev._prev;
    }
  }

  if (prev) {
    child._next = prev._next;
    prev._next = child;
  } else {
    child._next = parent[firstProp];
    parent[firstProp] = child;
  }

  if (child._next) {
    child._next._prev = child;
  } else {
    parent[lastProp] = child;
  }

  child._prev = prev;
  child.parent = child._dp = parent;
  return child;
},
    _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }

  if (lastProp === void 0) {
    lastProp = "_last";
  }

  var prev = child._prev,
      next = child._next;

  if (prev) {
    prev._next = next;
  } else if (parent[firstProp] === child) {
    parent[firstProp] = next;
  }

  if (next) {
    next._prev = prev;
  } else if (parent[lastProp] === child) {
    parent[lastProp] = prev;
  }

  child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
},
    _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
  child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
  child._act = 0;
},
    _uncache = function _uncache(animation, child) {
  if (animation && (!child || child._end > animation._dur || child._start < 0)) {
    // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
    var a = animation;

    while (a) {
      a._dirty = 1;
      a = a.parent;
    }
  }

  return animation;
},
    _recacheAncestors = function _recacheAncestors(animation) {
  var parent = animation.parent;

  while (parent && parent.parent) {
    //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
    parent._dirty = 1;
    parent.totalDuration();
    parent = parent.parent;
  }

  return animation;
},
    _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
  return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
},
    _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
  return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
},
    _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
  return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
},
    // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
  var whole = Math.floor(tTime /= cycleDuration);
  return tTime && whole === tTime ? whole - 1 : whole;
},
    _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
  return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
},
    _setEnd = function _setEnd(animation) {
  return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
},
    _alignPlayhead = function _alignPlayhead(animation, totalTime) {
  // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
  var parent = animation._dp;

  if (parent && parent.smoothChildTiming && animation._ts) {
    animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));

    _setEnd(animation);

    parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
  }

  return animation;
},

/*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/
_postAddChecks = function _postAddChecks(timeline, child) {
  var t;

  if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
    // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
    t = _parentToChildTotalTime(timeline.rawTime(), child);

    if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) {
      child.render(t, true);
    }
  } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.


  if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
    //in case any of the ancestors had completed but should now be enabled...
    if (timeline._dur < timeline.duration()) {
      t = timeline;

      while (t._dp) {
        t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.

        t = t._dp;
      }
    }

    timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
  }
},
    _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
  child.parent && _removeFromParent(child);
  child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
  child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));

  _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);

  _isFromOrFromStart(child) || (timeline._recent = child);
  skipChecks || _postAddChecks(timeline, child);
  timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)

  return timeline;
},
    _scrollTrigger = function _scrollTrigger(animation, trigger) {
  return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
},
    _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
  _initTween(tween, time, tTime);

  if (!tween._initted) {
    return 1;
  }

  if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
    _lazyTweens.push(tween);

    tween._lazy = [tTime, suppressEvents];
    return 1;
  }
},
    _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
  var parent = _ref.parent;
  return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
},
    // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
  var data = _ref2.data;
  return data === "isFromStart" || data === "isStart";
},
    _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
  var prevRatio = tween.ratio,
      ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1,
      // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
  repeatDelay = tween._rDelay,
      tTime = 0,
      pt,
      iteration,
      prevIteration;

  if (repeatDelay && tween._repeat) {
    // in case there's a zero-duration tween that has a repeat with a repeatDelay
    tTime = _clamp(0, tween._tDur, totalTime);
    iteration = _animationCycle(tTime, repeatDelay);
    tween._yoyo && iteration & 1 && (ratio = 1 - ratio);

    if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
      // if iteration changed
      prevRatio = 1 - ratio;
      tween.vars.repeatRefresh && tween._initted && tween.invalidate();
    }
  }

  if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
    if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) {
      // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
      return;
    }

    prevIteration = tween._zTime;
    tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.

    suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.

    tween.ratio = ratio;
    tween._from && (ratio = 1 - ratio);
    tween._time = 0;
    tween._tTime = tTime;
    pt = tween._pt;

    while (pt) {
      pt.r(ratio, pt.d);
      pt = pt._next;
    }

    totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
    tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
    tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");

    if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
      ratio && _removeFromParent(tween, 1);

      if (!suppressEvents && !_reverting) {
        _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);

        tween._prom && tween._prom();
      }
    }
  } else if (!tween._zTime) {
    tween._zTime = totalTime;
  }
},
    _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
  var child;

  if (time > prevTime) {
    child = animation._first;

    while (child && child._start <= time) {
      if (child.data === "isPause" && child._start > prevTime) {
        return child;
      }

      child = child._next;
    }
  } else {
    child = animation._last;

    while (child && child._start >= time) {
      if (child.data === "isPause" && child._start < prevTime) {
        return child;
      }

      child = child._prev;
    }
  }
},
    _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
  var repeat = animation._repeat,
      dur = _roundPrecise(duration) || 0,
      totalProgress = animation._tTime / animation._tDur;
  totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
  animation._dur = dur;
  animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
  totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
  animation.parent && _setEnd(animation);
  skipUncache || _uncache(animation.parent, animation);
  return animation;
},
    _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
  return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
},
    _zeroPosition = {
  _start: 0,
  endTime: _emptyFunc,
  totalDuration: _emptyFunc
},
    _parsePosition = function _parsePosition(animation, position, percentAnimation) {
  var labels = animation.labels,
      recent = animation._recent || _zeroPosition,
      clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur,
      //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
  i,
      offset,
      isPercent;

  if (_isString(position) && (isNaN(position) || position in labels)) {
    //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
    offset = position.charAt(0);
    isPercent = position.substr(-1) === "%";
    i = position.indexOf("=");

    if (offset === "<" || offset === ">") {
      i >= 0 && (position = position.replace(/=/, ""));
      return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
    }

    if (i < 0) {
      position in labels || (labels[position] = clippedDuration);
      return labels[position];
    }

    offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));

    if (isPercent && percentAnimation) {
      offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
    }

    return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
  }

  return position == null ? clippedDuration : +position;
},
    _createTweenType = function _createTweenType(type, params, timeline) {
  var isLegacy = _isNumber(params[1]),
      varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1),
      vars = params[varsIndex],
      irVars,
      parent;

  isLegacy && (vars.duration = params[1]);
  vars.parent = timeline;

  if (type) {
    irVars = vars;
    parent = timeline;

    while (parent && !("immediateRender" in irVars)) {
      // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
      irVars = parent.vars.defaults || {};
      parent = _isNotFalse(parent.vars.inherit) && parent.parent;
    }

    vars.immediateRender = _isNotFalse(irVars.immediateRender);
    type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
  }

  return new Tween(params[0], vars, params[varsIndex + 1]);
},
    _conditionalReturn = function _conditionalReturn(value, func) {
  return value || value === 0 ? func(value) : func;
},
    _clamp = function _clamp(min, max, value) {
  return value < min ? min : value > max ? max : value;
},
    getUnit = function getUnit(value, v) {
  return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
},
    // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
  return _conditionalReturn(value, function (v) {
    return _clamp(min, max, v);
  });
},
    _slice = [].slice,
    _isArrayLike = function _isArrayLike(value, nonEmpty) {
  return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
},
    _flatten = function _flatten(ar, leaveStrings, accumulator) {
  if (accumulator === void 0) {
    accumulator = [];
  }

  return ar.forEach(function (value) {
    var _accumulator;

    return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
  }) || accumulator;
},
    //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
  return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [value] : [];
},
    selector = function selector(value) {
  value = toArray(value)[0] || _warn("Invalid scope") || {};
  return function (v) {
    var el = value.current || value.nativeElement || value;
    return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
  };
},
    shuffle = function shuffle(a) {
  return a.sort(function () {
    return .5 - Math.random();
  });
},
    // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
  if (_isFunction(v)) {
    return v;
  }

  var vars = _isObject(v) ? v : {
    each: v
  },
      //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
  ease = _parseEase(vars.ease),
      from = vars.from || 0,
      base = parseFloat(vars.base) || 0,
      cache = {},
      isDecimal = from > 0 && from < 1,
      ratios = isNaN(from) || isDecimal,
      axis = vars.axis,
      ratioX = from,
      ratioY = from;

  if (_isString(from)) {
    ratioX = ratioY = {
      center: .5,
      edges: .5,
      end: 1
    }[from] || 0;
  } else if (!isDecimal && ratios) {
    ratioX = from[0];
    ratioY = from[1];
  }

  return function (i, target, a) {
    var l = (a || vars).length,
        distances = cache[l],
        originX,
        originY,
        x,
        y,
        d,
        j,
        max,
        min,
        wrapAt;

    if (!distances) {
      wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [1, _bigNum])[1];

      if (!wrapAt) {
        max = -_bigNum;

        while (max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l) {}

        wrapAt < l && wrapAt--;
      }

      distances = cache[l] = [];
      originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
      originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
      max = 0;
      min = _bigNum;

      for (j = 0; j < l; j++) {
        x = j % wrapAt - originX;
        y = originY - (j / wrapAt | 0);
        distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
        d > max && (max = d);
        d < min && (min = d);
      }

      from === "random" && shuffle(distances);
      distances.max = max - min;
      distances.min = min;
      distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
      distances.b = l < 0 ? base - l : base;
      distances.u = getUnit(vars.amount || vars.each) || 0; //unit

      ease = ease && l < 0 ? _invertEase(ease) : ease;
    }

    l = (distances[i] - distances.min) / distances.max || 0;
    return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
  };
},
    _roundModifier = function _roundModifier(v) {
  //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
  var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())

  return function (raw) {
    var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);

    return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
  };
},
    snap = function snap(snapTo, value) {
  var isArray = _isArray(snapTo),
      radius,
      is2D;

  if (!isArray && _isObject(snapTo)) {
    radius = isArray = snapTo.radius || _bigNum;

    if (snapTo.values) {
      snapTo = toArray(snapTo.values);

      if (is2D = !_isNumber(snapTo[0])) {
        radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
      }
    } else {
      snapTo = _roundModifier(snapTo.increment);
    }
  }

  return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function (raw) {
    is2D = snapTo(raw);
    return Math.abs(is2D - raw) <= radius ? is2D : raw;
  } : function (raw) {
    var x = parseFloat(is2D ? raw.x : raw),
        y = parseFloat(is2D ? raw.y : 0),
        min = _bigNum,
        closest = 0,
        i = snapTo.length,
        dx,
        dy;

    while (i--) {
      if (is2D) {
        dx = snapTo[i].x - x;
        dy = snapTo[i].y - y;
        dx = dx * dx + dy * dy;
      } else {
        dx = Math.abs(snapTo[i] - x);
      }

      if (dx < min) {
        min = dx;
        closest = i;
      }
    }

    closest = !radius || min <= radius ? snapTo[closest] : raw;
    return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
  });
},
    random = function random(min, max, roundingIncrement, returnFunction) {
  return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? !!(roundingIncrement = 0) : !returnFunction, function () {
    return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5) && (returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
  });
},
    pipe = function pipe() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }

  return function (value) {
    return functions.reduce(function (v, f) {
      return f(v);
    }, value);
  };
},
    unitize = function unitize(func, unit) {
  return function (value) {
    return func(parseFloat(value)) + (unit || getUnit(value));
  };
},
    normalize = function normalize(min, max, value) {
  return mapRange(min, max, 0, 1, value);
},
    _wrapArray = function _wrapArray(a, wrapper, value) {
  return _conditionalReturn(value, function (index) {
    return a[~~wrapper(index)];
  });
},
    wrap = function wrap(min, max, value) {
  // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
  var range = max - min;
  return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function (value) {
    return (range + (value - min) % range) % range + min;
  });
},
    wrapYoyo = function wrapYoyo(min, max, value) {
  var range = max - min,
      total = range * 2;
  return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function (value) {
    value = (total + (value - min) % total) % total || 0;
    return min + (value > range ? total - value : value);
  });
},
    _replaceRandom = function _replaceRandom(value) {
  //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
  var prev = 0,
      s = "",
      i,
      nums,
      end,
      isArray;

  while (~(i = value.indexOf("random(", prev))) {
    end = value.indexOf(")", i);
    isArray = value.charAt(i + 7) === "[";
    nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
    s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
    prev = end + 1;
  }

  return s + value.substr(prev, value.length - prev);
},
    mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
  var inRange = inMax - inMin,
      outRange = outMax - outMin;
  return _conditionalReturn(value, function (value) {
    return outMin + ((value - inMin) / inRange * outRange || 0);
  });
},
    interpolate = function interpolate(start, end, progress, mutate) {
  var func = isNaN(start + end) ? 0 : function (p) {
    return (1 - p) * start + p * end;
  };

  if (!func) {
    var isString = _isString(start),
        master = {},
        p,
        i,
        interpolators,
        l,
        il;

    progress === true && (mutate = 1) && (progress = null);

    if (isString) {
      start = {
        p: start
      };
      end = {
        p: end
      };
    } else if (_isArray(start) && !_isArray(end)) {
      interpolators = [];
      l = start.length;
      il = l - 2;

      for (i = 1; i < l; i++) {
        interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
      }

      l--;

      func = function func(p) {
        p *= l;
        var i = Math.min(il, ~~p);
        return interpolators[i](p - i);
      };

      progress = end;
    } else if (!mutate) {
      start = _merge(_isArray(start) ? [] : {}, start);
    }

    if (!interpolators) {
      for (p in end) {
        _addPropTween.call(master, start, p, "get", end[p]);
      }

      func = function func(p) {
        return _renderPropTweens(p, master) || (isString ? start.p : start);
      };
    }
  }

  return _conditionalReturn(progress, func);
},
    _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
  //used for nextLabel() and previousLabel()
  var labels = timeline.labels,
      min = _bigNum,
      p,
      distance,
      label;

  for (p in labels) {
    distance = labels[p] - fromTime;

    if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
      label = p;
      min = distance;
    }
  }

  return label;
},
    _callback = function _callback(animation, type, executeLazyFirst) {
  var v = animation.vars,
      callback = v[type],
      prevContext = _context,
      context = animation._ctx,
      params,
      scope,
      result;

  if (!callback) {
    return;
  }

  params = v[type + "Params"];
  scope = v.callbackScope || animation;
  executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.

  context && (_context = context);
  result = params ? callback.apply(scope, params) : callback.call(scope);
  _context = prevContext;
  return result;
},
    _interrupt = function _interrupt(animation) {
  _removeFromParent(animation);

  animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
  animation.progress() < 1 && _callback(animation, "onInterrupt");
  return animation;
},
    _quickTween,
    _registerPluginQueue = [],
    _createPlugin = function _createPlugin(config) {
  if (!config) return;
  config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.

  if (_windowExists() || config.headless) {
    // edge case: some build tools may pass in a null/undefined value
    var name = config.name,
        isFunc = _isFunction(config),
        Plugin = name && !isFunc && config.init ? function () {
      this._props = [];
    } : config,
        //in case someone passes in an object that's not a plugin, like CustomEase
    instanceDefaults = {
      init: _emptyFunc,
      render: _renderPropTweens,
      add: _addPropTween,
      kill: _killPropTweensOf,
      modifier: _addPluginModifier,
      rawVars: 0
    },
        statics = {
      targetTest: 0,
      get: 0,
      getSetter: _getSetter,
      aliases: {},
      register: 0
    };

    _wake();

    if (config !== Plugin) {
      if (_plugins[name]) {
        return;
      }

      _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods


      _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods


      _plugins[Plugin.prop = name] = Plugin;

      if (config.targetTest) {
        _harnessPlugins.push(Plugin);

        _reservedProps[name] = 1;
      }

      name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
    }

    _addGlobal(name, Plugin);

    config.register && config.register(gsap, Plugin, PropTween);
  } else {
    _registerPluginQueue.push(config);
  }
},

/*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */
_255 = 255,
    _colorLookup = {
  aqua: [0, _255, _255],
  lime: [0, _255, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, _255],
  navy: [0, 0, 128],
  white: [_255, _255, _255],
  olive: [128, 128, 0],
  yellow: [_255, _255, 0],
  orange: [_255, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [_255, 0, 0],
  pink: [_255, 192, 203],
  cyan: [0, _255, _255],
  transparent: [_255, _255, _255, 0]
},
    // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
  h += h < 0 ? 1 : h > 1 ? -1 : 0;
  return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
},
    splitColor = function splitColor(v, toHSL, forceAlpha) {
  var a = !v ? _colorLookup.black : _isNumber(v) ? [v >> 16, v >> 8 & _255, v & _255] : 0,
      r,
      g,
      b,
      h,
      s,
      l,
      max,
      min,
      d,
      wasHSL;

  if (!a) {
    if (v.substr(-1) === ",") {
      //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
      v = v.substr(0, v.length - 1);
    }

    if (_colorLookup[v]) {
      a = _colorLookup[v];
    } else if (v.charAt(0) === "#") {
      if (v.length < 6) {
        //for shorthand like #9F0 or #9F0F (could have alpha)
        r = v.charAt(1);
        g = v.charAt(2);
        b = v.charAt(3);
        v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
      }

      if (v.length === 9) {
        // hex with alpha, like #fd5e53ff
        a = parseInt(v.substr(1, 6), 16);
        return [a >> 16, a >> 8 & _255, a & _255, parseInt(v.substr(7), 16) / 255];
      }

      v = parseInt(v.substr(1), 16);
      a = [v >> 16, v >> 8 & _255, v & _255];
    } else if (v.substr(0, 3) === "hsl") {
      a = wasHSL = v.match(_strictNumExp);

      if (!toHSL) {
        h = +a[0] % 360 / 360;
        s = +a[1] / 100;
        l = +a[2] / 100;
        g = l <= .5 ? l * (s + 1) : l + s - l * s;
        r = l * 2 - g;
        a.length > 3 && (a[3] *= 1); //cast as number

        a[0] = _hue(h + 1 / 3, r, g);
        a[1] = _hue(h, r, g);
        a[2] = _hue(h - 1 / 3, r, g);
      } else if (~v.indexOf("=")) {
        //if relative values are found, just return the raw strings with the relative prefixes in place.
        a = v.match(_numExp);
        forceAlpha && a.length < 4 && (a[3] = 1);
        return a;
      }
    } else {
      a = v.match(_strictNumExp) || _colorLookup.transparent;
    }

    a = a.map(Number);
  }

  if (toHSL && !wasHSL) {
    r = a[0] / _255;
    g = a[1] / _255;
    b = a[2] / _255;
    max = Math.max(r, g, b);
    min = Math.min(r, g, b);
    l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
      h *= 60;
    }

    a[0] = ~~(h + .5);
    a[1] = ~~(s * 100 + .5);
    a[2] = ~~(l * 100 + .5);
  }

  forceAlpha && a.length < 4 && (a[3] = 1);
  return a;
},
    _colorOrderData = function _colorOrderData(v) {
  // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
  var values = [],
      c = [],
      i = -1;
  v.split(_colorExp).forEach(function (v) {
    var a = v.match(_numWithUnitExp) || [];
    values.push.apply(values, a);
    c.push(i += a.length + 1);
  });
  values.c = c;
  return values;
},
    _formatColors = function _formatColors(s, toHSL, orderMatchData) {
  var result = "",
      colors = (s + result).match(_colorExp),
      type = toHSL ? "hsla(" : "rgba(",
      i = 0,
      c,
      shell,
      d,
      l;

  if (!colors) {
    return s;
  }

  colors = colors.map(function (color) {
    return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
  });

  if (orderMatchData) {
    d = _colorOrderData(s);
    c = orderMatchData.c;

    if (c.join(result) !== d.c.join(result)) {
      shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
      l = shell.length - 1;

      for (; i < l; i++) {
        result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
      }
    }
  }

  if (!shell) {
    shell = s.split(_colorExp);
    l = shell.length - 1;

    for (; i < l; i++) {
      result += shell[i] + colors[i];
    }
  }

  return result + shell[l];
},
    _colorExp = function () {
  var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b",
      //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
  p;

  for (p in _colorLookup) {
    s += "|" + p + "\\b";
  }

  return new RegExp(s + ")", "gi");
}(),
    _hslExp = /hsl[a]?\(/,
    _colorStringFilter = function _colorStringFilter(a) {
  var combined = a.join(" "),
      toHSL;
  _colorExp.lastIndex = 0;

  if (_colorExp.test(combined)) {
    toHSL = _hslExp.test(combined);
    a[1] = _formatColors(a[1], toHSL);
    a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.

    return true;
  }
},

/*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */
_tickerActive,
    _ticker = function () {
  var _getTime = Date.now,
      _lagThreshold = 500,
      _adjustedLag = 33,
      _startTime = _getTime(),
      _lastUpdate = _startTime,
      _gap = 1000 / 240,
      _nextTime = _gap,
      _listeners = [],
      _id,
      _req,
      _raf,
      _self,
      _delta,
      _i,
      _tick = function _tick(v) {
    var elapsed = _getTime() - _lastUpdate,
        manual = v === true,
        overlap,
        dispatch,
        time,
        frame;

    (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
    _lastUpdate += elapsed;
    time = _lastUpdate - _startTime;
    overlap = time - _nextTime;

    if (overlap > 0 || manual) {
      frame = ++_self.frame;
      _delta = time - _self.time * 1000;
      _self.time = time = time / 1000;
      _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
      dispatch = 1;
    }

    manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.

    if (dispatch) {
      for (_i = 0; _i < _listeners.length; _i++) {
        // use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
      }
    }
  };

  _self = {
    time: 0,
    frame: 0,
    tick: function tick() {
      _tick(true);
    },
    deltaRatio: function deltaRatio(fps) {
      return _delta / (1000 / (fps || 60));
    },
    wake: function wake() {
      if (_coreReady) {
        if (!_coreInitted && _windowExists()) {
          _win = _coreInitted = window;
          _doc = _win.document || {};
          _globals.gsap = gsap;
          (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);

          _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});

          _registerPluginQueue.forEach(_createPlugin);
        }

        _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
        _id && _self.sleep();

        _req = _raf || function (f) {
          return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
        };

        _tickerActive = 1;

        _tick(2);
      }
    },
    sleep: function sleep() {
      (_raf ? cancelAnimationFrame : clearTimeout)(_id);
      _tickerActive = 0;
      _req = _emptyFunc;
    },
    lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
      _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited

      _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
    },
    fps: function fps(_fps) {
      _gap = 1000 / (_fps || 240);
      _nextTime = _self.time * 1000 + _gap;
    },
    add: function add(callback, once, prioritize) {
      var func = once ? function (t, d, f, v) {
        callback(t, d, f, v);

        _self.remove(func);
      } : callback;

      _self.remove(callback);

      _listeners[prioritize ? "unshift" : "push"](func);

      _wake();

      return func;
    },
    remove: function remove(callback, i) {
      ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
    },
    _listeners: _listeners
  };
  return _self;
}(),
    _wake = function _wake() {
  return !_tickerActive && _ticker.wake();
},
    //also ensures the core classes are initialized.

/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/
_easeMap = {},
    _customEaseExp = /^[\d.\-M][\d.\-,\s]/,
    _quotesExp = /["']/g,
    _parseObjectInString = function _parseObjectInString(value) {
  //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
  var obj = {},
      split = value.substr(1, value.length - 3).split(":"),
      key = split[0],
      i = 1,
      l = split.length,
      index,
      val,
      parsedVal;

  for (; i < l; i++) {
    val = split[i];
    index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
    parsedVal = val.substr(0, index);
    obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
    key = val.substr(index + 1).trim();
  }

  return obj;
},
    _valueInParentheses = function _valueInParentheses(value) {
  var open = value.indexOf("(") + 1,
      close = value.indexOf(")"),
      nested = value.indexOf("(", open);
  return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
},
    _configEaseFromString = function _configEaseFromString(name) {
  //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
  var split = (name + "").split("("),
      ease = _easeMap[split[0]];
  return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [_parseObjectInString(split[1])] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
},
    _invertEase = function _invertEase(ease) {
  return function (p) {
    return 1 - ease(1 - p);
  };
},
    // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
  var child = timeline._first,
      ease;

  while (child) {
    if (child instanceof Timeline) {
      _propagateYoyoEase(child, isYoyo);
    } else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
      if (child.timeline) {
        _propagateYoyoEase(child.timeline, isYoyo);
      } else {
        ease = child._ease;
        child._ease = child._yEase;
        child._yEase = ease;
        child._yoyo = isYoyo;
      }
    }

    child = child._next;
  }
},
    _parseEase = function _parseEase(ease, defaultEase) {
  return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
},
    _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
  if (easeOut === void 0) {
    easeOut = function easeOut(p) {
      return 1 - easeIn(1 - p);
    };
  }

  if (easeInOut === void 0) {
    easeInOut = function easeInOut(p) {
      return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
  }

  var ease = {
    easeIn: easeIn,
    easeOut: easeOut,
    easeInOut: easeInOut
  },
      lowercaseName;

  _forEachName(names, function (name) {
    _easeMap[name] = _globals[name] = ease;
    _easeMap[lowercaseName = name.toLowerCase()] = easeOut;

    for (var p in ease) {
      _easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    }
  });

  return ease;
},
    _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
  return function (p) {
    return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
  };
},
    _configElastic = function _configElastic(type, amplitude, period) {
  var p1 = amplitude >= 1 ? amplitude : 1,
      //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
  p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1),
      p3 = p2 / _2PI * (Math.asin(1 / p1) || 0),
      easeOut = function easeOut(p) {
    return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
  },
      ease = type === "out" ? easeOut : type === "in" ? function (p) {
    return 1 - easeOut(1 - p);
  } : _easeInOutFromOut(easeOut);

  p2 = _2PI / p2; //precalculate to optimize

  ease.config = function (amplitude, period) {
    return _configElastic(type, amplitude, period);
  };

  return ease;
},
    _configBack = function _configBack(type, overshoot) {
  if (overshoot === void 0) {
    overshoot = 1.70158;
  }

  var easeOut = function easeOut(p) {
    return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
  },
      ease = type === "out" ? easeOut : type === "in" ? function (p) {
    return 1 - easeOut(1 - p);
  } : _easeInOutFromOut(easeOut);

  ease.config = function (overshoot) {
    return _configBack(type, overshoot);
  };

  return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };


_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function (name, i) {
  var power = i < 5 ? i + 1 : i;

  _insertEase(name + ",Power" + (power - 1), i ? function (p) {
    return Math.pow(p, power);
  } : function (p) {
    return p;
  }, function (p) {
    return 1 - Math.pow(1 - p, power);
  }, function (p) {
    return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
  });
});

_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;

_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());

(function (n, c) {
  var n1 = 1 / c,
      n2 = 2 * n1,
      n3 = 2.5 * n1,
      easeOut = function easeOut(p) {
    return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
  };

  _insertEase("Bounce", function (p) {
    return 1 - easeOut(1 - p);
  }, easeOut);
})(7.5625, 2.75);

_insertEase("Expo", function (p) {
  return p ? Math.pow(2, 10 * (p - 1)) : 0;
});

_insertEase("Circ", function (p) {
  return -(_sqrt(1 - p * p) - 1);
});

_insertEase("Sine", function (p) {
  return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});

_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());

_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
  config: function config(steps, immediateStart) {
    if (steps === void 0) {
      steps = 1;
    }

    var p1 = 1 / steps,
        p2 = steps + (immediateStart ? 0 : 1),
        p3 = immediateStart ? 1 : 0,
        max = 1 - _tinyNum;
    return function (p) {
      return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
    };
  }
};
_defaults.ease = _easeMap["quad.out"];

_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (name) {
  return _callbackNames += name + "," + name + "Params,";
});
/*
 * --------------------------------------------------------------------------------------
 * CACHE
 * --------------------------------------------------------------------------------------
 */


var GSCache = function GSCache(target, harness) {
  this.id = _gsID++;
  target._gsap = this;
  this.target = target;
  this.harness = harness;
  this.get = harness ? harness.get : _getProperty;
  this.set = harness ? harness.getSetter : _getSetter;
};
/*
 * --------------------------------------------------------------------------------------
 * ANIMATION
 * --------------------------------------------------------------------------------------
 */

var Animation = /*#__PURE__*/function () {
  function Animation(vars) {
    this.vars = vars;
    this._delay = +vars.delay || 0;

    if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
      // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
      this._rDelay = vars.repeatDelay || 0;
      this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
    }

    this._ts = 1;

    _setDuration(this, +vars.duration, 1, 1);

    this.data = vars.data;

    if (_context) {
      this._ctx = _context;

      _context.data.push(this);
    }

    _tickerActive || _ticker.wake();
  }

  var _proto = Animation.prototype;

  _proto.delay = function delay(value) {
    if (value || value === 0) {
      this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
      this._delay = value;
      return this;
    }

    return this._delay;
  };

  _proto.duration = function duration(value) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
  };

  _proto.totalDuration = function totalDuration(value) {
    if (!arguments.length) {
      return this._tDur;
    }

    this._dirty = 0;
    return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
  };

  _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
    _wake();

    if (!arguments.length) {
      return this._tTime;
    }

    var parent = this._dp;

    if (parent && parent.smoothChildTiming && this._ts) {
      _alignPlayhead(this, _totalTime);

      !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
      //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.

      while (parent && parent.parent) {
        if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) {
          parent.totalTime(parent._tTime, true);
        }

        parent = parent.parent;
      }

      if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) {
        //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
        _addToTimeline(this._dp, this, this._start - this._delay);
      }
    }

    if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
      // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
      this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
      //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
      //   this._lock = 1;

      _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
      //}

    }

    return this;
  };

  _proto.time = function time(value, suppressEvents) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
  };

  _proto.totalProgress = function totalProgress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
  };

  _proto.progress = function progress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  };

  _proto.iteration = function iteration(value, suppressEvents) {
    var cycleDuration = this.duration() + this._rDelay;

    return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
  } // potential future addition:
  // isPlayingBackwards() {
  // 	let animation = this,
  // 		orientation = 1; // 1 = forward, -1 = backward
  // 	while (animation) {
  // 		orientation *= animation.reversed() || (animation.repeat() && !(animation.iteration() & 1)) ? -1 : 1;
  // 		animation = animation.parent;
  // 	}
  // 	return orientation < 0;
  // }
  ;

  _proto.timeScale = function timeScale(value, suppressEvents) {
    if (!arguments.length) {
      return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
    }

    if (this._rts === value) {
      return this;
    }

    var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
    // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
    //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
    // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.

    this._rts = +value || 0;
    this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.

    this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);

    _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.


    return _recacheAncestors(this);
  };

  _proto.paused = function paused(value) {
    if (!arguments.length) {
      return this._ps;
    }

    if (this._ps !== value) {
      this._ps = value;

      if (value) {
        this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.

        this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
      } else {
        _wake();

        this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.

        this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
      }
    }

    return this;
  };

  _proto.startTime = function startTime(value) {
    if (arguments.length) {
      this._start = value;
      var parent = this.parent || this._dp;
      parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
      return this;
    }

    return this._start;
  };

  _proto.endTime = function endTime(includeRepeats) {
    return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  };

  _proto.rawTime = function rawTime(wrapRepeats) {
    var parent = this.parent || this._dp; // _dp = detached parent

    return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
  };

  _proto.revert = function revert(config) {
    if (config === void 0) {
      config = _revertConfig;
    }

    var prevIsReverting = _reverting;
    _reverting = config;

    if (this._initted || this._startAt) {
      this.timeline && this.timeline.revert(config);
      this.totalTime(-0.01, config.suppressEvents);
    }

    this.data !== "nested" && config.kill !== false && this.kill();
    _reverting = prevIsReverting;
    return this;
  };

  _proto.globalTime = function globalTime(rawTime) {
    var animation = this,
        time = arguments.length ? rawTime : animation.rawTime();

    while (animation) {
      time = animation._start + time / (Math.abs(animation._ts) || 1);
      animation = animation._dp;
    }

    return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
  };

  _proto.repeat = function repeat(value) {
    if (arguments.length) {
      this._repeat = value === Infinity ? -2 : value;
      return _onUpdateTotalDuration(this);
    }

    return this._repeat === -2 ? Infinity : this._repeat;
  };

  _proto.repeatDelay = function repeatDelay(value) {
    if (arguments.length) {
      var time = this._time;
      this._rDelay = value;

      _onUpdateTotalDuration(this);

      return time ? this.time(time) : this;
    }

    return this._rDelay;
  };

  _proto.yoyo = function yoyo(value) {
    if (arguments.length) {
      this._yoyo = value;
      return this;
    }

    return this._yoyo;
  };

  _proto.seek = function seek(position, suppressEvents) {
    return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
  };

  _proto.restart = function restart(includeDelay, suppressEvents) {
    return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
  };

  _proto.play = function play(from, suppressEvents) {
    from != null && this.seek(from, suppressEvents);
    return this.reversed(false).paused(false);
  };

  _proto.reverse = function reverse(from, suppressEvents) {
    from != null && this.seek(from || this.totalDuration(), suppressEvents);
    return this.reversed(true).paused(false);
  };

  _proto.pause = function pause(atTime, suppressEvents) {
    atTime != null && this.seek(atTime, suppressEvents);
    return this.paused(true);
  };

  _proto.resume = function resume() {
    return this.paused(false);
  };

  _proto.reversed = function reversed(value) {
    if (arguments.length) {
      !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.

      return this;
    }

    return this._rts < 0;
  };

  _proto.invalidate = function invalidate() {
    this._initted = this._act = 0;
    this._zTime = -_tinyNum;
    return this;
  };

  _proto.isActive = function isActive() {
    var parent = this.parent || this._dp,
        start = this._start,
        rawTime;
    return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
  };

  _proto.eventCallback = function eventCallback(type, callback, params) {
    var vars = this.vars;

    if (arguments.length > 1) {
      if (!callback) {
        delete vars[type];
      } else {
        vars[type] = callback;
        params && (vars[type + "Params"] = params);
        type === "onUpdate" && (this._onUpdate = callback);
      }

      return this;
    }

    return vars[type];
  };

  _proto.then = function then(onFulfilled) {
    var self = this;
    return new Promise(function (resolve) {
      var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough,
          _resolve = function _resolve() {
        var _then = self.then;
        self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)

        _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
        resolve(f);
        self.then = _then;
      };

      if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) {
        _resolve();
      } else {
        self._prom = _resolve;
      }
    });
  };

  _proto.kill = function kill() {
    _interrupt(this);
  };

  return Animation;
}();

_setDefaults(Animation.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: false,
  parent: null,
  _initted: false,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -_tinyNum,
  _prom: 0,
  _ps: false,
  _rts: 1
});
/*
 * -------------------------------------------------
 * TIMELINE
 * -------------------------------------------------
 */


var Timeline = /*#__PURE__*/function (_Animation) {
  _inheritsLoose(Timeline, _Animation);

  function Timeline(vars, position) {
    var _this;

    if (vars === void 0) {
      vars = {};
    }

    _this = _Animation.call(this, vars) || this;
    _this.labels = {};
    _this.smoothChildTiming = !!vars.smoothChildTiming;
    _this.autoRemoveChildren = !!vars.autoRemoveChildren;
    _this._sort = _isNotFalse(vars.sortChildren);
    _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
    vars.reversed && _this.reverse();
    vars.paused && _this.paused(true);
    vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
    return _this;
  }

  var _proto2 = Timeline.prototype;

  _proto2.to = function to(targets, vars, position) {
    _createTweenType(0, arguments, this);

    return this;
  };

  _proto2.from = function from(targets, vars, position) {
    _createTweenType(1, arguments, this);

    return this;
  };

  _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
    _createTweenType(2, arguments, this);

    return this;
  };

  _proto2.set = function set(targets, vars, position) {
    vars.duration = 0;
    vars.parent = this;
    _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
    vars.immediateRender = !!vars.immediateRender;
    new Tween(targets, vars, _parsePosition(this, position), 1);
    return this;
  };

  _proto2.call = function call(callback, params, position) {
    return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
  } //ONLY for backward compatibility! Maybe delete?
  ;

  _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.duration = duration;
    vars.stagger = vars.stagger || stagger;
    vars.onComplete = onCompleteAll;
    vars.onCompleteParams = onCompleteAllParams;
    vars.parent = this;
    new Tween(targets, vars, _parsePosition(this, position));
    return this;
  };

  _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.runBackwards = 1;
    _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
    return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
  };

  _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
    toVars.startAt = fromVars;
    _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
    return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
  };

  _proto2.render = function render(totalTime, suppressEvents, force) {
    var prevTime = this._time,
        tDur = this._dirty ? this.totalDuration() : this._tDur,
        dur = this._dur,
        tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime),
        // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
    crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur),
        time,
        child,
        next,
        iteration,
        cycleDuration,
        prevPaused,
        pauseTween,
        timeScale,
        prevStart,
        prevIteration,
        yoyo,
        isYoyo;
    this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);

    if (tTime !== this._tTime || force || crossingStart) {
      if (prevTime !== this._time && dur) {
        //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
        tTime += this._time - prevTime;
        totalTime += this._time - prevTime;
      }

      time = tTime;
      prevStart = this._start;
      timeScale = this._ts;
      prevPaused = !timeScale;

      if (crossingStart) {
        dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.

        (totalTime || !suppressEvents) && (this._zTime = totalTime);
      }

      if (this._repeat) {
        //adjust the time for repeats and yoyos
        yoyo = this._yoyo;
        cycleDuration = dur + this._rDelay;

        if (this._repeat < -1 && totalTime < 0) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }

        time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)

        if (tTime === tDur) {
          // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);

          if (iteration && iteration === tTime / cycleDuration) {
            time = dur;
            iteration--;
          }

          time > dur && (time = dur);
        }

        prevIteration = _animationCycle(this._tTime, cycleDuration);
        !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion

        if (yoyo && iteration & 1) {
          time = dur - time;
          isYoyo = 1;
        }
        /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */


        if (iteration !== prevIteration && !this._lock) {
          var rewinding = yoyo && prevIteration & 1,
              doesWrap = rewinding === (yoyo && iteration & 1);
          iteration < prevIteration && (rewinding = !rewinding);
          prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.

          this._lock = 1;
          this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
          this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.

          !suppressEvents && this.parent && _callback(this, "onRepeat");
          this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);

          if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) {
            // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
            return this;
          }

          dur = this._dur; // in case the duration changed in the onRepeat

          tDur = this._tDur;

          if (doesWrap) {
            this._lock = 2;
            prevTime = rewinding ? dur : -0.0001;
            this.render(prevTime, true);
            this.vars.repeatRefresh && !isYoyo && this.invalidate();
          }

          this._lock = 0;

          if (!this._ts && !prevPaused) {
            return this;
          } //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.


          _propagateYoyoEase(this, isYoyo);
        }
      }

      if (this._hasPause && !this._forcing && this._lock < 2) {
        pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));

        if (pauseTween) {
          tTime -= time - (time = pauseTween._start);
        }
      }

      this._tTime = tTime;
      this._time = time;
      this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.

      if (!this._initted) {
        this._onUpdate = this.vars.onUpdate;
        this._initted = 1;
        this._zTime = totalTime;
        prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
      }

      if (!prevTime && time && !suppressEvents && !iteration) {
        _callback(this, "onStart");

        if (this._tTime !== tTime) {
          // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
          return this;
        }
      }

      if (time >= prevTime && totalTime >= 0) {
        child = this._first;

        while (child) {
          next = child._next;

          if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
              return this.render(totalTime, suppressEvents, force);
            }

            child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);

            if (time !== this._time || !this._ts && !prevPaused) {
              //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
              pauseTween = 0;
              next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)

              break;
            }
          }

          child = next;
        }
      } else {
        child = this._last;
        var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.

        while (child) {
          next = child._prev;

          if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
              return this.render(totalTime, suppressEvents, force);
            }

            child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.

            if (time !== this._time || !this._ts && !prevPaused) {
              //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
              pauseTween = 0;
              next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)

              break;
            }
          }

          child = next;
        }
      }

      if (pauseTween && !suppressEvents) {
        this.pause();
        pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;

        if (this._ts) {
          //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
          this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.

          _setEnd(this);

          return this.render(totalTime, suppressEvents, force);
        }
      }

      this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
      if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) if (!this._lock) {
        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.

        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
          _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);

          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }

    return this;
  };

  _proto2.add = function add(child, position) {
    var _this2 = this;

    _isNumber(position) || (position = _parsePosition(this, position, child));

    if (!(child instanceof Animation)) {
      if (_isArray(child)) {
        child.forEach(function (obj) {
          return _this2.add(obj, position);
        });
        return this;
      }

      if (_isString(child)) {
        return this.addLabel(child, position);
      }

      if (_isFunction(child)) {
        child = Tween.delayedCall(0, child);
      } else {
        return this;
      }
    }

    return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
  };

  _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
    if (nested === void 0) {
      nested = true;
    }

    if (tweens === void 0) {
      tweens = true;
    }

    if (timelines === void 0) {
      timelines = true;
    }

    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = -_bigNum;
    }

    var a = [],
        child = this._first;

    while (child) {
      if (child._start >= ignoreBeforeTime) {
        if (child instanceof Tween) {
          tweens && a.push(child);
        } else {
          timelines && a.push(child);
          nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
        }
      }

      child = child._next;
    }

    return a;
  };

  _proto2.getById = function getById(id) {
    var animations = this.getChildren(1, 1, 1),
        i = animations.length;

    while (i--) {
      if (animations[i].vars.id === id) {
        return animations[i];
      }
    }
  };

  _proto2.remove = function remove(child) {
    if (_isString(child)) {
      return this.removeLabel(child);
    }

    if (_isFunction(child)) {
      return this.killTweensOf(child);
    }

    _removeLinkedListItem(this, child);

    if (child === this._recent) {
      this._recent = this._last;
    }

    return _uncache(this);
  };

  _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
    if (!arguments.length) {
      return this._tTime;
    }

    this._forcing = 1;

    if (!this._dp && this._ts) {
      //special case for the global timeline (or any other that has no parent or detached parent).
      this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
    }

    _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);

    this._forcing = 0;
    return this;
  };

  _proto2.addLabel = function addLabel(label, position) {
    this.labels[label] = _parsePosition(this, position);
    return this;
  };

  _proto2.removeLabel = function removeLabel(label) {
    delete this.labels[label];
    return this;
  };

  _proto2.addPause = function addPause(position, callback, params) {
    var t = Tween.delayedCall(0, callback || _emptyFunc, params);
    t.data = "isPause";
    this._hasPause = 1;
    return _addToTimeline(this, t, _parsePosition(this, position));
  };

  _proto2.removePause = function removePause(position) {
    var child = this._first;
    position = _parsePosition(this, position);

    while (child) {
      if (child._start === position && child.data === "isPause") {
        _removeFromParent(child);
      }

      child = child._next;
    }
  };

  _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    var tweens = this.getTweensOf(targets, onlyActive),
        i = tweens.length;

    while (i--) {
      _overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
    }

    return this;
  };

  _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
    var a = [],
        parsedTargets = toArray(targets),
        child = this._first,
        isGlobalTime = _isNumber(onlyActive),
        // a number is interpreted as a global time. If the animation spans
    children;

    while (child) {
      if (child instanceof Tween) {
        if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) {
          // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
          a.push(child);
        }
      } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) {
        a.push.apply(a, children);
      }

      child = child._next;
    }

    return a;
  } // potential future feature - targets() on timelines
  // targets() {
  // 	let result = [];
  // 	this.getChildren(true, true, false).forEach(t => result.push(...t.targets()));
  // 	return result.filter((v, i) => result.indexOf(v) === i);
  // }
  ;

  _proto2.tweenTo = function tweenTo(position, vars) {
    vars = vars || {};

    var tl = this,
        endTime = _parsePosition(tl, position),
        _vars = vars,
        startAt = _vars.startAt,
        _onStart = _vars.onStart,
        onStartParams = _vars.onStartParams,
        immediateRender = _vars.immediateRender,
        initted,
        tween = Tween.to(tl, _setDefaults({
      ease: vars.ease || "none",
      lazy: false,
      immediateRender: false,
      time: endTime,
      overwrite: "auto",
      duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
      onStart: function onStart() {
        tl.pause();

        if (!initted) {
          var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
          tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
          initted = 1;
        }

        _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
      }
    }, vars));

    return immediateRender ? tween.render(0) : tween;
  };

  _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
    return this.tweenTo(toPosition, _setDefaults({
      startAt: {
        time: _parsePosition(this, fromPosition)
      }
    }, vars));
  };

  _proto2.recent = function recent() {
    return this._recent;
  };

  _proto2.nextLabel = function nextLabel(afterTime) {
    if (afterTime === void 0) {
      afterTime = this._time;
    }

    return _getLabelInDirection(this, _parsePosition(this, afterTime));
  };

  _proto2.previousLabel = function previousLabel(beforeTime) {
    if (beforeTime === void 0) {
      beforeTime = this._time;
    }

    return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
  };

  _proto2.currentLabel = function currentLabel(value) {
    return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
  };

  _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = 0;
    }

    var child = this._first,
        labels = this.labels,
        p;

    while (child) {
      if (child._start >= ignoreBeforeTime) {
        child._start += amount;
        child._end += amount;
      }

      child = child._next;
    }

    if (adjustLabels) {
      for (p in labels) {
        if (labels[p] >= ignoreBeforeTime) {
          labels[p] += amount;
        }
      }
    }

    return _uncache(this);
  };

  _proto2.invalidate = function invalidate(soft) {
    var child = this._first;
    this._lock = 0;

    while (child) {
      child.invalidate(soft);
      child = child._next;
    }

    return _Animation.prototype.invalidate.call(this, soft);
  };

  _proto2.clear = function clear(includeLabels) {
    if (includeLabels === void 0) {
      includeLabels = true;
    }

    var child = this._first,
        next;

    while (child) {
      next = child._next;
      this.remove(child);
      child = next;
    }

    this._dp && (this._time = this._tTime = this._pTime = 0);
    includeLabels && (this.labels = {});
    return _uncache(this);
  };

  _proto2.totalDuration = function totalDuration(value) {
    var max = 0,
        self = this,
        child = self._last,
        prevStart = _bigNum,
        prev,
        start,
        parent;

    if (arguments.length) {
      return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
    }

    if (self._dirty) {
      parent = self.parent;

      while (child) {
        prev = child._prev; //record it here in case the tween changes position in the sequence...

        child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.

        start = child._start;

        if (start > prevStart && self._sort && child._ts && !self._lock) {
          //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
          self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().

          _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
        } else {
          prevStart = start;
        }

        if (start < 0 && child._ts) {
          //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
          max -= start;

          if (!parent && !self._dp || parent && parent.smoothChildTiming) {
            self._start += start / self._ts;
            self._time -= start;
            self._tTime -= start;
          }

          self.shiftChildren(-start, false, -1e999);
          prevStart = 0;
        }

        child._end > max && child._ts && (max = child._end);
        child = prev;
      }

      _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);

      self._dirty = 0;
    }

    return self._tDur;
  };

  Timeline.updateRoot = function updateRoot(time) {
    if (_globalTimeline._ts) {
      _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));

      _lastRenderedFrame = _ticker.frame;
    }

    if (_ticker.frame >= _nextGCFrame) {
      _nextGCFrame += _config.autoSleep || 120;
      var child = _globalTimeline._first;
      if (!child || !child._ts) if (_config.autoSleep && _ticker._listeners.length < 2) {
        while (child && !child._ts) {
          child = child._next;
        }

        child || _ticker.sleep();
      }
    }
  };

  return Timeline;
}(Animation);

_setDefaults(Timeline.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});

var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
  //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
  var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter),
      index = 0,
      matchIndex = 0,
      result,
      startNums,
      color,
      endNum,
      chunk,
      startNum,
      hasRandom,
      a;
  pt.b = start;
  pt.e = end;
  start += ""; //ensure values are strings

  end += "";

  if (hasRandom = ~end.indexOf("random(")) {
    end = _replaceRandom(end);
  }

  if (stringFilter) {
    a = [start, end];
    stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.

    start = a[0];
    end = a[1];
  }

  startNums = start.match(_complexStringNumExp) || [];

  while (result = _complexStringNumExp.exec(end)) {
    endNum = result[0];
    chunk = end.substring(index, result.index);

    if (color) {
      color = (color + 1) % 5;
    } else if (chunk.substr(-5) === "rgba(") {
      color = 1;
    }

    if (endNum !== startNums[matchIndex++]) {
      startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.

      pt._pt = {
        _next: pt._pt,
        p: chunk || matchIndex === 1 ? chunk : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: startNum,
        c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
        m: color && color < 4 ? Math.round : 0
      };
      index = _complexStringNumExp.lastIndex;
    }
  }

  pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)

  pt.fp = funcParam;

  if (_relExp.test(end) || hasRandom) {
    pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
  }

  this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.

  return pt;
},
    _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
  _isFunction(end) && (end = end(index || 0, target, targets));
  var currentValue = target[prop],
      parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](),
      setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc,
      pt;

  if (_isString(end)) {
    if (~end.indexOf("random(")) {
      end = _replaceRandom(end);
    }

    if (end.charAt(1) === "=") {
      pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);

      if (pt || pt === 0) {
        // to avoid isNaN, like if someone passes in a value like "!= whatever"
        end = pt;
      }
    }
  }

  if (!optional || parsedStart !== end || _forceAllPropTweens) {
    if (!isNaN(parsedStart * end) && end !== "") {
      // fun fact: any number multiplied by "" is evaluated as the number 0!
      pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
      funcParam && (pt.fp = funcParam);
      modifier && pt.modifier(modifier, this, target);
      return this._pt = pt;
    }

    !currentValue && !(prop in target) && _missingPlugin(prop, end);
    return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
  }
},
    //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
  _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));

  if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) {
    return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
  }

  var copy = {},
      p;

  for (p in vars) {
    copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
  }

  return copy;
},
    _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
  var plugin, pt, ptLookup, i;

  if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
    tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);

    if (tween !== _quickTween) {
      ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.

      i = plugin._props.length;

      while (i--) {
        ptLookup[plugin._props[i]] = pt;
      }
    }
  }

  return plugin;
},
    _overwritingTween,
    //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens,
    _initTween = function _initTween(tween, time, tTime) {
  var vars = tween.vars,
      ease = vars.ease,
      startAt = vars.startAt,
      immediateRender = vars.immediateRender,
      lazy = vars.lazy,
      onUpdate = vars.onUpdate,
      runBackwards = vars.runBackwards,
      yoyoEase = vars.yoyoEase,
      keyframes = vars.keyframes,
      autoRevert = vars.autoRevert,
      dur = tween._dur,
      prevStartAt = tween._startAt,
      targets = tween._targets,
      parent = tween.parent,
      fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets,
      autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites,
      tl = tween.timeline,
      cleanVars,
      i,
      p,
      pt,
      target,
      hasPriority,
      gsData,
      harness,
      plugin,
      ptLookup,
      index,
      harnessVars,
      overwritten;
  tl && (!keyframes || !ease) && (ease = "none");
  tween._ease = _parseEase(ease, _defaults.ease);
  tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;

  if (yoyoEase && tween._yoyo && !tween._repeat) {
    //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
    yoyoEase = tween._yEase;
    tween._yEase = tween._ease;
    tween._ease = yoyoEase;
  }

  tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.

  if (!tl || keyframes && !vars.stagger) {
    //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
    harness = targets[0] ? _getCache(targets[0]).harness : 0;
    harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.

    cleanVars = _copyExcluding(vars, _reservedProps);

    if (prevStartAt) {
      prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.

      time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
      // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.

      prevStartAt._lazy = 0;
    }

    if (startAt) {
      _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
        data: "isStart",
        overwrite: false,
        parent: parent,
        immediateRender: true,
        lazy: !prevStartAt && _isNotFalse(lazy),
        startAt: null,
        delay: 0,
        onUpdate: onUpdate && function () {
          return _callback(tween, "onUpdate");
        },
        stagger: 0
      }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);


      tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.

      tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween

      time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.

      if (immediateRender) {
        if (dur && time <= 0 && tTime <= 0) {
          // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
          time && (tween._zTime = time);
          return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
        }
      }
    } else if (runBackwards && dur) {
      //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
      if (!prevStartAt) {
        time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0

        p = _setDefaults({
          overwrite: false,
          data: "isFromStart",
          //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
          lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
          immediateRender: immediateRender,
          //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
          stagger: 0,
          parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})

        }, cleanVars);
        harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})

        _removeFromParent(tween._startAt = Tween.set(targets, p));

        tween._startAt._dp = 0; // don't allow it to get put back into root timeline!

        tween._startAt._sat = tween; // used in globalTime()

        time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
        tween._zTime = time;

        if (!immediateRender) {
          _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded

        } else if (!time) {
          return;
        }
      }
    }

    tween._pt = tween._ptCache = 0;
    lazy = dur && _isNotFalse(lazy) || lazy && !dur;

    for (i = 0; i < targets.length; i++) {
      target = targets[i];
      gsData = target._gsap || _harness(targets)[i]._gsap;
      tween._ptLookup[i] = ptLookup = {};
      _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)

      index = fullTargets === targets ? i : fullTargets.indexOf(target);

      if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);

        plugin._props.forEach(function (name) {
          ptLookup[name] = pt;
        });

        plugin.priority && (hasPriority = 1);
      }

      if (!harness || harnessVars) {
        for (p in cleanVars) {
          if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) {
            plugin.priority && (hasPriority = 1);
          } else {
            ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
          }
        }
      }

      tween._op && tween._op[i] && tween.kill(target, tween._op[i]);

      if (autoOverwrite && tween._pt) {
        _overwritingTween = tween;

        _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!


        overwritten = !tween.parent;
        _overwritingTween = 0;
      }

      tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
    }

    hasPriority && _sortPropTweensByPriority(tween);
    tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
  }

  tween._onUpdate = onUpdate;
  tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.

  keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
},
    _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
  var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property],
      pt,
      rootPT,
      lookup,
      i;

  if (!ptCache) {
    ptCache = tween._ptCache[property] = [];
    lookup = tween._ptLookup;
    i = tween._targets.length;

    while (i--) {
      pt = lookup[i][property];

      if (pt && pt.d && pt.d._pt) {
        // it's a plugin, so find the nested PropTween
        pt = pt.d._pt;

        while (pt && pt.p !== property && pt.fp !== property) {
          // "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
          pt = pt._next;
        }
      }

      if (!pt) {
        // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
        // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
        _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.

        tween.vars[property] = "+=0";

        _initTween(tween, time);

        _forceAllPropTweens = 0;
        return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
      }

      ptCache.push(pt);
    }
  }

  i = ptCache.length;

  while (i--) {
    rootPT = ptCache[i];
    pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.

    pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
    pt.c = value - pt.s;
    rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)

    rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
  }
},
    _addAliasesToVars = function _addAliasesToVars(targets, vars) {
  var harness = targets[0] ? _getCache(targets[0]).harness : 0,
      propertyAliases = harness && harness.aliases,
      copy,
      p,
      i,
      aliases;

  if (!propertyAliases) {
    return vars;
  }

  copy = _merge({}, vars);

  for (p in propertyAliases) {
    if (p in copy) {
      aliases = propertyAliases[p].split(",");
      i = aliases.length;

      while (i--) {
        copy[aliases[i]] = copy[p];
      }
    }
  }

  return copy;
},
    // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
  var ease = obj.ease || easeEach || "power1.inOut",
      p,
      a;

  if (_isArray(obj)) {
    a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease

    obj.forEach(function (value, i) {
      return a.push({
        t: i / (obj.length - 1) * 100,
        v: value,
        e: ease
      });
    });
  } else {
    for (p in obj) {
      a = allProps[p] || (allProps[p] = []);
      p === "ease" || a.push({
        t: parseFloat(prop),
        v: obj[p],
        e: ease
      });
    }
  }
},
    _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
  return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
},
    _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
    _staggerPropsToSkip = {};

_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function (name) {
  return _staggerPropsToSkip[name] = 1;
});
/*
 * --------------------------------------------------------------------------------------
 * TWEEN
 * --------------------------------------------------------------------------------------
 */


var Tween = /*#__PURE__*/function (_Animation2) {
  _inheritsLoose(Tween, _Animation2);

  function Tween(targets, vars, position, skipInherit) {
    var _this3;

    if (typeof vars === "number") {
      position.duration = vars;
      vars = position;
      position = null;
    }

    _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
    var _this3$vars = _this3.vars,
        duration = _this3$vars.duration,
        delay = _this3$vars.delay,
        immediateRender = _this3$vars.immediateRender,
        stagger = _this3$vars.stagger,
        overwrite = _this3$vars.overwrite,
        keyframes = _this3$vars.keyframes,
        defaults = _this3$vars.defaults,
        scrollTrigger = _this3$vars.scrollTrigger,
        yoyoEase = _this3$vars.yoyoEase,
        parent = vars.parent || _globalTimeline,
        parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [targets] : toArray(targets),
        tl,
        i,
        copy,
        l,
        p,
        curTarget,
        staggerFunc,
        staggerVarsToMerge;
    _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
    _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property

    _this3._overwrite = overwrite;

    if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
      vars = _this3.vars;
      tl = _this3.timeline = new Timeline({
        data: "nested",
        defaults: defaults || {},
        targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
      }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.

      tl.kill();
      tl.parent = tl._dp = _assertThisInitialized(_this3);
      tl._start = 0;

      if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
        l = parsedTargets.length;
        staggerFunc = stagger && distribute(stagger);

        if (_isObject(stagger)) {
          //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
          for (p in stagger) {
            if (~_staggerTweenProps.indexOf(p)) {
              staggerVarsToMerge || (staggerVarsToMerge = {});
              staggerVarsToMerge[p] = stagger[p];
            }
          }
        }

        for (i = 0; i < l; i++) {
          copy = _copyExcluding(vars, _staggerPropsToSkip);
          copy.stagger = 0;
          yoyoEase && (copy.yoyoEase = yoyoEase);
          staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
          curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.

          copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
          copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;

          if (!stagger && l === 1 && copy.delay) {
            // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
            _this3._delay = delay = copy.delay;
            _this3._start += delay;
            copy.delay = 0;
          }

          tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
          tl._ease = _easeMap.none;
        }

        tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
      } else if (keyframes) {
        _inheritDefaults(_setDefaults(tl.vars.defaults, {
          ease: "none"
        }));

        tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
        var time = 0,
            a,
            kf,
            v;

        if (_isArray(keyframes)) {
          keyframes.forEach(function (frame) {
            return tl.to(parsedTargets, frame, ">");
          });
          tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
        } else {
          copy = {};

          for (p in keyframes) {
            p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
          }

          for (p in copy) {
            a = copy[p].sort(function (a, b) {
              return a.t - b.t;
            });
            time = 0;

            for (i = 0; i < a.length; i++) {
              kf = a[i];
              v = {
                ease: kf.e,
                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
              };
              v[p] = kf.v;
              tl.to(parsedTargets, v, time);
              time += v.duration;
            }
          }

          tl.duration() < duration && tl.to({}, {
            duration: duration - tl.duration()
          }); // in case keyframes didn't go to 100%
        }
      }

      duration || _this3.duration(duration = tl.duration());
    } else {
      _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
    }

    if (overwrite === true && !_suppressOverwrites) {
      _overwritingTween = _assertThisInitialized(_this3);

      _globalTimeline.killTweensOf(parsedTargets);

      _overwritingTween = 0;
    }

    _addToTimeline(parent, _assertThisInitialized(_this3), position);

    vars.reversed && _this3.reverse();
    vars.paused && _this3.paused(true);

    if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
      _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)

      _this3.render(Math.max(0, -delay) || 0); //in case delay is negative

    }

    scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
    return _this3;
  }

  var _proto3 = Tween.prototype;

  _proto3.render = function render(totalTime, suppressEvents, force) {
    var prevTime = this._time,
        tDur = this._tDur,
        dur = this._dur,
        isNegative = totalTime < 0,
        tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime,
        time,
        pt,
        iteration,
        cycleDuration,
        prevIteration,
        isYoyo,
        ratio,
        timeline,
        yoyoEase;

    if (!dur) {
      _renderZeroDurationTween(this, totalTime, suppressEvents, force);
    } else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
      //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
      time = tTime;
      timeline = this.timeline;

      if (this._repeat) {
        //adjust the time for repeats and yoyos
        cycleDuration = dur + this._rDelay;

        if (this._repeat < -1 && isNegative) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }

        time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)

        if (tTime === tDur) {
          // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);

          if (iteration && iteration === _roundPrecise(tTime / cycleDuration)) {
            time = dur;
            iteration--;
          }

          time > dur && (time = dur);
        }

        isYoyo = this._yoyo && iteration & 1;

        if (isYoyo) {
          yoyoEase = this._yEase;
          time = dur - time;
        }

        prevIteration = _animationCycle(this._tTime, cycleDuration);

        if (time === prevTime && !force && this._initted && iteration === prevIteration) {
          //could be during the repeatDelay part. No need to render and fire callbacks.
          this._tTime = tTime;
          return this;
        }

        if (iteration !== prevIteration) {
          timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality

          if (this.vars.repeatRefresh && !isYoyo && !this._lock && this._time !== cycleDuration && this._initted) {
            // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
            this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.

            this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
          }
        }
      }

      if (!this._initted) {
        if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
          this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.

          return this;
        }

        if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) {
          // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
          return this;
        }

        if (dur !== this._dur) {
          // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
          return this.render(totalTime, suppressEvents, force);
        }
      }

      this._tTime = tTime;
      this._time = time;

      if (!this._act && this._ts) {
        this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.

        this._lazy = 0;
      }

      this.ratio = ratio = (yoyoEase || this._ease)(time / dur);

      if (this._from) {
        this.ratio = ratio = 1 - ratio;
      }

      if (time && !prevTime && !suppressEvents && !iteration) {
        _callback(this, "onStart");

        if (this._tTime !== tTime) {
          // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
          return this;
        }
      }

      pt = this._pt;

      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }

      timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);

      if (this._onUpdate && !suppressEvents) {
        isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.

        _callback(this, "onUpdate");
      }

      this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");

      if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
        isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
        (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.

        if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
          // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
          _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);

          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }

    return this;
  };

  _proto3.targets = function targets() {
    return this._targets;
  };

  _proto3.invalidate = function invalidate(soft) {
    // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
    (!soft || !this.vars.runBackwards) && (this._startAt = 0);
    this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
    this._ptLookup = [];
    this.timeline && this.timeline.invalidate(soft);
    return _Animation2.prototype.invalidate.call(this, soft);
  };

  _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
    _tickerActive || _ticker.wake();
    this._ts || this.play();
    var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts),
        ratio;
    this._initted || _initTween(this, time);
    ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
    // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
    // if (_isObject(property)) { // performance optimization
    // 	for (p in property) {
    // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
    // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
    // 		}
    // 	}
    // } else {

    if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) {
      return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
    } //}


    _alignPlayhead(this, 0);

    this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
    return this.render(0);
  };

  _proto3.kill = function kill(targets, vars) {
    if (vars === void 0) {
      vars = "all";
    }

    if (!targets && (!vars || vars === "all")) {
      this._lazy = this._pt = 0;
      return this.parent ? _interrupt(this) : this;
    }

    if (this.timeline) {
      var tDur = this.timeline.totalDuration();
      this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.

      this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.

      return this;
    }

    var parsedTargets = this._targets,
        killingTargets = targets ? toArray(targets) : parsedTargets,
        propTweenLookup = this._ptLookup,
        firstPT = this._pt,
        overwrittenProps,
        curLookup,
        curOverwriteProps,
        props,
        p,
        pt,
        i;

    if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
      vars === "all" && (this._pt = 0);
      return _interrupt(this);
    }

    overwrittenProps = this._op = this._op || [];

    if (vars !== "all") {
      //so people can pass in a comma-delimited list of property names
      if (_isString(vars)) {
        p = {};

        _forEachName(vars, function (name) {
          return p[name] = 1;
        });

        vars = p;
      }

      vars = _addAliasesToVars(parsedTargets, vars);
    }

    i = parsedTargets.length;

    while (i--) {
      if (~killingTargets.indexOf(parsedTargets[i])) {
        curLookup = propTweenLookup[i];

        if (vars === "all") {
          overwrittenProps[i] = vars;
          props = curLookup;
          curOverwriteProps = {};
        } else {
          curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
          props = vars;
        }

        for (p in props) {
          pt = curLookup && curLookup[p];

          if (pt) {
            if (!("kill" in pt.d) || pt.d.kill(p) === true) {
              _removeLinkedListItem(this, pt, "_pt");
            }

            delete curLookup[p];
          }

          if (curOverwriteProps !== "all") {
            curOverwriteProps[p] = 1;
          }
        }
      }
    }

    this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.

    return this;
  };

  Tween.to = function to(targets, vars) {
    return new Tween(targets, vars, arguments[2]);
  };

  Tween.from = function from(targets, vars) {
    return _createTweenType(1, arguments);
  };

  Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
    return new Tween(callback, 0, {
      immediateRender: false,
      lazy: false,
      overwrite: false,
      delay: delay,
      onComplete: callback,
      onReverseComplete: callback,
      onCompleteParams: params,
      onReverseCompleteParams: params,
      callbackScope: scope
    }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
  };

  Tween.fromTo = function fromTo(targets, fromVars, toVars) {
    return _createTweenType(2, arguments);
  };

  Tween.set = function set(targets, vars) {
    vars.duration = 0;
    vars.repeatDelay || (vars.repeat = 0);
    return new Tween(targets, vars);
  };

  Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    return _globalTimeline.killTweensOf(targets, props, onlyActive);
  };

  return Tween;
}(Animation);

_setDefaults(Tween.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.


_forEachName("staggerTo,staggerFrom,staggerFromTo", function (name) {
  Tween[name] = function () {
    var tl = new Timeline(),
        params = _slice.call(arguments, 0);

    params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
    return tl[name].apply(tl, params);
  };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */


var _setterPlain = function _setterPlain(target, property, value) {
  return target[property] = value;
},
    _setterFunc = function _setterFunc(target, property, value) {
  return target[property](value);
},
    _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
  return target[property](data.fp, value);
},
    _setterAttribute = function _setterAttribute(target, property, value) {
  return target.setAttribute(property, value);
},
    _getSetter = function _getSetter(target, property) {
  return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
},
    _renderPlain = function _renderPlain(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
},
    _renderBoolean = function _renderBoolean(ratio, data) {
  return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
},
    _renderComplexString = function _renderComplexString(ratio, data) {
  var pt = data._pt,
      s = "";

  if (!ratio && data.b) {
    //b = beginning string
    s = data.b;
  } else if (ratio === 1 && data.e) {
    //e = ending string
    s = data.e;
  } else {
    while (pt) {
      s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.

      pt = pt._next;
    }

    s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
  }

  data.set(data.t, data.p, s, data);
},
    _renderPropTweens = function _renderPropTweens(ratio, data) {
  var pt = data._pt;

  while (pt) {
    pt.r(ratio, pt.d);
    pt = pt._next;
  }
},
    _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
  var pt = this._pt,
      next;

  while (pt) {
    next = pt._next;
    pt.p === property && pt.modifier(modifier, tween, target);
    pt = next;
  }
},
    _killPropTweensOf = function _killPropTweensOf(property) {
  var pt = this._pt,
      hasNonDependentRemaining,
      next;

  while (pt) {
    next = pt._next;

    if (pt.p === property && !pt.op || pt.op === property) {
      _removeLinkedListItem(this, pt, "_pt");
    } else if (!pt.dep) {
      hasNonDependentRemaining = 1;
    }

    pt = next;
  }

  return !hasNonDependentRemaining;
},
    _setterWithModifier = function _setterWithModifier(target, property, value, data) {
  data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
},
    _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
  var pt = parent._pt,
      next,
      pt2,
      first,
      last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)

  while (pt) {
    next = pt._next;
    pt2 = first;

    while (pt2 && pt2.pr > pt.pr) {
      pt2 = pt2._next;
    }

    if (pt._prev = pt2 ? pt2._prev : last) {
      pt._prev._next = pt;
    } else {
      first = pt;
    }

    if (pt._next = pt2) {
      pt2._prev = pt;
    } else {
      last = pt;
    }

    pt = next;
  }

  parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)


var PropTween = /*#__PURE__*/function () {
  function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
    this.t = target;
    this.s = start;
    this.c = change;
    this.p = prop;
    this.r = renderer || _renderPlain;
    this.d = data || this;
    this.set = setter || _setterPlain;
    this.pr = priority || 0;
    this._next = next;

    if (next) {
      next._prev = this;
    }
  }

  var _proto4 = PropTween.prototype;

  _proto4.modifier = function modifier(func, tween, target) {
    this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)

    this.set = _setterWithModifier;
    this.m = func;
    this.mt = target; //modifier target

    this.tween = tween;
  };

  return PropTween;
}(); //Initialization tasks

_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function (name) {
  return _reservedProps[name] = 1;
});

_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
  sortChildren: false,
  defaults: _defaults,
  autoRemoveChildren: true,
  id: "root",
  smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;

var _media = [],
    _listeners = {},
    _emptyArray = [],
    _lastMediaTime = 0,
    _contextID = 0,
    _dispatch = function _dispatch(type) {
  return (_listeners[type] || _emptyArray).map(function (f) {
    return f();
  });
},
    _onMediaChange = function _onMediaChange() {
  var time = Date.now(),
      matches = [];

  if (time - _lastMediaTime > 2) {
    _dispatch("matchMediaInit");

    _media.forEach(function (c) {
      var queries = c.queries,
          conditions = c.conditions,
          match,
          p,
          anyMatch,
          toggled;

      for (p in queries) {
        match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.

        match && (anyMatch = 1);

        if (match !== conditions[p]) {
          conditions[p] = match;
          toggled = 1;
        }
      }

      if (toggled) {
        c.revert();
        anyMatch && matches.push(c);
      }
    });

    _dispatch("matchMediaRevert");

    matches.forEach(function (c) {
      return c.onMatch(c, function (func) {
        return c.add(null, func);
      });
    });
    _lastMediaTime = time;

    _dispatch("matchMedia");
  }
};

var Context = /*#__PURE__*/function () {
  function Context(func, scope) {
    this.selector = scope && selector(scope);
    this.data = [];
    this._r = []; // returned/cleanup functions

    this.isReverted = false;
    this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely

    func && this.add(func);
  }

  var _proto5 = Context.prototype;

  _proto5.add = function add(name, func, scope) {
    // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
    // if (name && _isFunction(name.revert)) {
    // 	this.data.push(name);
    // 	return (name._ctx = this);
    // }
    if (_isFunction(name)) {
      scope = func;
      func = name;
      name = _isFunction;
    }

    var self = this,
        f = function f() {
      var prev = _context,
          prevSelector = self.selector,
          result;
      prev && prev !== self && prev.data.push(self);
      scope && (self.selector = selector(scope));
      _context = self;
      result = func.apply(self, arguments);
      _isFunction(result) && self._r.push(result);
      _context = prev;
      self.selector = prevSelector;
      self.isReverted = false;
      return result;
    };

    self.last = f;
    return name === _isFunction ? f(self, function (func) {
      return self.add(null, func);
    }) : name ? self[name] = f : f;
  };

  _proto5.ignore = function ignore(func) {
    var prev = _context;
    _context = null;
    func(this);
    _context = prev;
  };

  _proto5.getTweens = function getTweens() {
    var a = [];
    this.data.forEach(function (e) {
      return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
    });
    return a;
  };

  _proto5.clear = function clear() {
    this._r.length = this.data.length = 0;
  };

  _proto5.kill = function kill(revert, matchMedia) {
    var _this4 = this;

    if (revert) {
      (function () {
        var tweens = _this4.getTweens(),
            i = _this4.data.length,
            t;

        while (i--) {
          // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
          t = _this4.data[i];

          if (t.data === "isFlip") {
            t.revert();
            t.getChildren(true, true, false).forEach(function (tween) {
              return tweens.splice(tweens.indexOf(tween), 1);
            });
          }
        } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort


        tweens.map(function (t) {
          return {
            g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
            t: t
          };
        }).sort(function (a, b) {
          return b.g - a.g || -Infinity;
        }).forEach(function (o) {
          return o.t.revert(revert);
        }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.

        i = _this4.data.length;

        while (i--) {
          // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
          t = _this4.data[i];

          if (t instanceof Timeline) {
            if (t.data !== "nested") {
              t.scrollTrigger && t.scrollTrigger.revert();
              t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
            }
          } else {
            !(t instanceof Tween) && t.revert && t.revert(revert);
          }
        }

        _this4._r.forEach(function (f) {
          return f(revert, _this4);
        });

        _this4.isReverted = true;
      })();
    } else {
      this.data.forEach(function (e) {
        return e.kill && e.kill();
      });
    }

    this.clear();

    if (matchMedia) {
      var i = _media.length;

      while (i--) {
        // previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
        _media[i].id === this.id && _media.splice(i, 1);
      }
    }
  };

  _proto5.revert = function revert(config) {
    this.kill(config || {});
  };

  return Context;
}();

var MatchMedia = /*#__PURE__*/function () {
  function MatchMedia(scope) {
    this.contexts = [];
    this.scope = scope;
    _context && _context.data.push(this);
  }

  var _proto6 = MatchMedia.prototype;

  _proto6.add = function add(conditions, func, scope) {
    _isObject(conditions) || (conditions = {
      matches: conditions
    });
    var context = new Context(0, scope || this.scope),
        cond = context.conditions = {},
        mq,
        p,
        active;
    _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()

    this.contexts.push(context);
    func = context.add("onMatch", func);
    context.queries = conditions;

    for (p in conditions) {
      if (p === "all") {
        active = 1;
      } else {
        mq = _win.matchMedia(conditions[p]);

        if (mq) {
          _media.indexOf(context) < 0 && _media.push(context);
          (cond[p] = mq.matches) && (active = 1);
          mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
        }
      }
    }

    active && func(context, function (f) {
      return context.add(null, f);
    });
    return this;
  } // refresh() {
  // 	let time = _lastMediaTime,
  // 		media = _media;
  // 	_lastMediaTime = -1;
  // 	_media = this.contexts;
  // 	_onMediaChange();
  // 	_lastMediaTime = time;
  // 	_media = media;
  // }
  ;

  _proto6.revert = function revert(config) {
    this.kill(config || {});
  };

  _proto6.kill = function kill(revert) {
    this.contexts.forEach(function (c) {
      return c.kill(revert, true);
    });
  };

  return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */


var _gsap = {
  registerPlugin: function registerPlugin() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    args.forEach(function (config) {
      return _createPlugin(config);
    });
  },
  timeline: function timeline(vars) {
    return new Timeline(vars);
  },
  getTweensOf: function getTweensOf(targets, onlyActive) {
    return _globalTimeline.getTweensOf(targets, onlyActive);
  },
  getProperty: function getProperty(target, property, unit, uncache) {
    _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in

    var getter = _getCache(target || {}).get,
        format = unit ? _passThrough : _numericIfPossible;

    unit === "native" && (unit = "");
    return !target ? target : !property ? function (property, unit, uncache) {
      return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
  },
  quickSetter: function quickSetter(target, property, unit) {
    target = toArray(target);

    if (target.length > 1) {
      var setters = target.map(function (t) {
        return gsap.quickSetter(t, property, unit);
      }),
          l = setters.length;
      return function (value) {
        var i = l;

        while (i--) {
          setters[i](value);
        }
      };
    }

    target = target[0] || {};

    var Plugin = _plugins[property],
        cache = _getCache(target),
        p = cache.harness && (cache.harness.aliases || {})[property] || property,
        // in case it's an alias, like "rotate" for "rotation".
    setter = Plugin ? function (value) {
      var p = new Plugin();
      _quickTween._pt = 0;
      p.init(target, unit ? value + unit : value, _quickTween, 0, [target]);
      p.render(1, p);
      _quickTween._pt && _renderPropTweens(1, _quickTween);
    } : cache.set(target, p);

    return Plugin ? setter : function (value) {
      return setter(target, p, unit ? value + unit : value, cache, 1);
    };
  },
  quickTo: function quickTo(target, property, vars) {
    var _merge2;

    var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})),
        func = function func(value, start, startIsRelative) {
      return tween.resetTo(property, value, start, startIsRelative);
    };

    func.tween = tween;
    return func;
  },
  isTweening: function isTweening(targets) {
    return _globalTimeline.getTweensOf(targets, true).length > 0;
  },
  defaults: function defaults(value) {
    value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
    return _mergeDeep(_defaults, value || {});
  },
  config: function config(value) {
    return _mergeDeep(_config, value || {});
  },
  registerEffect: function registerEffect(_ref3) {
    var name = _ref3.name,
        effect = _ref3.effect,
        plugins = _ref3.plugins,
        defaults = _ref3.defaults,
        extendTimeline = _ref3.extendTimeline;
    (plugins || "").split(",").forEach(function (pluginName) {
      return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
    });

    _effects[name] = function (targets, vars, tl) {
      return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
    };

    if (extendTimeline) {
      Timeline.prototype[name] = function (targets, vars, position) {
        return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
      };
    }
  },
  registerEase: function registerEase(name, ease) {
    _easeMap[name] = _parseEase(ease);
  },
  parseEase: function parseEase(ease, defaultEase) {
    return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
  },
  getById: function getById(id) {
    return _globalTimeline.getById(id);
  },
  exportRoot: function exportRoot(vars, includeDelayedCalls) {
    if (vars === void 0) {
      vars = {};
    }

    var tl = new Timeline(vars),
        child,
        next;
    tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);

    _globalTimeline.remove(tl);

    tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).

    tl._time = tl._tTime = _globalTimeline._time;
    child = _globalTimeline._first;

    while (child) {
      next = child._next;

      if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) {
        _addToTimeline(tl, child, child._start - child._delay);
      }

      child = next;
    }

    _addToTimeline(_globalTimeline, tl, 0);

    return tl;
  },
  context: function context(func, scope) {
    return func ? new Context(func, scope) : _context;
  },
  matchMedia: function matchMedia(scope) {
    return new MatchMedia(scope);
  },
  matchMediaRefresh: function matchMediaRefresh() {
    return _media.forEach(function (c) {
      var cond = c.conditions,
          found,
          p;

      for (p in cond) {
        if (cond[p]) {
          cond[p] = false;
          found = 1;
        }
      }

      found && c.revert();
    }) || _onMediaChange();
  },
  addEventListener: function addEventListener(type, callback) {
    var a = _listeners[type] || (_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
  },
  removeEventListener: function removeEventListener(type, callback) {
    var a = _listeners[type],
        i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
  },
  utils: {
    wrap: wrap,
    wrapYoyo: wrapYoyo,
    distribute: distribute,
    random: random,
    snap: snap,
    normalize: normalize,
    getUnit: getUnit,
    clamp: clamp,
    splitColor: splitColor,
    toArray: toArray,
    selector: selector,
    mapRange: mapRange,
    pipe: pipe,
    unitize: unitize,
    interpolate: interpolate,
    shuffle: shuffle
  },
  install: _install,
  effects: _effects,
  ticker: _ticker,
  updateRoot: Timeline.updateRoot,
  plugins: _plugins,
  globalTimeline: _globalTimeline,
  core: {
    PropTween: PropTween,
    globals: _addGlobal,
    Tween: Tween,
    Timeline: Timeline,
    Animation: Animation,
    getCache: _getCache,
    _removeLinkedListItem: _removeLinkedListItem,
    reverting: function reverting() {
      return _reverting;
    },
    context: function context(toAdd) {
      if (toAdd && _context) {
        _context.data.push(toAdd);

        toAdd._ctx = _context;
      }

      return _context;
    },
    suppressOverwrites: function suppressOverwrites(value) {
      return _suppressOverwrites = value;
    }
  }
};

_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function (name) {
  return _gsap[name] = Tween[name];
});

_ticker.add(Timeline.updateRoot);

_quickTween = _gsap.to({}, {
  duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------

var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
  var pt = plugin._pt;

  while (pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop) {
    pt = pt._next;
  }

  return pt;
},
    _addModifiers = function _addModifiers(tween, modifiers) {
  var targets = tween._targets,
      p,
      i,
      pt;

  for (p in modifiers) {
    i = targets.length;

    while (i--) {
      pt = tween._ptLookup[i][p];

      if (pt && (pt = pt.d)) {
        if (pt._pt) {
          // is a plugin
          pt = _getPluginPropTween(pt, p);
        }

        pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
      }
    }
  }
},
    _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
  return {
    name: name,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function init(target, vars, tween) {
      tween._onInit = function (tween) {
        var temp, p;

        if (_isString(vars)) {
          temp = {};

          _forEachName(vars, function (name) {
            return temp[name] = 1;
          }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.


          vars = temp;
        }

        if (modifier) {
          temp = {};

          for (p in vars) {
            temp[p] = modifier(vars[p]);
          }

          vars = temp;
        }

        _addModifiers(tween, vars);
      };
    }
  };
}; //register core plugins


var gsap = _gsap.registerPlugin({
  name: "attr",
  init: function init(target, vars, tween, index, targets) {
    var p, pt, v;
    this.tween = tween;

    for (p in vars) {
      v = target.getAttribute(p) || "";
      pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
      pt.op = p;
      pt.b = v; // record the beginning value so we can revert()

      this._props.push(p);
    }
  },
  render: function render(ratio, data) {
    var pt = data._pt;

    while (pt) {
      _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)

      pt = pt._next;
    }
  }
}, {
  name: "endArray",
  init: function init(target, value) {
    var i = value.length;

    while (i--) {
      this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
  }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.

Tween.version = Timeline.version = gsap.version = "3.12.5";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0,
    Power1 = _easeMap.Power1,
    Power2 = _easeMap.Power2,
    Power3 = _easeMap.Power3,
    Power4 = _easeMap.Power4,
    Linear = _easeMap.Linear,
    Quad = _easeMap.Quad,
    Cubic = _easeMap.Cubic,
    Quart = _easeMap.Quart,
    Quint = _easeMap.Quint,
    Strong = _easeMap.Strong,
    Elastic = _easeMap.Elastic,
    Back = _easeMap.Back,
    SteppedEase = _easeMap.SteppedEase,
    Bounce = _easeMap.Bounce,
    Sine = _easeMap.Sine,
    Expo = _easeMap.Expo,
    Circ = _easeMap.Circ;

 //export some internal methods/orojects for use in CSSPlugin so that we can externalize that file and allow custom builds that exclude it.


;// CONCATENATED MODULE: ./node_modules/gsap/CSSPlugin.js
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/

/* eslint-disable */


var CSSPlugin_win,
    CSSPlugin_doc,
    _docElement,
    _pluginInitted,
    _tempDiv,
    _tempDivStyler,
    _recentSetterPlugin,
    CSSPlugin_reverting,
    CSSPlugin_windowExists = function _windowExists() {
  return typeof window !== "undefined";
},
    _transformProps = {},
    _RAD2DEG = 180 / Math.PI,
    _DEG2RAD = Math.PI / 180,
    _atan2 = Math.atan2,
    CSSPlugin_bigNum = 1e8,
    _capsExp = /([A-Z])/g,
    _horizontalExp = /(left|right|width|margin|padding|x)/i,
    _complexExp = /[\s,\(]\S/,
    _propertyAliases = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
},
    _renderCSSProp = function _renderCSSProp(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
},
    _renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
  return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
},
    _renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
  return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
},
    //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
  var value = data.s + data.c * ratio;
  data.set(data.t, data.p, ~~(value + (value < 0 ? -.5 : .5)) + data.u, data);
},
    _renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
  return data.set(data.t, data.p, ratio ? data.e : data.b, data);
},
    _renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
  return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
},
    _setterCSSStyle = function _setterCSSStyle(target, property, value) {
  return target.style[property] = value;
},
    _setterCSSProp = function _setterCSSProp(target, property, value) {
  return target.style.setProperty(property, value);
},
    _setterTransform = function _setterTransform(target, property, value) {
  return target._gsap[property] = value;
},
    _setterScale = function _setterScale(target, property, value) {
  return target._gsap.scaleX = target._gsap.scaleY = value;
},
    _setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache.scaleX = cache.scaleY = value;
  cache.renderTransform(ratio, cache);
},
    _setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache[property] = value;
  cache.renderTransform(ratio, cache);
},
    _transformProp = "transform",
    _transformOriginProp = _transformProp + "Origin",
    _saveStyle = function _saveStyle(property, isNotCSS) {
  var _this = this;

  var target = this.target,
      style = target.style,
      cache = target._gsap;

  if (property in _transformProps && style) {
    this.tfm = this.tfm || {};

    if (property !== "transform") {
      property = _propertyAliases[property] || property;
      ~property.indexOf(",") ? property.split(",").forEach(function (a) {
        return _this.tfm[a] = _get(target, a);
      }) : this.tfm[property] = cache.x ? cache[property] : _get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.

      property === _transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
    } else {
      return _propertyAliases.transform.split(",").forEach(function (p) {
        return _saveStyle.call(_this, p, isNotCSS);
      });
    }

    if (this.props.indexOf(_transformProp) >= 0) {
      return;
    }

    if (cache.svg) {
      this.svgo = target.getAttribute("data-svg-origin");
      this.props.push(_transformOriginProp, isNotCSS, "");
    }

    property = _transformProp;
  }

  (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
},
    _removeIndependentTransforms = function _removeIndependentTransforms(style) {
  if (style.translate) {
    style.removeProperty("translate");
    style.removeProperty("scale");
    style.removeProperty("rotate");
  }
},
    _revertStyle = function _revertStyle() {
  var props = this.props,
      target = this.target,
      style = target.style,
      cache = target._gsap,
      i,
      p;

  for (i = 0; i < props.length; i += 3) {
    // stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace(_capsExp, "-$1").toLowerCase());
  }

  if (this.tfm) {
    for (p in this.tfm) {
      cache[p] = this.tfm[p];
    }

    if (cache.svg) {
      cache.renderTransform();
      target.setAttribute("data-svg-origin", this.svgo || "");
    }

    i = CSSPlugin_reverting();

    if ((!i || !i.isStart) && !style[_transformProp]) {
      _removeIndependentTransforms(style);

      if (cache.zOrigin && style[_transformOriginProp]) {
        style[_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.

        cache.zOrigin = 0;
        cache.renderTransform();
      }

      cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
    }
  }
},
    _getStyleSaver = function _getStyleSaver(target, properties) {
  var saver = {
    target: target,
    props: [],
    revert: _revertStyle,
    save: _saveStyle
  };
  target._gsap || gsap.core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.

  properties && properties.split(",").forEach(function (p) {
    return saver.save(p);
  });
  return saver;
},
    _supports3D,
    _createElement = function _createElement(type, ns) {
  var e = CSSPlugin_doc.createElementNS ? CSSPlugin_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : CSSPlugin_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.

  return e && e.style ? e : CSSPlugin_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
},
    _getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
  var cs = getComputedStyle(target);
  return cs[property] || cs.getPropertyValue(property.replace(_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, _checkPropPrefix(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
},
    _prefixes = "O,Moz,ms,Ms,Webkit".split(","),
    _checkPropPrefix = function _checkPropPrefix(property, element, preferPrefix) {
  var e = element || _tempDiv,
      s = e.style,
      i = 5;

  if (property in s && !preferPrefix) {
    return property;
  }

  property = property.charAt(0).toUpperCase() + property.substr(1);

  while (i-- && !(_prefixes[i] + property in s)) {}

  return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? _prefixes[i] : "") + property;
},
    _initCore = function _initCore() {
  if (CSSPlugin_windowExists() && window.document) {
    CSSPlugin_win = window;
    CSSPlugin_doc = CSSPlugin_win.document;
    _docElement = CSSPlugin_doc.documentElement;
    _tempDiv = _createElement("div") || {
      style: {}
    };
    _tempDivStyler = _createElement("div");
    _transformProp = _checkPropPrefix(_transformProp);
    _transformOriginProp = _transformProp + "Origin";
    _tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.

    _supports3D = !!_checkPropPrefix("perspective");
    CSSPlugin_reverting = gsap.core.reverting;
    _pluginInitted = 1;
  }
},
    _getBBoxHack = function _getBBoxHack(swapIfPossible) {
  //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
  var svg = _createElement("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
      oldParent = this.parentNode,
      oldSibling = this.nextSibling,
      oldCSS = this.style.cssText,
      bbox;

  _docElement.appendChild(svg);

  svg.appendChild(this);
  this.style.display = "block";

  if (swapIfPossible) {
    try {
      bbox = this.getBBox();
      this._gsapBBox = this.getBBox; //store the original

      this.getBBox = _getBBoxHack;
    } catch (e) {}
  } else if (this._gsapBBox) {
    bbox = this._gsapBBox();
  }

  if (oldParent) {
    if (oldSibling) {
      oldParent.insertBefore(this, oldSibling);
    } else {
      oldParent.appendChild(this);
    }
  }

  _docElement.removeChild(svg);

  this.style.cssText = oldCSS;
  return bbox;
},
    _getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
  var i = attributesArray.length;

  while (i--) {
    if (target.hasAttribute(attributesArray[i])) {
      return target.getAttribute(attributesArray[i]);
    }
  }
},
    _getBBox = function _getBBox(target) {
  var bounds;

  try {
    bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
  } catch (error) {
    bounds = _getBBoxHack.call(target, true);
  }

  bounds && (bounds.width || bounds.height) || target.getBBox === _getBBoxHack || (bounds = _getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.

  return bounds && !bounds.width && !bounds.x && !bounds.y ? {
    x: +_getAttributeFallbacks(target, ["x", "cx", "x1"]) || 0,
    y: +_getAttributeFallbacks(target, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : bounds;
},
    _isSVG = function _isSVG(e) {
  return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
},
    //reports if the element is an SVG on which getBBox() actually works
_removeProperty = function _removeProperty(target, property) {
  if (property) {
    var style = target.style,
        first2Chars;

    if (property in _transformProps && property !== _transformOriginProp) {
      property = _transformProp;
    }

    if (style.removeProperty) {
      first2Chars = property.substr(0, 2);

      if (first2Chars === "ms" || property.substr(0, 6) === "webkit") {
        //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
        property = "-" + property;
      }

      style.removeProperty(first2Chars === "--" ? property : property.replace(_capsExp, "-$1").toLowerCase());
    } else {
      //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
      style.removeAttribute(property);
    }
  }
},
    _addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
  var pt = new PropTween(plugin._pt, target, property, 0, 1, onlySetAtEnd ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue);
  plugin._pt = pt;
  pt.b = beginning;
  pt.e = end;

  plugin._props.push(property);

  return pt;
},
    _nonConvertibleUnits = {
  deg: 1,
  rad: 1,
  turn: 1
},
    _nonStandardLayouts = {
  grid: 1,
  flex: 1
},
    //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
_convertToUnit = function _convertToUnit(target, property, value, unit) {
  var curValue = parseFloat(value) || 0,
      curUnit = (value + "").trim().substr((curValue + "").length) || "px",
      // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
  style = _tempDiv.style,
      horizontal = _horizontalExp.test(property),
      isRootSVG = target.tagName.toLowerCase() === "svg",
      measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"),
      amount = 100,
      toPixels = unit === "px",
      toPercent = unit === "%",
      px,
      parent,
      cache,
      isSVG;

  if (unit === curUnit || !curValue || _nonConvertibleUnits[unit] || _nonConvertibleUnits[curUnit]) {
    return curValue;
  }

  curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
  isSVG = target.getCTM && _isSVG(target);

  if ((toPercent || curUnit === "%") && (_transformProps[property] || ~property.indexOf("adius"))) {
    px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
    return _round(toPercent ? curValue / px * amount : curValue / 100 * px);
  }

  style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
  parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;

  if (isSVG) {
    parent = (target.ownerSVGElement || {}).parentNode;
  }

  if (!parent || parent === CSSPlugin_doc || !parent.appendChild) {
    parent = CSSPlugin_doc.body;
  }

  cache = parent._gsap;

  if (cache && toPercent && cache.width && horizontal && cache.time === _ticker.time && !cache.uncache) {
    return _round(curValue / cache.width * amount);
  } else {
    if (toPercent && (property === "height" || property === "width")) {
      // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
      var v = target.style[property];
      target.style[property] = amount + unit;
      px = target[measureProperty];
      v ? target.style[property] = v : _removeProperty(target, property);
    } else {
      (toPercent || curUnit === "%") && !_nonStandardLayouts[_getComputedProperty(parent, "display")] && (style.position = _getComputedProperty(target, "position"));
      parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.

      parent.appendChild(_tempDiv);
      px = _tempDiv[measureProperty];
      parent.removeChild(_tempDiv);
      style.position = "absolute";
    }

    if (horizontal && toPercent) {
      cache = _getCache(parent);
      cache.time = _ticker.time;
      cache.width = parent[measureProperty];
    }
  }

  return _round(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
},
    _get = function _get(target, property, unit, uncache) {
  var value;
  _pluginInitted || _initCore();

  if (property in _propertyAliases && property !== "transform") {
    property = _propertyAliases[property];

    if (~property.indexOf(",")) {
      property = property.split(",")[0];
    }
  }

  if (_transformProps[property] && property !== "transform") {
    value = _parseTransform(target, uncache);
    value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : _firstTwoOnly(_getComputedProperty(target, _transformOriginProp)) + " " + value.zOrigin + "px";
  } else {
    value = target.style[property];

    if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) {
      value = _specialProps[property] && _specialProps[property](target, property, unit) || _getComputedProperty(target, property) || _getProperty(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
  }

  return unit && !~(value + "").trim().indexOf(" ") ? _convertToUnit(target, property, value, unit) + unit : value;
},
    _tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
  // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
  if (!start || start === "none") {
    // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
    var p = _checkPropPrefix(prop, target, 1),
        s = p && _getComputedProperty(target, p, 1);

    if (s && s !== start) {
      prop = p;
      start = s;
    } else if (prop === "borderColor") {
      start = _getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
  }

  var pt = new PropTween(this._pt, target.style, prop, 0, 1, _renderComplexString),
      index = 0,
      matchIndex = 0,
      a,
      result,
      startValues,
      startNum,
      color,
      startValue,
      endValue,
      endNum,
      chunk,
      endUnit,
      startUnit,
      endValues;
  pt.b = start;
  pt.e = end;
  start += ""; // ensure values are strings

  end += "";

  if (end === "auto") {
    startValue = target.style[prop];
    target.style[prop] = end;
    end = _getComputedProperty(target, prop) || end;
    startValue ? target.style[prop] = startValue : _removeProperty(target, prop);
  }

  a = [start, end];

  _colorStringFilter(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().


  start = a[0];
  end = a[1];
  startValues = start.match(_numWithUnitExp) || [];
  endValues = end.match(_numWithUnitExp) || [];

  if (endValues.length) {
    while (result = _numWithUnitExp.exec(end)) {
      endValue = result[0];
      chunk = end.substring(index, result.index);

      if (color) {
        color = (color + 1) % 5;
      } else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") {
        color = 1;
      }

      if (endValue !== (startValue = startValues[matchIndex++] || "")) {
        startNum = parseFloat(startValue) || 0;
        startUnit = startValue.substr((startNum + "").length);
        endValue.charAt(1) === "=" && (endValue = _parseRelative(startNum, endValue) + startUnit);
        endNum = parseFloat(endValue);
        endUnit = endValue.substr((endNum + "").length);
        index = _numWithUnitExp.lastIndex - endUnit.length;

        if (!endUnit) {
          //if something like "perspective:300" is passed in and we must add a unit to the end
          endUnit = endUnit || _config.units[prop] || startUnit;

          if (index === end.length) {
            end += endUnit;
            pt.e += endUnit;
          }
        }

        if (startUnit !== endUnit) {
          startNum = _convertToUnit(target, prop, startValue, endUnit) || 0;
        } // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.


        pt._pt = {
          _next: pt._pt,
          p: chunk || matchIndex === 1 ? chunk : ",",
          //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
          s: startNum,
          c: endNum - startNum,
          m: color && color < 4 || prop === "zIndex" ? Math.round : 0
        };
      }
    }

    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
  } else {
    pt.r = prop === "display" && end === "none" ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue;
  }

  _relExp.test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).

  this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.

  return pt;
},
    _keywordToPercent = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
},
    _convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
  var split = value.split(" "),
      x = split[0],
      y = split[1] || "50%";

  if (x === "top" || x === "bottom" || y === "left" || y === "right") {
    //the user provided them in the wrong order, so flip them
    value = x;
    x = y;
    y = value;
  }

  split[0] = _keywordToPercent[x] || x;
  split[1] = _keywordToPercent[y] || y;
  return split.join(" ");
},
    _renderClearProps = function _renderClearProps(ratio, data) {
  if (data.tween && data.tween._time === data.tween._dur) {
    var target = data.t,
        style = target.style,
        props = data.u,
        cache = target._gsap,
        prop,
        clearTransforms,
        i;

    if (props === "all" || props === true) {
      style.cssText = "";
      clearTransforms = 1;
    } else {
      props = props.split(",");
      i = props.length;

      while (--i > -1) {
        prop = props[i];

        if (_transformProps[prop]) {
          clearTransforms = 1;
          prop = prop === "transformOrigin" ? _transformOriginProp : _transformProp;
        }

        _removeProperty(target, prop);
      }
    }

    if (clearTransforms) {
      _removeProperty(target, _transformProp);

      if (cache) {
        cache.svg && target.removeAttribute("transform");

        _parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.


        cache.uncache = 1;

        _removeIndependentTransforms(style);
      }
    }
  }
},
    // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
_specialProps = {
  clearProps: function clearProps(plugin, target, property, endValue, tween) {
    if (tween.data !== "isFromStart") {
      var pt = plugin._pt = new PropTween(plugin._pt, target, property, 0, 0, _renderClearProps);
      pt.u = endValue;
      pt.pr = -10;
      pt.tween = tween;

      plugin._props.push(property);

      return 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */

},

/*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */
_identity2DMatrix = [1, 0, 0, 1, 0, 0],
    _rotationalProperties = {},
    _isNullTransform = function _isNullTransform(value) {
  return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
},
    _getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
  var matrixString = _getComputedProperty(target, _transformProp);

  return _isNullTransform(matrixString) ? _identity2DMatrix : matrixString.substr(7).match(_numExp).map(_round);
},
    _getMatrix = function _getMatrix(target, force2D) {
  var cache = target._gsap || _getCache(target),
      style = target.style,
      matrix = _getComputedTransformMatrixAsArray(target),
      parent,
      nextSibling,
      temp,
      addedToDOM;

  if (cache.svg && target.getAttribute("transform")) {
    temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.

    matrix = [temp.a, temp.b, temp.c, temp.d, temp.e, temp.f];
    return matrix.join(",") === "1,0,0,1,0,0" ? _identity2DMatrix : matrix;
  } else if (matrix === _identity2DMatrix && !target.offsetParent && target !== _docElement && !cache.svg) {
    //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
    //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
    temp = style.display;
    style.display = "block";
    parent = target.parentNode;

    if (!parent || !target.offsetParent) {
      // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
      addedToDOM = 1; //flag

      nextSibling = target.nextElementSibling;

      _docElement.appendChild(target); //we must add it to the DOM in order to get values properly

    }

    matrix = _getComputedTransformMatrixAsArray(target);
    temp ? style.display = temp : _removeProperty(target, "display");

    if (addedToDOM) {
      nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : _docElement.removeChild(target);
    }
  }

  return force2D && matrix.length > 6 ? [matrix[0], matrix[1], matrix[4], matrix[5], matrix[12], matrix[13]] : matrix;
},
    _applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
  var cache = target._gsap,
      matrix = matrixArray || _getMatrix(target, true),
      xOriginOld = cache.xOrigin || 0,
      yOriginOld = cache.yOrigin || 0,
      xOffsetOld = cache.xOffset || 0,
      yOffsetOld = cache.yOffset || 0,
      a = matrix[0],
      b = matrix[1],
      c = matrix[2],
      d = matrix[3],
      tx = matrix[4],
      ty = matrix[5],
      originSplit = origin.split(" "),
      xOrigin = parseFloat(originSplit[0]) || 0,
      yOrigin = parseFloat(originSplit[1]) || 0,
      bounds,
      determinant,
      x,
      y;

  if (!originIsAbsolute) {
    bounds = _getBBox(target);
    xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
    yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
  } else if (matrix !== _identity2DMatrix && (determinant = a * d - b * c)) {
    //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
    x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
    y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
    xOrigin = x;
    yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
  }

  if (smooth || smooth !== false && cache.smooth) {
    tx = xOrigin - xOriginOld;
    ty = yOrigin - yOriginOld;
    cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
    cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
  } else {
    cache.xOffset = cache.yOffset = 0;
  }

  cache.xOrigin = xOrigin;
  cache.yOrigin = yOrigin;
  cache.smooth = !!smooth;
  cache.origin = origin;
  cache.originIsAbsolute = !!originIsAbsolute;
  target.style[_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).

  if (pluginToAddPropTweensTo) {
    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
  }

  target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
},
    _parseTransform = function _parseTransform(target, uncache) {
  var cache = target._gsap || new GSCache(target);

  if ("x" in cache && !uncache && !cache.uncache) {
    return cache;
  }

  var style = target.style,
      invertedScaleX = cache.scaleX < 0,
      px = "px",
      deg = "deg",
      cs = getComputedStyle(target),
      origin = _getComputedProperty(target, _transformOriginProp) || "0",
      x,
      y,
      z,
      scaleX,
      scaleY,
      rotation,
      rotationX,
      rotationY,
      skewX,
      skewY,
      perspective,
      xOrigin,
      yOrigin,
      matrix,
      angle,
      cos,
      sin,
      a,
      b,
      c,
      d,
      a12,
      a22,
      t1,
      t2,
      t3,
      a13,
      a23,
      a33,
      a42,
      a43,
      a32;
  x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
  scaleX = scaleY = 1;
  cache.svg = !!(target.getCTM && _isSVG(target));

  if (cs.translate) {
    // accommodate independent transforms by combining them into normal ones.
    if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") {
      style[_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[_transformProp] !== "none" ? cs[_transformProp] : "");
    }

    style.scale = style.rotate = style.translate = "none";
  }

  matrix = _getMatrix(target, cache.svg);

  if (cache.svg) {
    if (cache.uncache) {
      // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
      t2 = target.getBBox();
      origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
      t1 = "";
    } else {
      t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
    }

    _applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
  }

  xOrigin = cache.xOrigin || 0;
  yOrigin = cache.yOrigin || 0;

  if (matrix !== _identity2DMatrix) {
    a = matrix[0]; //a11

    b = matrix[1]; //a21

    c = matrix[2]; //a31

    d = matrix[3]; //a41

    x = a12 = matrix[4];
    y = a22 = matrix[5]; //2D matrix

    if (matrix.length === 6) {
      scaleX = Math.sqrt(a * a + b * b);
      scaleY = Math.sqrt(d * d + c * c);
      rotation = a || b ? _atan2(b, a) * _RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).

      skewX = c || d ? _atan2(c, d) * _RAD2DEG + rotation : 0;
      skewX && (scaleY *= Math.abs(Math.cos(skewX * _DEG2RAD)));

      if (cache.svg) {
        x -= xOrigin - (xOrigin * a + yOrigin * c);
        y -= yOrigin - (xOrigin * b + yOrigin * d);
      } //3D matrix

    } else {
      a32 = matrix[6];
      a42 = matrix[7];
      a13 = matrix[8];
      a23 = matrix[9];
      a33 = matrix[10];
      a43 = matrix[11];
      x = matrix[12];
      y = matrix[13];
      z = matrix[14];
      angle = _atan2(a32, a33);
      rotationX = angle * _RAD2DEG; //rotationX

      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a12 * cos + a13 * sin;
        t2 = a22 * cos + a23 * sin;
        t3 = a32 * cos + a33 * sin;
        a13 = a12 * -sin + a13 * cos;
        a23 = a22 * -sin + a23 * cos;
        a33 = a32 * -sin + a33 * cos;
        a43 = a42 * -sin + a43 * cos;
        a12 = t1;
        a22 = t2;
        a32 = t3;
      } //rotationY


      angle = _atan2(-c, a33);
      rotationY = angle * _RAD2DEG;

      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a * cos - a13 * sin;
        t2 = b * cos - a23 * sin;
        t3 = c * cos - a33 * sin;
        a43 = d * sin + a43 * cos;
        a = t1;
        b = t2;
        c = t3;
      } //rotationZ


      angle = _atan2(b, a);
      rotation = angle * _RAD2DEG;

      if (angle) {
        cos = Math.cos(angle);
        sin = Math.sin(angle);
        t1 = a * cos + b * sin;
        t2 = a12 * cos + a22 * sin;
        b = b * cos - a * sin;
        a22 = a22 * cos - a12 * sin;
        a = t1;
        a12 = t2;
      }

      if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
        //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
        rotationX = rotation = 0;
        rotationY = 180 - rotationY;
      }

      scaleX = _round(Math.sqrt(a * a + b * b + c * c));
      scaleY = _round(Math.sqrt(a22 * a22 + a32 * a32));
      angle = _atan2(a12, a22);
      skewX = Math.abs(angle) > 0.0002 ? angle * _RAD2DEG : 0;
      perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
    }

    if (cache.svg) {
      //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
      t1 = target.getAttribute("transform");
      cache.forceCSS = target.setAttribute("transform", "") || !_isNullTransform(_getComputedProperty(target, _transformProp));
      t1 && target.setAttribute("transform", t1);
    }
  }

  if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
    if (invertedScaleX) {
      scaleX *= -1;
      skewX += rotation <= 0 ? 180 : -180;
      rotation += rotation <= 0 ? 180 : -180;
    } else {
      scaleY *= -1;
      skewX += skewX <= 0 ? 180 : -180;
    }
  }

  uncache = uncache || cache.uncache;
  cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
  cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
  cache.z = z + px;
  cache.scaleX = _round(scaleX);
  cache.scaleY = _round(scaleY);
  cache.rotation = _round(rotation) + deg;
  cache.rotationX = _round(rotationX) + deg;
  cache.rotationY = _round(rotationY) + deg;
  cache.skewX = skewX + deg;
  cache.skewY = skewY + deg;
  cache.transformPerspective = perspective + px;

  if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) {
    style[_transformOriginProp] = _firstTwoOnly(origin);
  }

  cache.xOffset = cache.yOffset = 0;
  cache.force3D = _config.force3D;
  cache.renderTransform = cache.svg ? _renderSVGTransforms : _supports3D ? _renderCSSTransforms : _renderNon3DTransforms;
  cache.uncache = 0;
  return cache;
},
    _firstTwoOnly = function _firstTwoOnly(value) {
  return (value = value.split(" "))[0] + " " + value[1];
},
    //for handling transformOrigin values, stripping out the 3rd dimension
_addPxTranslate = function _addPxTranslate(target, start, value) {
  var unit = getUnit(start);
  return _round(parseFloat(start) + parseFloat(_convertToUnit(target, "x", value + "px", unit))) + unit;
},
    _renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
  cache.z = "0px";
  cache.rotationY = cache.rotationX = "0deg";
  cache.force3D = 0;

  _renderCSSTransforms(ratio, cache);
},
    _zeroDeg = "0deg",
    _zeroPx = "0px",
    _endParenthesis = ") ",
    _renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
  var _ref = cache || this,
      xPercent = _ref.xPercent,
      yPercent = _ref.yPercent,
      x = _ref.x,
      y = _ref.y,
      z = _ref.z,
      rotation = _ref.rotation,
      rotationY = _ref.rotationY,
      rotationX = _ref.rotationX,
      skewX = _ref.skewX,
      skewY = _ref.skewY,
      scaleX = _ref.scaleX,
      scaleY = _ref.scaleY,
      transformPerspective = _ref.transformPerspective,
      force3D = _ref.force3D,
      target = _ref.target,
      zOrigin = _ref.zOrigin,
      transforms = "",
      use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)


  if (zOrigin && (rotationX !== _zeroDeg || rotationY !== _zeroDeg)) {
    var angle = parseFloat(rotationY) * _DEG2RAD,
        a13 = Math.sin(angle),
        a33 = Math.cos(angle),
        cos;

    angle = parseFloat(rotationX) * _DEG2RAD;
    cos = Math.cos(angle);
    x = _addPxTranslate(target, x, a13 * cos * -zOrigin);
    y = _addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
    z = _addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
  }

  if (transformPerspective !== _zeroPx) {
    transforms += "perspective(" + transformPerspective + _endParenthesis;
  }

  if (xPercent || yPercent) {
    transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
  }

  if (use3D || x !== _zeroPx || y !== _zeroPx || z !== _zeroPx) {
    transforms += z !== _zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + _endParenthesis;
  }

  if (rotation !== _zeroDeg) {
    transforms += "rotate(" + rotation + _endParenthesis;
  }

  if (rotationY !== _zeroDeg) {
    transforms += "rotateY(" + rotationY + _endParenthesis;
  }

  if (rotationX !== _zeroDeg) {
    transforms += "rotateX(" + rotationX + _endParenthesis;
  }

  if (skewX !== _zeroDeg || skewY !== _zeroDeg) {
    transforms += "skew(" + skewX + ", " + skewY + _endParenthesis;
  }

  if (scaleX !== 1 || scaleY !== 1) {
    transforms += "scale(" + scaleX + ", " + scaleY + _endParenthesis;
  }

  target.style[_transformProp] = transforms || "translate(0, 0)";
},
    _renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
  var _ref2 = cache || this,
      xPercent = _ref2.xPercent,
      yPercent = _ref2.yPercent,
      x = _ref2.x,
      y = _ref2.y,
      rotation = _ref2.rotation,
      skewX = _ref2.skewX,
      skewY = _ref2.skewY,
      scaleX = _ref2.scaleX,
      scaleY = _ref2.scaleY,
      target = _ref2.target,
      xOrigin = _ref2.xOrigin,
      yOrigin = _ref2.yOrigin,
      xOffset = _ref2.xOffset,
      yOffset = _ref2.yOffset,
      forceCSS = _ref2.forceCSS,
      tx = parseFloat(x),
      ty = parseFloat(y),
      a11,
      a21,
      a12,
      a22,
      temp;

  rotation = parseFloat(rotation);
  skewX = parseFloat(skewX);
  skewY = parseFloat(skewY);

  if (skewY) {
    //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
    skewY = parseFloat(skewY);
    skewX += skewY;
    rotation += skewY;
  }

  if (rotation || skewX) {
    rotation *= _DEG2RAD;
    skewX *= _DEG2RAD;
    a11 = Math.cos(rotation) * scaleX;
    a21 = Math.sin(rotation) * scaleX;
    a12 = Math.sin(rotation - skewX) * -scaleY;
    a22 = Math.cos(rotation - skewX) * scaleY;

    if (skewX) {
      skewY *= _DEG2RAD;
      temp = Math.tan(skewX - skewY);
      temp = Math.sqrt(1 + temp * temp);
      a12 *= temp;
      a22 *= temp;

      if (skewY) {
        temp = Math.tan(skewY);
        temp = Math.sqrt(1 + temp * temp);
        a11 *= temp;
        a21 *= temp;
      }
    }

    a11 = _round(a11);
    a21 = _round(a21);
    a12 = _round(a12);
    a22 = _round(a22);
  } else {
    a11 = scaleX;
    a22 = scaleY;
    a21 = a12 = 0;
  }

  if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
    tx = _convertToUnit(target, "x", x, "px");
    ty = _convertToUnit(target, "y", y, "px");
  }

  if (xOrigin || yOrigin || xOffset || yOffset) {
    tx = _round(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
    ty = _round(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
  }

  if (xPercent || yPercent) {
    //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
    temp = target.getBBox();
    tx = _round(tx + xPercent / 100 * temp.width);
    ty = _round(ty + yPercent / 100 * temp.height);
  }

  temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
  target.setAttribute("transform", temp);
  forceCSS && (target.style[_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
},
    _addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
  var cap = 360,
      isString = _isString(endValue),
      endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? _RAD2DEG : 1),
      change = endNum - startNum,
      finalValue = startNum + change + "deg",
      direction,
      pt;

  if (isString) {
    direction = endValue.split("_")[1];

    if (direction === "short") {
      change %= cap;

      if (change !== change % (cap / 2)) {
        change += change < 0 ? cap : -cap;
      }
    }

    if (direction === "cw" && change < 0) {
      change = (change + cap * CSSPlugin_bigNum) % cap - ~~(change / cap) * cap;
    } else if (direction === "ccw" && change > 0) {
      change = (change - cap * CSSPlugin_bigNum) % cap - ~~(change / cap) * cap;
    }
  }

  plugin._pt = pt = new PropTween(plugin._pt, target, property, startNum, change, _renderPropWithEnd);
  pt.e = finalValue;
  pt.u = "deg";

  plugin._props.push(property);

  return pt;
},
    _assign = function _assign(target, source) {
  // Internet Explorer doesn't have Object.assign(), so we recreate it here.
  for (var p in source) {
    target[p] = source[p];
  }

  return target;
},
    _addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
  //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
  var startCache = _assign({}, target._gsap),
      exclude = "perspective,force3D,transformOrigin,svgOrigin",
      style = target.style,
      endCache,
      p,
      startValue,
      endValue,
      startNum,
      endNum,
      startUnit,
      endUnit;

  if (startCache.svg) {
    startValue = target.getAttribute("transform");
    target.setAttribute("transform", "");
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);

    _removeProperty(target, _transformProp);

    target.setAttribute("transform", startValue);
  } else {
    startValue = getComputedStyle(target)[_transformProp];
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);
    style[_transformProp] = startValue;
  }

  for (p in _transformProps) {
    startValue = startCache[p];
    endValue = endCache[p];

    if (startValue !== endValue && exclude.indexOf(p) < 0) {
      //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
      startUnit = getUnit(startValue);
      endUnit = getUnit(endValue);
      startNum = startUnit !== endUnit ? _convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
      endNum = parseFloat(endValue);
      plugin._pt = new PropTween(plugin._pt, endCache, p, startNum, endNum - startNum, _renderCSSProp);
      plugin._pt.u = endUnit || 0;

      plugin._props.push(p);
    }
  }

  _assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.


_forEachName("padding,margin,Width,Radius", function (name, index) {
  var t = "Top",
      r = "Right",
      b = "Bottom",
      l = "Left",
      props = (index < 3 ? [t, r, b, l] : [t + l, t + r, b + r, b + l]).map(function (side) {
    return index < 2 ? name + side : "border" + side + name;
  });

  _specialProps[index > 1 ? "border" + name : name] = function (plugin, target, property, endValue, tween) {
    var a, vars;

    if (arguments.length < 4) {
      // getter, passed target, property, and unit (from _get())
      a = props.map(function (prop) {
        return _get(plugin, prop, property);
      });
      vars = a.join(" ");
      return vars.split(a[0]).length === 5 ? a[0] : vars;
    }

    a = (endValue + "").split(" ");
    vars = {};
    props.forEach(function (prop, i) {
      return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
    });
    plugin.init(target, vars, tween);
  };
});

var CSSPlugin = {
  name: "css",
  register: _initCore,
  targetTest: function targetTest(target) {
    return target.style && target.nodeType;
  },
  init: function init(target, vars, tween, index, targets) {
    var props = this._props,
        style = target.style,
        startAt = tween.vars.startAt,
        startValue,
        endValue,
        endNum,
        startNum,
        type,
        specialProp,
        p,
        startUnit,
        endUnit,
        relative,
        isTransformRelated,
        transformPropTween,
        cache,
        smooth,
        hasPriority,
        inlineProps;
    _pluginInitted || _initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps

    this.styles = this.styles || _getStyleSaver(target);
    inlineProps = this.styles.props;
    this.tween = tween;

    for (p in vars) {
      if (p === "autoRound") {
        continue;
      }

      endValue = vars[p];

      if (_plugins[p] && _checkPlugin(p, vars, tween, index, target, targets)) {
        // plugins
        continue;
      }

      type = typeof endValue;
      specialProp = _specialProps[p];

      if (type === "function") {
        endValue = endValue.call(tween, index, target, targets);
        type = typeof endValue;
      }

      if (type === "string" && ~endValue.indexOf("random(")) {
        endValue = _replaceRandom(endValue);
      }

      if (specialProp) {
        specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
      } else if (p.substr(0, 2) === "--") {
        //CSS variable
        startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
        endValue += "";
        _colorExp.lastIndex = 0;

        if (!_colorExp.test(startValue)) {
          // colors don't have units
          startUnit = getUnit(startValue);
          endUnit = getUnit(endValue);
        }

        endUnit ? startUnit !== endUnit && (startValue = _convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
        this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
        props.push(p);
        inlineProps.push(p, 0, style[p]);
      } else if (type !== "undefined") {
        if (startAt && p in startAt) {
          // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
          startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
          _isString(startValue) && ~startValue.indexOf("random(") && (startValue = _replaceRandom(startValue));
          getUnit(startValue + "") || startValue === "auto" || (startValue += _config.units[p] || getUnit(_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.

          (startValue + "").charAt(1) === "=" && (startValue = _get(target, p)); // can't work with relative values
        } else {
          startValue = _get(target, p);
        }

        startNum = parseFloat(startValue);
        relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
        relative && (endValue = endValue.substr(2));
        endNum = parseFloat(endValue);

        if (p in _propertyAliases) {
          if (p === "autoAlpha") {
            //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
            if (startNum === 1 && _get(target, "visibility") === "hidden" && endNum) {
              //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
              startNum = 0;
            }

            inlineProps.push("visibility", 0, style.visibility);

            _addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
          }

          if (p !== "scale" && p !== "transform") {
            p = _propertyAliases[p];
            ~p.indexOf(",") && (p = p.split(",")[0]);
          }
        }

        isTransformRelated = p in _transformProps; //--- TRANSFORM-RELATED ---

        if (isTransformRelated) {
          this.styles.save(p);

          if (!transformPropTween) {
            cache = target._gsap;
            cache.renderTransform && !vars.parseTransform || _parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.

            smooth = vars.smoothOrigin !== false && cache.smooth;
            transformPropTween = this._pt = new PropTween(this._pt, style, _transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)

            transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
          }

          if (p === "scale") {
            this._pt = new PropTween(this._pt, cache, "scaleY", cache.scaleY, (relative ? _parseRelative(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, _renderCSSProp);
            this._pt.u = 0;
            props.push("scaleY", p);
            p += "X";
          } else if (p === "transformOrigin") {
            inlineProps.push(_transformOriginProp, 0, style[_transformOriginProp]);
            endValue = _convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.

            if (cache.svg) {
              _applySVGOrigin(target, endValue, 0, smooth, 0, this);
            } else {
              endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!

              endUnit !== cache.zOrigin && _addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);

              _addNonTweeningPT(this, style, p, _firstTwoOnly(startValue), _firstTwoOnly(endValue));
            }

            continue;
          } else if (p === "svgOrigin") {
            _applySVGOrigin(target, endValue, 1, smooth, 0, this);

            continue;
          } else if (p in _rotationalProperties) {
            _addRotationalPropTween(this, cache, p, startNum, relative ? _parseRelative(startNum, relative + endValue) : endValue);

            continue;
          } else if (p === "smoothOrigin") {
            _addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);

            continue;
          } else if (p === "force3D") {
            cache[p] = endValue;
            continue;
          } else if (p === "transform") {
            _addRawTransformPTs(this, endValue, target);

            continue;
          }
        } else if (!(p in style)) {
          p = _checkPropPrefix(p) || p;
        }

        if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !_complexExp.test(endValue) && p in style) {
          startUnit = (startValue + "").substr((startNum + "").length);
          endNum || (endNum = 0); // protect against NaN

          endUnit = getUnit(endValue) || (p in _config.units ? _config.units[p] : startUnit);
          startUnit !== endUnit && (startNum = _convertToUnit(target, p, startValue, endUnit));
          this._pt = new PropTween(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? _parseRelative(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? _renderRoundedCSSProp : _renderCSSProp);
          this._pt.u = endUnit || 0;

          if (startUnit !== endUnit && endUnit !== "%") {
            //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
            this._pt.b = startValue;
            this._pt.r = _renderCSSPropWithBeginning;
          }
        } else if (!(p in style)) {
          if (p in target) {
            //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
            this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
          } else if (p !== "parseTransform") {
            _missingPlugin(p, endValue);

            continue;
          }
        } else {
          _tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
        }

        isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
        props.push(p);
      }
    }

    hasPriority && _sortPropTweensByPriority(this);
  },
  render: function render(ratio, data) {
    if (data.tween._time || !CSSPlugin_reverting()) {
      var pt = data._pt;

      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }
    } else {
      data.styles.revert();
    }
  },
  get: _get,
  aliases: _propertyAliases,
  getSetter: function getSetter(target, property, plugin) {
    //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
    var p = _propertyAliases[property];
    p && p.indexOf(",") < 0 && (property = p);
    return property in _transformProps && property !== _transformOriginProp && (target._gsap.x || _get(target, "x")) ? plugin && _recentSetterPlugin === plugin ? property === "scale" ? _setterScale : _setterTransform : (_recentSetterPlugin = plugin || {}) && (property === "scale" ? _setterScaleWithRender : _setterTransformWithRender) : target.style && !_isUndefined(target.style[property]) ? _setterCSSStyle : ~property.indexOf("-") ? _setterCSSProp : _getSetter(target, property);
  },
  core: {
    _removeProperty: _removeProperty,
    _getMatrix: _getMatrix
  }
};
gsap.utils.checkPrefix = _checkPropPrefix;
gsap.core.getStyleSaver = _getStyleSaver;

(function (positionAndScale, rotation, others, aliases) {
  var all = _forEachName(positionAndScale + "," + rotation + "," + others, function (name) {
    _transformProps[name] = 1;
  });

  _forEachName(rotation, function (name) {
    _config.units[name] = "deg";
    _rotationalProperties[name] = 1;
  });

  _propertyAliases[all[13]] = positionAndScale + "," + rotation;

  _forEachName(aliases, function (name) {
    var split = name.split(":");
    _propertyAliases[split[1]] = all[split[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");

_forEachName("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (name) {
  _config.units[name] = "px";
});

gsap.registerPlugin(CSSPlugin);

;// CONCATENATED MODULE: ./node_modules/gsap/index.js


var gsapWithCSS = gsap.registerPlugin(CSSPlugin) || gsap,
    // to protect from tree shaking
TweenMaxWithCSS = gsapWithCSS.core.Tween;

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProductsFeed.vue?vue&type=script&lang=js






const isStringAndHasContent = (v) => typeof v == 'string' && v.length > 0

// NOTE: Keep this value synced with `.products-feed--fakebar` bottom value!
const fakeScrollbarOffsetBottom = 9

/* harmony default export */ var ProductsFeedvue_type_script_lang_js = ({
  name: 'ProductsFeed',
  components: { ProductFeed: ProductFeed },
  mixins: [ Translator ],
  props: {
    name: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    currency: {
      type: String,
      required: false,
      default: 'huf'
    },
    payment: {
      type: [Object, null],
      required: false,
      default: null
    },
    closable: {
      type: Boolean,
      required: false,
      default: true
    },
    counterLabelSingular: {
      type: String,
      required: false,
      default: null,
    },
    counterLabelPlural: {
      type: String,
      required: false,
      default: null,
    },
    buttonColor: {
      type: String,
      required: false,
      default: () => null,
    },
    textColor: {
      type: String,
      required: false,
      default: () => null,
    },
    fakeScrollbar: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isOpened: true,
      playbackPosition: 0,
      delayedItems: [],
      observedNodes: [],
      // firstItemTimerStyle: null,
      fakeScrollbarCanVisible: true,
      productsFrameResizeObserver: null,
    }
  },
  computed: {
    processedItems() {
      let items = [ ...this.items ];
      items = items.filter(item => typeof item.show_in_feed === 'undefined' || item.show_in_feed);
      items.sort((a, b) => a.ordno - b.ordno);

      return items.sort((a, b) => {
        let key = 0;
        for (let item of [a, b]) {
          if (
            item.first_from_in_sec !== null
            && item.first_from_in_sec <= this.playbackPosition
            && (item.first_to_in_sec === null || item.first_to_in_sec >= this.playbackPosition)
          ) {
            return key === 0 ? -1 : 1;
          }

          ++key;
        }

        return 0;
      });
    },
    customCounterLabel() {
      if (
        !isStringAndHasContent(this.counterLabelSingular)
        || !isStringAndHasContent(this.counterLabelPlural)
      ) {
        return false
      }

      return this.items.length > 1
        ? `${this.items.length} ${this.counterLabelPlural}`
        : `${this.items.length} ${this.counterLabelSingular}`
    },
    hasFirstItemTimer() {
      if (this.processedItems.length === 0) {
        return false;
      }

      const firstItem = this.processedItems[0];

      return firstItem.first_from_in_sec !== null && firstItem.first_to_in_sec !== null
        && firstItem.first_from_in_sec <= this.playbackPosition
        && firstItem.first_to_in_sec >= this.playbackPosition;
    },
    firstItemTimerStyle() {
      if (!this.hasFirstItemTimer) {
        return null;
      }

      const firstItem = this.processedItems[0];
      const width = 100 - (this.playbackPosition - firstItem.first_from_in_sec) / (firstItem.first_to_in_sec - firstItem.first_from_in_sec) * 100;

      return { 'width': width + '%', 'background-color': this.buttonColor };
    }
  },
  watch: {
    processedItems: {
      immediate: true,
      handler(val, oldVal) {
        if (!this.$refs.product) {
          this.delayedItems = val;
          this.$nextTick(() => this.initArcheo());
          return;
        }

        if (
          Array.isArray(val)
          && Array.isArray(oldVal)
          && val.length === oldVal.length
          && JSON.stringify(val) === JSON.stringify(oldVal)
        ) {
          return;
        }

        const boxes = this.$refs.product.map(i => i.$el).map(node => {
          return {
            node,
            x: node.offsetLeft,
            y: node.offsetTop,
          };
        })

        this.delayedItems = val;

        this.$nextTick(() => {
          this.initArcheo();

          // Animation.
          boxes.forEach(box => {
            if (box.x === box.node.offsetLeft && box.y === box.node.offsetTop) {
              return;
            }

            const x = box.x - box.node.offsetLeft;
            const y = box.y - box.node.offsetTop;

            gsapWithCSS.fromTo(box.node, { x, y }, { x: 0, y: 0, ease: 'power4.out' });
          });
        });
      },
    },
    fakeScrollbar(newVal) {
      this.handleFakeScrollbarStateChange(newVal)
    }
  },
  created() {
    this.$root.$bus.$on(Events.PLAYBACK_POSITION, (val) => {
      this.playbackPosition = val;
    });
  },
  mounted() {
    if (this.fakeScrollbar) {
      this.handleFakeScrollbarStateChange(true)
    }
  },
  methods: {
    // eventOnToggle() {
    //   if (!this.closable) {
    //     return
    //   }

    //   this.isOpened = !this.isOpened
    //   this.$emit('isOpened', this.isOpened)
    //   this.$root.$bus.$emit('streamview.products.toggle.status', this.isOpened)
    // },
    initArcheo() {
      const options = {
        root: this.$refs.productsFrame,
        threshold: 0.5
      };
      this.$refs.product.forEach(element => {
        if (this.observedNodes.includes(element.$el)) {
          return;
        }

        const observer = new IntersectionObserver((entries) => this.visibilityChanged(entries[0], element.product), options);
        observer.observe(element.$el);
        this.observedNodes.push(element.$el)
      });
    },
    visibilityChanged(entry, product) {
      if (entry.isIntersecting) {
        this.$root.$bus.$emit('aq', ['visibleItem', product.id.toString()]);
      }
    },
    handleFakeScrollbarStateChange(isEnabled) {
      if (isEnabled) {
        this.$refs.productsFrame.addEventListener('scroll', this.onScrollFakebar)
        this.productsFrameResizeObserver = new ResizeObserver(this.onResizeFakebar).observe(this.$refs.productsFrame)
        this.sizeToFitFakebar()
      } else {
        this.$refs.productsFrame.removeEventListener('scroll', this.onScrollFakebar)
        this.productsFrameResizeObserver.unobserve(this.$refs.productsFrame)
        this.productsFrameResizeObserver.disconnect()
      }
    },
    onScrollFakebar() {
      const ratio = this.$refs.productsFrame.scrollTop / this.$refs.productsFrame.scrollHeight
      const newVal = (this.$refs.productsFrame.offsetHeight - fakeScrollbarOffsetBottom) * ratio
      this.$refs.fakebarinner.style.top = `${newVal}px`
    },
    sizeToFitFakebar() {
      const ratio = this.$refs.productsFrame.offsetHeight / this.$refs.productsFrame.scrollHeight
      const newHeight = (this.$refs.productsFrame.offsetHeight - fakeScrollbarOffsetBottom) * ratio
      this.$refs.fakebarinner.style.height = `${newHeight}px`
    },
    onResizeFakebar() {
      this.$nextTick(() => {
        if (this.$refs.productsFrame && (this.$refs.productsFrame instanceof HTMLElement)) {
          this.fakeScrollbarCanVisible = this.$refs.productsFrame.scrollHeight > this.$refs.productsFrame.offsetHeight
          this.sizeToFitFakebar()
        } else {
          this.fakeScrollbarCanVisible = false
        }
      })
    }
  }
});

;// CONCATENATED MODULE: ./src/components/ProductsFeed.vue?vue&type=script&lang=js
 /* harmony default export */ var components_ProductsFeedvue_type_script_lang_js = (ProductsFeedvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/ProductsFeed.vue





/* normalize component */
;
var ProductsFeed_component = normalizeComponent(
  components_ProductsFeedvue_type_script_lang_js,
  ProductsFeedvue_type_template_id_8cefe366_render,
  ProductsFeedvue_type_template_id_8cefe366_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductsFeed = (ProductsFeed_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SubscriptionForm.vue?vue&type=template&id=6756a63c
var SubscriptionFormvue_type_template_id_6756a63c_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.wrapperClasses},[_c('div',{staticClass:"s1ead"},[_vm._v(_vm._s(_vm.label ?? _vm.tr('Subscription')))]),_c('div',{staticClass:"s4605"},[(!_vm.isSubscribedSuccessfully && !_vm.isAlreadySubscribed)?_c('div',{staticClass:"s39f3"},[(typeof _vm.form.name === 'string' && _vm.form.name.length > 0)?_c('div',{staticClass:"s0428"},[_vm._v(" "+_vm._s(_vm.form.name)+" ")]):_vm._e(),(_vm.form.name_enabled)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],ref:"nameInput",attrs:{"placeholder":_vm.namePlaceholder,"type":"text","size":"64"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing)return;_vm.name=$event.target.value}}}):_vm._e(),(_vm.nameInputError)?_c('p',{staticClass:"sc2a2"},[_vm._v(_vm._s(_vm.tr('Name field is required.')))]):_vm._e(),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"emailInput",attrs:{"placeholder":_vm.emailPlaceholder,"type":"email","size":"64"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing)return;_vm.email=$event.target.value}}}),(_vm.emailInputError)?_c('p',{staticClass:"sc2a2"},[_vm._v(_vm._s(_vm.tr('Email address field is required.')))]):_vm._e(),(_vm.form.phone_enabled)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],ref:"nameInput",attrs:{"placeholder":_vm.phonePlaceholder,"type":"text","size":"64"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing)return;_vm.phone=$event.target.value}}}):_vm._e(),(_vm.phoneInputError)?_c('p',{staticClass:"sc2a2"},[_vm._v(_vm._s(_vm.tr('Phone number field is required.')))]):_vm._e(),(typeof _vm.form.description === 'string' && _vm.form.description.length > 0)?_c('p',{staticClass:"s59c6"},[_vm._v(" "+_vm._s(_vm.form.description.trim())+" ")]):_vm._e(),_c('div',{staticClass:"sa6a2"}),_c('div',{staticClass:"s2d11"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.acceptPrivacy),expression:"acceptPrivacy"}],ref:"acceptInput",style:(_vm.inputStyles),attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.acceptPrivacy)?_vm._i(_vm.acceptPrivacy,null)>-1:(_vm.acceptPrivacy)},on:{"change":function($event){var $$a=_vm.acceptPrivacy,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.acceptPrivacy=$$a.concat([$$v]))}else{$$i>-1&&(_vm.acceptPrivacy=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.acceptPrivacy=$$c}}}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.acceptPrivacyLabel)}})])]),(_vm.acceptPrivacyError)?_c('p',{staticClass:"sc2a2"},[_vm._v(_vm._s(_vm.tr('Please confirm that you have read and understood the Privacy Policy.')))]):_vm._e(),_c('button',{class:{'sce50': true, 'disabled': _vm.isLoading},style:({ 'background-color': _vm.buttonColor }),on:{"click":function($event){return _vm.doSubscribe()}}},[(_vm.isLoading)?[_c('i',{staticClass:"sbaec s4a52"})]:[_vm._v(_vm._s(_vm.buttonLabel))]],2)]):(_vm.isSubscribedSuccessfully)?_c('div',{staticClass:"sdd4a"},[_vm._m(0),_c('p',{staticClass:"s9153"},[_vm._v(_vm._s(_vm.tr('You have been successfully subscribed!')))])]):(_vm.isAlreadySubscribed)?_c('div',{staticClass:"sdd4a"},[_vm._m(1),_c('p',{staticClass:"s9153"},[_vm._v(_vm._s(_vm.tr('You are already subscribed!')))])]):_vm._e(),(_vm.hasError)?_c('div',{staticClass:"s3e4e"},[_c('div',[_vm._m(2),_c('span',[_vm._v(" "+_vm._s(_vm.tr('Something went wrong.'))+" "),_c('br'),_vm._v(" "+_vm._s(_vm.tr('Please try again later.'))+" ")])]),_c('span',{staticClass:"sfc63",on:{"click":function($event){return _vm.closeError()}}},[_c('i',{staticClass:"sbaec s716f s1ffd"})])]):_vm._e()])])
}
var SubscriptionFormvue_type_template_id_6756a63c_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"s4a2f s919a"},[_c('i',{staticClass:"sbaec se5e5"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"s4a2f s53a0"},[_c('i',{staticClass:"sbaec s716f"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"s4a2f s53a0"},[_c('i',{staticClass:"sbaec s716f"})])
}]


;// CONCATENATED MODULE: ./src/components/SubscriptionForm.vue?vue&type=template&id=6756a63c

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SubscriptionForm.vue?vue&type=script&lang=js




/* harmony default export */ var SubscriptionFormvue_type_script_lang_js = ({
  name: 'SubscriptionForm',
  mixins: [Translator],
  props: {
    form: {
      type: [Object, lib.SubscriberForm],
      required: true,
    },
    label: {
      type: String || null,
      required: false,
    },
    language: {
      type: String,
      required: false,
      default() {
        return 'en';
      },
    },
    buttonColor: {
      type: String,
      required: false,
      default: null,
    },
    previewMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    transparent: {
      type: Boolean,
      required: false,
      default: false,
    },
    relative: {
      type: Boolean,
      required: false,
      default: false,
    },
    customer: {
      type: String,
      required: false,
    },
    campaign: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      hasError: false,
      isSubscribedSuccessfully: false,
      isAlreadySubscribed: false,
      isLoading: false,
      name: null,
      nameInputError: false,
      email: null,
      emailInputError: false,
      phone: null,
      phoneInputError: false,
      subscribe: [],
      acceptPrivacy: false,
      acceptPrivacyError: false,
    }
  },
  computed: {
    wrapperClasses() {
      return {
        's7cfe': true,
        's5e96': this.transparent,
        's99c4': this.relative,
      };
    },
    inputStyles() {
      return {'accent-color': (!(this.buttonColor == '#000' || this.buttonColor == '#000000') ? this.buttonColor : 'inherit')}
    },
    acceptPrivacyLabel() {
      const label = 'I accept the <a target="_blank" href="{url}">Privacy Policy</a>.'
      console.log(label, this.tr(label));
      return this.tr(label, { '{url}': this.form.privacy_url })
    },
    buttonLabel() {
      return (this.form.cta_label !== null && this.form.cta_label !== '') ? this.form.cta_label : this.tr('Subscribe')
    },
    namePlaceholder() {
      return (this.form.name_placeholder !== null || this.form.name_placeholder !== '') ? this.form.name_placeholder : this.tr('Full name')
    },
    emailPlaceholder() {
      return (this.form.email_placeholder !== null || this.form.email_placeholder !== '') ? this.form.email_placeholder : this.tr('Email address')
    },
    phonePlaceholder() {
      return (this.form.phone_placeholder !== null || this.form.phone_placeholder !== '') ? this.form.phone_placeholder : this.tr('Phone number')
    },
  },
  methods: {
    reset() {
      this.resetValidation()

      this.name = null
      this.email = null
      this.phone = null
    },
    resetValidation() {
      this.nameInputError = false
      this.emailInputError = false
      this.phoneInputError = false
      this.acceptPrivacyError = false
    },
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    validate() {
      this.resetValidation()
      let isValid = true

      if (
        this.form.name_enabled
        && (
          this.name === null
          || this.name === ''
        )
      ) {
        this.nameInputError = true

        isValid = false
      }

      if (!this.validEmail(this.email)) {
        this.emailInputError = true

        isValid = false
      }

      if (
        this.form.phone_enabled
        && (
          this.phone === null
          || this.phone === ''
        )
      ) {
        this.phoneInputError = true

        isValid = false
      }

      if (!this.acceptPrivacy) {
        this.acceptPrivacyError = true
        isValid = false
      }

      return isValid
    },
    doSubscribe() {
      if (this.isLoading || !this.validate()) {
        return
      }

      this.isLoading = true;

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          name: this.name,
          email: this.email,
          phone: this.phone,
          customer: this.customer,
          campaign: this.campaign
        })
      }

      let _apiUrl = this.$apiUrl
      if (this.previewMode) {
        _apiUrl = 'https://test.bannerse.com/wp-json'
      }
      const url = _apiUrl + '/smucrestapi/v2/form/' + this.form.id + '/subscriptions'
      fetch(url, requestOptions)
        .then(r => r.json())
        .then(resp => {
          if (resp && resp.data) {
            if (resp.data.inserted) {
              this.isSubscribedSuccessfully = true
            } else {
              this.isAlreadySubscribed = true
            }

            if (this.form.submit_click_tracking) {
              (new Image()).src = this.form.submit_click_tracking;
            }
          } else {
            this.hasError = true
          }
        })
        .finally(() => {
          this.isLoading = false;
        })
    },
    closeError() {
      this.hasError = false
    },
  }
});

;// CONCATENATED MODULE: ./src/components/SubscriptionForm.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SubscriptionFormvue_type_script_lang_js = (SubscriptionFormvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/SubscriptionForm.vue





/* normalize component */
;
var SubscriptionForm_component = normalizeComponent(
  components_SubscriptionFormvue_type_script_lang_js,
  SubscriptionFormvue_type_template_id_6756a63c_render,
  SubscriptionFormvue_type_template_id_6756a63c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SubscriptionForm = (SubscriptionForm_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Sidebar.vue?vue&type=script&lang=js















/* harmony default export */ var Sidebarvue_type_script_lang_js = ({
  name: 'Sidebar',
  namespaced: true,
  components: {
    Chat: Chat,
    Dragbar: Dragbar,
    ProductsFeed: ProductsFeed,
    StreamInfoBar: StreamInfoBar,
    SubscriptionForm: SubscriptionForm,
  },
  mixins: [Translator],
  props: {
    stream: {
      type: lib.StreamData,
      required: true
    },
    wsClient: {
      required: false,
      validator: (value) => {
        if (value === null) {
          return true;
        }

        if (
          typeof value === 'object'
          && value.constructor
          && value.constructor.name
          && value.constructor.name === 'WsClient'
        ) {
          return true
        }

        return false
      },
      default: null,
    },
    hasError: {
      type: Boolean,
      required: false,
      default: false,
    },
    isFullPortrait: {
      type: Boolean,
      required: false,
      default: false,
    },
    isMinimized: {
      type: Boolean,
      required: false,
      default: false,
    },
    isChatWindowVisible: {
      type: Boolean,
      required: false,
      default: false,
    },
    isVod: {
      type: Boolean,
      required: false,
      default: false,
    },
    streamviewEl: {
      type: HTMLElement,
      required: false,
      default: null,
    },
    videocontainerEl: {
      type: HTMLElement,
      required: false,
      default: null,
    },
    showProductsTab: {
      type: Boolean,
      required: false,
      default: false,
    },
    showChatTab: {
      type: Boolean,
      required: false,
      default: false,
    },
    showSubscriptionTab: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPreview: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasCustomProductsTabLabel: {
      type: Boolean,
      required: false,
      default: false,
    },
    isCompactAdvertisement: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      activeTab: 'products',
      debouncedResize: null,
      resizeObserver: null,
      newMessageCounter: 0,
      hasFloatingInfoInChat: false,
      chatInitialName: null,
      isJoined: false,
      isSubscriptionReopenVisible: false,
    }
  },
  created() {
    this.updateActiveTabOfSidebar(false)

    this.$root.$bus.$on('openMobileSidebar', (data) => {
      if (typeof data.event != 'undefined') {
        this.openMobileSidebarTo(data.event, data.to)

        setTimeout(() => {
          this.videocontainerEl.classList.remove('fluid')
        }, 250)
      }
    })
  },
  mounted() {
    this.initTabSelection()

    this.debouncedResize = _debounce(this.initTabSelection, 150)
    this.resizeObserver = new ResizeObserver(this.debouncedResize)
    this.resizeObserver.observe(this.$refs.tabs)
  },
  beforeDestroy() {
    this.resizeObserver.unobserve(this.$refs.tabs)
    this.resizeObserver.disconnect()
  },
  computed: {
    tabCounter() {
      let tabCounter = 0
      tabCounter += this.showProductsTab ? 1 : 0
      tabCounter += this.showChatTab ? 1 : 0
      tabCounter += this.showSubscriptionTab ? 1 : 0
      return tabCounter
    },
    sidebarTabsClasses() {
      return {
        'sea13': true,
        's8b1d': this.tabCounter == 1,
      };
    },
    sidebarTabsTabsClasses() {
      return {
        'sb6e4': true,
        's8d9e': this.activeTab === 'chat' && this.hasFloatingInfoInChat,
      };
    },
    chatMessages() {
      return this.isPreview ? dummyChatMessages() : []
    },
    dragbarMinHeight() {
      return this.streamviewEl !== null ? (this.streamviewEl.offsetWidth * (9/16)) : 0
    },
    dragbarMinHeightFeaturedImage() {
      if (this.streamviewEl === null) {
        return 0
      }

      const el = this.streamviewEl.querySelector('a[data-id="featured-image"]')
      return el !== null ? el.offsetTop : 0
    },
  },
  methods: {
    dragbarClosed() {
      this.$emit('dragbarClosed')
      setTimeout(() => this.$emit('fullPortraitSidebarIsVisible', false), 150)
    },
    switchTo($event, to, targetEl) {
      this.activeTab = to

      this.$emit('activeTab', this.activeTab)

      let targetElement = ($event !== null && $event.target && targetEl == undefined) ? $event.target : targetEl
      if (!targetElement.hasAttribute('data-smuc-tabid')) {
        targetElement = targetElement.closest('[data-smuc-tabid]')
      }

      if (this.$refs && this.$refs.sidebarTabSelection && targetElement) {
        this.$nextTick(() => {
          this.$refs.sidebarTabSelection.style.left = targetElement.offsetLeft + 'px'
          this.$refs.sidebarTabSelection.style.width = targetElement.offsetWidth + 'px'
          this.$refs.sidebarTabSelection.style.height = targetElement.offsetHeight + 'px'
        })
      }

      const tabComponentRefKey = 'tabComponent' + this.activeTab[0].toUpperCase() + this.activeTab.slice(1)
      if (this.$refs && this.$refs[tabComponentRefKey] && typeof this.$refs[tabComponentRefKey].tabActivated == 'function') {
        this.$refs[tabComponentRefKey].tabActivated()
      }
    },
    openMobileSidebarTo($event, to) {
      this.$emit('fullPortraitSidebarIsVisible', true)
      if (this.videocontainerEl) {
        this.videocontainerEl.style.height = (this.streamviewEl.offsetWidth * (9/16)).toString() + 'px'
        this.videocontainerEl.style.flex = '0 0 ' + (this.streamviewEl.offsetWidth * (9/16)).toString() + 'px'
      }
      this.switchTo($event, to, this.streamviewEl.querySelector('[data-smuc-tabid="' + to + '"]'))
    },
    updateActiveTabOfSidebar(updateSelectionElement = true) {
      this.activeTab = !this.showChatTab || this.isVod ? 'products' : this.activeTab
      if (this.activeTab === 'products' && (!this.stream.products.length || !this.showProductsTab) && this.showChatTab) {
        this.activeTab = 'chat'
      } else if (this.activeTab === 'chat' && !this.showChatTab && this.stream.products.length && this.showProductsTab) {
        this.activeTab = 'products'
      } else if (this.activeTab === 'products' && !this.showChatTab && !this.showProductsTab && this.showSubscriptionTab) {
        this.activeTab = 'subscription'
      }

      this.$emit('activeTab', this.activeTab)

      if (updateSelectionElement) {
        this.$nextTick(() => this.initTabSelection())
      }

      setTimeout(() => {
        this.isSubscriptionReopenVisible = this.tabCounter == 1 && this.showSubscriptionTab
      }, 1000)
    },
    initTabSelection() {
      if (
        !this.streamviewEl
        || !this.activeTab
        || !this.$refs[this.activeTab + '-tab']
        || this.activeTab == 'subscription'
      ) {
        return
      }

      this.$refs[this.activeTab + '-tab'].click()
    },
    reopenSubscriptionPanel() {
      console.log('reopenSubscriptionPanel')
      this.$root.$bus.$emit('streamview.subscriptionpanel.open')
    }
  },
  watch: {
    wsClient: {
      immediate: true,
      handler(val) {
        if (val !== null) {
          val.addEventListener(WsClientEvents.CHAT_MESSAGE, () => {
            if (this.activeTab !== 'chat' && this.newMessageCounter < 99) {
              ++this.newMessageCounter;
            }
          });
        }
      }
    },
    tabCounter() {
      const event = {
        target: this.$refs[this.activeTab + '-tab'],
      };
      this.switchTo(event, this.activeTab);
    },
    activeTab(val) {
      if (val === 'chat') {
        this.newMessageCounter = 0;
      }
    },
    newMessageCounter(val) {
      this.$root.$bus.$emit(Events.NEW_MESSAGE_COUNTER_VALUE, val);
    },
    hasError(val, oldVal) {
      if (val && oldVal !== val) {
        this.switchTo(null, 'products', this.$refs['products-tab']);
      }
    },
    streamviewEl(newVal) {
      if (newVal instanceof HTMLElement) {
        this.initTabSelection()

        if (this.stream.ad_use_featured_image) {
          this.$el.style.top = '100%'
          // To prevent transition on init..
          setTimeout(() => this.$el.classList.add('fluid'), 1000);
        }
      }
    },
    'streamviewEl.videoSourceIsLoaded': {
      immediate: true,
      handler(newVal) {
        if (newVal === true) {
          this.$nextTick(() => {
            this.initTabSelection()
          })
        }
      }
    },
    // This watcher used because of ADMIN
    'stream.show_product_list'() {
      this.updateActiveTabOfSidebar()
    },
    // This watcher used because of ADMIN
    'stream.show_chat'() {
      this.updateActiveTabOfSidebar()
    },
    // This watcher used because of ADMIN
    'stream.products'(newVal, oldVal) {
      if (
        (((oldVal && oldVal.length === 0) || oldVal == undefined) && newVal.length > 0)
        || (((oldVal && oldVal.length > 0) || oldVal == undefined) && newVal.length === 0)
      ) {
        this.updateActiveTabOfSidebar()
      }
    },
    isChatWindowVisible(newVal) {
      this.$nextTick(() => {
        if (
          newVal === true
          && this.wsClient !== null
          && this.$refs.tabComponentChat
          && this.$refs.tabComponentChat.$refs.tabComponentChat
          && typeof this.$refs.tabComponentChat.$refs.tabComponentChat.infiniteHandler == 'function'
        ) {
          this.$refs.tabComponentChat.$refs.tabComponentChat.infiniteHandler(true, null, true)
        }
      })
    },
  }
});

;// CONCATENATED MODULE: ./src/components/Sidebar.vue?vue&type=script&lang=js
 /* harmony default export */ var components_Sidebarvue_type_script_lang_js = (Sidebarvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/Sidebar.vue





/* normalize component */
;
var Sidebar_component = normalizeComponent(
  components_Sidebarvue_type_script_lang_js,
  Sidebarvue_type_template_id_68db5785_render,
  Sidebarvue_type_template_id_68db5785_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Sidebar = (Sidebar_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/OverlayTop.vue?vue&type=template&id=11208c26
var OverlayTopvue_type_template_id_11208c26_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay--bar sdfa6"},[(_vm.brandLogo)?_c('span',{staticClass:"sa301"},[_c('img',{ref:"logo",attrs:{"width":"45","height":"45"}})]):_vm._e(),(!(_vm.theKind === 'vod' || _vm.isSimpleVod || _vm.isPhotoAd) && _vm.theKind !== null)?_c('stream-kind',{staticClass:"s4193",attrs:{"label":_vm.tr(_vm.kindText),"kind":_vm.theKind}}):_vm._e(),(!_vm.hasError && _vm.stream.show_viewers && !_vm.isMinimized)?_c('span',{staticClass:"s4193 overlay--viewers"},[_c('i',{staticClass:"sbaec s8b0a"}),_vm._v(" "+_vm._s(_vm.formattedViewerCount)+" ")]):_vm._e(),(_vm.hasShareLink)?[_c('span',{staticClass:"s4193 s7b10 sa31d s854d",on:{"click":() => _vm.$emit('onShare')}},[_vm._v(" "+_vm._s(_vm.tr('Share'))+" ")])]:_vm._e(),(_vm.isClosableOverlayPlayer)?_c('span',{staticClass:"s8e7f"}):_vm._e(),(_vm.isClosableOverlayPlayer)?_c('span',{staticClass:"s4193 se4be",on:{"click":() => _vm.$emit('onClose')}},[_c('i',{staticClass:"sbaec s716f"})]):_vm._e(),(_vm.hasSidebar && _vm.sidebarIsCollapsible)?_c('span',{class:{'overlay--bar-item sd07c': true, open: _vm.sidebarCollapsed},on:{"click":() => _vm.$emit('onToggleSidebar')}},[_c('i',{staticClass:"sbaec s1a72"})]):_vm._e()],2)
}
var OverlayTopvue_type_template_id_11208c26_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StreamKind.vue?vue&type=template&id=2ed314cb
var StreamKindvue_type_template_id_2ed314cb_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cssClasses},[_c('i',{class:_vm.iconCssClasses}),(_vm.label.length > 0)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var StreamKindvue_type_template_id_2ed314cb_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StreamKind.vue?vue&type=script&lang=js

/* harmony default export */ var StreamKindvue_type_script_lang_js = ({
  name: 'StreamKind',
  props: {
    label: {
      type: String,
      required: false
    },
    kind: {
      type: String,
      required: true,
      validator: v => ['live', 'playback', 'vod', 'embed'].includes(v)
    }
  },
  computed: {
    cssClasses() {
      const classes = {
        'sd695': true,
        'sa7de': this.kind === 'live',
        's4a16': this.kind === 'playback',
        'stream--vod': this.kind === 'vod',
        'stream--embed': this.kind === 'embed',
      }

      classes[this.kind] = true

      return classes
    },
    iconCssClasses() {
      const classes = {
        'sbaec': true,
        'sa7de': this.kind === 'live',
        's4a16': this.kind === 'playback',
        'stream--vod': this.kind === 'vod',
        'stream--embed': this.kind === 'embed',
      }

      const isKindaLive = this.kind === 'live' || this.kind === 'playback'

      if (isKindaLive) {
        classes['sa7de'] = true
      }

      return classes
    }
  }
});

;// CONCATENATED MODULE: ./src/components/StreamKind.vue?vue&type=script&lang=js
 /* harmony default export */ var components_StreamKindvue_type_script_lang_js = (StreamKindvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/StreamKind.vue





/* normalize component */
;
var StreamKind_component = normalizeComponent(
  components_StreamKindvue_type_script_lang_js,
  StreamKindvue_type_template_id_2ed314cb_render,
  StreamKindvue_type_template_id_2ed314cb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StreamKind = (StreamKind_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/OverlayTop.vue?vue&type=script&lang=js





const isObj = (o) => Object.prototype.toString.call(o) == '[object Object]'

/* harmony default export */ var OverlayTopvue_type_script_lang_js = ({
  name: 'OverlayTop',
  components: {
    StreamKind: StreamKind,
  },
  mixins: [Translator],
  props: {
    stream: {
      type: lib.StreamData,
      required: true,
    },
    theKind: {
      type: String,
      required: true,
    },
    kindText: {
      type: String,
      required: false,
      default: 'Live'
    },
    isVod: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSimpleVod: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPhotoAd: {
      type: Boolean,
      required: false,
      default: false,
    },
    isMinimized: {
      type: Boolean,
      required: false,
      default: false,
    },
    isMuted: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasError: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasShareLink: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasSidebar: {
      type: Boolean,
      required: false,
      default: false,
    },
    sidebarCollapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPortrait: {
      type: Boolean,
      required: false,
      default: false,
    },
    viewersCount: {
      type: Number,
      required: false,
      default: 0,
    },
    mode: {
      type: String,
      required: false,
      default: 'overlay',
      validator: (v) => ['overlay', 'embedded', 'viewer'].includes(v)
    },
    playerDomain: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    brandLogo() {
      return isObj(this.stream.logo) && typeof this.stream.logo.url == 'string' ? this.stream.logo.url : null
    },
    isClosableOverlayPlayer() {
      return this.stream.show_close_button && !this.isVod && this.mode === 'overlay'
    },
    sidebarIsCollapsible() {
      return !this.isPortrait && (this.stream.width > this.stream.height)
    },
    formattedViewerCount() {
      return new Intl.NumberFormat('hu-HU').format(this.viewersCount);
    },
  },
  watch: {
    brandLogo: {
      immediate: true,
      handler(val, oldVal) {
        if (!val || val == oldVal) {
          return;
        }
        this.$nextTick(() => this.initLogoLazyLoad());
      },
    },
  },
  methods: {
    initLogoLazyLoad() {
      if (!this.$refs.logo || !this.brandLogo) {
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        const isVisible = entries[0].isIntersecting;
        if (isVisible) {
          this.$refs.logo.setAttribute('src', this.brandLogo);
          observer.disconnect();
        }
      });
      observer.observe(this.$refs.logo);
    },
  },
});

;// CONCATENATED MODULE: ./src/components/OverlayTop.vue?vue&type=script&lang=js
 /* harmony default export */ var components_OverlayTopvue_type_script_lang_js = (OverlayTopvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/OverlayTop.vue





/* normalize component */
;
var OverlayTop_component = normalizeComponent(
  components_OverlayTopvue_type_script_lang_js,
  OverlayTopvue_type_template_id_11208c26_render,
  OverlayTopvue_type_template_id_11208c26_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var OverlayTop = (OverlayTop_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/OverlayTools.vue?vue&type=template&id=0427c53a
var OverlayToolsvue_type_template_id_0427c53a_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'overlay--bar s5722': true, 'scba8': _vm.fullPortraitSidebarIsVisible}},[_c('div',{staticClass:"sadfc"},[(_vm.isOverlayChatRendered)?_c('chat',{ref:"chatOverlay",class:(_vm.isOverlayChatVisible ? '' : 'hide'),attrs:{"ws-client":_vm.wsClient,"messages":_vm.chatMessages,"button-color":_vm.stream.button_color,"text-color":_vm.stream.text_color,"language":_vm.language,"reversed-moderation":_vm.stream.reversed_chat_moderation}}):_vm._e()],1),(_vm.isOverlayTabsVisible)?_c('div',{staticClass:"s8454"},[_c('nav',{staticClass:"sea13"},[_c('div',{staticClass:"sb6e4"},[(_vm.showProductsTab)?_c('div',{ref:"product-tab",staticClass:"s9c7e",on:{"click":function($event){return _vm.openMobileSidebarTo($event, 'products')}}},[(_vm.hasCustomProductsTabLabel)?[_vm._v(" "+_vm._s(_vm.stream.tab_products_label_plural)+" ")]:[_c('i',{staticClass:"sbaec sdd35 s1ffd"}),_vm._v(" "+_vm._s(_vm.tr('Products'))+" ")]],2):_vm._e(),(_vm.showChatTab)?_c('div',{staticClass:"s9c7e",on:{"click":function($event){return _vm.openMobileSidebarTo($event, 'chat')}}},[_c('div',{staticClass:"s992c"},[_c('i',{staticClass:"sbaec s19d8 s1ffd"}),(_vm.newMessageCounter)?_c('div',{ref:"newMessagesCounter",staticClass:"sd56d s0f14"},[_vm._v(_vm._s(_vm.newMessageCounter))]):_vm._e()]),_vm._v(" "+_vm._s(_vm.tr('Comments'))+" ")]):_vm._e(),(_vm.showSubscriptionTab)?_c('div',{staticClass:"s9c7e",on:{"click":function($event){return _vm.openMobileSidebarTo($event, 'subscription')}}},[_vm._v(" "+_vm._s(_vm.stream.tab_subscription_form_label ?? _vm.tr('Subscription'))+" ")]):_vm._e()])])]):_vm._e()])
}
var OverlayToolsvue_type_template_id_0427c53a_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/OverlayTools.vue?vue&type=script&lang=js








/* harmony default export */ var OverlayToolsvue_type_script_lang_js = ({
  name: 'OverlayTools',
  components: {
    Chat: Chat,
  },
  mixins: [Translator],
  props: {
    stream: {
      type: lib.StreamData,
      required: true,
    },
    fullPortraitSidebarIsVisible: {
      type: Boolean,
      required: false,
      default: false,
    },
    isChatWindowVisible: {
      type: Boolean,
      required: false,
      default: false,
    },
    isFullPortrait: {
      type: Boolean,
      required: false,
      default: false,
    },
    isMinimized: {
      type: Boolean,
      required: false,
      default: false,
    },
    isMobile: {
      type: Boolean,
      required: false,
      default: false
    },
    wsClient: {
      required: false,
      validator: (value) => {
        if (value === null) {
          return true;
        }

        if (
          typeof value === 'object'
          && value.constructor
          && value.constructor.name
          && value.constructor.name === 'WsClient'
        ) {
          return true
        }

        return false
      },
      default: null,
    },
    showProductsTab: {
      type: Boolean,
      required: false,
      default: false,
    },
    showChatTab: {
      type: Boolean,
      required: false,
      default: false,
    },
    showSubscriptionTab: {
      type: Boolean,
      required: false,
      default: false,
    },
    sidebarActiveTab: {
      type: String,
      required: false,
      default: null,
    },
  },
  data: () => {
    return {
      newMessageCounter: 0,
    };
  },
  computed: {
    chatMessages() {
      return this.isPreview ? dummyChatMessages() : []
    },
    isOverlayChatRendered() {
      return this.isChatWindowVisible
        && this.showChatTab
        && !this.isMinimized
    },
    isOverlayChatVisible() {
      return (!this.isFullPortrait && !this.isMobile && ![null, 'chat'].includes(this.sidebarActiveTab))
        || (this.isFullPortrait && !this.fullPortraitSidebarIsVisible)
    },
    hasCustomProductsTabLabel() {
      return typeof this.stream.tab_products_label_plural == 'string' && this.stream.tab_products_label_plural.length > 0
    },
    isOverlayTabsVisible() {
      return (
        (this.showChatTab || this.showProductsTab)
        && this.isFullPortrait
        && !this.fullPortraitSidebarIsVisible
      )
    }
  },
  created() {
    this.$root.$bus.$on(Events.NEW_MESSAGE_COUNTER_VALUE, (val) => {
      this.newMessageCounter = val;
    });
  },
  methods: {
    openMobileSidebarTo(event, to) {
      this.$root.$bus.$emit('openMobileSidebar', {event, to})
    }
  },
  watch: {
    isOverlayChatRendered(newVal) {
      this.$nextTick(() => {
        if (
          newVal == true
          && this.wsClient !== null
          && this.$refs.chatOverlay
          && this.$refs.chatOverlay.$refs
          && this.$refs.chatOverlay.$refs.chat
          && typeof this.$refs.chatOverlay.$refs.chat.infiniteHandler == 'function'
        ) {
          this.$refs.chatOverlay.$refs.chat.infiniteHandler(true, null, true)
        }
      })
    }
  }
});

;// CONCATENATED MODULE: ./src/components/OverlayTools.vue?vue&type=script&lang=js
 /* harmony default export */ var components_OverlayToolsvue_type_script_lang_js = (OverlayToolsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/OverlayTools.vue





/* normalize component */
;
var OverlayTools_component = normalizeComponent(
  components_OverlayToolsvue_type_script_lang_js,
  OverlayToolsvue_type_template_id_0427c53a_render,
  OverlayToolsvue_type_template_id_0427c53a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var OverlayTools = (OverlayTools_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PaymentDetails.vue?vue&type=template&id=76f59a18
var PaymentDetailsvue_type_template_id_76f59a18_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"frame",class:_vm.frameClasses},[_c('header',{staticClass:"sb9bd"},[(_vm.streamviewEl != null)?_c('dragbar',{attrs:{"streamview-el":_vm.streamviewEl,"draggable-container":_vm.$el,"tap-to-close":true,"rule-to-update":"top","top-offset":0},on:{"closed":_vm.eventOnDetailsClose}}):_vm._e(),_c('span',{on:{"click":_vm.eventOnBack}},[_c('i',{staticClass:"sbaec s469b s1ffd"}),_vm._v(" "+_vm._s(_vm.tr('Back'))+" ")])],1),(_vm.isPaymentCompleted)?_c('div',{class:_vm.paymentCompletedClasses},[_c('div',{staticClass:"s7880"}),_c('div',{staticClass:"sc56b"},[_vm._v(_vm._s(_vm.completedStatus === 'success' ? _vm.tr('successful payment') : _vm.tr('unsuccessful payment')))])]):[_c('section',{staticClass:"sb9bd smc-payment-details--head"},[_c('label',{staticClass:"sbd4b"},[_vm._v(_vm._s(_vm.product.title))]),(_vm.formattedPrice !== null)?_c('div',{class:{'sdef8': true, 'sf36e': _vm.product.sales_price}},[(_vm.product.sales_price)?_c('span',{staticClass:"s51d3"},[_vm._v(_vm._s(_vm.formattedSalesPrice))]):_vm._e(),_c('span',{staticClass:"s2200"},[_vm._v(_vm._s(_vm.formattedPrice))])]):_vm._e()]),_c('section',{staticClass:"sb9bd"},[_c('label',{staticClass:"s322f"},[_vm._v(_vm._s(_vm.tr('Payment informations')))])]),_c('section',{staticClass:"sb9bd se3a2"},[(_vm.payment.type === 'stripe')?_c('stripe-form',{attrs:{"payment":_vm.payment,"product":_vm.product,"currency":_vm.currency,"language":_vm.language},on:{"set-is-loading":_vm.setIsLoading,"complete-payment":_vm.completePayment}}):_vm._e()],1)]],2)
}
var PaymentDetailsvue_type_template_id_76f59a18_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/payment/StripeForm.vue?vue&type=template&id=663a5eef
var StripeFormvue_type_template_id_663a5eef_render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"stripeForm",class:{'s5df2': true, fulfilled: _vm.isValidForm},on:{"submit":_vm.pay}},[_c('div',{ref:"stripeFormForm",staticClass:"s3132"},[_c('div',{ref:"payment-request-button"}),(_vm.paymentRequestButtonVisible)?_c('div',{staticClass:"s38b4"},[_vm._v(" "+_vm._s(_vm.tr('or'))+" ")]):_vm._e(),_c('div',{staticClass:"s784c"},[_c('div',{staticClass:"s51ab"},[_c('div',{ref:"card-number"})]),_c('div',{staticClass:"s3002"},[_c('div',{ref:"card-expiry",staticClass:"s820e"}),_c('div',{ref:"card-cvc",staticClass:"s1025"})]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.billingName),expression:"billingName"}],attrs:{"type":"text","placeholder":_vm.tr('Billing name')},domProps:{"value":(_vm.billingName)},on:{"input":function($event){if($event.target.composing)return;_vm.billingName=$event.target.value}}}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.billingAddress),expression:"billingAddress"}],attrs:{"type":"text","placeholder":_vm.tr('Billing address')},domProps:{"value":(_vm.billingAddress)},on:{"input":function($event){if($event.target.composing)return;_vm.billingAddress=$event.target.value}}}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.billingEmail),expression:"billingEmail"}],attrs:{"type":"email","placeholder":_vm.tr('Email address')},domProps:{"value":(_vm.billingEmail)},on:{"change":_vm.onChangeEmail,"keyup":_vm.onKeyupEmail,"input":function($event){if($event.target.composing)return;_vm.billingEmail=$event.target.value}}}),(_vm.errorMessage)?_c('div',{staticClass:"scb5e"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e()])]),_c('div',{staticClass:"s39d2"},[_c('button',{class:_vm.payButtonClasses,attrs:{"type":"submit"}},[(_vm.isLoading)?_c('i',{staticClass:"s158d"}):[(_vm.isValidForm)?[_vm._v(" "+_vm._s(_vm.tr('Pay now'))+": "+_vm._s(_vm.formattedSalesPrice !== null ? _vm.formattedSalesPrice : _vm.formattedPrice)+" ")]:[_vm._v(" "+_vm._s(_vm.tr('Fill out form to pay'))+" ")]]],2)])])
}
var StripeFormvue_type_template_id_663a5eef_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/payment/StripeForm.vue?vue&type=script&lang=js




/* harmony default export */ var StripeFormvue_type_script_lang_js = ({
  name: 'StripeForm',
  mixins: [ mixin, Translator ],
  props: {
    payment: {
      type: Object,
      required: true,
      default: null
    },
    product: {
      type: [Object, null],
      required: false,
      default: null
    },
    currency: {
      type: String,
      required: false,
      default: 'huf'
    }
  },
  data () {
    return {
      stripe: null,
      stripeLoader: null,
      elements: null,
      paymentRequest: null,
      cardNumberElement: null,
      cardExpiryElement: null,
      cardCvcElement: null,
      paymentRequestButton: null,
      paymentRequestButtonVisible: false,
      billingName: '',
      billingAddress: '',
      billingEmail: '',
      isValidCardNumber: false,
      isValidExpiry: false,
      isValidCvc: false,
      isValidEmail: false,
      isLoading: false,
      errorMessage: null,

      style: {
        base: {
          iconColor: '#1d2128',
          color: '#1d2128',
          lineHeight: '46px',
          fontWeight: 400,
          fontFamily: 'inherit',
          fontSmoothing: 'antialiased',
          fontSize: '11px',
          letterSpacing: '0.1px',
          '::placeholder': {
            color: '#1d21287f'
          },
          ':-webkit-autofill': {
            color: '#1d21287f'
          },
        },
      }
    }
  },
  computed: {
    payButtonClasses() {
      return {
        sb02a: true,
        s0aaa: this.isLoading || !this.isValidForm
      }
    },
    isValidForm() {
      if (!this.isValidCardNumber || !this.isValidExpiry || !this.isValidCvc ||
          !this.billingName || !this.billingAddress || !this.isValidEmail
      ) {
        return false
      }
      return true
    },
  },
  watch: {
    isLoading() {
      this.$emit('set-is-loading', this.isLoading)
    },
    isValidForm(newVal) {
      if (newVal === true) {
        setTimeout(() => this.$refs.stripeFormForm.scrollTo({top: 1987, behavior: 'smooth'}), 250)
      }
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.stripe !== null) {
        return
      }
      if (this.stripeLoader === null) {
        this.stripeLoader = (__webpack_require__(427)/* .loadStripe */ .c);
      }

      this.stripeLoader(this.payment.data.stripe_publishable_key)
        .then((stripe) => {
          this.stripe = stripe

          this.elements = this.stripe.elements({ locale: this.language })

          this.cardNumberElement = this.elements.create('cardNumber', { style: this.style })
          this.cardExpiryElement = this.elements.create('cardExpiry', { style: this.style })
          this.cardCvcElement = this.elements.create('cardCvc', { style: this.style })

          this.cardNumberElement.mount(this.$refs['card-number'])
          this.cardExpiryElement.mount(this.$refs['card-expiry'])
          this.cardCvcElement.mount(this.$refs['card-cvc'])

          this.cardNumberElement.on('change', this.onChangeStripeElement)
          this.cardExpiryElement.on('change', this.onChangeStripeElement)
          this.cardCvcElement.on('change', this.onChangeStripeElement)

          this.paymentRequestInit()
        })
    },
    onChangeStripeElement(e) {
      const hasError = !!(e.error && e.error.message)
      const isValid = !!(!hasError && e.complete && !e.empty)

      if (e.elementType === 'cardNumber') {
        this.isValidCardNumber = isValid
      }
      else if (e.elementType === 'cardExpiry') {
        this.isValidExpiry = isValid
      }
      else if (e.elementType === 'cardCvc') {
        this.isValidCvc = isValid
      }

      if (hasError && !this.errorMessage) {
        this.errorMessage = e.error.message
      }
      if (!hasError) {
        this.errorMessage = null
      }
    },
    onChangeEmail() {
      this.isValidEmail = this.validEmail(this.billingEmail)
      this.errorMessage = !this.isValidEmail ? this.tr('The email address you provided is incorrect') : null
    },
    onKeyupEmail(){
      this.isValidEmail = this.validEmail(this.billingEmail)
    },
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    async paymentRequestInit(){
      const price = (this.product.sales_price !== null ? this.product.sales_price : this.product.price) * 100
      this.paymentRequest = this.stripe.paymentRequest({
        country: 'HU',
        currency: this.currency,
        total: {
          label: this.product.title,
          amount: price,
        },
        requestPayerName: true,
        requestPayerEmail: true,
      })

      this.paymentRequestButton = this.elements.create('paymentRequestButton', {
        paymentRequest: this.paymentRequest,
      })

      this.paymentRequest.canMakePayment().then(result => {
        if (result) {
          this.paymentRequestButton.mount(this.$refs['payment-request-button'])
          this.paymentRequestButtonVisible = true

          this.paymentRequest.on('paymentmethod', async (ev) => {
            this.paymentRequestComplete(ev)
          })
        } else {
          this.paymentRequestButtonVisible = false
        }
      })

    },
    async paymentRequestComplete(ev){
      const requestParams = {
        product_id: this.product.id
      }

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestParams)
      }

      const url = this.$apiUrl + '/smucrestapi/v2/payment/prepare-pay-product'
        fetch(url, requestOptions)
          .then((response) => response.json())
          .then(async (result) => {
            const clientSecret = result.data.clientsec
            const {paymentIntent, error: confirmError} = await this.stripe.confirmCardPayment(
              clientSecret,
              {payment_method: ev.paymentMethod.id},
              {handleActions: false}
            );

            if (confirmError) {
              ev.complete('fail');
              this.$emit('complete-payment', 'failed')
            } else {
              ev.complete('success');
              if (paymentIntent.status === "requires_action") {
                const {error} = await this.stripe.confirmCardPayment(clientSecret)
                if (error) {
                  this.$emit('complete-payment', 'failed')
                } else {
                  this.$emit('complete-payment', 'success')
                }
              } else {
                this.$emit('complete-payment', 'success')
              }
            }
          })
          .catch(() => {
          })
    },
    async pay(e) {
      e.preventDefault()

      if (this.isLoading || !this.isValidForm) {
        return
      }

      this.isLoading = true
      this.errorMessage = null

      // Create Payment Method in Stripe
      const result = await this.stripe.createPaymentMethod({
        type: 'card',
        card: this.cardNumberElement,
        billing_details: {
          address: {
            line1: this.billingAddress
          },
          email: this.billingEmail,
          name: this.billingName
        }
      })

      if (result.error) {
        this.errorMessage = result.error.message
        this.isLoading = false
        return
      }

      // Send request to backend
      const requestParams = {
        payment_method_id: result.paymentMethod.id,
        product_id: this.product.id,
        billing: {
          name: this.billingName,
          address: this.billingAddress,
          email: this.billingEmail
        }
      }

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestParams)
      }

      const url = this.$apiUrl + '/smucrestapi/v2/payment/pay-product'
      fetch(url, requestOptions)
        .then((response) => response.json())
        .then(() => {
          this.$emit('set-is-loading', false)
          this.$emit('complete-payment', 'success')
        })
        .catch(() => {
          this.$emit('set-is-loading', false)
          this.$emit('complete-payment', 'failed')
        })
    }
  }
});

;// CONCATENATED MODULE: ./src/components/payment/StripeForm.vue?vue&type=script&lang=js
 /* harmony default export */ var payment_StripeFormvue_type_script_lang_js = (StripeFormvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/payment/StripeForm.vue





/* normalize component */
;
var StripeForm_component = normalizeComponent(
  payment_StripeFormvue_type_script_lang_js,
  StripeFormvue_type_template_id_663a5eef_render,
  StripeFormvue_type_template_id_663a5eef_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StripeForm = (StripeForm_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PaymentDetails.vue?vue&type=script&lang=js






/* harmony default export */ var PaymentDetailsvue_type_script_lang_js = ({
  name: 'StripePayment',
  namespaced: true,
  mixins: [ mixin, Translator ],
  components: { Dragbar: Dragbar, StripeForm: StripeForm },
  props: {
    product: {
      type: Object,
      required: true
    },
    payment: {
      type: [Object, null],
      required: false,
      default: null
    },
    currency: {
      type: String,
      required: false,
      default: 'huf'
    },
    isMobile: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonColor: {
      type: String,
      required: false,
      default() {
        return '#000000';
      },
    },
    textColor: {
      type: String,
      required: false,
      default() {
        return '#ffffff';
      },
    },
  },
  data() {
    return {
      slideUpClassOnFrame: true,
      streamviewEl: null,
      isLoading: false,
      isPaymentCompleted: false,
      completedStatus: null
    }
  },
  computed: {
    frameClasses() {
      return {
        's3222': true,
        'see95': this.slideUpClassOnFrame,
      };
    },
    paymentCompletedClasses() {
      return {
        's1923': true,
        'sea5b': this.completedStatus === 'success',
        's7a0e': this.completedStatus === 'failed'
      }
    },
    isPurchasable() {
      return this.payment && this.product.payable && this.product.price
    },
    buttonLabel() {
      return this.isPurchasable ? this.tr('Purchase') : this.tr('Learn more')
    }
  },
  mounted() {
    if (this.$parent && this.$parent && this.$parent.$el) {
      this.streamviewEl = this.$parent.$el
    }

    setTimeout(() => this.slideUpClassOnFrame = false, 300)
  },
  methods: {
    eventOnBack() {
      this.$refs.frame.classList.add('slide-down');
      this.eventOnDetailsClose();
    },
    eventOnDetailsClose() {
      setTimeout(() => {
        this.$root.$bus.$emit('streamview.product.payment.close');
      }, 200);
    },
    setIsLoading(value) {
      this.isLoading = value
    },
    completePayment(status) {
      this.isPaymentCompleted = true
      this.completedStatus = status
    },
  },
});

;// CONCATENATED MODULE: ./src/components/PaymentDetails.vue?vue&type=script&lang=js
 /* harmony default export */ var components_PaymentDetailsvue_type_script_lang_js = (PaymentDetailsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/PaymentDetails.vue





/* normalize component */
;
var PaymentDetails_component = normalizeComponent(
  components_PaymentDetailsvue_type_script_lang_js,
  PaymentDetailsvue_type_template_id_76f59a18_render,
  PaymentDetailsvue_type_template_id_76f59a18_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PaymentDetails = (PaymentDetails_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ShareThisStreamModal.vue?vue&type=template&id=b5388768
var ShareThisStreamModalvue_type_template_id_b5388768_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"se703",on:{"click":_vm.eventOnShareModal}},[_c('div',{ref:"shareModalInner",staticClass:"sea97"},[_c('span',{ref:"closeButton",staticClass:"sfc63",on:{"click":_vm.eventOnShareModal}},[_c('i',{staticClass:"sbaec s2ed3 s1ffd"})]),_c('span',{staticClass:"sc48b"},[(_vm.isAd)?[_vm._v(_vm._s(_vm.tr('share the ad')))]:[_vm._v(_vm._s(_vm.tr('share the player')))]],2),_c('div',{staticClass:"sd5d3"},[_vm._v(_vm._s(_vm.theTitle))]),_c('div',{staticClass:"sac77",on:{"click":_vm.shareLinkCopy}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.url),expression:"url"}],attrs:{"readonly":""},domProps:{"value":(_vm.url)},on:{"input":function($event){if($event.target.composing)return;_vm.url=$event.target.value}}}),_vm._m(0)]),_c('button',{style:('background-color:' + _vm.buttonColor + '; color: ' + _vm.textColor),on:{"click":_vm.shareLinkCopy}},[_vm._v(" "+_vm._s(_vm.shareLinkText)+" ")])])])
}
var ShareThisStreamModalvue_type_template_id_b5388768_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"sbaec s9951 sc1b1"})])
}]


;// CONCATENATED MODULE: ./src/components/ShareThisStreamModal.vue?vue&type=template&id=b5388768

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ShareThisStreamModal.vue?vue&type=script&lang=js



/* harmony default export */ var ShareThisStreamModalvue_type_script_lang_js = ({
  name: 'ShareThisStreamModal',
  mixins: [Translator],
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    buttonColor: {
      type: String,
      required: false,
      default() {
        return '#000000';
      },
    },
    textColor: {
      type: String,
      required: false,
      default() {
        return '#ffffff';
      },
    },
    isAd: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      shareLinkCopied: false,
      isNavigatorShareSupported: false,
    }
  },
  computed: {
    theTitle() {
      return this.isNavigatorShareSupported ? this.tr('Share with others') : this.tr('Copy link to clipboard')
    },
    shareLinkText() {
      if (this.isNavigatorShareSupported) {
        return this.tr('Share')
      }

      return this.shareLinkCopied ? this.tr('Copied to clipboard') : this.tr('Copy')
    },
  },
  created() {
    this.isNavigatorShareSupported = typeof navigator.share == 'function'
  },
  methods: {
    eventOnShareModal(e) {
      const inner = this.$refs.shareModalInner
      const btn = this.$refs.closeButton
      if (!e.path.includes(inner) || e.path.includes(btn)) {
        this.$emit('closed')
      }
    },
    async shareLinkCopy(e) {
      e.preventDefault()
      e.stopPropagation()

      // Native share on mobile devices
      if (this.isNavigatorShareSupported) {
        try {
          await navigator.share({
            title: this.title,
            text: this.title,
            url: this.url
          })
        } catch (err) {
          console.error(err)
        }

        return;
      }

      // Default share, copy to clipboard..
      if (!navigator.clipboard) {
        return;
      }

      try {
        navigator.clipboard.writeText(this.url);

        this.shareLinkCopied = true
        setTimeout(() => {
          this.shareLinkCopied = false
        }, 1500)
      } catch (err) {
        console.error('Failed to copy!', err);
      }
    },
  }
});

;// CONCATENATED MODULE: ./src/components/ShareThisStreamModal.vue?vue&type=script&lang=js
 /* harmony default export */ var components_ShareThisStreamModalvue_type_script_lang_js = (ShareThisStreamModalvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/ShareThisStreamModal.vue





/* normalize component */
;
var ShareThisStreamModal_component = normalizeComponent(
  components_ShareThisStreamModalvue_type_script_lang_js,
  ShareThisStreamModalvue_type_template_id_b5388768_render,
  ShareThisStreamModalvue_type_template_id_b5388768_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ShareThisStreamModal = (ShareThisStreamModal_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CompactAdControlBar.vue?vue&type=template&id=4d38301e
var CompactAdControlBarvue_type_template_id_4d38301e_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s5370"},[(!_vm.hasProducts && _vm.hasSubscriptionForm)?_c('span',{class:_vm.subscriptionButtonClasses,style:(_vm.buttonStyle),on:{"click":() => _vm.$emit('activeTab', 'subscription')}},[_vm._v(" "+_vm._s(_vm.subscriptionFormLabel ?? _vm.tr('Subscription'))+" ")]):(!_vm.hideProductsButton)?_c('span',{class:_vm.buttonClasses,style:(_vm.buttonStyle),on:{"click":() => _vm.$emit('activeTab', 'products')}},[(_vm.hasCustomProductsTabLabel)?[_vm._v(" "+_vm._s(_vm.productsLabelPlural)+" ")]:[_c('i',{staticClass:"sbaec sdd35",style:(_vm.buttonIconStyle)}),_vm._v(" "+_vm._s(_vm.tr('Products'))+" ")]],2):_vm._e(),(_vm.pinnedProduct !== null && !_vm.fullWidthButton)?_c('span',{staticClass:"s6897 s5e76",on:{"click":() => _vm.open()}},[_vm._v(" "+_vm._s(_vm.pinnedProduct.title)+" ")]):_vm._e()])
}
var CompactAdControlBarvue_type_template_id_4d38301e_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CompactAdControlBar.vue?vue&type=script&lang=js





/* harmony default export */ var CompactAdControlBarvue_type_script_lang_js = ({
  name: 'CompactAdControlBar',
  mixins: [ Translator ],
  props: {
    hasSubscriptionForm: {
      type: Boolean,
      required: false,
      default: true,
    },
    subscriptionFormLabel: {
      type: String || null,
      required: false,
    },
    hasProducts: {
      type: Boolean,
      required: false,
      default: true,
    },
    hasCustomProductsTabLabel: {
      type: Boolean,
      required: false,
      default: false,
    },
    productsLabelPlural: {
      type: String,
      required: false,
      default: '',
    },
    hideProductsButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    pinnedProduct: {
      type: lib.Feed,
      required: false,
      default: null,
      validator: (v) => v === null || (v !== null && Object.prototype.toString.call(v) == '[object Object]' && v.constructor.name == 'Feed')
    },
    buttonColor: {
      type: String,
      required: false,
      default() {
        return '#000000';
      },
    },
    textColor: {
      type: String,
      required: false,
      default() {
        return '#ffffff';
      },
    },
  },
  data: () => ({
    playbackPosition: 0,
  }),
  computed: {
    buttonClasses() {
      return {
        's6897': true,
        'se343': true,
        'sa31d': true,
        's854d': true,
        's2476': this.fullWidthButton,
        's896c': !this.hasProducts,
      };
    },
    buttonStyle() {
      return {
        'background-color': this.coloredButton ? this.buttonColor : null,
        'color': this.coloredButton ? this.textColor : null,
        'text-shadow': this.coloredButton ? 'none' : null,
      };
    },
    buttonIconStyle() {
      return {
        'background-color': this.coloredButton ? this.textColor : null,
      };
    },
    subscriptionButtonClasses() {
      return {
        's6897': true,
        'se343': true,
        'sa31d': true,
        's854d': true,
        's2476': this.fullWidthButton,
      };
    },
    fullWidthButton() {
      return this.playbackPosition >= 3 && !this.hideProductsButton;
    },
    coloredButton() {
      return this.playbackPosition >= 5 && !this.hideProductsButton;
    },
  },
  mounted() {
    this.$root.$bus.$on(Events.PLAYBACK_POSITION, this.updatePlaybackPosition);
  },
  methods: {
    open() {
      window.open(this.pinnedProduct.link, '_blank')
    },
    updatePlaybackPosition(val) {
      this.playbackPosition = val;
    },
  }
});

;// CONCATENATED MODULE: ./src/components/CompactAdControlBar.vue?vue&type=script&lang=js
 /* harmony default export */ var components_CompactAdControlBarvue_type_script_lang_js = (CompactAdControlBarvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/CompactAdControlBar.vue





/* normalize component */
;
var CompactAdControlBar_component = normalizeComponent(
  components_CompactAdControlBarvue_type_script_lang_js,
  CompactAdControlBarvue_type_template_id_4d38301e_render,
  CompactAdControlBarvue_type_template_id_4d38301e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CompactAdControlBar = (CompactAdControlBar_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SubscriptionPanel.vue?vue&type=template&id=69af59c0
var SubscriptionPanelvue_type_template_id_69af59c0_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"frame",class:_vm.frameClasses},[_c('header',{staticClass:"subscription-panel--section sc108"},[(_vm.streamviewEl != null)?_c('dragbar',{attrs:{"streamview-el":_vm.streamviewEl,"draggable-container":_vm.$el,"tap-to-close":true,"rule-to-update":"top","top-offset":0},on:{"closed":_vm.eventOnDetailsClose}}):_vm._e()],1),_c('div',{staticClass:"subscription-panel--section"},[(_vm.form !== null)?_c('subscription-form',{attrs:{"form":_vm.form,"label":_vm.label,"button-color":_vm.buttonColor,"preview-mode":_vm.previewMode,"customer":_vm.customer,"campaign":_vm.campaign,"language":_vm.language}}):_vm._e()],1)])
}
var SubscriptionPanelvue_type_template_id_69af59c0_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SubscriptionPanel.vue?vue&type=script&lang=js






/* harmony default export */ var SubscriptionPanelvue_type_script_lang_js = ({
  name: 'SubscriptionPanel',
  components: {
    Dragbar: Dragbar,
    SubscriptionForm: SubscriptionForm,
  },
  mixins: [Translator],
  props: {
    form: {
      type: [Object, lib.SubscriberForm],
      required: true,
    },
    label: {
      type: String || null,
      required: false,
    },
    language: {
      type: String,
      required: false,
      default() {
        return 'en';
      },
    },
    buttonColor: {
      type: String,
      required: false,
      default: null,
    },
    previewMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    customer: {
      type: String,
      required: false,
    },
    campaign: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      clickTracked: false,
      slideUpClassOnFrame: true,
      streamviewEl: null,
    }
  },
  computed: {
    frameClasses() {
      return {
        's7cfe': true,
        'see95': this.slideUpClassOnFrame,
      };
    },
  },
  mounted() {
    if (this.$parent && this.$parent && this.$parent.$el) {
      this.streamviewEl = this.$parent.$el
    }

    setTimeout(() => this.slideUpClassOnFrame = false, 300)
  },
  methods: {
    tabActivated() {
      if (!this.clickTracked && this.form.click_tracking) {
        this.clickTracked = true;
        (new Image()).src = this.form.click_tracking;
      }
    },
    eventOnDetailsClose() {
      setTimeout(() => {
        this.$root.$bus.$emit('streamview.subscriptionpanel.close')
      }, 200)
    },
  }
});

;// CONCATENATED MODULE: ./src/components/SubscriptionPanel.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SubscriptionPanelvue_type_script_lang_js = (SubscriptionPanelvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/SubscriptionPanel.vue





/* normalize component */
;
var SubscriptionPanel_component = normalizeComponent(
  components_SubscriptionPanelvue_type_script_lang_js,
  SubscriptionPanelvue_type_template_id_69af59c0_render,
  SubscriptionPanelvue_type_template_id_69af59c0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SubscriptionPanel = (SubscriptionPanel_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StreamViewPhotoad.vue?vue&type=template&id=b1da75b4
var StreamViewPhotoadvue_type_template_id_b1da75b4_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc7ff s32ec"},[(_vm.photos.length !== 0 && _vm.photos[0].url !== null)?_c('div',{staticClass:"s883d"},[_c('img',{attrs:{"src":_vm.photos[0].url}}),_c('vueper-slides',{attrs:{"autoplay":_vm.carouselAutoplay,"duration":_vm.carouselDuration,"pause-on-hover":""}},_vm._l((_vm.photos),function(media,i){return _c('vueper-slide',{key:'photoad-slide--' + i,attrs:{"image":media.url,"link":_vm.adUrl ? _vm.adUrl : null,"open-in-new":""}})}),1)],1):_vm._e(),_vm._t("default")],2)
}
var StreamViewPhotoadvue_type_template_id_b1da75b4_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/vueperslides/dist/vueperslides.common.js
var vueperslides_common = __webpack_require__(429);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StreamViewPhotoad.vue?vue&type=script&lang=js







/* harmony default export */ var StreamViewPhotoadvue_type_script_lang_js = ({
  name: 'StreamViewPhotoad',
  components: {
    VueperSlides: vueperslides_common.VueperSlides,
    VueperSlide: vueperslides_common.VueperSlide,
  },
  mixins: [StreamViewType],
  props: {
    stream: {
      type: lib.StreamData,
      required: true,
    },
    playerDomain: {
      type: String,
      required: false,
      default: () => 'player.bannerse.com',
    },
    isPreview: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonColor: {
      type: String,
      required: false,
      default() {
        return '#3D1094';
      },
    },
    viewMode: {
      type: String,
      required: false,
      default() {
        return 'embedded';
      },
    },
    optimizeForAd: {
      type: Boolean,
      required: false,
      default: false,
    },
    adUrl: {
      type: String,
      required: false,
      default: () => '',
    },
  },
  computed: {
    photos() {
      return this.stream.photoad_photos.filter(item => item !== null);
    },
    carouselAutoplay() {
      return this.stream.photoad_autoswipe_duration > 0;
    },
    carouselDuration() {
      if (!this.carouselAutoplay || this.stream.photoad_photos.length < 2) {
        return 999999 * 1000;
      }

      return this.stream.photoad_autoswipe_duration * 1000;
    },
  },
});

;// CONCATENATED MODULE: ./src/components/StreamViewPhotoad.vue?vue&type=script&lang=js
 /* harmony default export */ var components_StreamViewPhotoadvue_type_script_lang_js = (StreamViewPhotoadvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/StreamViewPhotoad.vue





/* normalize component */
;
var StreamViewPhotoad_component = normalizeComponent(
  components_StreamViewPhotoadvue_type_script_lang_js,
  StreamViewPhotoadvue_type_template_id_b1da75b4_render,
  StreamViewPhotoadvue_type_template_id_b1da75b4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StreamViewPhotoad = (StreamViewPhotoad_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AdFeaturedImage.vue?vue&type=template&id=280533ae
var AdFeaturedImagevue_type_template_id_280533ae_render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"s62f5",attrs:{"href":_vm.theLink,"target":_vm.hasLink ? '_blank' : '_self',"data-id":"featured-image"}},[(_vm.imageSrc !== null)?_c('img',{attrs:{"src":_vm.imageSrc.url,"width":_vm.imageDimension[0],"height":_vm.imageDimension[1]}}):_c('svg',{attrs:{"width":"75","height":"107","viewBox":"0 0 75 107","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 0.25H24.375V34.5079C28.46 33.0006 32.8826 32.1759 37.5 32.1759C58.2107 32.1759 75 48.7576 75 69.2132C75 89.6679 58.2107 106.25 37.5 106.25C16.7893 106.25 0 89.6679 0 69.2132C0 68.592 0.0154495 67.9739 0.0460625 67.3612H0V0.25ZM32.8125 83.6472L52.5 72.4202C55.0001 70.9954 55.0001 67.431 52.5 66.0054L32.8125 54.7788C30.3125 53.3538 27.1875 55.136 27.1875 57.987V80.4386C27.1875 83.2899 30.3125 85.0721 32.8125 83.6472Z","fill":"#f0f0f0"}})])])
}
var AdFeaturedImagevue_type_template_id_280533ae_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AdFeaturedImage.vue?vue&type=script&lang=js

const AdFeaturedImagevue_type_script_lang_js_isObj = (o) => Object.prototype.toString.call(o) == '[object Object]'

/* harmony default export */ var AdFeaturedImagevue_type_script_lang_js = ({
  name: 'AdFeaturedImage',
  props: {
    stream: {
      type: Object,
      required: true
    }
  },
  computed: {
    imageSrc() {
      return AdFeaturedImagevue_type_script_lang_js_isObj(this.stream.ad_featured_image) && typeof this.stream.ad_featured_image.url == 'string' ? this.stream.ad_featured_image : null
    },
    imageDimension() {
      if (this.stream.ad_size === '400x900') {
        return [400, 635]
      }

      return [540, 960]
    },
    hasLink() {
      return this.stream.ad_use_featured_image
        && typeof this.stream.ad_featured_image_link === 'string'
        && this.stream.ad_featured_image_link.length > 0
    },
    theLink() {
      return this.hasLink ? this.stream.ad_featured_image_link : 'javascript:void(0)'
    }
  }
});

;// CONCATENATED MODULE: ./src/components/AdFeaturedImage.vue?vue&type=script&lang=js
 /* harmony default export */ var components_AdFeaturedImagevue_type_script_lang_js = (AdFeaturedImagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/AdFeaturedImage.vue





/* normalize component */
;
var AdFeaturedImage_component = normalizeComponent(
  components_AdFeaturedImagevue_type_script_lang_js,
  AdFeaturedImagevue_type_template_id_280533ae_render,
  AdFeaturedImagevue_type_template_id_280533ae_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AdFeaturedImage = (AdFeaturedImage_component.exports);
;// CONCATENATED MODULE: ./src/js/bus.js


const bus = new (external_commonjs_vue_commonjs2_vue_root_Vue_default())();
/* harmony default export */ var js_bus = (bus);

;// CONCATENATED MODULE: ./src/js/video.js
const smucFallbackVideoSource = 'data:video/webm;base64,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';

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StreamView.vue?vue&type=script&lang=js





























const mobileBreakdownAt = 920 - 1

const StreamViewvue_type_script_lang_js_isObj = (o) => Object.prototype.toString.call(o) == '[object Object]'

let fontFaceMaxRetry = 10

/* harmony default export */ var StreamViewvue_type_script_lang_js = ({
  name: 'StreamView',
  components: { HeartGun: HeartGun, ProductFeed: ProductFeed, StreamInfoBar: StreamInfoBar, ProductDetails: ProductDetails, StreamViewCloudflare: StreamViewCloudflare, StreamViewEmbedSocial: StreamViewEmbedSocial, StreamViewPhotoad: StreamViewPhotoad, Sidebar: Sidebar, OverlayTop: OverlayTop, OverlayTools: OverlayTools, PaymentDetails: PaymentDetails, ShareThisStreamModal: ShareThisStreamModal, CompactAdControlBar: CompactAdControlBar, SubscriptionPanel: SubscriptionPanel, AdFeaturedImage: AdFeaturedImage },
  mixins: [ Translator, SoftKeyboardDetection, Safari14Mixin ],
  props: {
    playerDomain: {
      type: String,
      required: false,
      default: () => '',
    },
    streamThumbnailDomain: {
      type: String,
      required: false,
      default: () => '',
    },
    optimizeForAd: {
      type: Boolean,
      required: false,
      default: false,
    },
    wsClient: {
      required: false,
      validator: (value) => {
        if (value === null) {
          return true;
        }

        if (
          typeof value === 'object'
          && value.constructor
          && value.constructor.name
          && value.constructor.name === 'WsClient'
        ) {
          return true
        }

        return false
      },
      default: null,
    },
    disconnectedText: {
      type: String,
      required: false,
      default: 'Stream is interrupted'
    },
    errorMessage: {
      type: String,
      required: false,
      default: '',
    },
    isJoined: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPreview: {
      type: Boolean,
      required: false,
      default: false
    },
    previewViewMode: {
      type: [String, null],
      required: false,
      validator: (v) => ['desktop', 'mobile', null].includes(v),
      default: null,
    },
    kindText: {
      type: String,
      required: false,
      default: 'Live'
    },
    mode: {
      type: String,
      required: false,
      default: 'overlay',
      validator: (v) => ['overlay', 'embedded', 'viewer'].includes(v)
    },
    stream: {
      type: lib.StreamData,
      required: true,
    },
  },
  data() {
    return {
      thisEl: null,
      playerControlIsVisible: true,
      playbackPosition: 0,
      viewTimeCheckTimer: null,
      viewTime: 0,
      threeSecViewSent: false,
      dateNow: null,
      player: null,
      isPlaying: false,
      liveStreamDisconnected: false,
      isFullscreen: false,
      isMinimized: false,
      isMuted: false,
      isChatWindowVisible: true,
      viewersCount: 0,
      debouncedWidth: 0,
      widthTimeout: null,
      vodChapterNumber: 0,
      hasNextVodChapter: false,
      deviceOrientation: null,
      videoSourceIsLoaded: false,
      shareModalOpened: false,
      unmutedFirst: false,
      previewProductDetails: null,
      payableProduct: null,
      fullPortraitSidebarIsVisible: false,
      playerInstance: null,
      videoContainerResizeObserver: null,
      videoContainerOrientation: 'landscape',
      sidebarActiveTab: null,
      sidebarCollapsed: false,
      collapsingTo: null,
      iframeLoaded: false,
      isSubscriptionModalVisible: false,
      sidebarPreviousTab: null,

      delayedPinnedProduct: null,
      animationPinnedProductOut: false,

      adSizes: ['300x250', '336x280', '300x600', '400x600', '400x900', '640x360'],
      compactAdSizes: ['300x250', '336x280'],
      isCompactAdvertisementSidebarVisible: false,

      // Temporary.
      indamediaDesktopPixelVisible: false,
      indamediaMobilePixelVisible: false,
    }
  },
  beforeCreate() {
    if (!this.$root.$bus) {
      this.$root.$bus = js_bus;
    }
  },
  mounted() {
    this.thisEl = this.$el

    this.eventOnResize()

    const debouncedResize = _debounce(this.videoContainerResizeHandler, 150)
    this.videoContainerResizeObserver = new ResizeObserver(debouncedResize)
    this.videoContainerResizeObserver.observe(this.$refs.videoContainer)

    this.$root.$bus.$emit('aq', ['event', 'player_impression']);

    new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          observer.disconnect();
          this.$root.$bus.$emit('aq', ['event', 'player_visible_impression']);

          if (
            this.stream.apikey === 'dc10ce63b8da98a13a20b8ac7e5a711442d0f362'
            || this.stream.apikey === 'c657d0b017ac664a3db5f504d97594419f8a83af'
            || this.stream.apikey === '3b4f43531538b6c3960abcd24454534331ca68a0'
          ) {
            this.indamediaDesktopPixelVisible = true;
          }
          if (
            this.stream.apikey === 'b3891eb0331d8030944b3756a3ea445e93211ed1'
            || this.stream.apikey === '20f174963024876e74a881c1ca62c8c871976515'
            || this.stream.apikey === '264059624449216169c4b94932e2a9725dca66c8'
          ) {
            this.indamediaMobilePixelVisible = true;
          }

          this.shouldCallDelayedSidebarAppearance()
        }
      });
    }).observe(this.$el);
  },
  watch: {
    wsClient: {
      immediate: true,
      handler(val) {
        if (val !== null) {
          this.wsClient.addEventListener(WsClientEvents.INFO, this.onWsInfo);
          this.wsClient.addEventListener(WsClientEvents.FEED_INFO, (receivedFeedData) => {
            let newFeed = JSON.parse(JSON.stringify(this.stream.feed));

            // Removing deleted items.
            const receivedFeedIdList = receivedFeedData.map(i => i.id);
            newFeed = newFeed.filter(i => receivedFeedIdList.includes(i.id));

            // Updating feed properties.
            newFeed = newFeed.map(i => {
              const newData = receivedFeedData.find(n => n.id === i.id);
              if (!newData) {
                return i;
              }

              return Object.assign(i, newData);
            });

            // Adding new items.
            const currentFeedIdList = this.stream.feed.map(i => i.id);
            const receivedNewItems = receivedFeedData.filter(i => !currentFeedIdList.includes(i.id));
            if (receivedNewItems.length !== 0) {
              newFeed = newFeed.concat(receivedNewItems);
            }

            this.stream.updateValues({ feed: newFeed });
          });
        }
      }
    },
    fullPortraitSidebarIsVisible(val, oldVal) {
      if (!this.$refs['cloudflarePlayer'] || val === oldVal) {
        return;
      }

      this.$refs['cloudflarePlayer'].setAutosize(this.optimizeForAd ? false : !val);
      this.$refs['cloudflarePlayer'].setFullPortraitSidebarIsVisible(val);
    },
    playerOrientation: {
      immediate: true,
      handler(val, oldVal) {
        this.$nextTick(() => {
          if (val === oldVal) {
            return;
          }

          this.updateControlFreezeStatus();
        });
      },
    },
    videoSource(src) {
      if (
        src !== null
        && src !== ''
        && this.stream.start_minimized
        && !this.isPreview
        && this.mode === 'overlay'
      ) {
        this.isMinimized = true
        this.isChatWindowVisible = false
        this.$root.$bus.$emit('streamview.minimize.status', this.isMinimized)
      }
    },
    isSimpleVod: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.videoSourceIsLoaded = true
        }
      }
    },
    liveStatus(newVal) {
      if (newVal === 'paused') {
        this.pause()
      }
    },
    isStatusMessageVisible: {
      immediate: true,
      handler(newVal) {
        if (newVal === true && this.stream.width === null) {
          this.stream.width = (this.videoOrientation === 'portrait' || this.isOrientationPortraitForced) ? 405 : 1280
          this.stream.height = 720
        }
      }
    },
    pinnedItem: {
      immediate: true,
      handler(val, oldVal) {
        if (!oldVal) {
          this.delayedPinnedProduct = val;
          return;
        }

        if (val && oldVal && val.id === oldVal.id) {
          return;
        }

        this.animationPinnedProductOut = true;
        setTimeout(() => this.delayedPinnedProduct = val, 150)
      },
    },
    delayedPinnedProduct() {
      this.animationPinnedProductOut = false;
    },
    isMobileBreakpoint(newVal, oldVal) {
      // These will fix the following case:
      // Portrait video on mobile + open comments + resize browser to desktop + resize back to mobile
      // = switching to desktop with proper layout + overlay tools will be visible again
      if (oldVal == true && newVal == false) {
        this.$refs.videoContainer.style.height = null
        this.$refs.videoContainer.style.flex = null
        this.fullPortraitSidebarIsVisible = false
      }
    },
    coverUrl: {
      immediate: true,
      handler(val, oldVal) {
        if (!val || val == oldVal) {
          return;
        }
        this.$nextTick(() => this.initBlurredBgLazyload());
      },
    },
    optimizeForAd(newVal) {
      this.updatePlayerOptimizedForAd(!newVal)
    },
    'stream.font_id': {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal == undefined && oldVal == undefined) {
          return
        }

        if (oldVal != null || oldVal != '') {
          this.removeFontFace(oldVal)
        }

        this.addFontFace(newVal)
      }
    },
    sidebarActiveTab(newVal, oldVal) {
      if (
        oldVal != null
        && newVal == 'subscription'
        && !this.isSubscriptionModalVisible
      ) {
        this.isSubscriptionModalVisible = true
        this.sidebarPreviousTab = oldVal
      }
    },
  },
  computed: {
    pinnedProductClasses() {
      return {
        'pulse-button sce9d': true,
        's65f2': this.animationPinnedProductOut,
      };
    },
    popupAdButtonClasses() {
      return {
        's4a7c': true,
        'sa31d': true,
        'sce9d': true,
        'sda50': true,
        's46cf': this.isPlaying && this.playbackPosition >= 6,
      };
    },
    isMobileBreakpoint() {
      if (this.isPreview) {
        return false;
      }

      return this.windowWidth <= mobileBreakdownAt || (this.$el && this.$el.parentNode.clientWidth <= mobileBreakdownAt)
    },
    isMobile() {
      if (navigator && navigator.userAgentData && navigator.userAgentData.mobile) {
        return true;
      }

      let check = false;
      // eslint-disable-next-line
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);

      return check;
    },
    isWindowsOS() {
      return /'Win32|Win64|Windows|Windows NT|WinCE/gi.test(navigator.userAgent);
    },
    isSafari() {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    },
    isIos() {
      return (!!window.navigator.userAgent.match(/iPad/i) || !!window.navigator.userAgent.match(/iPhone/i));
    },
    isWebKit() {
      return !!window.navigator.userAgent.match(/WebKit/i);
    },
    isIosSafari() {
      return this.isSafari && this.isIos && this.isWebKit && !window.navigator.userAgent.match(/CriOS/i);
    },
    hasError() {
      return !!this.errorMessage;
    },
    theLanguage() {
      return this.stream.streamview_language
    },
    maxWidth() {
      return parseInt(this.stream.max_width, 10)
    },
    maxHeight() {
      return parseInt(this.stream.max_height, 10)
    },
    videoScale() {
      return this.stream.video_layout === 'fit' ? 'contain' : 'cover'
    },
    videoOrientation() {
      if (this.stream === null) {
        return 'landscape'
      }

      switch (parseInt(this.stream.orientation, 10)) {
        case 2: return 'custom'
        case 1: return 'landscape'
        case 0: return 'portrait'
        default: return 'landscape'
      }
    },
    videoOrientationByVideoSource() {
      if (this.stream.width == null || this.stream.height == null) {
        return 'landscape'
      }

      const ratio = this.stream.width / this.stream.height
      if (
        ratio == 1
        || (
          (ratio > 10 / 16)
          && (ratio < 16 / 10)
        )
      ) {
        return 'custom'
      } else if (ratio <= 10 / 16) {
        return 'portrait'
      } else {
        return 'landscape'
      }
    },
    liveStatus() {
      if (!this.stream) {
        return 'unknown'
      }

      const status = typeof this.stream.stream_status === 'number' || /^\d+$/.test(this.stream.stream_status) ? parseInt(this.stream.stream_status, 10) : -1
      switch (status) {
        case 0: return 'waiting'
        case 1: return 'live'
        case 2: return 'paused'
        case 3: return 'closed'
        default: return 'unknown'
      }
    },
    vodChapters() {
      return this.stream && typeof this.stream.vods === 'string' && this.stream.vods.length
        ? this.stream.vods.split(',')
        : []
    },
    videoSourceForPreview() {
      return smucFallbackVideoSource
    },
    videoSource() {
      const hasStreamUrl = this.stream != null
        && StreamViewvue_type_script_lang_js_isObj(this.stream.stream_urls)
        && this.stream.stream_urls.primary;

      if (
        this.stream === null
        || (
          this.isKindaLive
          && !this.isPreview
          && (
            !this.isJoined
            || this.liveStatus !== 'live'
          )
        )
      ) {
        return null
      }

      if (
        this.stream != null
        && this.isPreview
        && !this.isSimpleVod
      ) {
        if (
          this.isPlayback
          && typeof this.stream.vod_data_id == 'string'
          && this.stream.vod_data_id.length > 0
          && this.stream.vod_data_id in this.stream.playlist
        ) {
          return this.stream.playlist[this.stream.vod_data_id].url
        } else if (
          this.isPlayback
          && parseInt(this.stream.vod_data_id, 10) != 0
          && !isNaN(parseInt(this.stream.vod_data_id, 10))
          && hasStreamUrl
        ) {
          return this.stream.stream_urls.primary
        } else if (
          this.streamType == 'live'
          && this.liveStatus == 'closed'
          && this.vodChapters.length
        ) {
          return this.vodChapters[this.vodChapterNumber]
        } else {
          return null
        }
      }

      // Embedded social player.
      if (this.isEmbedSocialVideo) {
        return this.stream.embed_social_video
      }

      // Simple vod.
      if (this.isSimpleVod && hasStreamUrl) {
        return this.stream.stream_urls.primary;
      }

      // Live / Fake live streaming.
      if (
        this.isKindaLive
        && this.liveStatus != 'closed'
        && hasStreamUrl
      ) {
        return this.stream.stream_urls.primary;
      }

      // If this was a LIVE or PLAYBACK stream
      if (
        (this.streamType == 'live' || this.streamType == 'playback')
        && this.liveStatus == 'closed'
        && this.vodChapters.length
      ) {
        return this.vodChapters[this.vodChapterNumber]
      }

      return null
    },
    theVideoSource() {
      if (this.videoSource === null || /(youtube|vimeo|facebook|cloudflarestream|videodelivery)|(\.(m3u8|mp4))/.exec(this.videoSource) != null) {
        return this.videoSource
      }

      console.warn('[VideoSource] Not a valid source is presented.', this.videoSource)
      return null
    },
    isSimpleVod() {
      return this.streamType === 'embed'
    },
    isEmbedSocialVideo() {
      // @TODO: Should we switch to stream.type === 2?
      return this.stream !== null
        && typeof this.stream.embed_social_video === 'string'
        && this.stream.embed_social_video.length > 0
        && /youtu.?be|facebook|vimeo/.test(this.stream.embed_social_video)
    },
    isKindaLive() {
      return (this.theKind === 'live' || this.theKind === 'playback')
    },
    isLive() {
      return this.streamType == 'live' && this.liveStatus !== 'closed'
    },
    isPlayback() {
      return this.streamType == 'playback' && this.liveStatus !== 'closed'
    },
    isPhotoAd() {
      return this.streamType == 'photo_ad'
    },
    theKind() {
      if (!this.stream) {
        return null
      }

      if (this.isPlayback) {
        return 'playback'
      } else if (this.isVod) {
        return 'vod'
      } else if (this.isSimpleVod) {
        return 'embed'
      } else if (this.isPhotoAd) {
        return 'photo_ad'
      }

      return 'live'
    },
    isVod() {
      return this.stream
        && typeof this.stream.vods == 'string'
        && this.stream.vods.length
        && this.liveStatus === 'closed'
        && (
          this.stream.vods.includes('mp4')
          || this.stream.vods.includes('videodelivery.net')
          || this.stream.vods.includes('cloudflarestream.com')
        )
    },
    streamType() {
      switch (parseInt(this.stream.type, 10)) {
        case 0: return 'live'
        case 1: return 'playback'
        case 2: return 'embed'
        case 3: return 'ad'
        case 4: return 'photo_ad'
        default: return 'live'
      }
    },
    coverOrientation() {
      if (this.videoOrientation === 'custom') {
        return this.maxHeight > this.maxWidth ? 'portrait' : 'landscape';
      }

      return this.videoOrientationByVideoSource;
    },
    playerOrientation() {
      if (this.playerOrientationForced) {
        return 'portrait';
      }

      if (this.videoOrientation === 'custom') {
        if (this.stream.max_width / this.stream.max_height >= 1) {
         return 'landscape';
        }
        else {
          return 'portrait';
        }
      }

      return this.videoOrientation;
    },
    playerOrientationForced() {
      return this.isOrientationPortraitForced || this.previewViewMode === 'mobile' || this.optimizeForAd;
    },
    shareThisLink() {
      if (this.stream.player_url) {
        return this.stream.player_url;
      }

      let result = 'https://' + this.playerDomain + '/stream/?apikey=' + this.stream.apikey;
      if (this.stream.optimize_for_ad && this.stream.player_subdomain) {
        result = result.replace('//player.', '//' + this.stream.player_subdomain + '.');
      }

      return result;
    },
    cssClasses() {
      const classes = {
        s841d: true,
        'is-live': this.isKindaLive,
        'is-playback': this.isPlayback,
        'is-vod': this.isVod,
        's73df': this.isEmbedSocialVideo,
        's7279': this.stream.rounded_corners,
        'sf9ed': this.optimizeForAd,
        's8e38': this.isCompactAdvertisementSize,
        's0e47': this.isCompactAdvertisementSidebarVisible,
        's9852': this.isIosSafari,
        'is-arabic': this.isArabic,
      }

      if (this.optimizeForAd) {
        classes[`as300x250`] = this.stream.ad_size == '300x250'
        classes[`as336x280`] = this.stream.ad_size == '336x280'
        classes[`as300x600`] = this.stream.ad_size == '300x600'
        classes[`as400x600`] = this.stream.ad_size == '400x600'
        classes[`as400x900`] = this.stream.ad_size == '400x900'
        classes[`as640x360`] = this.stream.ad_size == '640x360'
      }

      if (this.stream.ad_use_featured_image) {
        classes['s9bee'] = true
      }

      if (this.isEmbedSocialVideo) {
        classes['s1b99'] = /youtube\.com/.test(this.videoSource || '')
      }

      classes['muted'] = this.isMuted
      classes['s74ba'] = this.isFullscreen
      classes['scba8'] = this.isMinimized

      classes['s04e6'] = this.mode === 'overlay'
      classes['s799d'] = this.mode === 'embedded'
      classes['mode--viewer'] = this.mode === 'viewer'

      classes['scb78'] = this.isPreview
      classes['s714a'] = this.sidebarCollapsed

      classes['s1e25'] = this.videoScale === 'contain'
      classes['s1e38'] = this.videoScale === 'cover'

      classes['s591a'] = this.playerOrientationForced
      classes['s1b2f'] = this.videoOrientation === 'custom'
      classes['s9b7a'] = this.playerOrientation === 'portrait'
      classes['s7302'] = this.playerOrientation === 'landscape'

      if (this.stream.width !== null && this.stream.height !== null) {
        const ratio = this.stream.width / this.stream.height
        if (
          ratio == 1
          || (
            (ratio > 10 / 16)
            && (ratio < 16 / 10)
          )
        ) {
          classes['sbf7e'] = true
        } else if (ratio <= 10 / 16) {
          classes['s7b5d'] = true
        } else {
          classes['sc40a'] = true
        }
      } else {
        if (this.isOrientationPortraitForced) {
          classes['s7b5d'] = true
        }
        else {
          classes['s7b5d'] = this.videoOrientation === 'portrait'
          classes['sc40a'] = this.videoOrientation === 'landscape'
        }
      }

      classes['pby--yes'] = this.stream.show_smuc_logo
      classes['s4104'] = !this.stream.show_smuc_logo
      classes['s6245'] = this.stream.products.length !== 0 && this.stream.show_product_list
      classes['no-products'] = this.stream.products.length === 0 || !this.stream.show_product_list

      classes['is-windows-os'] = this.isWindowsOS
      classes['sca8b'] = this.isSafari
      classes['s4271'] = this.softKeyboardVisible && (this.mode === 'viewer' || this.mode === 'overlay')
      classes['pinned-item'] = !!this.pinnedItem
      classes['s91da'] = this.noSidebar
      classes['s9709'] = this.playerControlIsVisible;

      return classes
    },
    customStyles() {
      const styles = {}
      if (this.videoOrientation == 'custom' && !this.isMobileBreakpoint) {
        styles['aspect-ratio'] = `${this.maxWidth}/${this.maxHeight}`

        if (this.maxWidth >= this.maxHeight) {
          styles['max-width'] = `${this.maxWidth}px`
          styles['max-height'] = `calc(100% - 30px)`
        } else {
          styles['max-width'] = `${this.maxWidth}px`
          styles['max-height'] = `${this.maxHeight}px`
        }
      }

      if (
        this.videoOrientationByVideoSource == 'custom'
        && !(
          this.isMobileBreakpoint
          || this.previewViewMode == 'mobile'
        )
      ) {
        styles['aspect-ratio'] = `${this.stream.width}/${this.stream.height}`
      }

      return styles
    },
    simpleVodCustomStyles() {
      const styles = {}

      if (this.videoOrientationByVideoSource == 'custom') {
        styles['aspect-ratio'] = `${this.stream.width}/${this.stream.height}`

        if (this.videoContainerOrientation == 'landscape') {
          styles['width'] = 'auto'
          styles['height'] = '100%'
        } else if (this.videoContainerOrientation == 'portrait') {
          styles['width'] = '100%'
          styles['height'] = 'auto'
        } else {
          styles['width'] = '100%'
          styles['height'] = '100%'
        }
      }

      return styles
    },
    showProductsTab() {
      return this.stream.show_product_list && this.stream.products.length > 0;
    },
    showChatTab() {
      return this.stream.show_chat && !this.hasError;
    },
    showSubscriptionTab() {
      return !(this.stream.subscriber_form_id === null || this.stream.subscriber_form_id === '');
    },
    noSidebar() {
      return !this.showProductsTab && !this.showChatTab && !this.showSubscriptionTab
    },
    isOrientationPortraitForced() {
      return (this.isMobileBreakpoint && !this.isMinimized)
        || (this.videoOrientation == 'custom' && this.stream.max_width < this.stream.max_height && !this.isMinimized)
        || this.optimizeForAd
        || this.previewViewMode === 'mobile'
    },
    isFullPortrait() {
      return (this.videoOrientation === 'portrait' || this.isOrientationPortraitForced || this.previewViewMode === 'mobile')
        && this.stream.width < this.stream.height
    },
    isStatusMessageVisible() {
      return (
        ['waiting', 'paused', 'closed'].includes(this.liveStatus)
        && !this.isVod
        && !this.isSimpleVod
        && !this.isPhotoAd
      )
    },
    coverLandscape() {
      return StreamViewvue_type_script_lang_js_isObj(this.stream.cover) && typeof this.stream.cover.url == 'string' ? this.stream.cover : this.defaultCover.landscape
    },
    coverPortrait() {
      return StreamViewvue_type_script_lang_js_isObj(this.stream.cover_portrait) && typeof this.stream.cover_portrait.url == 'string' ? this.stream.cover_portrait : this.defaultCover.portrait
    },
    defaultCover() {
      let result = {
        landscape: null,
        portrait: null,
      };

      if (
        this.stream.cover !== null
        || this.stream.cover_portrait !== null
        || this.isLive
      ) {
        return result;
      }

      if (
        this.stream !== null
        && typeof this.stream.embed_social_video === 'string'
        && this.stream.embed_social_video.length > 0
        && /youtu.?be|facebook|vimeo/.test(this.stream.embed_social_video)
      ) {
        return result;
      }

      if (
        !(
          StreamViewvue_type_script_lang_js_isObj(this.stream.stream_urls)
          && typeof this.stream.stream_urls.primary === 'string'
        )
      ) {
        return result;
      }

      let uuid;
      if (this.stream.type == 2 || this.vodChapters.length !== 0) {
        let videoUrl = '';

        if (this.stream.type == 2) {
          videoUrl = this.stream.stream_urls.primary;
        }
        else if (this.vodChapters.length !== 0) {
          videoUrl = this.vodChapters[0];
        }

        const matches = /\/([0-9a-f]{32})\//.exec(videoUrl)
        if (!Array.isArray(matches)) {
          return result;
        }

        uuid = matches[1]
      } else if (this.stream.type == 1) {
        uuid = this.stream.vod_data_id
      } else {
        return result;
      }

      let coverType = 'landscape';
      if (this.stream.width && this.stream.height && this.stream.width <= this.stream.height) {
        coverType = 'portrait';
      }

      result[coverType] = new lib.Media(
        0,
        'https://' + this.streamThumbnailDomain + '/' + uuid + '.jpg?time=5s&height=600'
      );

      return result;
    },
    coverUrl() {
      let url;
      if (this.coverPortrait != null && (this.coverOrientation == 'portrait' || this.coverLandscape == null)) {
        url = this.coverPortrait.url;
      }
      else if (this.coverLandscape != null) {
        url = this.coverLandscape.url;
      }

      return typeof url == 'string' && url.length > 0 ? url : null;
    },
    videoSourceIsLoading() {
      // return this.liveStatus === 'live' && (!this.videoSource || !this.videoSourceIsLoaded);
      return this.videoSource != null && !this.videoSourceIsLoaded;
    },
    windowWidth: {
      get() {
        return this.debouncedWidth;
      },
      set(val) {
        if (this.widthTimeout) {
          clearTimeout(this.widthTimeout)
        }

        this.widthTimeout = setTimeout(() => {
          this.debouncedWidth = val;
        }, 500);
      }
    },
    pinnedItem() {
      const timeBasedPinnedItem = this.stream.products.find(p => {
        if (p.pinned_from_in_sec === null) {
          return false;
        }

        let resp = p.pinned_from_in_sec <= this.playbackPosition;
        if (p.pinned_to) {
          resp = resp && (p.pinned_to_in_sec === null || p.pinned_to_in_sec >= this.playbackPosition);
        }

        return resp;
      });

      if (timeBasedPinnedItem) {
        return timeBasedPinnedItem;
      }

      const pinnedItem = this.stream.products.find(p => p.pinned);
      if (pinnedItem) {
        return pinnedItem;
      }

      return null;
    },
    hasCustomProductsTabLabelSingular() {
      return typeof this.stream.tab_products_label_singular == 'string' && this.stream.tab_products_label_singular.length > 0
    },
    hasCustomProductsTabLabel() {
      return typeof this.stream.tab_products_label_plural == 'string' && this.stream.tab_products_label_plural.length > 0
    },
    isCompactAdvertisementSize() {
      return this.optimizeForAd && this.compactAdSizes.includes(this.stream.ad_size)
    },
    hasAdUrl() {
      return typeof this.stream.ad_url == 'string' && this.stream.ad_url.length > 0
    },
    isVideoAd640x360() {
      return this.optimizeForAd && this.stream.ad_size === '640x360'
    },
    adUrl() {
      if (!this.hasAdUrl) {
        return '';
      }

      const prefixed = 'https://' + this.stream.ad_url.replace('https://', '').replace('http://', '')

      let link = prefixed;
      if (this.$root.clickTracker) {
        link = this.$root.clickTracker + link;
      }

      return link;
    },
    isArabic() {
      return this.stream && this.stream.streamview_language === 'ar';
    },
  },
  created() {
    this.debouncedWidth = window.innerWidth
    this.dateNow = new Date()

    // Initial, temporary/predicted values for video container dimensions
    // based on stream settings.
    if (this.stream.width == null || this.stream.height == null) {
      this.stream.width = (this.videoOrientation === 'portrait' || this.isOrientationPortraitForced) ? 405 : 1280
      this.stream.height = 720
    }

    // @TODO - !isVod volt a videoJS idején..
    this.isMuted = true

    this.$root.$bus.$on('streamview.product.feed.details', (product) => {
      if (this.isCompactAdvertisementSize) {
        let link = product.link;
        if (this.$root.clickTracker) {
          link = this.$root.clickTracker + link;
        }

        window.open(link, '_blank')
        return
      }

      if (this.sidebarCollapsed) {
        this.onToggleSidebar()
      }
      this.previewProductDetails = product
    });

    this.$root.$bus.$on('streamview.product.feed.details.close', () => {
      this.previewProductDetails = null
    });

    this.$root.$bus.$on('streamview.product.payment.start', (product) => {
      this.payableProduct = product
    });

    this.$root.$bus.$on('streamview.product.payment.close', () => {
      this.payableProduct = null
    });

    this.$root.$bus.$on('streamview.subscriptionpanel.open', () => {
      this.isSubscriptionModalVisible = true
    });

    this.$root.$bus.$on('streamview.subscriptionpanel.close', () => {
      this.isSubscriptionModalVisible = false

      // Hate these ugly solutions....
      if (this.sidebarPreviousTab !== null) {
        this.$el.querySelector('[data-smuc-tabid="' + this.sidebarPreviousTab + '"]').click()
      }
    });

    this.$root.$bus.$on(Events.PLAYBACK_POSITION, (val) => {
      this.playbackPosition = val;
    })

    this.playerControlIsVisible = (this.isVod || this.isSimpleVod) && !this.stream.player_autoplay;
    this.$root.$bus.$on(Events.PLAYER_CONTROL_VISIVILITY_CHANGE, (isVisible) => {
      this.playerControlIsVisible = isVisible;
    });

    window.addEventListener('resize', this.eventOnResize)

    this.eventOnResize()

    this.eventOnOrientationChange()
  },
  beforeDestroy() {
    if (this.player) {
      this.player.destroy()
    }

    window.removeEventListener('resize', this.eventOnResize)

    this.videoContainerResizeObserver.unobserve(this.$refs.videoContainer)
    this.videoContainerResizeObserver.disconnect()
  },
  methods: {
    addFontFace(uuid) {
      if (typeof this.$el == 'undefined' && fontFaceMaxRetry-- > 0) {
        setTimeout(() => this.addFontFace(uuid), 250)
        return
      }

      const fontsSubdomain = this.$apiUrl && this.$apiUrl.includes('test.') ? 'fonts-test' : 'fonts'

      let family = "smuc" + this.stream.apikey;
      let fontFormat = 'opentype'
      if (this.stream.font_meta) {
        if (this.stream.font_meta.name) {
          family = this.stream.font_meta.name
        }

        if (this.stream.font_meta.mime.includes('ttf')) {
          fontFormat = 'truetype'
        } else if (this.stream.font_meta.mime.includes('woff2')) {
          fontFormat = 'woff2'
        } else if (this.stream.font_meta.mime.includes('woff')) {
          fontFormat = 'woff'
        } else if (this.stream.font_meta.mime.includes('eot')) {
          fontFormat = 'embedded-opentype'
        }
      }

      let css = `
        @font-face {
          font-family: "${family}";
          src: url("https://${fontsSubdomain}.smuc.workers.dev/${uuid}/regular") format("${fontFormat}");
          font-weight: 400;
          font-style: normal;
          font-display: swap;
        }
        @font-face {
          font-family: "${family}";
          src: url("https://${fontsSubdomain}.smuc.workers.dev/${uuid}/bold") format("${fontFormat}");
          font-weight: 700;
          font-style: normal;
          font-display: swap;
        }
        div[data-smuc-cfid="${uuid}"] {
          font-family: "${family}", Poppins, Helvetica, Arial, sans-serif !important;
        }
      `;
      const style = document.createElement('style');
      style.id = 'smuc-custom-font--' + uuid;

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
      this.$el.appendChild(style);
    },
    removeFontFace(uuid) {
      if (typeof this.$el == 'undefined') {
        return
      }

      const $style = this.$el.querySelector('#smuc-custom-font--' + uuid)
      if ($style) {
        $style.remove()
      }
    },
    initBlurredBgLazyload() {
      if (!this.$refs.blurredBg || !this.coverUrl) {
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        const isVisible = entries[0].isIntersecting;
        if (isVisible) {
          observer.disconnect();

          if (this.coverUrl.includes('thumbnail.smuc.io') || this.coverUrl.includes('thumbnail.bannerse.com')) {
            this.resolveProtectedCoverImage(this.coverUrl).then(resolvedUrl => {
              if (this.$refs.cloudflarePlayer) {
                this.$refs.cloudflarePlayer.loadPoster(resolvedUrl);
              }
              this.$refs.blurredBg.style.backgroundImage = 'url("' + resolvedUrl + '")';
            });
          }
          else {
            this.imageUrlToBase64(this.coverUrl).then(base64Url => {
              if (this.$refs.cloudflarePlayer) {
                this.$refs.cloudflarePlayer.loadPoster(base64Url);
              }
              this.$refs.blurredBg.style.backgroundImage = 'url("' + base64Url + '")';
            });
          }
        }
      });
      observer.observe(this.$refs.blurredBg);
    },
    videoLoadedDefault() {
      this.$nextTick(() => {
        this.videoSourceIsLoaded = true
        this.$emit('videoLoaded')
      });
    },
    videoLoadedMetadata(dimensions) {
      if (
        dimensions.width > 0
        && dimensions.height > 0
        && (
          this.isPreview
          || this.isKindaLive
        )
      ) {
        this.stream.width = dimensions.width
        this.stream.height = dimensions.height
      }
    },
    play() {
      if (this.player) {
        this.player.play();
      }
    },
    pause() {
      if (this.player) {
        this.player.pause();
      }
    },
    onPlay() {
      if (!this.isPlaying) {
        this.isPlaying = true;

        if (this.viewTimeCheckTimer === null) {
          let lastCheck = new Date();
          this.viewTimeCheckTimer = setInterval(() => {
            const now = new Date();

            this.viewTime += now.getTime() - lastCheck.getTime();
            if (!this.threeSecViewSent && this.viewTime >= 3000) {
              this.threeSecViewSent = true;
              this.$root.$bus.$emit('aq', ['event', '3sec_view']);
            }

            lastCheck = now;
          }, 100);
        }

        this.$emit('play');
      }
    },
    onPause() {
      if (this.isPlaying) {
        this.isPlaying = false;

        if (this.viewTimeCheckTimer !== null) {
          clearInterval(this.viewTimeCheckTimer);
          this.viewTimeCheckTimer = null;
        }

        this.$emit('pause');
      }
    },
    eventOnVolumeChange(value) {
      if (value > 0) {
        this.isMuted = !this.isMuted;
      }
    },
    eventOnUnmute() {
      if (this.isPreview || this.unmutedFirst) {
        return
      }

      this.unmutedFirst = true

      this.isMuted = false
      if (this.player) {
        this.player.muted = this.isMuted
      }
    },
    eventOnMinimize() {
      if (this.isPreview) {
        return
      }

      this.closePortraitSidebar()

      this.isMinimized = !this.isMinimized
      this.isChatWindowVisible = !this.isMinimized

      this.$root.$bus.$emit('streamview.minimize.status', this.isMinimized)
    },
    eventOnFullscreen() {
      if (this.isPreview) {
        return
      }

      this.closePortraitSidebar()

      this.isFullscreen = !this.isFullscreen
      this.$root.$bus.$emit('streamview.fullscreen.status', this.isFullscreen)
    },
    onToggleSidebar() {
      if (this.isPreview) {
        return
      }

      this.sidebarCollapsed = !this.sidebarCollapsed

      clearTimeout(this.collapsingTo)
      this.$refs.sidebar.$el.classList.add('collapsing')
      this.collapsingTo = setTimeout(() => {
        this.$refs.sidebar.$el.classList.remove('collapsing')
        clearTimeout(this.collapsingTo)
        this.collapsingTo = null
      }, 250)
    },
    eventOnShare() {
      if (!this.isPreview) {
        this.$root.$bus.$emit('aq', ['event', 'share']);
      }

      this.shareModalOpened = true
    },
    onWsInfo(info) {
      this.viewersCount = info.attendeeCount
    },
    eventOnResize() {
      if (
        this.isPreview
        && this.$el
        && this.$el.closest('.stream-preview')
        && this.$el.closest('.stream-preview').scrollWidth <= mobileBreakdownAt
      ) {
        this.windowWidth = this.$el.closest('.stream-preview').scrollWidth
      } else if (
        this.mode == 'embedded'
        && this.$el
        && this.$el.parentNode
      ) {
        this.windowWidth = this.$el.parentNode.offsetWidth || window.innerWidth
      } else {
        this.windowWidth = window.innerWidth
      }

      const orientation = this.getOrientation();
      if (this.deviceOrientation !== orientation) {
        this.deviceOrientation = orientation;
      }
    },
    playerEventEnded() {
      // If we have MORE THAN ONE chapters..
      if (
        this.isVod
        && this.vodChapters.length > 1
        && this.vodChapterNumber <= (this.vodChapters.length - 1)
      ) {
        this.jumpToNextChapter()
      }

      this.$root.$bus.$emit('streamview.player.ended')
    },
    jumpToNextChapter() {
      if ((this.vodChapterNumber + 1) >= this.vodChapters.length) {
        this.vodChapterNumber = 0
        this.hasNextVodChapter = false
      } else {
        this.hasNextVodChapter = true
        this.vodChapterNumber++
      }
    },
    closePortraitSidebar() {
      if (!this.isFullPortrait) {
        return
      }

      this.$refs.videoContainer.style.height = null
      this.$refs.videoContainer.style.flex = null
      this.fullPortraitSidebarIsVisible = false
    },
    videoContainerResizeHandler() {
      this.videoContainerOrientation = this.$refs.videoContainer.offsetWidth > this.$refs.videoContainer.offsetHeight ? 'landscape' : 'portrait'
    },
    onVideoContainerMouseMove() {
      if (this.$refs.cloudflarePlayer) {
        this.$refs.cloudflarePlayer.onMouseOver(true);
      }
    },
    onVideoContainerMouseOverChange(isOver) {
      if (this.$refs.cloudflarePlayer) {
        this.$refs.cloudflarePlayer.onMouseOver(isOver);
      }
    },
    eventOnOrientationChange() {
      if (!this.isMobileBreakpoint || this.mode != 'overlay') {
        return
      }

      let portrait = window.matchMedia("(orientation: landscape)");
      portrait.addEventListener("change", (e) => {
        if (e.matches) {
            // Landscape mode
            if (!this.isMinimized) {
              this.eventOnMinimize()
            }
        } else {
            // Portrait
            if (this.isMinimized) {
              this.eventOnMinimize()
            }
        }
      })
    },
    updateControlFreezeStatus() {
      this.$nextTick(() => {
        if (!this.$refs['cloudflarePlayer']) {
          return;
        }

        const freeze = this.playerOrientation === 'portrait' && this.videoOrientationByVideoSource !== 'landscape';
        this.$refs['cloudflarePlayer'].freezeControls(freeze);
      });
    },
    onIframeLoaded() {
      this.iframeLoaded = true;
      this.updateControlFreezeStatus();
      this.updatePlayerOptimizedForAd();
    },
    imageUrlToBase64(url) {
      return fetch(url)
        .then(response => response.blob())
        .then(blob => new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result)
          reader.onerror = reject
          reader.readAsDataURL(blob)
        }));
    },
    resolveProtectedCoverImage(url) {
      const parsedUrl = new URL(url);
      if (!parsedUrl.search) {
        parsedUrl.search = '';
      }
      parsedUrl.search += '&json=1';
      const processedUrl = parsedUrl.toString();

      return fetch(processedUrl).then(resp => resp.json()).then(({ url }) => url);
    },
    updatePlayerOptimizedForAd(reset = false) {
      this.$nextTick(() => {
        if (this.optimizeForAd && this.$refs.cloudflarePlayer) {
          this.$refs.cloudflarePlayer.setOptimizeForAd(!reset);
          this.$refs.cloudflarePlayer.setAutosize(reset);
          this.$refs.cloudflarePlayer.setCoverContentMode(reset ? 'cover' : 'contain');
        }
      });
    },
    makeCompactAdvertisementSidebarVisible(newValue) {
      this.sidebarActiveTab = newValue

      if (this.stream.ad_use_featured_image) {
        this.$refs.sidebar.$el.style.top = null;
      } else {
        this.isCompactAdvertisementSidebarVisible = true
      }
    },
    dragbarClosed() {
      if (this.isCompactAdvertisementSidebarVisible) {
        this.isCompactAdvertisementSidebarVisible = false
        this.$refs.sidebar.$el.style.top = null
      }
      else if (this.stream.ad_size === '640x360') {
        this.$refs.sidebar.$el.style.top = null
      }
    },
    // Only fired when in AD mode!
    eventPlayerVideoClicked() {
      if (
        this.optimizeForAd
        && this.hasAdUrl
        && this.isPlaying
      ) {
        window.open(this.adUrl, '_blank')

        this.pause();
        this.$root.$bus.$emit('aq', ['event', 'video_click']);
      }
    },
    openSidebarVideoAd640x360(event) {
      let to = ''
      if (this.showProductsTab) {
        to = 'products'
      } else if (this.showChatTab) {
        to = 'chat'
      } else if (this.showSubscriptionTab) {
        to = 'subscription'
      } else {
        return
      }

      this.$root.$bus.$emit('openMobileSidebar', {event, to})
    },
    shouldCallDelayedSidebarAppearance() {
      // Delay sidebar appearance for 640x360 AD
      if (
        this.stream.ad_size === '640x360'
        && /\d+/.test(this.stream.delay_sidebar_appearance)
        && !this.noSidebar
        && this.$refs.sidebarToggle640x360
      ) {
        setTimeout(() => this.$refs.sidebarToggle640x360.click(), (parseInt(this.stream.delay_sidebar_appearance, 10) * 1000))
      }
    }
  }
});

;// CONCATENATED MODULE: ./src/components/StreamView.vue?vue&type=script&lang=js
 /* harmony default export */ var components_StreamViewvue_type_script_lang_js = (StreamViewvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/StreamView.vue





/* normalize component */
;
var StreamView_component = normalizeComponent(
  components_StreamViewvue_type_script_lang_js,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StreamView = (StreamView_component.exports);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SubscribeNotification.vue?vue&type=template&id=2f71bb1c
var SubscribeNotificationvue_type_template_id_2f71bb1c_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showModal),expression:"!showModal"}],staticClass:"sbccc",style:(_vm.notificationStyle),on:{"click":function($event){_vm.showModal = true}}},[_c('div',{staticClass:"sca49"},[_c('svg',{attrs:{"width":"31","height":"24","viewBox":"0 0 31 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.69019 0.422044C6.56084 0.290066 6.40676 0.184869 6.23673 0.112464C6.06671 0.0400596 5.88409 0.00186598 5.6993 6.66827e-05C5.51452 -0.00173261 5.33118 0.0328972 5.15979 0.101978C4.98839 0.171058 4.83228 0.273235 4.70038 0.40267C3.20841 1.88598 2.02492 3.65003 1.21818 5.59306C0.411436 7.53609 -0.00258069 9.61963 1.2103e-05 11.7235C-0.00240775 13.908 0.444191 16.0698 1.31209 18.0746C2.17999 20.0793 3.45067 21.8843 5.04526 23.3775C5.31364 23.6256 5.66815 23.7593 6.03352 23.7503C6.39889 23.7413 6.74635 23.5902 7.00213 23.3291C7.61438 22.7168 7.53882 21.7423 6.94982 21.1785C5.6701 19.9589 4.65173 18.4918 3.95661 16.8664C3.26149 15.241 2.90413 13.4913 2.90626 11.7235C2.90626 8.14685 4.34195 4.90348 6.67082 2.54361C7.23269 1.97204 7.29082 1.02267 6.69019 0.422044ZM10.1021 3.83785C9.84696 3.5753 9.49811 3.4246 9.13204 3.41879C8.76596 3.41298 8.4125 3.55253 8.14913 3.80685C7.10085 4.84139 6.26877 6.07407 5.70131 7.43318C5.13385 8.79228 4.84235 10.2507 4.84376 11.7235C4.84148 13.2807 5.16686 14.8211 5.79874 16.2444C6.43062 17.6677 7.35487 18.9422 8.51144 19.985C8.77736 20.2199 9.12348 20.3435 9.47807 20.3302C9.83265 20.3168 10.1685 20.1675 10.416 19.9133C11.0515 19.2778 10.9333 18.278 10.3366 17.7162C9.51857 16.9472 8.86699 16.0187 8.4221 14.9879C7.9772 13.9572 7.74846 12.8461 7.75001 11.7235C7.75001 9.49535 8.63544 7.4726 10.075 5.98848C10.6291 5.41885 10.7202 4.45204 10.1021 3.83592V3.83785ZM20.8979 3.83785C21.153 3.5753 21.5019 3.4246 21.868 3.41879C22.234 3.41298 22.5875 3.55253 22.8509 3.80685C23.8992 4.84139 24.7312 6.07407 25.2987 7.43318C25.8661 8.79228 26.1577 10.2507 26.1562 11.7235C26.1585 13.2807 25.8331 14.8211 25.2013 16.2444C24.5694 17.6677 23.6451 18.9422 22.4886 19.985C22.2226 20.2199 21.8765 20.3435 21.5219 20.3302C21.1674 20.3168 20.8315 20.1675 20.584 19.9133C19.9485 19.2778 20.0667 18.278 20.6634 17.7162C21.4814 16.9472 22.133 16.0187 22.5779 14.9879C23.0228 13.9572 23.2515 12.8461 23.25 11.7235C23.25 9.49535 22.3646 7.4726 20.925 5.98848C20.3709 5.41885 20.2798 4.45204 20.8979 3.83592V3.83785ZM24.3098 0.423983C24.4392 0.292004 24.5932 0.186807 24.7633 0.114402C24.9333 0.0419969 25.1159 0.0038038 25.3007 0.0020045C25.4855 0.000205206 25.6688 0.0348345 25.8402 0.103915C26.0116 0.172995 26.1677 0.275173 26.2996 0.404607C27.7914 1.88769 28.9747 3.65143 29.7815 5.5941C30.5882 7.53678 31.0023 9.61995 31 11.7235C31.0024 13.908 30.5558 16.0698 29.6879 18.0746C28.82 20.0793 27.5493 21.8843 25.9547 23.3775C25.6864 23.6256 25.3319 23.7593 24.9665 23.7503C24.6011 23.7413 24.2536 23.5902 23.9979 23.3291C23.3856 22.7168 23.4612 21.7423 24.0521 21.1785C25.3315 19.9587 26.3495 18.4916 27.0443 16.8662C27.7391 15.2408 28.0961 13.4911 28.0937 11.7235C28.0937 8.14685 26.6581 4.90348 24.3292 2.54361C23.7673 1.97204 23.7092 1.02267 24.3098 0.422044V0.423983ZM15.5 8.81723C14.7292 8.81723 13.99 9.12342 13.445 9.66845C12.8999 10.2135 12.5938 10.9527 12.5938 11.7235C12.5938 12.4943 12.8999 13.2335 13.445 13.7785C13.99 14.3235 14.7292 14.6297 15.5 14.6297C16.2708 14.6297 17.01 14.3235 17.555 13.7785C18.1001 13.2335 18.4062 12.4943 18.4062 11.7235C18.4062 10.9527 18.1001 10.2135 17.555 9.66845C17.01 9.12342 16.2708 8.81723 15.5 8.81723Z","fill":_vm.textColor}})])]),_c('div',{staticClass:"s9905"},[_vm._v(" "+_vm._s(_vm.remainingTimeText)+" "),(_vm.remainingTimeText !== '')?_c('br'):_vm._e(),_c('strong',[_vm._v(_vm._s(_vm.tr('Live is coming soon')))])]),_c('div',{staticClass:"sadde"},[_vm._v(_vm._s(_vm.tr('More'))+" >")])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showModal),expression:"showModal"}],staticClass:"s7ecc",style:(_vm.modalStyle)},[_c('div',{staticClass:"s099f"},[(_vm.brandLogo)?_c('img',{staticClass:"s1eee",attrs:{"src":_vm.brandLogo}}):_vm._e(),_c('div',{staticClass:"s85e4",on:{"click":function($event){return _vm.openShare()}}},[_vm._v(_vm._s(_vm.tr('Share')))]),_c('div',{staticClass:"s716f",on:{"click":function($event){_vm.showModal = false}}})]),_c('div',{staticClass:"s9905"},[_c('svg',{attrs:{"width":"31","height":"24","viewBox":"0 0 31 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.69019 0.422044C6.56084 0.290066 6.40676 0.184869 6.23673 0.112464C6.06671 0.0400596 5.88409 0.00186598 5.6993 6.66827e-05C5.51452 -0.00173261 5.33118 0.0328972 5.15979 0.101978C4.98839 0.171058 4.83228 0.273235 4.70038 0.40267C3.20841 1.88598 2.02492 3.65003 1.21818 5.59306C0.411436 7.53609 -0.00258069 9.61963 1.2103e-05 11.7235C-0.00240775 13.908 0.444191 16.0698 1.31209 18.0746C2.17999 20.0793 3.45067 21.8843 5.04526 23.3775C5.31364 23.6256 5.66815 23.7593 6.03352 23.7503C6.39889 23.7413 6.74635 23.5902 7.00213 23.3291C7.61438 22.7168 7.53882 21.7423 6.94982 21.1785C5.6701 19.9589 4.65173 18.4918 3.95661 16.8664C3.26149 15.241 2.90413 13.4913 2.90626 11.7235C2.90626 8.14685 4.34195 4.90348 6.67082 2.54361C7.23269 1.97204 7.29082 1.02267 6.69019 0.422044ZM10.1021 3.83785C9.84696 3.5753 9.49811 3.4246 9.13204 3.41879C8.76596 3.41298 8.4125 3.55253 8.14913 3.80685C7.10085 4.84139 6.26877 6.07407 5.70131 7.43318C5.13385 8.79228 4.84235 10.2507 4.84376 11.7235C4.84148 13.2807 5.16686 14.8211 5.79874 16.2444C6.43062 17.6677 7.35487 18.9422 8.51144 19.985C8.77736 20.2199 9.12348 20.3435 9.47807 20.3302C9.83265 20.3168 10.1685 20.1675 10.416 19.9133C11.0515 19.2778 10.9333 18.278 10.3366 17.7162C9.51857 16.9472 8.86699 16.0187 8.4221 14.9879C7.9772 13.9572 7.74846 12.8461 7.75001 11.7235C7.75001 9.49535 8.63544 7.4726 10.075 5.98848C10.6291 5.41885 10.7202 4.45204 10.1021 3.83592V3.83785ZM20.8979 3.83785C21.153 3.5753 21.5019 3.4246 21.868 3.41879C22.234 3.41298 22.5875 3.55253 22.8509 3.80685C23.8992 4.84139 24.7312 6.07407 25.2987 7.43318C25.8661 8.79228 26.1577 10.2507 26.1562 11.7235C26.1585 13.2807 25.8331 14.8211 25.2013 16.2444C24.5694 17.6677 23.6451 18.9422 22.4886 19.985C22.2226 20.2199 21.8765 20.3435 21.5219 20.3302C21.1674 20.3168 20.8315 20.1675 20.584 19.9133C19.9485 19.2778 20.0667 18.278 20.6634 17.7162C21.4814 16.9472 22.133 16.0187 22.5779 14.9879C23.0228 13.9572 23.2515 12.8461 23.25 11.7235C23.25 9.49535 22.3646 7.4726 20.925 5.98848C20.3709 5.41885 20.2798 4.45204 20.8979 3.83592V3.83785ZM24.3098 0.423983C24.4392 0.292004 24.5932 0.186807 24.7633 0.114402C24.9333 0.0419969 25.1159 0.0038038 25.3007 0.0020045C25.4855 0.000205206 25.6688 0.0348345 25.8402 0.103915C26.0116 0.172995 26.1677 0.275173 26.2996 0.404607C27.7914 1.88769 28.9747 3.65143 29.7815 5.5941C30.5882 7.53678 31.0023 9.61995 31 11.7235C31.0024 13.908 30.5558 16.0698 29.6879 18.0746C28.82 20.0793 27.5493 21.8843 25.9547 23.3775C25.6864 23.6256 25.3319 23.7593 24.9665 23.7503C24.6011 23.7413 24.2536 23.5902 23.9979 23.3291C23.3856 22.7168 23.4612 21.7423 24.0521 21.1785C25.3315 19.9587 26.3495 18.4916 27.0443 16.8662C27.7391 15.2408 28.0961 13.4911 28.0937 11.7235C28.0937 8.14685 26.6581 4.90348 24.3292 2.54361C23.7673 1.97204 23.7092 1.02267 24.3098 0.422044V0.423983ZM15.5 8.81723C14.7292 8.81723 13.99 9.12342 13.445 9.66845C12.8999 10.2135 12.5938 10.9527 12.5938 11.7235C12.5938 12.4943 12.8999 13.2335 13.445 13.7785C13.99 14.3235 14.7292 14.6297 15.5 14.6297C16.2708 14.6297 17.01 14.3235 17.555 13.7785C18.1001 13.2335 18.4062 12.4943 18.4062 11.7235C18.4062 10.9527 18.1001 10.2135 17.555 9.66845C17.01 9.12342 16.2708 8.81723 15.5 8.81723Z","fill":"white"}})]),_c('p',[_vm._v(" "+_vm._s(_vm.remainingTimeText)+" "),(_vm.remainingTimeText !== '')?_c('br'):_vm._e(),_c('strong',[_vm._v(_vm._s(_vm.tr('Live is coming soon')))])])]),_c('form',{staticClass:"s3fcd",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('strong',[_vm._v(_vm._s(_vm.tr('Subscribe and get notified')))]),_c('p',[_vm._v(_vm._s(_vm.tr('Please, enter your e-mail and we will notify before the live will getting started.')))]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"email",attrs:{"type":"email","placeholder":_vm.tr('Your e-mail...')},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing)return;_vm.email=$event.target.value}}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.privacyPolicyLabel)}}),_c('button',{style:(_vm.notificationStyle),attrs:{"type":"submit","disabled":_vm.isLoading}},[_vm._v(" "+_vm._s(_vm.tr('Subscribe to live'))+" ")])])])])
}
var SubscribeNotificationvue_type_template_id_2f71bb1c_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SubscribeNotification.vue?vue&type=script&lang=js



/* harmony default export */ var SubscribeNotificationvue_type_script_lang_js = ({
  name: 'SubscribeNotification',
  mixins: [ Translator ],
  props: {
    buttonColor: {
      type: String,
      required: false,
      default() {
        return '#000000';
      },
    },
    textColor: {
      type: String,
      required: false,
      default() {
        return '#ffffff';
      },
    },
    startDate: {
      type: Date,
      required: true
    },
    brandLogo: {
      type: [String, null],
      required: false,
      default: null,
      validator: (value) => {
        if (value === null || value && !value.length) {
          return true
        }

        return /(jpe?g|png|gif|svg|webp)$/.exec(value) != null
      }
    },
    coverUrl: {
      type: [String, null],
      required: false,
      default: null,
      validator: (value) => {
        if (value === null || value && !value.length) {
          return true
        }

        return /(jpe?g|png|gif|svg|webp)$/.exec(value) != null
      }
    },
    apikey: {
      type: String,
      required: false,
      default() {
        return '';
      },
    },
    privacyPolicyUrl: {
      type: String,
      required: false,
      default() {
        return '';
      },
    },
  },
  data: () => ({
    remainingTimeInterval: null,
    remainingMins: null,
    remainingTimeText: '',
    showModal: false,
    isLoading: false,
  }),
  computed: {
    notificationStyle() {
      return {
        'background-color': this.buttonColor,
        color: this.textColor
      }
    },
    modalStyle() {
      return {
        'background-image': this.coverUrl ? 'url(' + this.coverUrl + ')' : null
      }
    },
    privacyPolicyLabel() {
      const label = 'By subscribing, you confirm that you have read and accept our <a target=_blank href={url}>Privacy Policy</a>. We use your email address only for sending notifications about the broadcast.'
      return this.tr(label, { '{url}': this.privacyPolicyUrl })
    },
  },
  mounted () {
    const dateNow = new Date()
    this.remainingMins = (this.startDate - dateNow) / 1000 / 60
    this.setRemainingText()

    this.remainingTimeInterval = setInterval(() => {
      this.remainingMins--
      this.setRemainingText()
    }, 1000 * 60)
  },
  watch: {
    startDate() {
      const dateNow = new Date()
      this.remainingMins = (this.startDate - dateNow) / 1000 / 60

      this.setRemainingText()
    },
    language() {
      this.setRemainingText()
    }
  },
  methods: {
    setRemainingText() {
      if (this.remainingMins < 0) {
        this.remainingTimeText = ''
        return
      }

      let remainingMins = this.remainingMins
      const days = Math.floor(remainingMins / (60 * 24))
      remainingMins -= days * 60 * 24

      const hours = Math.floor(remainingMins / 60)
      remainingMins -= hours * 60

      remainingMins = Math.floor(remainingMins)

      this.remainingTimeText = '';
      if (days) {
        this.remainingTimeText += days + ' ' + (days > 1 ? this.tr('days') : this.tr('day')) + ' '
      }

      if ((days && !hours) || hours) {
        this.remainingTimeText += hours + ' ' + (hours > 1 ? this.tr('hours') : this.tr('hour')) + ' '
      }

      if (remainingMins < 1) {
        this.remainingTimeText = ''
      } else {
        this.remainingTimeText += remainingMins + ' ' + (remainingMins > 1 ? this.tr('minutes') : this.tr('minute')) + ' '
      }
    },
    openShare() {
      this.showModal = false
      this.$emit('open-share')
    },
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    submit() {
      if (!this.validEmail(this.email) || this.isLoading) {
        this.$refs['email'].focus()
        return
      }

      this.isLoading = true;

      // Send request to backend
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({email: this.email, apikey: this.apikey})
      }

      const url = this.$apiUrl + '/smucrestapi/v2/stream/subscribe-for-notification'
      fetch(url, requestOptions)
        .then(() => {
          this.showModal = false
          this.$emit('subscribed')
        })
        .finally(() => {
          this.isLoading = false;
        })
    }
  },
});

;// CONCATENATED MODULE: ./src/components/SubscribeNotification.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SubscribeNotificationvue_type_script_lang_js = (SubscribeNotificationvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/SubscribeNotification.vue





/* normalize component */
;
var SubscribeNotification_component = normalizeComponent(
  components_SubscribeNotificationvue_type_script_lang_js,
  SubscribeNotificationvue_type_template_id_2f71bb1c_render,
  SubscribeNotificationvue_type_template_id_2f71bb1c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SubscribeNotification = (SubscribeNotification_component.exports);
;// CONCATENATED MODULE: ./src/install.js
if (false) {}







const SmucStreamView = {
 install(Vue) {
  Vue.component('stream-view', StreamView);
  Vue.component('products-feed', ProductsFeed);
  Vue.component('subscribe-notification', SubscribeNotification);
 }
};

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(SmucStreamView);
}

/* harmony default export */ var install = (SmucStreamView);

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = (install);


}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=smucio-streamview.common.js.map